import { scopeStackApiV2 as api } from "./ScopeStackAPIV2";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    v2ListAccountConnections: build.query<
      V2ListAccountConnectionsApiResponse,
      V2ListAccountConnectionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-connections`,
        params: { filter: queryArg.filter },
      }),
    }),
    v2CreateAccountConnection: build.mutation<
      V2CreateAccountConnectionApiResponse,
      V2CreateAccountConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-connections`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetAccountConnection: build.query<
      V2GetAccountConnectionApiResponse,
      V2GetAccountConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-connections/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateAccountConnection: build.mutation<
      V2UpdateAccountConnectionApiResponse,
      V2UpdateAccountConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-connections/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteAccountConnection: build.mutation<
      V2DeleteAccountConnectionApiResponse,
      V2DeleteAccountConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-connections/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ReconnectAccountConnection: build.mutation<
      V2ReconnectAccountConnectionApiResponse,
      V2ReconnectAccountConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-connections/${queryArg.id}/reconnect-requests`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2EnableAccountConnection: build.mutation<
      V2EnableAccountConnectionApiResponse,
      V2EnableAccountConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-connections/${queryArg.id}/enable-requests`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2DisableAccountConnection: build.mutation<
      V2DisableAccountConnectionApiResponse,
      V2DisableAccountConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-connections/${queryArg.id}/disable-requests`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2GetAccountFinancials: build.query<
      V2GetAccountFinancialsApiResponse,
      V2GetAccountFinancialsApiArg
    >({
      query: () => ({ url: `/v2/account-financials` }),
    }),
    v2ListAccountFlagValues: build.query<
      V2ListAccountFlagValuesApiResponse,
      V2ListAccountFlagValuesApiArg
    >({
      query: () => ({ url: `/v2/account-flag-values` }),
    }),
    v2GetAccountFlagValue: build.query<
      V2GetAccountFlagValueApiResponse,
      V2GetAccountFlagValueApiArg
    >({
      query: (queryArg) => ({ url: `/v2/account-flag-values/${queryArg.id}` }),
    }),
    v2UpdateAccountFlagValue: build.mutation<
      V2UpdateAccountFlagValueApiResponse,
      V2UpdateAccountFlagValueApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-flag-values/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteAccountFlagValue: build.mutation<
      V2DeleteAccountFlagValueApiResponse,
      V2DeleteAccountFlagValueApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-flag-values/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListAccountHealthSnapshots: build.query<
      V2ListAccountHealthSnapshotsApiResponse,
      V2ListAccountHealthSnapshotsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-health-snapshots`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2GetAccountHealthSnapshot: build.query<
      V2GetAccountHealthSnapshotApiResponse,
      V2GetAccountHealthSnapshotApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-health-snapshots/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2GetAccountLogo: build.query<
      V2GetAccountLogoApiResponse,
      V2GetAccountLogoApiArg
    >({
      query: () => ({ url: `/v2/account-logo` }),
    }),
    v2UpdateAccountLogo: build.mutation<
      V2UpdateAccountLogoApiResponse,
      V2UpdateAccountLogoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-logo`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2ListAccounts: build.query<
      V2ListAccountsApiResponse,
      V2ListAccountsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/accounts`,
        params: { include: queryArg.include },
      }),
    }),
    v2CreateAccount: build.mutation<
      V2CreateAccountApiResponse,
      V2CreateAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/accounts`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetAccount: build.query<V2GetAccountApiResponse, V2GetAccountApiArg>({
      query: (queryArg) => ({
        url: `/v2/account`,
        params: { include: queryArg.include },
      }),
    }),
    v2ListApprovalLevelsForAccount: build.query<
      V2ListApprovalLevelsForAccountApiResponse,
      V2ListApprovalLevelsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/approval-levels`,
        params: {
          page: queryArg.page,
          filter: queryArg.filter,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateApprovalLevel: build.mutation<
      V2CreateApprovalLevelApiResponse,
      V2CreateApprovalLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/approval-levels`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetApprovalLevel: build.query<
      V2GetApprovalLevelApiResponse,
      V2GetApprovalLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/approval-levels/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateApprovalLevel: build.mutation<
      V2UpdateApprovalLevelApiResponse,
      V2UpdateApprovalLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/approval-levels/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteApprovalLevel: build.mutation<
      V2DeleteApprovalLevelApiResponse,
      V2DeleteApprovalLevelApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/approval-levels/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ChangeApprovalLevelPositionById: build.mutation<
      V2ChangeApprovalLevelPositionByIdApiResponse,
      V2ChangeApprovalLevelPositionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/approval-levels/${queryArg.id}/moves`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2RestoreApprovalLevelById: build.mutation<
      V2RestoreApprovalLevelByIdApiResponse,
      V2RestoreApprovalLevelByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/approval-levels/${queryArg.id}/restore-requests`,
        method: "PUT",
      }),
    }),
    v2PurgeApprovalLevelById: build.mutation<
      V2PurgeApprovalLevelByIdApiResponse,
      V2PurgeApprovalLevelByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/approval-levels/${queryArg.id}/purge-requests`,
        method: "DELETE",
      }),
    }),
    v2ConsolidateTechnicalApprovalLevels: build.mutation<
      V2ConsolidateTechnicalApprovalLevelsApiResponse,
      V2ConsolidateTechnicalApprovalLevelsApiArg
    >({
      query: () => ({
        url: `/v2/approval-levels/consolidations`,
        method: "POST",
      }),
    }),
    v2ListLobApprovalsForAccount: build.query<
      V2ListLobApprovalsForAccountApiResponse,
      V2ListLobApprovalsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lob-approvals`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreateLobApproval: build.mutation<
      V2CreateLobApprovalApiResponse,
      V2CreateLobApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lob-approvals`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetLobApproval: build.query<
      V2GetLobApprovalApiResponse,
      V2GetLobApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lob-approvals/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateLobApproval: build.mutation<
      V2UpdateLobApprovalApiResponse,
      V2UpdateLobApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lob-approvals/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteLobApproval: build.mutation<
      V2DeleteLobApprovalApiResponse,
      V2DeleteLobApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lob-approvals/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListLobApprovalUsersForAccount: build.query<
      V2ListLobApprovalUsersForAccountApiResponse,
      V2ListLobApprovalUsersForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lob-approval-users`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreateLobApprovalUser: build.mutation<
      V2CreateLobApprovalUserApiResponse,
      V2CreateLobApprovalUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lob-approval-users`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetLobApprovalUser: build.query<
      V2GetLobApprovalUserApiResponse,
      V2GetLobApprovalUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lob-approval-users/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateLobApprovalUser: build.mutation<
      V2UpdateLobApprovalUserApiResponse,
      V2UpdateLobApprovalUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lob-approval-users/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteLobApprovalUser: build.mutation<
      V2DeleteLobApprovalUserApiResponse,
      V2DeleteLobApprovalUserApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/lob-approval-users/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListApprovalStepsForAccount: build.query<
      V2ListApprovalStepsForAccountApiResponse,
      V2ListApprovalStepsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/approval-steps`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2GetApprovalStep: build.query<
      V2GetApprovalStepApiResponse,
      V2GetApprovalStepApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/approval-steps/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2ListAttachmentTypesForAccount: build.query<
      V2ListAttachmentTypesForAccountApiResponse,
      V2ListAttachmentTypesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/attachment-types`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateAttachmentType: build.mutation<
      V2CreateAttachmentTypeApiResponse,
      V2CreateAttachmentTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/attachment-types`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetAttachmentType: build.query<
      V2GetAttachmentTypeApiResponse,
      V2GetAttachmentTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/attachment-types/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateAttachmentType: build.mutation<
      V2UpdateAttachmentTypeApiResponse,
      V2UpdateAttachmentTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/attachment-types/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteAttachmentType: build.mutation<
      V2DeleteAttachmentTypeApiResponse,
      V2DeleteAttachmentTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/attachment-types/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListAuditLogs: build.query<
      V2ListAuditLogsApiResponse,
      V2ListAuditLogsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/audit-logs`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          sort: queryArg.sort,
        },
      }),
    }),
    v2ListProjectAuditLogs: build.query<
      V2ListProjectAuditLogsApiResponse,
      V2ListProjectAuditLogsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/audit-logs`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          sort: queryArg.sort,
        },
      }),
    }),
    v2GetAuditLogById: build.query<
      V2GetAuditLogByIdApiResponse,
      V2GetAuditLogByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/audit-logs/${queryArg.id}` }),
    }),
    v2RevertAuditLogById: build.mutation<
      V2RevertAuditLogByIdApiResponse,
      V2RevertAuditLogByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/audit-logs/${queryArg.id}/reverts`,
        method: "PUT",
      }),
    }),
    v2ListBlueprintsForAccount: build.query<
      V2ListBlueprintsForAccountApiResponse,
      V2ListBlueprintsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/blueprints`,
        params: {
          filter: queryArg.filter,
          sort: queryArg.sort,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateBlueprint: build.mutation<
      V2CreateBlueprintApiResponse,
      V2CreateBlueprintApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/blueprints`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetBlueprint: build.query<
      V2GetBlueprintApiResponse,
      V2GetBlueprintApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/blueprints/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateBlueprint: build.mutation<
      V2UpdateBlueprintApiResponse,
      V2UpdateBlueprintApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/blueprints/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteBlueprint: build.mutation<
      V2DeleteBlueprintApiResponse,
      V2DeleteBlueprintApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/blueprints/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListBusinessUnitsForAccount: build.query<
      V2ListBusinessUnitsForAccountApiResponse,
      V2ListBusinessUnitsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/business-units`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateBusinessUnit: build.mutation<
      V2CreateBusinessUnitApiResponse,
      V2CreateBusinessUnitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/business-units`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetBusinessUnit: build.query<
      V2GetBusinessUnitApiResponse,
      V2GetBusinessUnitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/business-units/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateBusinessUnit: build.mutation<
      V2UpdateBusinessUnitApiResponse,
      V2UpdateBusinessUnitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/business-units/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteBusinessUnit: build.mutation<
      V2DeleteBusinessUnitApiResponse,
      V2DeleteBusinessUnitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/business-units/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListSpecialConditionsForBusinessUnit: build.query<
      V2ListSpecialConditionsForBusinessUnitApiResponse,
      V2ListSpecialConditionsForBusinessUnitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/business-units/${queryArg.businessUnitId}/special-conditions`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreateSpecialConditionForBusinessUnit: build.mutation<
      V2CreateSpecialConditionForBusinessUnitApiResponse,
      V2CreateSpecialConditionForBusinessUnitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/business-units/${queryArg.businessUnitId}/special-conditions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetBusinessUnitSpecialConditionById: build.query<
      V2GetBusinessUnitSpecialConditionByIdApiResponse,
      V2GetBusinessUnitSpecialConditionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/business-units/${queryArg.businessUnitId}/special-conditions/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateBusinessUnitSpecialCondition: build.mutation<
      V2UpdateBusinessUnitSpecialConditionApiResponse,
      V2UpdateBusinessUnitSpecialConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/business-units/${queryArg.businessUnitId}/special-conditions/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteBusinessUnitSpecialCondition: build.mutation<
      V2DeleteBusinessUnitSpecialConditionApiResponse,
      V2DeleteBusinessUnitSpecialConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/business-units/${queryArg.businessUnitId}/special-conditions/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListClientsForAccount: build.query<
      V2ListClientsForAccountApiResponse,
      V2ListClientsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients`,
        params: {
          filter: queryArg.filter,
          sort: queryArg.sort,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateClient: build.mutation<
      V2CreateClientApiResponse,
      V2CreateClientApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetClient: build.query<V2GetClientApiResponse, V2GetClientApiArg>({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateClient: build.mutation<
      V2UpdateClientApiResponse,
      V2UpdateClientApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteClient: build.mutation<
      V2DeleteClientApiResponse,
      V2DeleteClientApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2DownloadClientsCsv: build.query<
      V2DownloadClientsCsvApiResponse,
      V2DownloadClientsCsvApiArg
    >({
      query: () => ({ url: `/v2/clients/downloads` }),
    }),
    v2MergeClientRecords: build.mutation<
      V2MergeClientRecordsApiResponse,
      V2MergeClientRecordsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.id}/merge-requests`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2ListContactsForClient: build.query<
      V2ListContactsForClientApiResponse,
      V2ListContactsForClientApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.clientId}/contacts`,
        params: { filter: queryArg.filter, page: queryArg.page },
      }),
    }),
    v2CreateContactForClient: build.mutation<
      V2CreateContactForClientApiResponse,
      V2CreateContactForClientApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.clientId}/contacts`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetClientContactById: build.query<
      V2GetClientContactByIdApiResponse,
      V2GetClientContactByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.clientId}/contacts/${queryArg.id}`,
      }),
    }),
    v2UpdateClientContact: build.mutation<
      V2UpdateClientContactApiResponse,
      V2UpdateClientContactApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.clientId}/contacts/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteClientContact: build.mutation<
      V2DeleteClientContactApiResponse,
      V2DeleteClientContactApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.clientId}/contacts/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListSpecialConditionsForClient: build.query<
      V2ListSpecialConditionsForClientApiResponse,
      V2ListSpecialConditionsForClientApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.clientId}/special-conditions`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreateSpecialConditionForClient: build.mutation<
      V2CreateSpecialConditionForClientApiResponse,
      V2CreateSpecialConditionForClientApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.clientId}/special-conditions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetClientSpecialConditionById: build.query<
      V2GetClientSpecialConditionByIdApiResponse,
      V2GetClientSpecialConditionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.clientId}/special-conditions/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateClientSpecialCondition: build.mutation<
      V2UpdateClientSpecialConditionApiResponse,
      V2UpdateClientSpecialConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.clientId}/special-conditions/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteClientSpecialCondition: build.mutation<
      V2DeleteClientSpecialConditionApiResponse,
      V2DeleteClientSpecialConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/clients/${queryArg.clientId}/special-conditions/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListCollaboratorsForAccount: build.query<
      V2ListCollaboratorsForAccountApiResponse,
      V2ListCollaboratorsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/collaborators`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2GetCollaboratorById: build.query<
      V2GetCollaboratorByIdApiResponse,
      V2GetCollaboratorByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/collaborators/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2ListConnectedApp: build.query<
      V2ListConnectedAppApiResponse,
      V2ListConnectedAppApiArg
    >({
      query: () => ({ url: `/v2/connected-apps/` }),
    }),
    v2ListContactsForAccount: build.query<
      V2ListContactsForAccountApiResponse,
      V2ListContactsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/contacts`,
        params: { filter: queryArg.filter, page: queryArg.page },
      }),
    }),
    v2CreateContact: build.mutation<
      V2CreateContactApiResponse,
      V2CreateContactApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/contacts`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetContactById: build.query<
      V2GetContactByIdApiResponse,
      V2GetContactByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/contacts/${queryArg.id}` }),
    }),
    v2UpdateContact: build.mutation<
      V2UpdateContactApiResponse,
      V2UpdateContactApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/contacts/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteContact: build.mutation<
      V2DeleteContactApiResponse,
      V2DeleteContactApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/contacts/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListContentTemplatesForAccount: build.query<
      V2ListContentTemplatesForAccountApiResponse,
      V2ListContentTemplatesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/content-templates`,
        params: {
          filter: queryArg.filter,
          sort: queryArg.sort,
          page: queryArg.page,
        },
      }),
    }),
    v2GetContentTemplate: build.query<
      V2GetContentTemplateApiResponse,
      V2GetContentTemplateApiArg
    >({
      query: (queryArg) => ({ url: `/v2/content-templates/${queryArg.id}` }),
    }),
    v2ImportContentTemplate: build.mutation<
      V2ImportContentTemplateApiResponse,
      V2ImportContentTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/content-templates/${queryArg.id}/imports`,
        method: "PUT",
      }),
    }),
    v2ListCrmOpportunitiesForAccount: build.query<
      V2ListCrmOpportunitiesForAccountApiResponse,
      V2ListCrmOpportunitiesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/crm-opportunities`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2ListCurrencysForAccount: build.query<
      V2ListCurrencysForAccountApiResponse,
      V2ListCurrencysForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/currencies`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateCurrency: build.mutation<
      V2CreateCurrencyApiResponse,
      V2CreateCurrencyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/currencies`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetCurrency: build.query<V2GetCurrencyApiResponse, V2GetCurrencyApiArg>({
      query: (queryArg) => ({
        url: `/v2/currencies/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateCurrency: build.mutation<
      V2UpdateCurrencyApiResponse,
      V2UpdateCurrencyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/currencies/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteCurrency: build.mutation<
      V2DeleteCurrencyApiResponse,
      V2DeleteCurrencyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/currencies/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListCustomerSuccesses: build.query<
      V2ListCustomerSuccessesApiResponse,
      V2ListCustomerSuccessesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/customer-successes`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateCustomerSuccess: build.mutation<
      V2CreateCustomerSuccessApiResponse,
      V2CreateCustomerSuccessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/customer-successes`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetCustomerSuccess: build.query<
      V2GetCustomerSuccessApiResponse,
      V2GetCustomerSuccessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/customer-successes/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateCustomerSuccess: build.mutation<
      V2UpdateCustomerSuccessApiResponse,
      V2UpdateCustomerSuccessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/customer-successes/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteCustomerSuccess: build.mutation<
      V2DeleteCustomerSuccessApiResponse,
      V2DeleteCustomerSuccessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/customer-successes/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListDataImportsForAccount: build.query<
      V2ListDataImportsForAccountApiResponse,
      V2ListDataImportsForAccountApiArg
    >({
      query: () => ({ url: `/v2/data-imports` }),
    }),
    v2CreateDataImport: build.mutation<
      V2CreateDataImportApiResponse,
      V2CreateDataImportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/data-imports`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetDataImportById: build.query<
      V2GetDataImportByIdApiResponse,
      V2GetDataImportByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/data-imports/${queryArg.id}` }),
    }),
    v2ListDocumentDeliveriesForAccount: build.query<
      V2ListDocumentDeliveriesForAccountApiResponse,
      V2ListDocumentDeliveriesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-deliveries`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2GetDocumentDelivery: build.query<
      V2GetDocumentDeliveryApiResponse,
      V2GetDocumentDeliveryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-deliveries/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2ListDocumentRequestsForAccount: build.query<
      V2ListDocumentRequestsForAccountApiResponse,
      V2ListDocumentRequestsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-requests`,
        params: {
          sort: queryArg.sort,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateDocumentRequest: build.mutation<
      V2CreateDocumentRequestApiResponse,
      V2CreateDocumentRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-requests`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetDocumentRequest: build.query<
      V2GetDocumentRequestApiResponse,
      V2GetDocumentRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-requests/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateDocumentRequest: build.mutation<
      V2UpdateDocumentRequestApiResponse,
      V2UpdateDocumentRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-requests/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteDocumentRequest: build.mutation<
      V2DeleteDocumentRequestApiResponse,
      V2DeleteDocumentRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-requests/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListDocumentTemplatesForAccount: build.query<
      V2ListDocumentTemplatesForAccountApiResponse,
      V2ListDocumentTemplatesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-templates`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateDocumentTemplate: build.mutation<
      V2CreateDocumentTemplateApiResponse,
      V2CreateDocumentTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-templates`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetDocumentTemplate: build.query<
      V2GetDocumentTemplateApiResponse,
      V2GetDocumentTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-templates/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateDocumentTemplate: build.mutation<
      V2UpdateDocumentTemplateApiResponse,
      V2UpdateDocumentTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-templates/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteDocumentTemplate: build.mutation<
      V2DeleteDocumentTemplateApiResponse,
      V2DeleteDocumentTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-templates/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2RestoreDocumentTemplate: build.mutation<
      V2RestoreDocumentTemplateApiResponse,
      V2RestoreDocumentTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-templates/${queryArg.id}/restore-requests`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2GetFilenameFormatOptions: build.query<
      V2GetFilenameFormatOptionsApiResponse,
      V2GetFilenameFormatOptionsApiArg
    >({
      query: () => ({ url: `/v2/document-templates/filename-format-options` }),
    }),
    v2DownloadDocumentTemplate: build.query<
      V2DownloadDocumentTemplateApiResponse,
      V2DownloadDocumentTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-templates/${queryArg.id}/download`,
      }),
    }),
    v2UploadDocumentTemplate: build.mutation<
      V2UploadDocumentTemplateApiResponse,
      V2UploadDocumentTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/document-templates/${queryArg.id}/upload`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2CreateExecutiveSummaryRequest: build.mutation<
      V2CreateExecutiveSummaryRequestApiResponse,
      V2CreateExecutiveSummaryRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/executive-summary-requests`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetExecutiveSummaryRequest: build.query<
      V2GetExecutiveSummaryRequestApiResponse,
      V2GetExecutiveSummaryRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/executive-summary-requests/${queryArg.id}`,
      }),
    }),
    v2ListExpenseCategoriessForAccount: build.query<
      V2ListExpenseCategoriessForAccountApiResponse,
      V2ListExpenseCategoriessForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/expense-categories`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
          sort: queryArg.sort,
        },
      }),
    }),
    v2CreateExpenseCategory: build.mutation<
      V2CreateExpenseCategoryApiResponse,
      V2CreateExpenseCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/expense-categories`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetExpenseCategoryById: build.query<
      V2GetExpenseCategoryByIdApiResponse,
      V2GetExpenseCategoryByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/expense-categories/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateExpenseCategory: build.mutation<
      V2UpdateExpenseCategoryApiResponse,
      V2UpdateExpenseCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/expense-categories/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteExpenseCategory: build.mutation<
      V2DeleteExpenseCategoryApiResponse,
      V2DeleteExpenseCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/expense-categories/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListExternalRequestsForAccount: build.query<
      V2ListExternalRequestsForAccountApiResponse,
      V2ListExternalRequestsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external-requests`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2GetExternalRequest: build.query<
      V2GetExternalRequestApiResponse,
      V2GetExternalRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external-requests/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2AcceptExternalRequest: build.mutation<
      V2AcceptExternalRequestApiResponse,
      V2AcceptExternalRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external-requests/${queryArg.id}/acceptances`,
        method: "PUT",
      }),
    }),
    v2OfferExternalRequest: build.mutation<
      V2OfferExternalRequestApiResponse,
      V2OfferExternalRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external-requests/${queryArg.id}/offers`,
        method: "PUT",
      }),
    }),
    v2DeclineExternalRequest: build.mutation<
      V2DeclineExternalRequestApiResponse,
      V2DeclineExternalRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/external-requests/${queryArg.id}/declinations`,
        method: "PUT",
      }),
    }),
    v2ListFreeTrialsForAccount: build.query<
      V2ListFreeTrialsForAccountApiResponse,
      V2ListFreeTrialsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/free-trials`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreateFreeTrial: build.mutation<
      V2CreateFreeTrialApiResponse,
      V2CreateFreeTrialApiArg
    >({
      query: () => ({ url: `/v2/free-trials`, method: "POST" }),
    }),
    v2GetFreeTrial: build.query<
      V2GetFreeTrialApiResponse,
      V2GetFreeTrialApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/free-trials/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2CancelFreeTrial: build.mutation<
      V2CancelFreeTrialApiResponse,
      V2CancelFreeTrialApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/free-trials/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListGovernancesForAccount: build.query<
      V2ListGovernancesForAccountApiResponse,
      V2ListGovernancesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/governances`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateGovernance: build.mutation<
      V2CreateGovernanceApiResponse,
      V2CreateGovernanceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/governances`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetGovernanceById: build.query<
      V2GetGovernanceByIdApiResponse,
      V2GetGovernanceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/governances/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateGovernance: build.mutation<
      V2UpdateGovernanceApiResponse,
      V2UpdateGovernanceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/governances/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteGovernance: build.mutation<
      V2DeleteGovernanceApiResponse,
      V2DeleteGovernanceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/governances/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ChangeGovernancePositionById: build.mutation<
      V2ChangeGovernancePositionByIdApiResponse,
      V2ChangeGovernancePositionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/governances/${queryArg.id}/moves`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2RestoreGovernanceById: build.mutation<
      V2RestoreGovernanceByIdApiResponse,
      V2RestoreGovernanceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/governances/${queryArg.id}/restore-requests`,
        method: "PUT",
      }),
    }),
    v2PurgeGovernanceById: build.mutation<
      V2PurgeGovernanceByIdApiResponse,
      V2PurgeGovernanceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/governances/${queryArg.id}/purge-requests`,
        method: "DELETE",
      }),
    }),
    v2ListIntegratedProducts: build.query<
      V2ListIntegratedProductsApiResponse,
      V2ListIntegratedProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/integrated-products`,
        params: { filter: queryArg.filter, page: queryArg.page },
      }),
    }),
    v2ListIntegrationLogsForAccount: build.query<
      V2ListIntegrationLogsForAccountApiResponse,
      V2ListIntegrationLogsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-connections/${queryArg.accountConnectionId}/integration-logs`,
        params: { page: queryArg.page },
      }),
    }),
    v2GetIntegrationLog: build.query<
      V2GetIntegrationLogApiResponse,
      V2GetIntegrationLogApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/account-connections/${queryArg.accountConnectionId}/integration-logs/${queryArg.id}`,
      }),
    }),
    v2ListLandingPageContent: build.query<
      V2ListLandingPageContentApiResponse,
      V2ListLandingPageContentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/landing-page-contents`,
        params: { filter: queryArg.filter, page: queryArg.page },
      }),
    }),
    v2ListLanguageFieldsForAccount: build.query<
      V2ListLanguageFieldsForAccountApiResponse,
      V2ListLanguageFieldsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/language-fields`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2GetLanguageFieldById: build.query<
      V2GetLanguageFieldByIdApiResponse,
      V2GetLanguageFieldByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/language-fields/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2ChangeLanguageFieldPositionById: build.mutation<
      V2ChangeLanguageFieldPositionByIdApiResponse,
      V2ChangeLanguageFieldPositionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/language-fields/${queryArg.id}/moves`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2GetServiceLevelsOfEffort: build.query<
      V2GetServiceLevelsOfEffortApiResponse,
      V2GetServiceLevelsOfEffortApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.serviceId}/level-of-efforts`,
        params: { page: queryArg.page },
      }),
    }),
    v2CreateLevelOfEffortForService: build.mutation<
      V2CreateLevelOfEffortForServiceApiResponse,
      V2CreateLevelOfEffortForServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.serviceId}/level-of-efforts`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetServiceLevelOfEffort: build.query<
      V2GetServiceLevelOfEffortApiResponse,
      V2GetServiceLevelOfEffortApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.serviceId}/level-of-efforts/${queryArg.id}`,
        params: { page: queryArg.page },
      }),
    }),
    v2UpdateLevelOfEffortForService: build.mutation<
      V2UpdateLevelOfEffortForServiceApiResponse,
      V2UpdateLevelOfEffortForServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.serviceId}/level-of-efforts/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteLevelOfEffortFromService: build.mutation<
      V2DeleteLevelOfEffortFromServiceApiResponse,
      V2DeleteLevelOfEffortFromServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.serviceId}/level-of-efforts/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2GetSubserviceLevelsOfEffort: build.query<
      V2GetSubserviceLevelsOfEffortApiResponse,
      V2GetSubserviceLevelsOfEffortApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.subserviceId}/level-of-efforts`,
        params: { page: queryArg.page },
      }),
    }),
    v2CreateLevelOfEffortForSubservice: build.mutation<
      V2CreateLevelOfEffortForSubserviceApiResponse,
      V2CreateLevelOfEffortForSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.subserviceId}/level-of-efforts`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetSubserviceLevelOfEffort: build.query<
      V2GetSubserviceLevelOfEffortApiResponse,
      V2GetSubserviceLevelOfEffortApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.subserviceId}/level-of-efforts/${queryArg.id}`,
        params: { page: queryArg.page },
      }),
    }),
    v2UpdateLevelOfEffortForSubservice: build.mutation<
      V2UpdateLevelOfEffortForSubserviceApiResponse,
      V2UpdateLevelOfEffortForSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.subserviceId}/level-of-efforts/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteLevelOfEffortFromSubservice: build.mutation<
      V2DeleteLevelOfEffortFromSubserviceApiResponse,
      V2DeleteLevelOfEffortFromSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.subserviceId}/level-of-efforts/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListLineOfBusinessesForAccount: build.query<
      V2ListLineOfBusinessesForAccountApiResponse,
      V2ListLineOfBusinessesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/line-of-businesses`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateLineOfBusiness: build.mutation<
      V2CreateLineOfBusinessApiResponse,
      V2CreateLineOfBusinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/line-of-businesses`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetLineOfBusiness: build.query<
      V2GetLineOfBusinessApiResponse,
      V2GetLineOfBusinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/line-of-businesses/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateLineOfBusiness: build.mutation<
      V2UpdateLineOfBusinessApiResponse,
      V2UpdateLineOfBusinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/line-of-businesses/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteLineOfBusiness: build.mutation<
      V2DeleteLineOfBusinessApiResponse,
      V2DeleteLineOfBusinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/line-of-businesses/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2WhoAmI: build.query<V2WhoAmIApiResponse, V2WhoAmIApiArg>({
      query: () => ({ url: `/v2/me` }),
    }),
    v2ListNotes: build.query<V2ListNotesApiResponse, V2ListNotesApiArg>({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/notes`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreateNote: build.mutation<V2CreateNoteApiResponse, V2CreateNoteApiArg>({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/notes`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetNote: build.query<V2GetNoteApiResponse, V2GetNoteApiArg>({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/notes/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateNote: build.mutation<V2UpdateNoteApiResponse, V2UpdateNoteApiArg>({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/notes/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteNote: build.mutation<V2DeleteNoteApiResponse, V2DeleteNoteApiArg>({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/notes/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListOpenRouterKeysForAccount: build.query<
      V2ListOpenRouterKeysForAccountApiResponse,
      V2ListOpenRouterKeysForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/open-router-keys`,
        params: { page: queryArg.page },
      }),
    }),
    v2CreateOpenRouterKey: build.mutation<
      V2CreateOpenRouterKeyApiResponse,
      V2CreateOpenRouterKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/open-router-keys`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetOpenRouterKey: build.query<
      V2GetOpenRouterKeyApiResponse,
      V2GetOpenRouterKeyApiArg
    >({
      query: (queryArg) => ({ url: `/v2/open-router-keys/${queryArg.id}` }),
    }),
    v2UpdateOpenRouterKey: build.mutation<
      V2UpdateOpenRouterKeyApiResponse,
      V2UpdateOpenRouterKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/open-router-keys/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteOpenRouterKey: build.mutation<
      V2DeleteOpenRouterKeyApiResponse,
      V2DeleteOpenRouterKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/open-router-keys/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListPartnerRequestsForAccount: build.query<
      V2ListPartnerRequestsForAccountApiResponse,
      V2ListPartnerRequestsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/partner-requests`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreatePartnerRequest: build.mutation<
      V2CreatePartnerRequestApiResponse,
      V2CreatePartnerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/partner-requests`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetPartnerRequest: build.query<
      V2GetPartnerRequestApiResponse,
      V2GetPartnerRequestApiArg
    >({
      query: (queryArg) => ({ url: `/v2/partner-requests/${queryArg.id}` }),
    }),
    v2UpdatePartnerRequest: build.mutation<
      V2UpdatePartnerRequestApiResponse,
      V2UpdatePartnerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/partner-requests/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeletePartnerRequest: build.mutation<
      V2DeletePartnerRequestApiResponse,
      V2DeletePartnerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/partner-requests/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2CompletePartnerRequest: build.mutation<
      V2CompletePartnerRequestApiResponse,
      V2CompletePartnerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/partner-requests/${queryArg.id}/completions`,
        method: "PUT",
      }),
    }),
    v2RevisePartnerRequest: build.mutation<
      V2RevisePartnerRequestApiResponse,
      V2RevisePartnerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/partner-requests/${queryArg.id}/revisions`,
        method: "PUT",
      }),
    }),
    v2DeclinePartnerRequest: build.mutation<
      V2DeclinePartnerRequestApiResponse,
      V2DeclinePartnerRequestApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/partner-requests/${queryArg.id}/declinations`,
        method: "PUT",
      }),
    }),
    v2CountPartnerRequests: build.query<
      V2CountPartnerRequestsApiResponse,
      V2CountPartnerRequestsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/partner-requests/count`,
      }),
    }),
    v2ListPaymentCreditsForAccount: build.query<
      V2ListPaymentCreditsForAccountApiResponse,
      V2ListPaymentCreditsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/payment-credits`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreatePaymentCredit: build.mutation<
      V2CreatePaymentCreditApiResponse,
      V2CreatePaymentCreditApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/payment-credits`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetPaymentCredit: build.query<
      V2GetPaymentCreditApiResponse,
      V2GetPaymentCreditApiArg
    >({
      query: (queryArg) => ({ url: `/v2/payment-credits/${queryArg.id}` }),
    }),
    v2UpdatePaymentCredit: build.mutation<
      V2UpdatePaymentCreditApiResponse,
      V2UpdatePaymentCreditApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/payment-credits/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeletePaymentCredit: build.mutation<
      V2DeletePaymentCreditApiResponse,
      V2DeletePaymentCreditApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/payment-credits/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListPaymentTermsForAccount: build.query<
      V2ListPaymentTermsForAccountApiResponse,
      V2ListPaymentTermsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/payment-terms`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreatePaymentTerm: build.mutation<
      V2CreatePaymentTermApiResponse,
      V2CreatePaymentTermApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/payment-terms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetPaymentTerm: build.query<
      V2GetPaymentTermApiResponse,
      V2GetPaymentTermApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/payment-terms/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdatePaymentTerm: build.mutation<
      V2UpdatePaymentTermApiResponse,
      V2UpdatePaymentTermApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/payment-terms/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeletePaymentTerm: build.mutation<
      V2DeletePaymentTermApiResponse,
      V2DeletePaymentTermApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/payment-terms/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListPerformanceIndicatorsForAccount: build.query<
      V2ListPerformanceIndicatorsForAccountApiResponse,
      V2ListPerformanceIndicatorsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/performance-indicators`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreatePerformanceIndicator: build.mutation<
      V2CreatePerformanceIndicatorApiResponse,
      V2CreatePerformanceIndicatorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/performance-indicators`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetPerformanceIndicator: build.query<
      V2GetPerformanceIndicatorApiResponse,
      V2GetPerformanceIndicatorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/performance-indicators/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdatePerformanceIndicator: build.mutation<
      V2UpdatePerformanceIndicatorApiResponse,
      V2UpdatePerformanceIndicatorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/performance-indicators/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeletePerformanceIndicator: build.mutation<
      V2DeletePerformanceIndicatorApiResponse,
      V2DeletePerformanceIndicatorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/performance-indicators/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListPhasesForAccount: build.query<
      V2ListPhasesForAccountApiResponse,
      V2ListPhasesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/phases`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreatePhase: build.mutation<
      V2CreatePhaseApiResponse,
      V2CreatePhaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/phases`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetPhaseById: build.query<
      V2GetPhaseByIdApiResponse,
      V2GetPhaseByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/phases/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdatePhase: build.mutation<
      V2UpdatePhaseApiResponse,
      V2UpdatePhaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/phases/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeletePhase: build.mutation<
      V2DeletePhaseApiResponse,
      V2DeletePhaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/phases/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ChangePhasePositionById: build.mutation<
      V2ChangePhasePositionByIdApiResponse,
      V2ChangePhasePositionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/phases/${queryArg.id}/moves`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2RestorePhaseById: build.mutation<
      V2RestorePhaseByIdApiResponse,
      V2RestorePhaseByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/phases/${queryArg.id}/restore-requests`,
        method: "PUT",
      }),
    }),
    v2PurgePhaseById: build.mutation<
      V2PurgePhaseByIdApiResponse,
      V2PurgePhaseByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/phases/${queryArg.id}/purge-requests`,
        method: "DELETE",
      }),
    }),
    v2ListPresalesEngineersForAccount: build.query<
      V2ListPresalesEngineersForAccountApiResponse,
      V2ListPresalesEngineersForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/presales-engineers`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2GetPresalesEngineerById: build.query<
      V2GetPresalesEngineerByIdApiResponse,
      V2GetPresalesEngineerByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/presales-engineers/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2ListPricingAdjustmentsForAccount: build.query<
      V2ListPricingAdjustmentsForAccountApiResponse,
      V2ListPricingAdjustmentsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/pricing-adjustments`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreatePricingAdjustment: build.mutation<
      V2CreatePricingAdjustmentApiResponse,
      V2CreatePricingAdjustmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/pricing-adjustments`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetPricingAdjustmentById: build.query<
      V2GetPricingAdjustmentByIdApiResponse,
      V2GetPricingAdjustmentByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/pricing-adjustments/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdatePricingAdjustmentById: build.mutation<
      V2UpdatePricingAdjustmentByIdApiResponse,
      V2UpdatePricingAdjustmentByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/pricing-adjustments/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeletePricingAdjustmentById: build.mutation<
      V2DeletePricingAdjustmentByIdApiResponse,
      V2DeletePricingAdjustmentByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/pricing-adjustments/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListPrivileges: build.query<
      V2ListPrivilegesApiResponse,
      V2ListPrivilegesApiArg
    >({
      query: () => ({ url: `/v2/privileges` }),
    }),
    v2ListProductAccountingsForAccount: build.query<
      V2ListProductAccountingsForAccountApiResponse,
      V2ListProductAccountingsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.productId}/product-accountings`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreateProductAccounting: build.mutation<
      V2CreateProductAccountingApiResponse,
      V2CreateProductAccountingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.productId}/product-accountings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProductAccounting: build.query<
      V2GetProductAccountingApiResponse,
      V2GetProductAccountingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.productId}/product-accountings/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProductAccounting: build.mutation<
      V2UpdateProductAccountingApiResponse,
      V2UpdateProductAccountingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.productId}/product-accountings/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProductAccounting: build.mutation<
      V2DeleteProductAccountingApiResponse,
      V2DeleteProductAccountingApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.productId}/product-accountings/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListProductsForAccount: build.query<
      V2ListProductsForAccountApiResponse,
      V2ListProductsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProduct: build.mutation<
      V2CreateProductApiResponse,
      V2CreateProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProduct: build.query<V2GetProductApiResponse, V2GetProductApiArg>({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProduct: build.mutation<
      V2UpdateProductApiResponse,
      V2UpdateProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProduct: build.mutation<
      V2DeleteProductApiResponse,
      V2DeleteProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListProjectApprovalsForAccount: build.query<
      V2ListProjectApprovalsForAccountApiResponse,
      V2ListProjectApprovalsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-approvals`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectApproval: build.mutation<
      V2CreateProjectApprovalApiResponse,
      V2CreateProjectApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-approvals`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectApproval: build.query<
      V2GetProjectApprovalApiResponse,
      V2GetProjectApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-approvals/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectApproval: build.mutation<
      V2UpdateProjectApprovalApiResponse,
      V2UpdateProjectApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-approvals/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectApproval: build.mutation<
      V2DeleteProjectApprovalApiResponse,
      V2DeleteProjectApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-approvals/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ApproveProjectApprovalById: build.mutation<
      V2ApproveProjectApprovalByIdApiResponse,
      V2ApproveProjectApprovalByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-approvals/${queryArg.id}/approvals`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2CancelProjectApprovalById: build.mutation<
      V2CancelProjectApprovalByIdApiResponse,
      V2CancelProjectApprovalByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-approvals/${queryArg.id}/cancellations`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2DeclineProjectApprovalById: build.mutation<
      V2DeclineProjectApprovalByIdApiResponse,
      V2DeclineProjectApprovalByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-approvals/${queryArg.id}/declinations`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2RescopeProjectApprovalById: build.mutation<
      V2RescopeProjectApprovalByIdApiResponse,
      V2RescopeProjectApprovalByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-approvals/${queryArg.id}/rescope-requests`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2ListProjectAttachmentsForAccount: build.query<
      V2ListProjectAttachmentsForAccountApiResponse,
      V2ListProjectAttachmentsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-attachments`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectAttachment: build.mutation<
      V2CreateProjectAttachmentApiResponse,
      V2CreateProjectAttachmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-attachments`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectAttachmentById: build.query<
      V2GetProjectAttachmentByIdApiResponse,
      V2GetProjectAttachmentByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-attachments/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectAttachment: build.mutation<
      V2UpdateProjectAttachmentApiResponse,
      V2UpdateProjectAttachmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-attachments/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectAttachment: build.mutation<
      V2DeleteProjectAttachmentApiResponse,
      V2DeleteProjectAttachmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-attachments/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2CountProjectAttachments: build.query<
      V2CountProjectAttachmentsApiResponse,
      V2CountProjectAttachmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-attachments/count`,
      }),
    }),
    v2DownloadProjectAttachment: build.query<
      V2DownloadProjectAttachmentApiResponse,
      V2DownloadProjectAttachmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-attachments/${queryArg.id}/download`,
      }),
    }),
    v2UploadProjectAttachment: build.mutation<
      V2UploadProjectAttachmentApiResponse,
      V2UploadProjectAttachmentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-attachments/${queryArg.id}/upload`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2ListProjectCollaborators: build.query<
      V2ListProjectCollaboratorsApiResponse,
      V2ListProjectCollaboratorsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-collaborators`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectCollaborator: build.mutation<
      V2CreateProjectCollaboratorApiResponse,
      V2CreateProjectCollaboratorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-collaborators`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectCollaboratorById: build.query<
      V2GetProjectCollaboratorByIdApiResponse,
      V2GetProjectCollaboratorByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-collaborators/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectCollaborator: build.mutation<
      V2UpdateProjectCollaboratorApiResponse,
      V2UpdateProjectCollaboratorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-collaborators/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectCollaborator: build.mutation<
      V2DeleteProjectCollaboratorApiResponse,
      V2DeleteProjectCollaboratorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-collaborators/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2CountProjectCollaborators: build.query<
      V2CountProjectCollaboratorsApiResponse,
      V2CountProjectCollaboratorsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-collaborators/count`,
      }),
    }),
    v2ListProjectConditionsForAccount: build.query<
      V2ListProjectConditionsForAccountApiResponse,
      V2ListProjectConditionsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-conditions`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2GetProjectCondition: build.query<
      V2GetProjectConditionApiResponse,
      V2GetProjectConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-conditions/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectCondition: build.mutation<
      V2UpdateProjectConditionApiResponse,
      V2UpdateProjectConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-conditions/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectCondition: build.mutation<
      V2DeleteProjectConditionApiResponse,
      V2DeleteProjectConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-conditions/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2SkipProjectCondition: build.mutation<
      V2SkipProjectConditionApiResponse,
      V2SkipProjectConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-conditions/${queryArg.id}/skips`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2RestoreProjectCondition: build.mutation<
      V2RestoreProjectConditionApiResponse,
      V2RestoreProjectConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-conditions/${queryArg.id}/restore-requests`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2CountProjectConditions: build.query<
      V2CountProjectConditionsApiResponse,
      V2CountProjectConditionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-conditions/count`,
      }),
    }),
    v2ListProjectContacts: build.query<
      V2ListProjectContactsApiResponse,
      V2ListProjectContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-contacts`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectContact: build.mutation<
      V2CreateProjectContactApiResponse,
      V2CreateProjectContactApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-contacts`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectContact: build.query<
      V2GetProjectContactApiResponse,
      V2GetProjectContactApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-contacts/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectContact: build.mutation<
      V2UpdateProjectContactApiResponse,
      V2UpdateProjectContactApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-contacts/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectContact: build.mutation<
      V2DeleteProjectContactApiResponse,
      V2DeleteProjectContactApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-contacts/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2CountProjectContacts: build.query<
      V2CountProjectContactsApiResponse,
      V2CountProjectContactsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-contacts/count`,
      }),
    }),
    v2ListProjectCredits: build.query<
      V2ListProjectCreditsApiResponse,
      V2ListProjectCreditsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-credits`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectCredit: build.mutation<
      V2CreateProjectCreditApiResponse,
      V2CreateProjectCreditApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-credits`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectCreditById: build.query<
      V2GetProjectCreditByIdApiResponse,
      V2GetProjectCreditByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-credits/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectCredit: build.mutation<
      V2UpdateProjectCreditApiResponse,
      V2UpdateProjectCreditApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-credits/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectCredit: build.mutation<
      V2DeleteProjectCreditApiResponse,
      V2DeleteProjectCreditApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-credits/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListProjectDocumentsForAccount: build.query<
      V2ListProjectDocumentsForAccountApiResponse,
      V2ListProjectDocumentsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-documents`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectDocument: build.mutation<
      V2CreateProjectDocumentApiResponse,
      V2CreateProjectDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-documents`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectDocument: build.query<
      V2GetProjectDocumentApiResponse,
      V2GetProjectDocumentApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-documents/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2CreateProjectDuplication: build.mutation<
      V2CreateProjectDuplicationApiResponse,
      V2CreateProjectDuplicationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-duplications`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2ListProjectExpenses: build.query<
      V2ListProjectExpensesApiResponse,
      V2ListProjectExpensesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-expenses`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
          sort: queryArg.sort,
        },
      }),
    }),
    v2CreateProjectExpense: build.mutation<
      V2CreateProjectExpenseApiResponse,
      V2CreateProjectExpenseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-expenses`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectExpenseById: build.query<
      V2GetProjectExpenseByIdApiResponse,
      V2GetProjectExpenseByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-expenses/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectExpense: build.mutation<
      V2UpdateProjectExpenseApiResponse,
      V2UpdateProjectExpenseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-expenses/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectExpense: build.mutation<
      V2DeleteProjectExpenseApiResponse,
      V2DeleteProjectExpenseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-expenses/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2CountProjectExpenses: build.query<
      V2CountProjectExpensesApiResponse,
      V2CountProjectExpensesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-expenses/count`,
      }),
    }),
    v2ListProjectGovernances: build.query<
      V2ListProjectGovernancesApiResponse,
      V2ListProjectGovernancesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-governances`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectGovernance: build.mutation<
      V2CreateProjectGovernanceApiResponse,
      V2CreateProjectGovernanceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-governances`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectGovernanceById: build.query<
      V2GetProjectGovernanceByIdApiResponse,
      V2GetProjectGovernanceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-governances/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectGovernance: build.mutation<
      V2UpdateProjectGovernanceApiResponse,
      V2UpdateProjectGovernanceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-governances/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectGovernance: build.mutation<
      V2DeleteProjectGovernanceApiResponse,
      V2DeleteProjectGovernanceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-governances/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ChangeProjectGovernancePositionById: build.mutation<
      V2ChangeProjectGovernancePositionByIdApiResponse,
      V2ChangeProjectGovernancePositionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-governances/${queryArg.id}/moves`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2CountProjectGovernances: build.query<
      V2CountProjectGovernancesApiResponse,
      V2CountProjectGovernancesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-governances/count`,
      }),
    }),
    v2ListProjectLocations: build.query<
      V2ListProjectLocationsApiResponse,
      V2ListProjectLocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-locations`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectLocation: build.mutation<
      V2CreateProjectLocationApiResponse,
      V2CreateProjectLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-locations`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectLocationById: build.query<
      V2GetProjectLocationByIdApiResponse,
      V2GetProjectLocationByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-locations/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectLocation: build.mutation<
      V2UpdateProjectLocationApiResponse,
      V2UpdateProjectLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-locations/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectLocation: build.mutation<
      V2DeleteProjectLocationApiResponse,
      V2DeleteProjectLocationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-locations/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2CountProjectLocations: build.query<
      V2CountProjectLocationsApiResponse,
      V2CountProjectLocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-locations/count`,
      }),
    }),
    v2ListProjectPhasesForAccount: build.query<
      V2ListProjectPhasesForAccountApiResponse,
      V2ListProjectPhasesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-phases`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectPhase: build.mutation<
      V2CreateProjectPhaseApiResponse,
      V2CreateProjectPhaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-phases`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectPhaseById: build.query<
      V2GetProjectPhaseByIdApiResponse,
      V2GetProjectPhaseByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-phases/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectPhase: build.mutation<
      V2UpdateProjectPhaseApiResponse,
      V2UpdateProjectPhaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-phases/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectPhase: build.mutation<
      V2DeleteProjectPhaseApiResponse,
      V2DeleteProjectPhaseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-phases/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListProjectProductsForAccount: build.query<
      V2ListProjectProductsForAccountApiResponse,
      V2ListProjectProductsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-products`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          sort: queryArg.sort,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectProduct: build.mutation<
      V2CreateProjectProductApiResponse,
      V2CreateProjectProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-products`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectProduct: build.query<
      V2GetProjectProductApiResponse,
      V2GetProjectProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-products/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectProduct: build.mutation<
      V2UpdateProjectProductApiResponse,
      V2UpdateProjectProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-products/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectProduct: build.mutation<
      V2DeleteProjectProductApiResponse,
      V2DeleteProjectProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-products/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2CountProjectProducts: build.query<
      V2CountProjectProductsApiResponse,
      V2CountProjectProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-products/count`,
      }),
    }),
    v2ListProjectResourcesForAccount: build.query<
      V2ListProjectResourcesForAccountApiResponse,
      V2ListProjectResourcesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-resources`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectResource: build.mutation<
      V2CreateProjectResourceApiResponse,
      V2CreateProjectResourceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-resources`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectResource: build.query<
      V2GetProjectResourceApiResponse,
      V2GetProjectResourceApiArg
    >({
      query: (queryArg) => ({ url: `/v2/project-resources/${queryArg.id}` }),
    }),
    v2UpdateProjectResource: build.mutation<
      V2UpdateProjectResourceApiResponse,
      V2UpdateProjectResourceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-resources/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectResource: build.mutation<
      V2DeleteProjectResourceApiResponse,
      V2DeleteProjectResourceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-resources/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2CountProjectResources: build.query<
      V2CountProjectResourcesApiResponse,
      V2CountProjectResourcesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-resources/count`,
      }),
    }),
    v2ListProjectServices: build.query<
      V2ListProjectServicesApiResponse,
      V2ListProjectServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-services`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectService: build.mutation<
      V2CreateProjectServiceApiResponse,
      V2CreateProjectServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-services`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectServiceById: build.query<
      V2GetProjectServiceByIdApiResponse,
      V2GetProjectServiceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-services/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectService: build.mutation<
      V2UpdateProjectServiceApiResponse,
      V2UpdateProjectServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-services/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectService: build.mutation<
      V2DeleteProjectServiceApiResponse,
      V2DeleteProjectServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-services/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2DuplicateProjectServiceById: build.mutation<
      V2DuplicateProjectServiceByIdApiResponse,
      V2DuplicateProjectServiceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-services/${queryArg.id}/duplications`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2RefreshProjectServiceById: build.mutation<
      V2RefreshProjectServiceByIdApiResponse,
      V2RefreshProjectServiceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-services/${queryArg.id}/refresh-requests`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2SyncrhonizeStandardProjectServiceById: build.mutation<
      V2SyncrhonizeStandardProjectServiceByIdApiResponse,
      V2SyncrhonizeStandardProjectServiceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-services/${queryArg.id}/standard-synchronizations`,
        method: "POST",
      }),
    }),
    v2CountProjectServices: build.query<
      V2CountProjectServicesApiResponse,
      V2CountProjectServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-services/count`,
      }),
    }),
    v2ListProjectSubservices: build.query<
      V2ListProjectSubservicesApiResponse,
      V2ListProjectSubservicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-subservices`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectSubservice: build.mutation<
      V2CreateProjectSubserviceApiResponse,
      V2CreateProjectSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-subservices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectSubserviceById: build.query<
      V2GetProjectSubserviceByIdApiResponse,
      V2GetProjectSubserviceByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/project-subservices/${queryArg.id}` }),
    }),
    v2UpdateProjectSubservice: build.mutation<
      V2UpdateProjectSubserviceApiResponse,
      V2UpdateProjectSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-subservices/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectSubservice: build.mutation<
      V2DeleteProjectSubserviceApiResponse,
      V2DeleteProjectSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-subservices/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2SyncrhonizeStandardProjectSubserviceById: build.mutation<
      V2SyncrhonizeStandardProjectSubserviceByIdApiResponse,
      V2SyncrhonizeStandardProjectSubserviceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-subservices/${queryArg.id}/standard-synchronizations`,
        method: "POST",
      }),
    }),
    v2ListProjectSurveys: build.query<
      V2ListProjectSurveysApiResponse,
      V2ListProjectSurveysApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-surveys`,
        params: { page: queryArg.page },
      }),
    }),
    v2CountProjectSurveys: build.query<
      V2CountProjectSurveysApiResponse,
      V2CountProjectSurveysApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-surveys/count`,
      }),
    }),
    v2GetProjectSurvey: build.query<
      V2GetProjectSurveyApiResponse,
      V2GetProjectSurveyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-surveys/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2ListProjectVariables: build.query<
      V2ListProjectVariablesApiResponse,
      V2ListProjectVariablesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-variables`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectVariable: build.mutation<
      V2CreateProjectVariableApiResponse,
      V2CreateProjectVariableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-variables`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectVariableById: build.query<
      V2GetProjectVariableByIdApiResponse,
      V2GetProjectVariableByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-variables/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProjectVariable: build.mutation<
      V2UpdateProjectVariableApiResponse,
      V2UpdateProjectVariableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-variables/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProjectVariable: build.mutation<
      V2DeleteProjectVariableApiResponse,
      V2DeleteProjectVariableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-variables/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ChangeProjectVariablePositionById: build.mutation<
      V2ChangeProjectVariablePositionByIdApiResponse,
      V2ChangeProjectVariablePositionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-variables/${queryArg.id}/moves`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2RestoreProjectVariableById: build.mutation<
      V2RestoreProjectVariableByIdApiResponse,
      V2RestoreProjectVariableByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-variables/${queryArg.id}/restore-requests`,
        method: "PUT",
      }),
    }),
    v2PurgeProjectVariableById: build.mutation<
      V2PurgeProjectVariableByIdApiResponse,
      V2PurgeProjectVariableByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-variables/${queryArg.id}/purge-requests`,
        method: "DELETE",
      }),
    }),
    v2ListProjectVersions: build.query<
      V2ListProjectVersionsApiResponse,
      V2ListProjectVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-versions`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProjectVersion: build.mutation<
      V2CreateProjectVersionApiResponse,
      V2CreateProjectVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-versions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectVersionById: build.query<
      V2GetProjectVersionByIdApiResponse,
      V2GetProjectVersionByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/project-versions/${queryArg.id}` }),
    }),
    v2UpdateProjectVersion: build.mutation<
      V2UpdateProjectVersionApiResponse,
      V2UpdateProjectVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-versions/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2RevertProjectVersion: build.mutation<
      V2RevertProjectVersionApiResponse,
      V2RevertProjectVersionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/project-versions/${queryArg.id}/reverts`,
        method: "PUT",
      }),
    }),
    v2CountProjectVersions: build.query<
      V2CountProjectVersionsApiResponse,
      V2CountProjectVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/project-versions/count`,
      }),
    }),
    v2ListProjectsForAccount: build.query<
      V2ListProjectsForAccountApiResponse,
      V2ListProjectsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects`,
        params: {
          filter: queryArg.filter,
          sort: queryArg.sort,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateProject: build.mutation<
      V2CreateProjectApiResponse,
      V2CreateProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProjectById: build.query<
      V2GetProjectByIdApiResponse,
      V2GetProjectByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateProject: build.mutation<
      V2UpdateProjectApiResponse,
      V2UpdateProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteProject: build.mutation<
      V2DeleteProjectApiResponse,
      V2DeleteProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2PurgeProject: build.mutation<
      V2PurgeProjectApiResponse,
      V2PurgeProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}/purge-requests`,
        method: "DELETE",
      }),
    }),
    v2RemoveCrmIntegrationFromProject: build.mutation<
      V2RemoveCrmIntegrationFromProjectApiResponse,
      V2RemoveCrmIntegrationFromProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}/crm-integrations`,
        method: "DELETE",
      }),
    }),
    v2RequestApprovalForProjectById: build.mutation<
      V2RequestApprovalForProjectByIdApiResponse,
      V2RequestApprovalForProjectByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}/approval-requests`,
        method: "PUT",
      }),
    }),
    v2CancelApprovalRequestForProjectById: build.mutation<
      V2CancelApprovalRequestForProjectByIdApiResponse,
      V2CancelApprovalRequestForProjectByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}/approval-cancellations`,
        method: "PUT",
      }),
    }),
    v2RestartScopingForProjectById: build.mutation<
      V2RestartScopingForProjectByIdApiResponse,
      V2RestartScopingForProjectByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}/rescope-requests`,
        method: "PUT",
      }),
    }),
    v2UpdateProjectToWonById: build.mutation<
      V2UpdateProjectToWonByIdApiResponse,
      V2UpdateProjectToWonByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}/deal-wins`,
        method: "PUT",
      }),
    }),
    v2UpdateProjectToLostById: build.mutation<
      V2UpdateProjectToLostByIdApiResponse,
      V2UpdateProjectToLostByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}/deal-losses`,
        method: "PUT",
      }),
    }),
    v2SyncProjectRevenueToCrm: build.mutation<
      V2SyncProjectRevenueToCrmApiResponse,
      V2SyncProjectRevenueToCrmApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}/crm-synchronizations`,
        method: "POST",
      }),
    }),
    v2DuplicateProjectById: build.mutation<
      V2DuplicateProjectByIdApiResponse,
      V2DuplicateProjectByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}/duplications`,
        method: "POST",
      }),
    }),
    v2ExportProjects: build.mutation<
      V2ExportProjectsApiResponse,
      V2ExportProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/exports`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2UpdateTargetMargin: build.mutation<
      V2UpdateTargetMarginApiResponse,
      V2UpdateTargetMarginApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.id}/margin-settings`,
        method: "PUT",
      }),
    }),
    v2ProjectMergeData: build.query<
      V2ProjectMergeDataApiResponse,
      V2ProjectMergeDataApiArg
    >({
      query: (queryArg) => ({ url: `/v2/projects/${queryArg.id}/merge-data` }),
    }),
    v2ListPromptContentsForAccount: build.query<
      V2ListPromptContentsForAccountApiResponse,
      V2ListPromptContentsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/prompt-contents`,
        params: { page: queryArg.page },
      }),
    }),
    v2GetPromptContent: build.query<
      V2GetPromptContentApiResponse,
      V2GetPromptContentApiArg
    >({
      query: (queryArg) => ({ url: `/v2/prompt-contents/${queryArg.id}` }),
    }),
    v2ListPromptOverridesForAccount: build.query<
      V2ListPromptOverridesForAccountApiResponse,
      V2ListPromptOverridesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/prompt-overrides`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreatePromptOverride: build.mutation<
      V2CreatePromptOverrideApiResponse,
      V2CreatePromptOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/prompt-overrides`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetPromptOverride: build.query<
      V2GetPromptOverrideApiResponse,
      V2GetPromptOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/prompt-overrides/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdatePromptOverride: build.mutation<
      V2UpdatePromptOverrideApiResponse,
      V2UpdatePromptOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/prompt-overrides/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeletePromptOverride: build.mutation<
      V2DeletePromptOverrideApiResponse,
      V2DeletePromptOverrideApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/prompt-overrides/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListQuestionnaireSectionsForQuestionnaire: build.query<
      V2ListQuestionnaireSectionsForQuestionnaireApiResponse,
      V2ListQuestionnaireSectionsForQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-sections`,
        params: {
          sort: queryArg.sort,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateQuestionnaireSection: build.mutation<
      V2CreateQuestionnaireSectionApiResponse,
      V2CreateQuestionnaireSectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-sections`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetQuestionnaireSectionById: build.query<
      V2GetQuestionnaireSectionByIdApiResponse,
      V2GetQuestionnaireSectionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-sections/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateQuestionnaireSection: build.mutation<
      V2UpdateQuestionnaireSectionApiResponse,
      V2UpdateQuestionnaireSectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-sections/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteQuestionnaireSection: build.mutation<
      V2DeleteQuestionnaireSectionApiResponse,
      V2DeleteQuestionnaireSectionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-sections/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListQuestionnairesForAccount: build.query<
      V2ListQuestionnairesForAccountApiResponse,
      V2ListQuestionnairesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires`,
        params: {
          filter: queryArg.filter,
          sort: queryArg.sort,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateQuestionnaire: build.mutation<
      V2CreateQuestionnaireApiResponse,
      V2CreateQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetQuestionnaireById: build.query<
      V2GetQuestionnaireByIdApiResponse,
      V2GetQuestionnaireByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateQuestionnaire: build.mutation<
      V2UpdateQuestionnaireApiResponse,
      V2UpdateQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteQuestionnaire: build.mutation<
      V2DeleteQuestionnaireApiResponse,
      V2DeleteQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2EvaluateQuestionnaire: build.mutation<
      V2EvaluateQuestionnaireApiResponse,
      V2EvaluateQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.id}/evaluate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2ListQuestionsForQuestionnaire: build.query<
      V2ListQuestionsForQuestionnaireApiResponse,
      V2ListQuestionsForQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questions`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateQuestion: build.mutation<
      V2CreateQuestionApiResponse,
      V2CreateQuestionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetQuestionById: build.query<
      V2GetQuestionByIdApiResponse,
      V2GetQuestionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questions/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateQuestion: build.mutation<
      V2UpdateQuestionApiResponse,
      V2UpdateQuestionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questions/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteQuestion: build.mutation<
      V2DeleteQuestionApiResponse,
      V2DeleteQuestionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questions/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListQuestionnaireCalculationsForQuestionnaire: build.query<
      V2ListQuestionnaireCalculationsForQuestionnaireApiResponse,
      V2ListQuestionnaireCalculationsForQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-calculations`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateQuestionnaireCalculation: build.mutation<
      V2CreateQuestionnaireCalculationApiResponse,
      V2CreateQuestionnaireCalculationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-calculations`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetQuestionnaireCalculationById: build.query<
      V2GetQuestionnaireCalculationByIdApiResponse,
      V2GetQuestionnaireCalculationByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-calculations/${queryArg.id}`,
      }),
    }),
    v2UpdateQuestionnaireCalculation: build.mutation<
      V2UpdateQuestionnaireCalculationApiResponse,
      V2UpdateQuestionnaireCalculationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-calculations/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteQuestionnaireCalculation: build.mutation<
      V2DeleteQuestionnaireCalculationApiResponse,
      V2DeleteQuestionnaireCalculationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-calculations/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListQuestionnaireLookupsForQuestionnaire: build.query<
      V2ListQuestionnaireLookupsForQuestionnaireApiResponse,
      V2ListQuestionnaireLookupsForQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-lookups`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateQuestionnaireLookup: build.mutation<
      V2CreateQuestionnaireLookupApiResponse,
      V2CreateQuestionnaireLookupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-lookups`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetQuestionnaireLookupById: build.query<
      V2GetQuestionnaireLookupByIdApiResponse,
      V2GetQuestionnaireLookupByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-lookups/${queryArg.id}`,
      }),
    }),
    v2UpdateQuestionnaireLookup: build.mutation<
      V2UpdateQuestionnaireLookupApiResponse,
      V2UpdateQuestionnaireLookupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-lookups/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteQuestionnaireLookup: build.mutation<
      V2DeleteQuestionnaireLookupApiResponse,
      V2DeleteQuestionnaireLookupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-lookups/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListQuestionnaireRecommendationsForQuestionnaire: build.query<
      V2ListQuestionnaireRecommendationsForQuestionnaireApiResponse,
      V2ListQuestionnaireRecommendationsForQuestionnaireApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-recommendations`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateQuestionnaireRecommendation: build.mutation<
      V2CreateQuestionnaireRecommendationApiResponse,
      V2CreateQuestionnaireRecommendationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-recommendations`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetQuestionnaireRecommendationById: build.query<
      V2GetQuestionnaireRecommendationByIdApiResponse,
      V2GetQuestionnaireRecommendationByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-recommendations/${queryArg.id}`,
      }),
    }),
    v2UpdateQuestionnaireRecommendation: build.mutation<
      V2UpdateQuestionnaireRecommendationApiResponse,
      V2UpdateQuestionnaireRecommendationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-recommendations/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteQuestionnaireRecommendation: build.mutation<
      V2DeleteQuestionnaireRecommendationApiResponse,
      V2DeleteQuestionnaireRecommendationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/questionnaires/${queryArg.questionnaireId}/questionnaire-recommendations/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListQuotesForAccount: build.query<
      V2ListQuotesForAccountApiResponse,
      V2ListQuotesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/quotes`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateQuote: build.mutation<
      V2CreateQuoteApiResponse,
      V2CreateQuoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/quotes`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetQuote: build.query<V2GetQuoteApiResponse, V2GetQuoteApiArg>({
      query: (queryArg) => ({
        url: `/v2/quotes/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateQuote: build.mutation<
      V2UpdateQuoteApiResponse,
      V2UpdateQuoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/quotes/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
        params: { include: queryArg.include },
      }),
    }),
    v2DeleteQuote: build.mutation<
      V2DeleteQuoteApiResponse,
      V2DeleteQuoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/quotes/${queryArg.id}`,
        method: "DELETE",
        params: { include: queryArg.include },
      }),
    }),
    v2RecalculateQuote: build.mutation<
      V2RecalculateQuoteApiResponse,
      V2RecalculateQuoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/quotes/${queryArg.id}/recalculations`,
        method: "POST",
      }),
    }),
    v2AcceptVendorDocumentForQuote: build.mutation<
      V2AcceptVendorDocumentForQuoteApiResponse,
      V2AcceptVendorDocumentForQuoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/quotes/${queryArg.id}/document-acceptances`,
        method: "PUT",
      }),
    }),
    v2CountQuotes: build.query<V2CountQuotesApiResponse, V2CountQuotesApiArg>({
      query: (queryArg) => ({
        url: `/v2/projects/${queryArg.projectId}/quotes/count`,
      }),
    }),
    v2ListRateTablesForAccount: build.query<
      V2ListRateTablesForAccountApiResponse,
      V2ListRateTablesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/rate-tables`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateRateTable: build.mutation<
      V2CreateRateTableApiResponse,
      V2CreateRateTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/rate-tables`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetRateTable: build.query<
      V2GetRateTableApiResponse,
      V2GetRateTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/rate-tables/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateRateTable: build.mutation<
      V2UpdateRateTableApiResponse,
      V2UpdateRateTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/rate-tables/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteRateTable: build.mutation<
      V2DeleteRateTableApiResponse,
      V2DeleteRateTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/rate-tables/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2DuplicateRateTable: build.mutation<
      V2DuplicateRateTableApiResponse,
      V2DuplicateRateTableApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/rate-tables/${queryArg.id}/duplications`,
        method: "POST",
      }),
    }),
    v2ListReleaseFlags: build.query<
      V2ListReleaseFlagsApiResponse,
      V2ListReleaseFlagsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/release-flags`,
        params: {
          sort: queryArg.sort,
          filter: queryArg.filter,
          page: queryArg.page,
        },
      }),
    }),
    v2CreateReleaseFlag: build.mutation<
      V2CreateReleaseFlagApiResponse,
      V2CreateReleaseFlagApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/release-flags`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetReleaseFlag: build.query<
      V2GetReleaseFlagApiResponse,
      V2GetReleaseFlagApiArg
    >({
      query: (queryArg) => ({ url: `/v2/release-flags/${queryArg.id}` }),
    }),
    v2UpdateReleaseFlag: build.mutation<
      V2UpdateReleaseFlagApiResponse,
      V2UpdateReleaseFlagApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/release-flags/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteReleaseFlag: build.mutation<
      V2DeleteReleaseFlagApiResponse,
      V2DeleteReleaseFlagApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/release-flags/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListResourceAllocations: build.query<
      V2ListResourceAllocationsApiResponse,
      V2ListResourceAllocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-allocations`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreateResourceAllocation: build.mutation<
      V2CreateResourceAllocationApiResponse,
      V2CreateResourceAllocationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-allocations`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetResourceAllocationById: build.query<
      V2GetResourceAllocationByIdApiResponse,
      V2GetResourceAllocationByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/resource-allocations/${queryArg.id}` }),
    }),
    v2UpdateResourceAllocation: build.mutation<
      V2UpdateResourceAllocationApiResponse,
      V2UpdateResourceAllocationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-allocations/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteResourceAllocation: build.mutation<
      V2DeleteResourceAllocationApiResponse,
      V2DeleteResourceAllocationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-allocations/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListResourcePlans: build.query<
      V2ListResourcePlansApiResponse,
      V2ListResourcePlansApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-plans`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateResourcePlan: build.mutation<
      V2CreateResourcePlanApiResponse,
      V2CreateResourcePlanApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-plans`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetResourcePlanById: build.query<
      V2GetResourcePlanByIdApiResponse,
      V2GetResourcePlanByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/resource-plans/${queryArg.id}` }),
    }),
    v2UpdateResourcePlan: build.mutation<
      V2UpdateResourcePlanApiResponse,
      V2UpdateResourcePlanApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-plans/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteResourcePlan: build.mutation<
      V2DeleteResourcePlanApiResponse,
      V2DeleteResourcePlanApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-plans/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2DuplicateResourcePlan: build.mutation<
      V2DuplicateResourcePlanApiResponse,
      V2DuplicateResourcePlanApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-plans/${queryArg.id}/duplications`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2ListResourceRatesForAccount: build.query<
      V2ListResourceRatesForAccountApiResponse,
      V2ListResourceRatesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-rates`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateResourceRate: build.mutation<
      V2CreateResourceRateApiResponse,
      V2CreateResourceRateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-rates`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetResourceRateById: build.query<
      V2GetResourceRateByIdApiResponse,
      V2GetResourceRateByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/resource-rates/${queryArg.id}` }),
    }),
    v2UpdateResourceRate: build.mutation<
      V2UpdateResourceRateApiResponse,
      V2UpdateResourceRateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-rates/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteResourceRate: build.mutation<
      V2DeleteResourceRateApiResponse,
      V2DeleteResourceRateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resource-rates/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListResourcesForAccount: build.query<
      V2ListResourcesForAccountApiResponse,
      V2ListResourcesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resources`,
        params: {
          filter: queryArg.filter,
          include: queryArg.include,
          page: queryArg.page,
        },
      }),
    }),
    v2CreateResource: build.mutation<
      V2CreateResourceApiResponse,
      V2CreateResourceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resources`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetResourceById: build.query<
      V2GetResourceByIdApiResponse,
      V2GetResourceByIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/resources/${queryArg.id}` }),
    }),
    v2UpdateResource: build.mutation<
      V2UpdateResourceApiResponse,
      V2UpdateResourceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resources/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteResource: build.mutation<
      V2DeleteResourceApiResponse,
      V2DeleteResourceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/resources/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListRolesForAccount: build.query<
      V2ListRolesForAccountApiResponse,
      V2ListRolesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/roles`,
        params: {
          filter: queryArg.filter,
          sort: queryArg.sort,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateRole: build.mutation<V2CreateRoleApiResponse, V2CreateRoleApiArg>({
      query: (queryArg) => ({
        url: `/v2/roles`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetRole: build.query<V2GetRoleApiResponse, V2GetRoleApiArg>({
      query: (queryArg) => ({
        url: `/v2/roles/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateRole: build.mutation<V2UpdateRoleApiResponse, V2UpdateRoleApiArg>({
      query: (queryArg) => ({
        url: `/v2/roles/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteRole: build.mutation<V2DeleteRoleApiResponse, V2DeleteRoleApiArg>({
      query: (queryArg) => ({
        url: `/v2/roles/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListSalesExecutivesForAccount: build.query<
      V2ListSalesExecutivesForAccountApiResponse,
      V2ListSalesExecutivesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/sales-executives`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateSalesExecutive: build.mutation<
      V2CreateSalesExecutiveApiResponse,
      V2CreateSalesExecutiveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/sales-executives`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetSalesExecutiveById: build.query<
      V2GetSalesExecutiveByIdApiResponse,
      V2GetSalesExecutiveByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/sales-executives/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateSalesExecutive: build.mutation<
      V2UpdateSalesExecutiveApiResponse,
      V2UpdateSalesExecutiveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/sales-executives/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteSalesExecutive: build.mutation<
      V2DeleteSalesExecutiveApiResponse,
      V2DeleteSalesExecutiveApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/sales-executives/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListServiceCategorysForAccount: build.query<
      V2ListServiceCategorysForAccountApiResponse,
      V2ListServiceCategorysForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/service-categories`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
          sort: queryArg.sort,
        },
      }),
    }),
    v2GetServiceCategory: build.query<
      V2GetServiceCategoryApiResponse,
      V2GetServiceCategoryApiArg
    >({
      query: (queryArg) => ({ url: `/v2/service-categories/${queryArg.id}` }),
    }),
    v2ListServiceConditionsForAccount: build.query<
      V2ListServiceConditionsForAccountApiResponse,
      V2ListServiceConditionsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/service-conditions`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateServiceCondition: build.mutation<
      V2CreateServiceConditionApiResponse,
      V2CreateServiceConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/service-conditions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetServiceCondition: build.query<
      V2GetServiceConditionApiResponse,
      V2GetServiceConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/service-conditions/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateServiceCondition: build.mutation<
      V2UpdateServiceConditionApiResponse,
      V2UpdateServiceConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/service-conditions/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteServiceCondition: build.mutation<
      V2DeleteServiceConditionApiResponse,
      V2DeleteServiceConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/service-conditions/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListServicesForAccount: build.query<
      V2ListServicesForAccountApiResponse,
      V2ListServicesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services`,
        params: {
          filter: queryArg.filter,
          sort: queryArg.sort,
          include: queryArg.include,
          page: queryArg.page,
        },
      }),
    }),
    v2CreateService: build.mutation<
      V2CreateServiceApiResponse,
      V2CreateServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetServiceById: build.query<
      V2GetServiceByIdApiResponse,
      V2GetServiceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateService: build.mutation<
      V2UpdateServiceApiResponse,
      V2UpdateServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteService: build.mutation<
      V2DeleteServiceApiResponse,
      V2DeleteServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ActivateService: build.mutation<
      V2ActivateServiceApiResponse,
      V2ActivateServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.id}/activations`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2RestoreService: build.mutation<
      V2RestoreServiceApiResponse,
      V2RestoreServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.id}/undos`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2ChangeServicePositionById: build.mutation<
      V2ChangeServicePositionByIdApiResponse,
      V2ChangeServicePositionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.id}/move-to`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DuplicateService: build.mutation<
      V2DuplicateServiceApiResponse,
      V2DuplicateServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.id}/duplications`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2DownloadService: build.mutation<
      V2DownloadServiceApiResponse,
      V2DownloadServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.id}/downloads`,
        method: "POST",
      }),
    }),
    v2DownloadListOfServices: build.mutation<
      V2DownloadListOfServicesApiResponse,
      V2DownloadListOfServicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/downloads`,
        method: "POST",
        params: { filter: queryArg.filter },
      }),
    }),
    v2GetSharedSurveyById: build.query<
      V2GetSharedSurveyByIdApiResponse,
      V2GetSharedSurveyByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/shared-surveys/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateSharedSurvey: build.mutation<
      V2UpdateSharedSurveyApiResponse,
      V2UpdateSharedSurveyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/shared-surveys/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2ListSubcontractorsForAccount: build.query<
      V2ListSubcontractorsForAccountApiResponse,
      V2ListSubcontractorsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subcontractors`,
        params: { page: queryArg.page },
      }),
    }),
    v2GetSubcontractor: build.query<
      V2GetSubcontractorApiResponse,
      V2GetSubcontractorApiArg
    >({
      query: (queryArg) => ({ url: `/v2/subcontractors/${queryArg.id}` }),
    }),
    v2ListSubscriptionsForAccount: build.query<
      V2ListSubscriptionsForAccountApiResponse,
      V2ListSubscriptionsForAccountApiArg
    >({
      query: () => ({ url: `/v2/subscriptions` }),
    }),
    v2CreateSubscription: build.mutation<
      V2CreateSubscriptionApiResponse,
      V2CreateSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subscriptions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetSubscription: build.query<
      V2GetSubscriptionApiResponse,
      V2GetSubscriptionApiArg
    >({
      query: (queryArg) => ({ url: `/v2/subscriptions/${queryArg.id}` }),
    }),
    v2UpdateSubscription: build.mutation<
      V2UpdateSubscriptionApiResponse,
      V2UpdateSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subscriptions/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteSubscription: build.mutation<
      V2DeleteSubscriptionApiResponse,
      V2DeleteSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subscriptions/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListSubservicesForAccount: build.query<
      V2ListSubservicesForAccountApiResponse,
      V2ListSubservicesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateSubservice: build.mutation<
      V2CreateSubserviceApiResponse,
      V2CreateSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetSubserviceById: build.query<
      V2GetSubserviceByIdApiResponse,
      V2GetSubserviceByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateSubservice: build.mutation<
      V2UpdateSubserviceApiResponse,
      V2UpdateSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteSubservice: build.mutation<
      V2DeleteSubserviceApiResponse,
      V2DeleteSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ActivateSubservice: build.mutation<
      V2ActivateSubserviceApiResponse,
      V2ActivateSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.id}/activations`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    v2ChangeSubservicePositionById: build.mutation<
      V2ChangeSubservicePositionByIdApiResponse,
      V2ChangeSubservicePositionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.id}/moves`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2ListSurveyRecommendationsForAccount: build.query<
      V2ListSurveyRecommendationsForAccountApiResponse,
      V2ListSurveyRecommendationsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/survey-recommendations`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2GetSurveyRecommendationById: build.query<
      V2GetSurveyRecommendationByIdApiResponse,
      V2GetSurveyRecommendationByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/survey-recommendations/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateSurveyRecommendation: build.mutation<
      V2UpdateSurveyRecommendationApiResponse,
      V2UpdateSurveyRecommendationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/survey-recommendations/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteSurveyRecommendation: build.mutation<
      V2DeleteSurveyRecommendationApiResponse,
      V2DeleteSurveyRecommendationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/survey-recommendations/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ApplySurveyRecommendation: build.mutation<
      V2ApplySurveyRecommendationApiResponse,
      V2ApplySurveyRecommendationApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/survey-recommendations/${queryArg.id}/applications`,
        method: "PUT",
      }),
    }),
    v2ListSurveyResponsesForAccount: build.query<
      V2ListSurveyResponsesForAccountApiResponse,
      V2ListSurveyResponsesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/survey-responses`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateSurveyResponse: build.mutation<
      V2CreateSurveyResponseApiResponse,
      V2CreateSurveyResponseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/survey-responses`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetSurveyResponseById: build.query<
      V2GetSurveyResponseByIdApiResponse,
      V2GetSurveyResponseByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/survey-responses/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateSurveyResponse: build.mutation<
      V2UpdateSurveyResponseApiResponse,
      V2UpdateSurveyResponseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/survey-responses/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteSurveyResponse: build.mutation<
      V2DeleteSurveyResponseApiResponse,
      V2DeleteSurveyResponseApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/survey-responses/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListSurveysForAccount: build.query<
      V2ListSurveysForAccountApiResponse,
      V2ListSurveysForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/surveys`,
        params: {
          filter: queryArg.filter,
          sort: queryArg.sort,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateSurvey: build.mutation<
      V2CreateSurveyApiResponse,
      V2CreateSurveyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/surveys`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetSurveyById: build.query<
      V2GetSurveyByIdApiResponse,
      V2GetSurveyByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/surveys/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateSurvey: build.mutation<
      V2UpdateSurveyApiResponse,
      V2UpdateSurveyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/surveys/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteSurvey: build.mutation<
      V2DeleteSurveyApiResponse,
      V2DeleteSurveyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/surveys/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2CalculateSurveyRecommendations: build.mutation<
      V2CalculateSurveyRecommendationsApiResponse,
      V2CalculateSurveyRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/surveys/${queryArg.id}/calculations`,
        method: "PUT",
      }),
    }),
    v2ApplySurveyRecommendations: build.mutation<
      V2ApplySurveyRecommendationsApiResponse,
      V2ApplySurveyRecommendationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/surveys/${queryArg.id}/applications`,
        method: "PUT",
      }),
    }),
    v2ShareSurvey: build.mutation<
      V2ShareSurveyApiResponse,
      V2ShareSurveyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/surveys/${queryArg.id}/shares`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2ListTagsForAccount: build.query<
      V2ListTagsForAccountApiResponse,
      V2ListTagsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/tags`,
        params: { page: queryArg.page, filter: queryArg.filter },
      }),
    }),
    v2GetTag: build.query<V2GetTagApiResponse, V2GetTagApiArg>({
      query: (queryArg) => ({ url: `/v2/tags/${queryArg.id}` }),
    }),
    v2GetServiceTaskRates: build.query<
      V2GetServiceTaskRatesApiResponse,
      V2GetServiceTaskRatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.serviceId}/task-rates`,
        params: { page: queryArg.page },
      }),
    }),
    v2CreateTaskRateForService: build.mutation<
      V2CreateTaskRateForServiceApiResponse,
      V2CreateTaskRateForServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.serviceId}/task-rates`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetServiceTaskRate: build.query<
      V2GetServiceTaskRateApiResponse,
      V2GetServiceTaskRateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.serviceId}/task-rates/${queryArg.id}`,
        params: { page: queryArg.page },
      }),
    }),
    v2UpdateTaskRateForService: build.mutation<
      V2UpdateTaskRateForServiceApiResponse,
      V2UpdateTaskRateForServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.serviceId}/task-rates/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteTaskRateFromService: build.mutation<
      V2DeleteTaskRateFromServiceApiResponse,
      V2DeleteTaskRateFromServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/services/${queryArg.serviceId}/task-rates/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2GetSubserviceTaskRates: build.query<
      V2GetSubserviceTaskRatesApiResponse,
      V2GetSubserviceTaskRatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.subserviceId}/task-rates`,
        params: { page: queryArg.page },
      }),
    }),
    v2CreateTaskRateForSubservice: build.mutation<
      V2CreateTaskRateForSubserviceApiResponse,
      V2CreateTaskRateForSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.subserviceId}/task-rates`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetSubserviceTaskRate: build.query<
      V2GetSubserviceTaskRateApiResponse,
      V2GetSubserviceTaskRateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.subserviceId}/task-rates/${queryArg.id}`,
        params: { page: queryArg.page },
      }),
    }),
    v2UpdateTaskRateForSubservice: build.mutation<
      V2UpdateTaskRateForSubserviceApiResponse,
      V2UpdateTaskRateForSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.subserviceId}/task-rates/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteTaskRateFromSubservice: build.mutation<
      V2DeleteTaskRateFromSubserviceApiResponse,
      V2DeleteTaskRateFromSubserviceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/subservices/${queryArg.subserviceId}/task-rates/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2GetProductTaskRates: build.query<
      V2GetProductTaskRatesApiResponse,
      V2GetProductTaskRatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.productId}/task-rates`,
        params: { page: queryArg.page },
      }),
    }),
    v2CreateTaskRateForProduct: build.mutation<
      V2CreateTaskRateForProductApiResponse,
      V2CreateTaskRateForProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.productId}/task-rates`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetProductTaskRate: build.query<
      V2GetProductTaskRateApiResponse,
      V2GetProductTaskRateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.productId}/task-rates/${queryArg.id}`,
        params: { page: queryArg.page },
      }),
    }),
    v2UpdateTaskRateForProduct: build.mutation<
      V2UpdateTaskRateForProductApiResponse,
      V2UpdateTaskRateForProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.productId}/task-rates/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteTaskRateFromProduct: build.mutation<
      V2DeleteTaskRateFromProductApiResponse,
      V2DeleteTaskRateFromProductApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/products/${queryArg.productId}/task-rates/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListTeamsForAccount: build.query<
      V2ListTeamsForAccountApiResponse,
      V2ListTeamsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/teams`,
        params: {
          page: queryArg.page,
          include: queryArg.include,
          filter: queryArg.filter,
        },
      }),
    }),
    v2CreateTeam: build.mutation<V2CreateTeamApiResponse, V2CreateTeamApiArg>({
      query: (queryArg) => ({
        url: `/v2/teams`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetTeam: build.query<V2GetTeamApiResponse, V2GetTeamApiArg>({
      query: (queryArg) => ({
        url: `/v2/teams/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateTeam: build.mutation<V2UpdateTeamApiResponse, V2UpdateTeamApiArg>({
      query: (queryArg) => ({
        url: `/v2/teams/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteTeam: build.mutation<V2DeleteTeamApiResponse, V2DeleteTeamApiArg>({
      query: (queryArg) => ({
        url: `/v2/teams/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListTextBlocksForAccount: build.query<
      V2ListTextBlocksForAccountApiResponse,
      V2ListTextBlocksForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/text-blocks`,
        params: {
          sort: queryArg.sort,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateTextBlock: build.mutation<
      V2CreateTextBlockApiResponse,
      V2CreateTextBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/text-blocks`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetTextBlock: build.query<
      V2GetTextBlockApiResponse,
      V2GetTextBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/text-blocks/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateTextBlock: build.mutation<
      V2UpdateTextBlockApiResponse,
      V2UpdateTextBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/text-blocks/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteTextBlock: build.mutation<
      V2DeleteTextBlockApiResponse,
      V2DeleteTextBlockApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/text-blocks/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListThirdPartyServicesForAccount: build.query<
      V2ListThirdPartyServicesForAccountApiResponse,
      V2ListThirdPartyServicesForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/third-party-services`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateThirdPartyService: build.mutation<
      V2CreateThirdPartyServiceApiResponse,
      V2CreateThirdPartyServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/third-party-services`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetThirdPartyService: build.query<
      V2GetThirdPartyServiceApiResponse,
      V2GetThirdPartyServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/third-party-services/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateThirdPartyService: build.mutation<
      V2UpdateThirdPartyServiceApiResponse,
      V2UpdateThirdPartyServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/third-party-services/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteThirdPartyService: build.mutation<
      V2DeleteThirdPartyServiceApiResponse,
      V2DeleteThirdPartyServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/third-party-services/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2MoveThirdPartyService: build.mutation<
      V2MoveThirdPartyServiceApiResponse,
      V2MoveThirdPartyServiceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/third-party-services/${queryArg.id}/moves`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getV2UserFavorites: build.query<
      GetV2UserFavoritesApiResponse,
      GetV2UserFavoritesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-favorites`,
        params: { filter: queryArg.filter },
      }),
    }),
    v2CreateUserFavorite: build.mutation<
      V2CreateUserFavoriteApiResponse,
      V2CreateUserFavoriteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-favorites`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2DeleteUserFavorite: build.mutation<
      V2DeleteUserFavoriteApiResponse,
      V2DeleteUserFavoriteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-favorites/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListUserFiltersForAccount: build.query<
      V2ListUserFiltersForAccountApiResponse,
      V2ListUserFiltersForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-filters`,
        params: { filter: queryArg.filter },
      }),
    }),
    v2CreateUserFilter: build.mutation<
      V2CreateUserFilterApiResponse,
      V2CreateUserFilterApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-filters`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetUserFilter: build.query<
      V2GetUserFilterApiResponse,
      V2GetUserFilterApiArg
    >({
      query: (queryArg) => ({ url: `/v2/user-filters/${queryArg.id}` }),
    }),
    v2UpdateUserFilter: build.mutation<
      V2UpdateUserFilterApiResponse,
      V2UpdateUserFilterApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-filters/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteUserFilter: build.mutation<
      V2DeleteUserFilterApiResponse,
      V2DeleteUserFilterApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-filters/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListUserFlagValues: build.query<
      V2ListUserFlagValuesApiResponse,
      V2ListUserFlagValuesApiArg
    >({
      query: () => ({ url: `/v2/user-flag-values` }),
    }),
    v2GetUserFlagValue: build.query<
      V2GetUserFlagValueApiResponse,
      V2GetUserFlagValueApiArg
    >({
      query: (queryArg) => ({ url: `/v2/user-flag-values/${queryArg.id}` }),
    }),
    v2UpdateUserFlagValue: build.mutation<
      V2UpdateUserFlagValueApiResponse,
      V2UpdateUserFlagValueApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-flag-values/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteUserFlagValue: build.mutation<
      V2DeleteUserFlagValueApiResponse,
      V2DeleteUserFlagValueApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-flag-values/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListUserViewsForAccount: build.query<
      V2ListUserViewsForAccountApiResponse,
      V2ListUserViewsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-views`,
        params: { filter: queryArg.filter, include: queryArg.include },
      }),
    }),
    v2CreateUserView: build.mutation<
      V2CreateUserViewApiResponse,
      V2CreateUserViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-views`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetUserView: build.query<V2GetUserViewApiResponse, V2GetUserViewApiArg>({
      query: (queryArg) => ({
        url: `/v2/user-views/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateUserView: build.mutation<
      V2UpdateUserViewApiResponse,
      V2UpdateUserViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-views/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteUserView: build.mutation<
      V2DeleteUserViewApiResponse,
      V2DeleteUserViewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/user-views/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListUsersForAccount: build.query<
      V2ListUsersForAccountApiResponse,
      V2ListUsersForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateUser: build.mutation<V2CreateUserApiResponse, V2CreateUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/users`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2ShowCurrentUserForAccount: build.query<
      V2ShowCurrentUserForAccountApiResponse,
      V2ShowCurrentUserForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/current`,
        params: { include: queryArg.include },
      }),
    }),
    v2GetUser: build.query<V2GetUserApiResponse, V2GetUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateUser: build.mutation<V2UpdateUserApiResponse, V2UpdateUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteUser: build.mutation<V2DeleteUserApiResponse, V2DeleteUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ResetUserFilters: build.mutation<
      V2ResetUserFiltersApiResponse,
      V2ResetUserFiltersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.id}/filter-resets`,
        method: "PUT",
      }),
    }),
    v2UnlockUser: build.mutation<V2UnlockUserApiResponse, V2UnlockUserApiArg>({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.id}/user-unlocks`,
        method: "PUT",
      }),
    }),
    v2ListServiceAccountCredentials: build.query<
      V2ListServiceAccountCredentialsApiResponse,
      V2ListServiceAccountCredentialsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.userId}/service-account-credentials`,
        params: { page: queryArg.page },
      }),
    }),
    v2CreateServiceAccountCredential: build.mutation<
      V2CreateServiceAccountCredentialApiResponse,
      V2CreateServiceAccountCredentialApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.userId}/service-account-credentials`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetServiceAccountCredential: build.query<
      V2GetServiceAccountCredentialApiResponse,
      V2GetServiceAccountCredentialApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.userId}/service-account-credentials/${queryArg.id}`,
      }),
    }),
    v2UpdateServiceAccountCredential: build.mutation<
      V2UpdateServiceAccountCredentialApiResponse,
      V2UpdateServiceAccountCredentialApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.userId}/service-account-credentials/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteServiceAccountCredential: build.mutation<
      V2DeleteServiceAccountCredentialApiResponse,
      V2DeleteServiceAccountCredentialApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.userId}/service-account-credentials/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2RotateServiceAccountCredential: build.mutation<
      V2RotateServiceAccountCredentialApiResponse,
      V2RotateServiceAccountCredentialApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/users/${queryArg.userId}/service-account-credentials/${queryArg.serviceAccountCredentialId}/rotations`,
        method: "POST",
      }),
    }),
    v2ListVendorsForAccount: build.query<
      V2ListVendorsForAccountApiResponse,
      V2ListVendorsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/vendors`,
        params: {
          filter: queryArg.filter,
          page: queryArg.page,
          include: queryArg.include,
        },
      }),
    }),
    v2CreateVendor: build.mutation<
      V2CreateVendorApiResponse,
      V2CreateVendorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/vendors`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetVendor: build.query<V2GetVendorApiResponse, V2GetVendorApiArg>({
      query: (queryArg) => ({ url: `/v2/vendors/${queryArg.id}` }),
    }),
    v2UpdateVendor: build.mutation<
      V2UpdateVendorApiResponse,
      V2UpdateVendorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/vendors/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteVendor: build.mutation<
      V2DeleteVendorApiResponse,
      V2DeleteVendorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/vendors/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListSpecialConditionsForVendor: build.query<
      V2ListSpecialConditionsForVendorApiResponse,
      V2ListSpecialConditionsForVendorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/vendors/${queryArg.vendorId}/special-conditions`,
        params: { page: queryArg.page, include: queryArg.include },
      }),
    }),
    v2CreateSpecialConditionForVendor: build.mutation<
      V2CreateSpecialConditionForVendorApiResponse,
      V2CreateSpecialConditionForVendorApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/vendors/${queryArg.vendorId}/special-conditions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetVendorSpecialConditionById: build.query<
      V2GetVendorSpecialConditionByIdApiResponse,
      V2GetVendorSpecialConditionByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/vendors/${queryArg.vendorId}/special-conditions/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateVendorSpecialCondition: build.mutation<
      V2UpdateVendorSpecialConditionApiResponse,
      V2UpdateVendorSpecialConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/vendors/${queryArg.vendorId}/special-conditions/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteVendorSpecialCondition: build.mutation<
      V2DeleteVendorSpecialConditionApiResponse,
      V2DeleteVendorSpecialConditionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/vendors/${queryArg.vendorId}/special-conditions/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    v2ListWebhookSubscriptionsForAccount: build.query<
      V2ListWebhookSubscriptionsForAccountApiResponse,
      V2ListWebhookSubscriptionsForAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/webhook-subscriptions`,
        params: { include: queryArg.include, page: queryArg.page },
      }),
    }),
    v2CreateWebhookSubscription: build.mutation<
      V2CreateWebhookSubscriptionApiResponse,
      V2CreateWebhookSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/webhook-subscriptions`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    v2GetWebhookSubscription: build.query<
      V2GetWebhookSubscriptionApiResponse,
      V2GetWebhookSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/webhook-subscriptions/${queryArg.id}`,
        params: { include: queryArg.include },
      }),
    }),
    v2UpdateWebhookSubscription: build.mutation<
      V2UpdateWebhookSubscriptionApiResponse,
      V2UpdateWebhookSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/webhook-subscriptions/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    v2DeleteWebhookSubscription: build.mutation<
      V2DeleteWebhookSubscriptionApiResponse,
      V2DeleteWebhookSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/webhook-subscriptions/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedV2 };
export type V2ListAccountConnectionsApiResponse =
  /** status 200 Acount Connection response */ {
    data?: V2AccountConnectionResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListAccountConnectionsApiArg = {
  filter?: {
    active?: boolean;
    products?: boolean;
    crm?: boolean;
  };
};
export type V2CreateAccountConnectionApiResponse =
  /** status 201 Create Account Connection response */ {
    data?: V2AccountConnectionResource;
  };
export type V2CreateAccountConnectionApiArg = {
  body: {
    data?: V2AccountConnectionResource;
  };
};
export type V2GetAccountConnectionApiResponse =
  /** status 200 Project response */ {
    data?: V2AccountConnectionResource;
    included?: V2AccountResource[];
  };
export type V2GetAccountConnectionApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each account-connection */
  include?: "account"[];
};
export type V2UpdateAccountConnectionApiResponse =
  /** status 200 Update Account Connection response */ {
    data?: V2AccountConnectionResource;
  };
export type V2UpdateAccountConnectionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2AccountConnectionResource;
  };
};
export type V2DeleteAccountConnectionApiResponse =
  /** status 204 The Delete Account Connection was deleted successfully */ undefined;
export type V2DeleteAccountConnectionApiArg = {
  /** ID of record */
  id: number;
};
export type V2ReconnectAccountConnectionApiResponse =
  /** status 200 Update Account Connection response */ {
    data?: V2AccountConnectionResource;
  };
export type V2ReconnectAccountConnectionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2AccountConnectionResource;
  };
};
export type V2EnableAccountConnectionApiResponse =
  /** status 200 Update Account Connection response */ {
    data?: V2AccountConnectionResource;
  };
export type V2EnableAccountConnectionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2AccountConnectionResource;
  };
};
export type V2DisableAccountConnectionApiResponse =
  /** status 200 Update Account Connection response */ {
    data?: V2AccountConnectionResource;
  };
export type V2DisableAccountConnectionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2AccountConnectionResource;
  };
};
export type V2GetAccountFinancialsApiResponse =
  /** status 200 Project response */ {
    data?: V2AccountFinancialResource;
  };
export type V2GetAccountFinancialsApiArg = void;
export type V2ListAccountFlagValuesApiResponse =
  /** status 200 Account flag value list response */ {
    data?: V2AccountFlagValueResource[];
  };
export type V2ListAccountFlagValuesApiArg = void;
export type V2GetAccountFlagValueApiResponse =
  /** status 200 Account flag value response */ {
    data?: V2AccountFlagValueResource;
  };
export type V2GetAccountFlagValueApiArg = {
  /** The LaunchDarkly flag key */
  id: string;
};
export type V2UpdateAccountFlagValueApiResponse =
  /** status 200 Account flag value updated */ {
    data?: V2AccountFlagValueResource;
  };
export type V2UpdateAccountFlagValueApiArg = {
  /** The LaunchDarkly flag key */
  id: string;
  body: {
    data?: V2AccountFlagValueResource;
  };
};
export type V2DeleteAccountFlagValueApiResponse =
  /** status 204 Account flag override cleared */ undefined;
export type V2DeleteAccountFlagValueApiArg = {
  /** The LaunchDarkly flag key */
  id: string;
};
export type V2ListAccountHealthSnapshotsApiResponse =
  /** status 200 Account health snapshot list response */ {
    data?: V2AccountHealthSnapshotResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListAccountHealthSnapshotsApiArg = {
  filter?: {
    account?: string;
    "week-start"?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be sideloaded with each snapshot */
  include?: "account"[];
};
export type V2GetAccountHealthSnapshotApiResponse =
  /** status 200 Account health snapshot response */ {
    data?: V2AccountHealthSnapshotResource;
    included?: V2AccountResource[];
  };
export type V2GetAccountHealthSnapshotApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be sideloaded with the snapshot */
  include?: "account"[];
};
export type V2GetAccountLogoApiResponse = /** status 200 Project response */ {
  data?: V2AccountLogoResource;
};
export type V2GetAccountLogoApiArg = void;
export type V2UpdateAccountLogoApiResponse =
  /** status 200 Update AccountLogo response */ {
    data?: V2AccountLogoResource;
  };
export type V2UpdateAccountLogoApiArg = {
  body: {
    data?: V2AccountLogoResource;
  };
};
export type V2ListAccountsApiResponse = /** status 200 Account response */ {
  data?: V2AccountResource;
  included?: (
    | V2BusinessUnitResource
    | V2ClientResource
    | V2CrmOpportunityResource
    | V2DocumentTemplateResource
    | V2GovernanceResource
    | V2LineOfBusinessResource
    | V2PaymentCreditResource
    | V2PaymentTermResource
    | V2PhaseResource
    | V2ProductResource
    | V2ProjectVariableResource
    | V2ProjectResource
    | V2RateTableResource
    | V2ResourceResource
    | V2ServiceResource
    | V2RoleResource
    | V2TeamResource
    | V2UserResource
  )[];
};
export type V2ListAccountsApiArg = {
  /** Associated data that may be loaded with the account */
  include?: (
    | "business-units"
    | "clients"
    | "crm-opportunities"
    | "document-templates"
    | "governances"
    | "line-of-businesses"
    | "payment-credits"
    | "payment-terms"
    | "phases"
    | "products"
    | "project-variables"
    | "projects"
    | "rate-tables"
    | "resources"
    | "services"
    | "roles"
    | "teams"
    | "users"
  )[];
};
export type V2CreateAccountApiResponse =
  /** status 201 Create account response */ {
    data?: V2AccountResource;
  };
export type V2CreateAccountApiArg = {
  body: {
    data?: V2AccountResource;
  };
};
export type V2GetAccountApiResponse = /** status 200 Account response */ {
  data?: V2AccountResource;
  included?: (
    | V2BusinessUnitResource
    | V2ClientResource
    | V2CrmOpportunityResource
    | V2DocumentTemplateResource
    | V2GovernanceResource
    | V2LineOfBusinessResource
    | V2PaymentCreditResource
    | V2PaymentTermResource
    | V2PhaseResource
    | V2ProductResource
    | V2ProjectVariableResource
    | V2ProjectResource
    | V2RateTableResource
    | V2ResourceResource
    | V2ServiceResource
    | V2RoleResource
    | V2TeamResource
    | V2UserResource
  )[];
};
export type V2GetAccountApiArg = {
  /** Associated data that may be loaded with the account */
  include?: (
    | "business-units"
    | "clients"
    | "crm-opportunities"
    | "document-templates"
    | "governances"
    | "line-of-businesses"
    | "payment-credits"
    | "payment-terms"
    | "phases"
    | "products"
    | "project-variables"
    | "projects"
    | "rate-tables"
    | "resources"
    | "services"
    | "roles"
    | "teams"
    | "users"
  )[];
};
export type V2ListApprovalLevelsForAccountApiResponse =
  /** status 200 Approval Level list response */ {
    data?: V2ApprovalLevelResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListApprovalLevelsForAccountApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
  filter?: {
    active?: boolean;
    kind?: ("business" | "technical" | "sales")[];
  };
  /** Associated data that may be loaded with each approval level */
  include?: "account"[];
};
export type V2CreateApprovalLevelApiResponse =
  /** status 201 Create Approval Level response */ {
    data?: V2ApprovalLevelResource;
  };
export type V2CreateApprovalLevelApiArg = {
  body: {
    data?: V2ApprovalLevelResource;
  };
};
export type V2GetApprovalLevelApiResponse =
  /** status 200 Approval Level response */ {
    data?: V2ApprovalLevelResource;
    included?: V2AccountResource[];
  };
export type V2GetApprovalLevelApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each approval level */
  include?: "account"[];
};
export type V2UpdateApprovalLevelApiResponse =
  /** status 200 Update Approval Level response */ {
    data?: V2ApprovalLevelResource;
  };
export type V2UpdateApprovalLevelApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ApprovalLevelResource;
  };
};
export type V2DeleteApprovalLevelApiResponse =
  /** status 204 The Approval Level was deleted successfully */ undefined;
export type V2DeleteApprovalLevelApiArg = {
  /** ID of record */
  id: number;
};
export type V2ChangeApprovalLevelPositionByIdApiResponse =
  /** status 200 Find Approval Level by ID response */ {
    data?: V2ApprovalLevelResource;
  };
export type V2ChangeApprovalLevelPositionByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ApprovalLevelResource;
  };
};
export type V2RestoreApprovalLevelByIdApiResponse =
  /** status 200 Restored Approval Level response */ {
    data?: V2ApprovalLevelResource;
  };
export type V2RestoreApprovalLevelByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2PurgeApprovalLevelByIdApiResponse =
  /** status 204 The Approval Level was purged successfully */ undefined;
export type V2PurgeApprovalLevelByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2ConsolidateTechnicalApprovalLevelsApiResponse =
  /** status 200 The surviving consolidated Approval Level */
    | {
        data?: V2ApprovalLevelResource;
      }
    | /** status 204 The account has no technical approval levels; nothing to consolidate */ undefined;
export type V2ConsolidateTechnicalApprovalLevelsApiArg = void;
export type V2ListLobApprovalsForAccountApiResponse =
  /** status 200 LOB Approval list response */ {
    data?: V2LobApprovalResource[];
    included?: (V2LobResource | V2LobApprovalUserResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListLobApprovalsForAccountApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each LOB approval */
  include?: ("section" | "lob-approval-users")[];
};
export type V2CreateLobApprovalApiResponse =
  /** status 201 Create LOB Approval response */ {
    data?: V2LobApprovalResource;
  };
export type V2CreateLobApprovalApiArg = {
  body: {
    data?: V2LobApprovalResource;
  };
};
export type V2GetLobApprovalApiResponse =
  /** status 200 LOB Approval response */ {
    data?: V2LobApprovalResource;
    included?: (V2LobResource | V2LobApprovalUserResource)[];
  };
export type V2GetLobApprovalApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with the LOB approval */
  include?: ("section" | "lob-approval-users")[];
};
export type V2UpdateLobApprovalApiResponse =
  /** status 200 Update LOB Approval response */ {
    data?: V2LobApprovalResource;
  };
export type V2UpdateLobApprovalApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2LobApprovalResource;
  };
};
export type V2DeleteLobApprovalApiResponse =
  /** status 204 The LOB Approval was deleted successfully */ undefined;
export type V2DeleteLobApprovalApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListLobApprovalUsersForAccountApiResponse =
  /** status 200 LOB Approval User list response */ {
    data?: V2LobApprovalUserResource[];
    included?: V2LobApprovalResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListLobApprovalUsersForAccountApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each LOB approval user */
  include?: "lob-approval"[];
};
export type V2CreateLobApprovalUserApiResponse =
  /** status 201 Create LOB Approval User response */ {
    data?: V2LobApprovalUserResource;
  };
export type V2CreateLobApprovalUserApiArg = {
  body: {
    data?: V2LobApprovalUserResource;
  };
};
export type V2GetLobApprovalUserApiResponse =
  /** status 200 LOB Approval User response */ {
    data?: V2LobApprovalUserResource;
    included?: V2LobApprovalResource[];
  };
export type V2GetLobApprovalUserApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with the LOB approval user */
  include?: "lob-approval"[];
};
export type V2UpdateLobApprovalUserApiResponse =
  /** status 200 Update LOB Approval User response */ {
    data?: V2LobApprovalUserResource;
  };
export type V2UpdateLobApprovalUserApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2LobApprovalUserResource;
  };
};
export type V2DeleteLobApprovalUserApiResponse =
  /** status 204 The LOB Approval User was deleted successfully */ undefined;
export type V2DeleteLobApprovalUserApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListApprovalStepsForAccountApiResponse =
  /** status 200 Approval Step list response */ {
    data?: V2ApprovalStepResource[];
    included?: (
      | V2ProjectResource
      | V2ProjectVersionResource
      | V2ProjectApprovalResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListApprovalStepsForAccountApiArg = {
  filter?: {
    project?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each approval step */
  include?: ("project" | "project-version" | "project-approvals")[];
};
export type V2GetApprovalStepApiResponse = /** status 200 Project response */ {
  data?: V2ApprovalStepResource;
  included?: (
    | V2ProjectResource
    | V2ProjectVersionResource
    | V2ProjectApprovalResource
  )[];
};
export type V2GetApprovalStepApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each approval step */
  include?: ("project" | "project-version" | "project-approvals")[];
};
export type V2ListAttachmentTypesForAccountApiResponse =
  /** status 200 Attachment Type list response */ {
    data?: V2AttachmentTypeResource[];
    included?: (V2AccountResource | V2ProjectAttachmentResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListAttachmentTypesForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each attachment type */
  include?: ("account" | "project-attachments")[];
};
export type V2CreateAttachmentTypeApiResponse =
  /** status 201 Create Attachment Type response */ {
    data?: V2AttachmentTypeResource;
  };
export type V2CreateAttachmentTypeApiArg = {
  body: {
    data?: V2AttachmentTypeResource;
  };
};
export type V2GetAttachmentTypeApiResponse =
  /** status 200 Project response */ {
    data?: V2AttachmentTypeResource;
    included?: (V2AccountResource | V2ProjectAttachmentResource)[];
  };
export type V2GetAttachmentTypeApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each attachment type */
  include?: ("account" | "project-attachments")[];
};
export type V2UpdateAttachmentTypeApiResponse =
  /** status 200 Update Attachment Type response */ {
    data?: V2AttachmentTypeResource;
  };
export type V2UpdateAttachmentTypeApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2AttachmentTypeResource;
  };
};
export type V2DeleteAttachmentTypeApiResponse =
  /** status 204 The Delete Attachment Type was deleted successfully */ undefined;
export type V2DeleteAttachmentTypeApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListAuditLogsApiResponse =
  /** status 200 Audit Log list response */ {
    data?: V2AuditLogResource[];
    links?: V2Paging;
  };
export type V2ListAuditLogsApiArg = {
  filter?: {
    project?: string;
    "context-type"?: string;
    "context-id"?: string;
    after?: string;
    before?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: ("created-at" | "-created-at")[];
};
export type V2ListProjectAuditLogsApiResponse =
  /** status 200 Audit Log list response */ {
    data?: V2AuditLogResource[];
    links?: V2Paging;
  };
export type V2ListProjectAuditLogsApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  filter?: {
    after?: string;
    before?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: ("created-at" | "-created-at")[];
};
export type V2GetAuditLogByIdApiResponse =
  /** status 200 Audit log response */ {
    data?: V2AuditLogResource;
  };
export type V2GetAuditLogByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2RevertAuditLogByIdApiResponse =
  /** status 204 Audit log object was successfulll reverted to its prior state */ undefined;
export type V2RevertAuditLogByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListBlueprintsForAccountApiResponse =
  /** status 200 Blueprint list response */ {
    data?: V2BlueprintResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListBlueprintsForAccountApiArg = {
  filter?: {
    name?: string;
    tag_list?: string;
    "service-id"?: string;
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "name"
    | "-name"
    | "code"
    | "-code"
    | "tag-list"
    | "-tag-list"
    | "executive-summary"
    | "-executive-summary"
    | "solution-summary"
    | "-solution-summary"
    | "payload"
    | "-payload"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each blueprint */
  include?: ("account" | "blueprint-items.resource")[];
};
export type V2CreateBlueprintApiResponse =
  /** status 201 Create Blueprint response */ {
    data?: V2BlueprintResource;
  };
export type V2CreateBlueprintApiArg = {
  body: {
    data?: V2BlueprintResource;
  };
};
export type V2GetBlueprintApiResponse = /** status 200 Project response */ {
  data?: V2BlueprintResource;
  included?: V2AccountResource[];
};
export type V2GetBlueprintApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each blueprint */
  include?: "account"[];
};
export type V2UpdateBlueprintApiResponse =
  /** status 200 Update Blueprint response */ {
    data?: V2BlueprintResource;
  };
export type V2UpdateBlueprintApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2BlueprintResource;
  };
};
export type V2DeleteBlueprintApiResponse =
  /** status 204 The Delete Blueprint was deleted successfully */ undefined;
export type V2DeleteBlueprintApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListBusinessUnitsForAccountApiResponse =
  /** status 200 Business Unit list response */ {
    data?: V2BusinessUnitResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListBusinessUnitsForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each business unit */
  include?: "account"[];
};
export type V2CreateBusinessUnitApiResponse =
  /** status 201 Create BusinessUnit response */ {
    data?: V2BusinessUnitResource;
  };
export type V2CreateBusinessUnitApiArg = {
  body: {
    data?: V2BusinessUnitResource;
  };
};
export type V2GetBusinessUnitApiResponse = /** status 200 Project response */ {
  data?: V2BusinessUnitResource;
  included?: V2AccountResource[];
};
export type V2GetBusinessUnitApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each business unit */
  include?: "account"[];
};
export type V2UpdateBusinessUnitApiResponse =
  /** status 200 Update BusinessUnit response */ {
    data?: V2BusinessUnitResource;
  };
export type V2UpdateBusinessUnitApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2BusinessUnitResource;
  };
};
export type V2DeleteBusinessUnitApiResponse =
  /** status 204 The business unit was deleted successfully */ undefined;
export type V2DeleteBusinessUnitApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListSpecialConditionsForBusinessUnitApiResponse =
  /** status 200 special condition list response */ {
    data?: V2SpecialConditionResource[];
    links?: V2Paging;
  };
export type V2ListSpecialConditionsForBusinessUnitApiArg = {
  /** ID of business unit record */
  businessUnitId: number;
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each business unit */
  include?: ("owner" | "service-condition")[];
};
export type V2CreateSpecialConditionForBusinessUnitApiResponse =
  /** status 201 Create special condition response */ {
    data?: V2SpecialConditionResource;
  };
export type V2CreateSpecialConditionForBusinessUnitApiArg = {
  /** ID of business unit record */
  businessUnitId: number;
  body: {
    data?: V2SpecialConditionResource;
  };
};
export type V2GetBusinessUnitSpecialConditionByIdApiResponse =
  /** status 200 Find special condition by ID response */ {
    data?: V2SpecialConditionResource;
  };
export type V2GetBusinessUnitSpecialConditionByIdApiArg = {
  /** ID of business unit record */
  businessUnitId: number;
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each business unit */
  include?: ("owner" | "service-condition")[];
};
export type V2UpdateBusinessUnitSpecialConditionApiResponse =
  /** status 200 Update business unit special condition response */ {
    data?: V2SpecialConditionResource;
  };
export type V2UpdateBusinessUnitSpecialConditionApiArg = {
  /** ID of business unit record */
  businessUnitId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2SpecialConditionResource;
  };
};
export type V2DeleteBusinessUnitSpecialConditionApiResponse =
  /** status 204 The special condition was deleted successfully */ undefined;
export type V2DeleteBusinessUnitSpecialConditionApiArg = {
  /** ID of business unit record */
  businessUnitId: number;
  /** ID of record */
  id: number;
};
export type V2ListClientsForAccountApiResponse =
  /** status 200 Client list response */ {
    data?: V2ClientResource[];
    included?: (V2AccountResource | V2RateTableResource | V2ContactResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListClientsForAccountApiArg = {
  filter?: {
    name?: string;
    domain?: string;
    id?: string;
    active?: boolean;
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "active"
    | "-active"
    | "name"
    | "-name"
    | "msa-date"
    | "-msa-date"
    | "domain"
    | "-domain"
    | "user-defined-fields"
    | "-user-defined-fields"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each client */
  include?: ("account" | "rate-table" | "contacts")[];
};
export type V2CreateClientApiResponse =
  /** status 201 Create Client response */ {
    data?: V2ClientResource;
  };
export type V2CreateClientApiArg = {
  body: {
    data?: V2ClientResource;
  };
};
export type V2GetClientApiResponse = /** status 200 Project response */ {
  data?: V2ClientResource;
  included?: (V2AccountResource | V2RateTableResource | V2ContactResource)[];
};
export type V2GetClientApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each client */
  include?: ("account" | "rate-table" | "contacts")[];
};
export type V2UpdateClientApiResponse =
  /** status 200 Update Client response */ {
    data?: V2ClientResource;
  };
export type V2UpdateClientApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ClientResource;
  };
};
export type V2DeleteClientApiResponse =
  /** status 204 The client was deleted successfully */ undefined;
export type V2DeleteClientApiArg = {
  /** ID of record */
  id: number;
};
export type V2DownloadClientsCsvApiResponse =
  /** status 200 CSV file of active clients */ string;
export type V2DownloadClientsCsvApiArg = void;
export type V2MergeClientRecordsApiResponse =
  /** status 204 Clients successfully merged */ undefined;
export type V2MergeClientRecordsApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: {
      id?: number;
      type?: string;
      attributes?: {
        "client-id"?: number;
      };
    };
  };
};
export type V2ListContactsForClientApiResponse =
  /** status 200 contact list response */ {
    data?: V2ContactResource[];
    links?: V2Paging;
  };
export type V2ListContactsForClientApiArg = {
  /** ID of client record */
  clientId: number;
  filter?: {
    name?: string;
    email?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateContactForClientApiResponse =
  /** status 201 Create contact response */ {
    data?: V2ContactResource;
  };
export type V2CreateContactForClientApiArg = {
  /** ID of client record */
  clientId: number;
  body: {
    data?: V2ContactResource;
  };
};
export type V2GetClientContactByIdApiResponse =
  /** status 200 Find contact by ID response */ {
    data?: V2ContactResource;
  };
export type V2GetClientContactByIdApiArg = {
  /** ID of client record */
  clientId: number;
  /** ID of record */
  id: number;
};
export type V2UpdateClientContactApiResponse =
  /** status 200 Update client contact response */ {
    data?: V2ContactResource;
  };
export type V2UpdateClientContactApiArg = {
  /** ID of client record */
  clientId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2ContactResource;
  };
};
export type V2DeleteClientContactApiResponse =
  /** status 204 The Delete contact was deleted successfully */ undefined;
export type V2DeleteClientContactApiArg = {
  /** ID of client record */
  clientId: number;
  /** ID of record */
  id: number;
};
export type V2ListSpecialConditionsForClientApiResponse =
  /** status 200 special condition list response */ {
    data?: V2SpecialConditionResource[];
    links?: V2Paging;
  };
export type V2ListSpecialConditionsForClientApiArg = {
  /** ID of client record */
  clientId: number;
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each client */
  include?: ("owner" | "service-condition")[];
};
export type V2CreateSpecialConditionForClientApiResponse =
  /** status 201 Create special condition response */ {
    data?: V2SpecialConditionResource;
  };
export type V2CreateSpecialConditionForClientApiArg = {
  /** ID of client record */
  clientId: number;
  body: {
    data?: V2SpecialConditionResource;
  };
};
export type V2GetClientSpecialConditionByIdApiResponse =
  /** status 200 Find special condition by ID response */ {
    data?: V2SpecialConditionResource;
  };
export type V2GetClientSpecialConditionByIdApiArg = {
  /** ID of client record */
  clientId: number;
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each client */
  include?: ("owner" | "service-condition")[];
};
export type V2UpdateClientSpecialConditionApiResponse =
  /** status 200 Update client special condition response */ {
    data?: V2SpecialConditionResource;
  };
export type V2UpdateClientSpecialConditionApiArg = {
  /** ID of client record */
  clientId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2SpecialConditionResource;
  };
};
export type V2DeleteClientSpecialConditionApiResponse =
  /** status 204 The special condition was deleted successfully */ undefined;
export type V2DeleteClientSpecialConditionApiArg = {
  /** ID of client record */
  clientId: number;
  /** ID of record */
  id: number;
};
export type V2ListCollaboratorsForAccountApiResponse =
  /** status 200 Collaborator list response */ {
    data?: V2CollaboratorResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListCollaboratorsForAccountApiArg = {
  filter?: {
    name?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each collaborator */
  include?: "account"[];
};
export type V2GetCollaboratorByIdApiResponse =
  /** status 200 Find collaborator by ID response */ {
    data?: V2CollaboratorResource;
    included?: V2AccountResource[];
  };
export type V2GetCollaboratorByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each collaborator */
  include?: "account"[];
};
export type V2ListConnectedAppApiResponse =
  /** status 200 ConnectedApps collection response */ {
    data?: V2ConnectedAppResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListConnectedAppApiArg = void;
export type V2ListContactsForAccountApiResponse =
  /** status 200 contact list response */ {
    data?: V2ContactResource[];
    links?: V2Paging;
  };
export type V2ListContactsForAccountApiArg = {
  filter?: {
    name?: string;
    email?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateContactApiResponse =
  /** status 201 Create contact response */ {
    data?: V2ContactResource;
  };
export type V2CreateContactApiArg = {
  body: {
    data?: V2ContactResource;
  };
};
export type V2GetContactByIdApiResponse =
  /** status 200 Find contact by ID response */ {
    data?: V2ContactResource;
  };
export type V2GetContactByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateContactApiResponse =
  /** status 200 Update contact response */ {
    data?: V2ContactResource;
  };
export type V2UpdateContactApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ContactResource;
  };
};
export type V2DeleteContactApiResponse =
  /** status 204 The Delete contact was deleted successfully */ undefined;
export type V2DeleteContactApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListContentTemplatesForAccountApiResponse =
  /** status 200 Content Template list response */ {
    data?: V2ContentTemplateResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListContentTemplatesForAccountApiArg = {
  filter?: {
    name?: string;
    "template-type"?: ("service" | "blueprint" | "survey")[];
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "name"
    | "-name"
    | "description"
    | "-description"
    | "template-type"
    | "-template-type"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2GetContentTemplateApiResponse =
  /** status 200 Project response */ {
    data?: V2ContentTemplateResource;
  };
export type V2GetContentTemplateApiArg = {
  /** ID of record */
  id: number;
};
export type V2ImportContentTemplateApiResponse =
  /** status 200 Project response */ {
    data?: V2ServiceResource[];
    included?: (V2PhaseResource | V2ResourceResource)[];
  };
export type V2ImportContentTemplateApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListCrmOpportunitiesForAccountApiResponse =
  /** status 200 CRM Opportunity list response */ {
    data?: V2CrmOpportunityResource[];
    included?: (V2AccountResource | V2ProjectResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListCrmOpportunitiesForAccountApiArg = {
  filter?: {
    "is-closed"?: boolean;
    "display-name"?: string;
    "opportunity-id"?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each CRM opportunity */
  include?: ("account" | "projects")[];
};
export type V2ListCurrencysForAccountApiResponse =
  /** status 200 Currency list response */ {
    data?: V2CurrencyResource[];
    included?: (V2AccountResource | V2RateTableResource | V2UserResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListCurrencysForAccountApiArg = {
  filter?: {
    active?: boolean;
    default?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each currency */
  include?: ("account" | "rate-tables" | "users")[];
};
export type V2CreateCurrencyApiResponse =
  /** status 201 Create Currency response */ {
    data?: V2CurrencyResource;
  };
export type V2CreateCurrencyApiArg = {
  body: {
    data?: V2CurrencyResource;
  };
};
export type V2GetCurrencyApiResponse = /** status 200 Currency response */ {
  data?: V2CurrencyResource;
  included?: (V2AccountResource | V2RateTableResource | V2UserResource)[];
};
export type V2GetCurrencyApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each currency */
  include?: ("account" | "rate-tables" | "users")[];
};
export type V2UpdateCurrencyApiResponse =
  /** status 200 Update Currency response */ {
    data?: V2CurrencyResource;
  };
export type V2UpdateCurrencyApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2CurrencyResource;
  };
};
export type V2DeleteCurrencyApiResponse =
  /** status 204 The Delete Currency was deleted successfully */ undefined;
export type V2DeleteCurrencyApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListCustomerSuccessesApiResponse =
  /** status 200 Project Contact list response */ {
    data?: V2CustomerSuccessResource[];
    included?: (
      | V2ProjectResource
      | V2AccountResource
      | V2PerformanceIndicatorResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListCustomerSuccessesApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each blueprint */
  include?: ("project" | "account" | "performance-indicators")[];
};
export type V2CreateCustomerSuccessApiResponse =
  /** status 201 Create Project Contact response */ {
    data?: V2CustomerSuccessResource;
  };
export type V2CreateCustomerSuccessApiArg = {
  body: {
    data?: V2CustomerSuccessResource;
  };
};
export type V2GetCustomerSuccessApiResponse =
  /** status 200 Project Contact list response */ {
    data?: V2CustomerSuccessResource;
    included?: (
      | V2ProjectResource
      | V2AccountResource
      | V2PerformanceIndicatorResource
    )[];
  };
export type V2GetCustomerSuccessApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each blueprint */
  include?: ("project" | "account" | "performance-indicators")[];
};
export type V2UpdateCustomerSuccessApiResponse =
  /** status 200 Update Project Contact response */ {
    data?: V2CustomerSuccessResource;
  };
export type V2UpdateCustomerSuccessApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2CustomerSuccessResource;
  };
};
export type V2DeleteCustomerSuccessApiResponse =
  /** status 204 The Project Contact was deleted successfully */ undefined;
export type V2DeleteCustomerSuccessApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListDataImportsForAccountApiResponse =
  /** status 200 Data import list response */ {
    data?: V2DataImportResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListDataImportsForAccountApiArg = void;
export type V2CreateDataImportApiResponse =
  /** status 201 Create data import response */ {
    data?: V2DataImportResource;
  };
export type V2CreateDataImportApiArg = {
  body: {
    data?: V2DataImportResource;
  };
};
export type V2GetDataImportByIdApiResponse =
  /** status 200 Project response */ {
    data?: V2DataImportResource;
  };
export type V2GetDataImportByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListDocumentDeliveriesForAccountApiResponse =
  /** status 200 Document delivery list response */ {
    data?: V2DocumentDeliveryResource[];
    included?: V2ProjectResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListDocumentDeliveriesForAccountApiArg = {
  filter?: {
    project_document?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each document delivery */
  include?: "project"[];
};
export type V2GetDocumentDeliveryApiResponse =
  /** status 200 Document delivery response */ {
    data?: V2DocumentDeliveryResource;
    included?: V2ProjectResource[];
  };
export type V2GetDocumentDeliveryApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each document delivery */
  include?: "project"[];
};
export type V2ListDocumentRequestsForAccountApiResponse =
  /** status 200 Document Request list response */ {
    data?: V2DocumentRequestResource[];
    included?: (
      | V2ProjectResource
      | V2DocumentDeliveryResource
      | V2ProjectDocumentResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListDocumentRequestsForAccountApiArg = {
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "status"
    | "-status"
    | "delivery-type"
    | "-delivery-type"
    | "email-list"
    | "-email-list"
    | "force-regeneration"
    | "-force-regeneration"
    | "generate-pdf"
    | "-generate-pdf"
    | "document-url"
    | "-document-url"
    | "templates"
    | "-templates"
    | "account-connection-id"
    | "-account-connection-id"
    | "drive-id"
    | "-drive-id"
    | "filepath"
    | "-filepath"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each document requests */
  include?: ("project" | "document-deliveries" | "project-documents")[];
};
export type V2CreateDocumentRequestApiResponse =
  /** status 201 Create DocumentRequest response */ {
    data?: V2DocumentRequestResource;
  };
export type V2CreateDocumentRequestApiArg = {
  body: {
    data?: V2DocumentRequestResource;
  };
};
export type V2GetDocumentRequestApiResponse =
  /** status 200 Document Request response */ {
    data?: V2DocumentRequestResource;
    included?: (
      | V2ProjectResource
      | V2DocumentDeliveryResource
      | V2ProjectDocumentResource
    )[];
  };
export type V2GetDocumentRequestApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each document requests */
  include?: ("project" | "document-deliveries" | "project-documents")[];
};
export type V2UpdateDocumentRequestApiResponse =
  /** status 200 Update Document Request response */ {
    data?: V2DocumentRequestResource;
  };
export type V2UpdateDocumentRequestApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2DocumentRequestResource;
  };
};
export type V2DeleteDocumentRequestApiResponse =
  /** status 204 The document requests was deleted successfully */ undefined;
export type V2DeleteDocumentRequestApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListDocumentTemplatesForAccountApiResponse =
  /** status 200 Document Template list response */ {
    data?: V2DocumentTemplateResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListDocumentTemplatesForAccountApiArg = {
  filter?: {
    name?: string;
    active?: boolean[];
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each document template */
  include?: "account"[];
};
export type V2CreateDocumentTemplateApiResponse =
  /** status 201 Create DocumentTemplate response */ {
    data?: V2DocumentTemplateResource;
  };
export type V2CreateDocumentTemplateApiArg = {
  body: {
    data?: V2DocumentTemplateResource;
  };
};
export type V2GetDocumentTemplateApiResponse =
  /** status 200 Document template response */ {
    data?: V2DocumentTemplateResource;
    included?: V2AccountResource[];
  };
export type V2GetDocumentTemplateApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each document template */
  include?: "account"[];
};
export type V2UpdateDocumentTemplateApiResponse =
  /** status 200 Update DocumentTemplate response */ {
    data?: V2DocumentTemplateResource;
  };
export type V2UpdateDocumentTemplateApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2DocumentTemplateResource;
  };
};
export type V2DeleteDocumentTemplateApiResponse =
  /** status 204 The document template was deleted successfully */ undefined;
export type V2DeleteDocumentTemplateApiArg = {
  /** ID of record */
  id: number;
};
export type V2RestoreDocumentTemplateApiResponse =
  /** status 200 Update document template response */ {
    data?: V2DocumentTemplateResource;
  };
export type V2RestoreDocumentTemplateApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2DocumentTemplateResource;
  };
};
export type V2GetFilenameFormatOptionsApiResponse =
  /** status 200 Document template response */ {
    "filename-format"?: string[];
  };
export type V2GetFilenameFormatOptionsApiArg = void;
export type V2DownloadDocumentTemplateApiResponse =
  /** status 200 Successful file download */ Blob;
export type V2DownloadDocumentTemplateApiArg = {
  /** ID of record */
  id: number;
};
export type V2UploadDocumentTemplateApiResponse =
  /** status 201 The merge template file was saved successfully */ undefined;
export type V2UploadDocumentTemplateApiArg = {
  /** ID of record */
  id: number;
  body: {
    "document_template[merge_template]"?: Blob;
  };
};
export type V2CreateExecutiveSummaryRequestApiResponse =
  /** status 201 Executive Summary Request response */ {
    data?: V2ExecutiveSummaryRequestResource;
  };
export type V2CreateExecutiveSummaryRequestApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  body: {
    data?: V2ExecutiveSummaryRequestResource;
  };
};
export type V2GetExecutiveSummaryRequestApiResponse =
  /** status 200 Project response */ {
    data?: V2ExecutiveSummaryRequestResource;
  };
export type V2GetExecutiveSummaryRequestApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  /** ID of record */
  id: number;
};
export type V2ListExpenseCategoriessForAccountApiResponse =
  /** status 200 Expense category list response */ {
    data?: V2ExpenseCategoryResource[];
    included?: (V2AccountResource | V2PhaseResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListExpenseCategoriessForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each expense category */
  include?: ("account" | "phase")[];
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "active"
    | "-active"
    | "name"
    | "-name"
    | "rate"
    | "-rate"
    | "use-resource-rate"
    | "-use-resource-rate"
    | "markup"
    | "-markup"
    | "variable"
    | "-variable"
    | "status"
    | "-status"
  )[];
};
export type V2CreateExpenseCategoryApiResponse =
  /** status 201 Create Expense Category response */ {
    data?: V2ExpenseCategoryResource;
  };
export type V2CreateExpenseCategoryApiArg = {
  body: {
    data?: V2ExpenseCategoryResource;
  };
};
export type V2GetExpenseCategoryByIdApiResponse =
  /** status 200 Find expense category by ID response */ {
    data?: V2ExpenseCategoryResource;
    included?: (V2AccountResource | V2PhaseResource)[];
  };
export type V2GetExpenseCategoryByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each expense category */
  include?: ("account" | "phase")[];
};
export type V2UpdateExpenseCategoryApiResponse =
  /** status 200 Update Expense Category response */ {
    data?: V2ExpenseCategoryResource;
  };
export type V2UpdateExpenseCategoryApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ExpenseCategoryResource;
  };
};
export type V2DeleteExpenseCategoryApiResponse =
  /** status 204 The Delete Expense Category was deleted successfully */ undefined;
export type V2DeleteExpenseCategoryApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListExternalRequestsForAccountApiResponse =
  /** status 200 External Request list response */ {
    data?: V2ExternalRequestResource[];
    included?: (
      | V2AccountResource
      | V2ProjectResource
      | V2LobResource
      | V2SubcontractorResource
      | V2SubprojectResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListExternalRequestsForAccountApiArg = {
  filter?: {
    project?: string;
    subcontractor?: string;
    subproject?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each client */
  include?: ("account" | "project" | "lob" | "subcontractor" | "subproject")[];
};
export type V2GetExternalRequestApiResponse =
  /** status 200 External Request response */ {
    data?: V2ExternalRequestResource;
    included?: (
      | V2AccountResource
      | V2ProjectResource
      | V2LobResource
      | V2SubcontractorResource
      | V2SubprojectResource
    )[];
  };
export type V2GetExternalRequestApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each client */
  include?: ("account" | "project" | "lob" | "subcontractor" | "subproject")[];
};
export type V2AcceptExternalRequestApiResponse =
  /** status 200 Accept External Request response */ {
    data?: V2ExternalRequestResource;
  };
export type V2AcceptExternalRequestApiArg = {
  /** ID of record */
  id: number;
};
export type V2OfferExternalRequestApiResponse =
  /** status 200 Offer External Request response */ {
    data?: V2ExternalRequestResource;
  };
export type V2OfferExternalRequestApiArg = {
  /** ID of record */
  id: number;
};
export type V2DeclineExternalRequestApiResponse =
  /** status 200 Decline External Request response */ {
    data?: V2ExternalRequestResource;
  };
export type V2DeclineExternalRequestApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListFreeTrialsForAccountApiResponse =
  /** status 200 Free Trial list response */ {
    data?: V2FreeTrialResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListFreeTrialsForAccountApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each client */
  include?: "account"[];
};
export type V2CreateFreeTrialApiResponse =
  /** status 201 Create Free Trial response */ {
    data?: V2FreeTrialResource;
  };
export type V2CreateFreeTrialApiArg = void;
export type V2GetFreeTrialApiResponse = /** status 200 Project response */ {
  data?: V2FreeTrialResource;
  included?: V2AccountResource[];
};
export type V2GetFreeTrialApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each client */
  include?: "account"[];
};
export type V2CancelFreeTrialApiResponse =
  /** status 204 The Free trial was canceled successfully */ undefined;
export type V2CancelFreeTrialApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListGovernancesForAccountApiResponse =
  /** status 200 Governance list response */ {
    data?: V2GovernanceResource[];
    included?: (
      | V2AccountResource
      | V2ResourceResource
      | V2PhaseResource
      | V2ServiceCategoryResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListGovernancesForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each governance */
  include?: ("account" | "resource" | "phase" | "service-category")[];
};
export type V2CreateGovernanceApiResponse =
  /** status 201 Create Governance response */ {
    data?: V2GovernanceResource;
  };
export type V2CreateGovernanceApiArg = {
  body: {
    data?: V2GovernanceResource;
  };
};
export type V2GetGovernanceByIdApiResponse =
  /** status 200 Find governance by ID response */ {
    data?: V2GovernanceResource;
    included?: (
      | V2AccountResource
      | V2ResourceResource
      | V2PhaseResource
      | V2ServiceCategoryResource
    )[];
  };
export type V2GetGovernanceByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each governance */
  include?: ("account" | "resource" | "phase" | "service-category")[];
};
export type V2UpdateGovernanceApiResponse =
  /** status 200 Update Governance response */ {
    data?: V2GovernanceResource;
  };
export type V2UpdateGovernanceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2GovernanceResource;
  };
};
export type V2DeleteGovernanceApiResponse =
  /** status 204 The governance was deleted successfully */ undefined;
export type V2DeleteGovernanceApiArg = {
  /** ID of record */
  id: number;
};
export type V2ChangeGovernancePositionByIdApiResponse =
  /** status 200 Find governance by ID response */ {
    data?: V2GovernanceResource;
  };
export type V2ChangeGovernancePositionByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2GovernanceResource;
  };
};
export type V2RestoreGovernanceByIdApiResponse =
  /** status 200 Restored governance response */ {
    data?: V2GovernanceResource;
  };
export type V2RestoreGovernanceByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2PurgeGovernanceByIdApiResponse =
  /** status 204 The governance was purged successfully */ undefined;
export type V2PurgeGovernanceByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListIntegratedProductsApiResponse =
  /** status 200 Integrated Products list response */ {
    data?: V2IntegratedProductResource[];
    links?: V2Paging;
    meta?: {
      "record-count"?: number;
    };
  };
export type V2ListIntegratedProductsApiArg = {
  filter?: {
    "account-connection"?: string;
    "product-id"?: string;
    name?: string;
    "manufacturer-part-number"?: string;
    "manufacturer-name"?: string;
    "vendor-name"?: string;
    sku?: string;
    category?: string;
    subcategory?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2ListIntegrationLogsForAccountApiResponse =
  /** status 200 IntegrationLog list response */ {
    data?: V2IntegrationLogResource[];
    included?: (V2AccountResource | V2AccountConnectionResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListIntegrationLogsForAccountApiArg = {
  accountConnectionId: string;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2GetIntegrationLogApiResponse =
  /** status 200 Project response */ {
    data?: V2IntegrationLogResource;
    included?: (V2AccountResource | V2AccountConnectionResource)[];
  };
export type V2GetIntegrationLogApiArg = {
  accountConnectionId: string;
  /** ID of record */
  id: number;
};
export type V2ListLandingPageContentApiResponse =
  /** status 200 Landing Page Content list response */ {
    data?: V2LandingPageContentResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListLandingPageContentApiArg = {
  filter?: {
    stage?: "free" | "essentials" | "business" | "premium";
  };
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2ListLanguageFieldsForAccountApiResponse =
  /** status 200 Langauge field list response */ {
    data?: V2LanguageFieldResource[];
    included?: (V2AccountResource | V2ProjectExpenseResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListLanguageFieldsForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each language field */
  include?: ("account" | "project-expenses")[];
};
export type V2GetLanguageFieldByIdApiResponse =
  /** status 200 Find language field by ID response */ {
    data?: V2LanguageFieldResource;
    included?: (V2AccountResource | V2ProjectExpenseResource)[];
  };
export type V2GetLanguageFieldByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each language field */
  include?: ("account" | "project-expenses")[];
};
export type V2ChangeLanguageFieldPositionByIdApiResponse =
  /** status 200 Find language field by ID response */ {
    data?: V2LanguageFieldResource;
  };
export type V2ChangeLanguageFieldPositionByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2LanguageFieldResource;
  };
};
export type V2GetServiceLevelsOfEffortApiResponse =
  /** status 200 Service levels of effort retreived successfully */ {
    data?: V2LevelOfEffortResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2GetServiceLevelsOfEffortApiArg = {
  /** ID of service to which the resource is associated */
  serviceId: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateLevelOfEffortForServiceApiResponse =
  /** status 201 Create level of effort response */ {
    data?: V2LevelOfEffortResource;
  };
export type V2CreateLevelOfEffortForServiceApiArg = {
  /** ID of service to which the resource is associated */
  serviceId: number;
  body: {
    data?: V2LevelOfEffortResource;
  };
};
export type V2GetServiceLevelOfEffortApiResponse =
  /** status 200 Level of effort retreived successfully */ {
    data?: V2LevelOfEffortResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2GetServiceLevelOfEffortApiArg = {
  /** ID of service to which the resource is associated */
  serviceId: number;
  /** ID of record */
  id: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2UpdateLevelOfEffortForServiceApiResponse =
  /** status 201 Create level of effort response */ {
    data?: V2LevelOfEffortResource;
  };
export type V2UpdateLevelOfEffortForServiceApiArg = {
  /** ID of service to which the resource is associated */
  serviceId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2LevelOfEffortResource;
  };
};
export type V2DeleteLevelOfEffortFromServiceApiResponse =
  /** status 204 The level of effort was deleted successfully */ undefined;
export type V2DeleteLevelOfEffortFromServiceApiArg = {
  /** ID of service to which the resource is associated */
  serviceId: number;
  /** ID of record */
  id: number;
};
export type V2GetSubserviceLevelsOfEffortApiResponse =
  /** status 200 Subservice levels of effort retreived successfully */ {
    data?: V2LevelOfEffortResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2GetSubserviceLevelsOfEffortApiArg = {
  /** ID of subservice to which the resource is associated */
  subserviceId: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateLevelOfEffortForSubserviceApiResponse =
  /** status 201 Create level of effort response */ {
    data?: V2LevelOfEffortResource;
  };
export type V2CreateLevelOfEffortForSubserviceApiArg = {
  /** ID of subservice to which the resource is associated */
  subserviceId: number;
  body: {
    data?: V2LevelOfEffortResource;
  };
};
export type V2GetSubserviceLevelOfEffortApiResponse =
  /** status 200 Level of effort retreived successfully */ {
    data?: V2LevelOfEffortResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2GetSubserviceLevelOfEffortApiArg = {
  /** ID of subservice to which the resource is associated */
  subserviceId: number;
  /** ID of record */
  id: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2UpdateLevelOfEffortForSubserviceApiResponse =
  /** status 201 Create level of effort response */ {
    data?: V2LevelOfEffortResource;
  };
export type V2UpdateLevelOfEffortForSubserviceApiArg = {
  /** ID of subservice to which the resource is associated */
  subserviceId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2LevelOfEffortResource;
  };
};
export type V2DeleteLevelOfEffortFromSubserviceApiResponse =
  /** status 204 The level of effort was deleted successfully */ undefined;
export type V2DeleteLevelOfEffortFromSubserviceApiArg = {
  /** ID of subservice to which the resource is associated */
  subserviceId: number;
  /** ID of record */
  id: number;
};
export type V2ListLineOfBusinessesForAccountApiResponse =
  /** status 200 LineOfBusiness list response */ {
    data?: V2LineOfBusinessResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListLineOfBusinessesForAccountApiArg = {
  filter?: {
    name?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each line of business */
  include?: "account"[];
};
export type V2CreateLineOfBusinessApiResponse =
  /** status 201 Create LineOfBusiness response */ {
    data?: V2LineOfBusinessResource;
  };
export type V2CreateLineOfBusinessApiArg = {
  body: {
    data?: V2LineOfBusinessResource;
  };
};
export type V2GetLineOfBusinessApiResponse =
  /** status 200 Line of Business response */ {
    data?: V2LineOfBusinessResource;
    included?: V2AccountResource[];
  };
export type V2GetLineOfBusinessApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each line of business */
  include?: "account"[];
};
export type V2UpdateLineOfBusinessApiResponse =
  /** status 200 Update Line Of Business response */ {
    data?: V2LineOfBusinessResource;
  };
export type V2UpdateLineOfBusinessApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2LineOfBusinessResource;
  };
};
export type V2DeleteLineOfBusinessApiResponse =
  /** status 204 The Delete Line Of Business was deleted successfully */ undefined;
export type V2DeleteLineOfBusinessApiArg = {
  /** ID of record */
  id: number;
};
export type V2WhoAmIApiResponse = /** status 200 Who Am I response */ {
  data?: V2MeResource;
  links?: V2Paging;
};
export type V2WhoAmIApiArg = void;
export type V2ListNotesApiResponse =
  /** status 200 Project Contact list response */ {
    data?: V2NoteResource[];
    included?: V2ProjectResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListNotesApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each note */
  include?: "project"[];
};
export type V2CreateNoteApiResponse =
  /** status 201 Create Project Contact response */ {
    data?: V2NoteResource;
  };
export type V2CreateNoteApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  body: {
    data?: V2NoteResource;
  };
};
export type V2GetNoteApiResponse =
  /** status 200 Project Contact list response */ {
    data?: V2NoteResource;
    included?: V2ProjectResource[];
  };
export type V2GetNoteApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each note */
  include?: "project"[];
};
export type V2UpdateNoteApiResponse =
  /** status 200 Update Project Contact response */ {
    data?: V2NoteResource;
  };
export type V2UpdateNoteApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2NoteResource;
  };
};
export type V2DeleteNoteApiResponse =
  /** status 204 The Project Contact was deleted successfully */ undefined;
export type V2DeleteNoteApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  /** ID of record */
  id: number;
};
export type V2ListOpenRouterKeysForAccountApiResponse =
  /** status 200 OpenRouterKey list response */ {
    data?: V2OpenRouterKeyResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListOpenRouterKeysForAccountApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateOpenRouterKeyApiResponse =
  /** status 201 Create OpenRouterKey response */ {
    data?: V2OpenRouterKeyResource;
  };
export type V2CreateOpenRouterKeyApiArg = {
  body: {
    data?: V2OpenRouterKeyResource;
  };
};
export type V2GetOpenRouterKeyApiResponse = /** status 200 Project response */ {
  data?: V2OpenRouterKeyResource;
};
export type V2GetOpenRouterKeyApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateOpenRouterKeyApiResponse =
  /** status 200 Update OpenRouterKey response */ {
    data?: V2OpenRouterKeyResource;
  };
export type V2UpdateOpenRouterKeyApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2OpenRouterKeyResource;
  };
};
export type V2DeleteOpenRouterKeyApiResponse =
  /** status 204 The open router key was deleted successfully */ undefined;
export type V2DeleteOpenRouterKeyApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListPartnerRequestsForAccountApiResponse =
  /** status 200 Partner Request list response */ {
    data?: V2PartnerRequestResource[];
    included?: (
      | V2AccountResource
      | V2ProjectResource
      | V2LobResource
      | V2SubcontractorResource
      | V2CurrencyResource
      | V2ThirdPartyServiceResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListPartnerRequestsForAccountApiArg = {
  filter?: {
    project?: string;
    subcontractor?: string;
    subproject?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each client */
  include?: (
    | "account"
    | "project"
    | "lob"
    | "subcontractor"
    | "currency"
    | "third-party-services"
  )[];
};
export type V2CreatePartnerRequestApiResponse =
  /** status 201 Create Partner Request response */ {
    data?: V2PartnerRequestResource;
  };
export type V2CreatePartnerRequestApiArg = {
  body: {
    data?: V2PartnerRequestResource;
  };
};
export type V2GetPartnerRequestApiResponse =
  /** status 200 Partner ReqeuesProjectt response */ {
    data?: V2PartnerRequestResource;
  };
export type V2GetPartnerRequestApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdatePartnerRequestApiResponse =
  /** status 200 Update Partner Request response */ {
    data?: V2PartnerRequestResource;
  };
export type V2UpdatePartnerRequestApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2PartnerRequestResource;
  };
};
export type V2DeletePartnerRequestApiResponse =
  /** status 204 The Delete Partner Request was deleted successfully */ undefined;
export type V2DeletePartnerRequestApiArg = {
  /** ID of record */
  id: number;
};
export type V2CompletePartnerRequestApiResponse =
  /** status 200 Complete Partner Request response */ {
    data?: V2PartnerRequestResource;
  };
export type V2CompletePartnerRequestApiArg = {
  /** ID of record */
  id: number;
};
export type V2RevisePartnerRequestApiResponse =
  /** status 200 Revise Partner Request response */ {
    data?: V2PartnerRequestResource;
  };
export type V2RevisePartnerRequestApiArg = {
  /** ID of record */
  id: number;
};
export type V2DeclinePartnerRequestApiResponse =
  /** status 200 Decline Partner Request response */ {
    data?: V2PartnerRequestResource;
  };
export type V2DeclinePartnerRequestApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountPartnerRequestsApiResponse =
  /** status 200 Partner requests count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountPartnerRequestsApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListPaymentCreditsForAccountApiResponse =
  /** status 200 Payment Credit list response */ {
    data?: V2PaymentCreditResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListPaymentCreditsForAccountApiArg = {
  filter?: {
    "payment-source"?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each payment credit */
  include?: "account"[];
};
export type V2CreatePaymentCreditApiResponse =
  /** status 201 Create Payment Credit response */ {
    data?: V2PaymentCreditResource;
  };
export type V2CreatePaymentCreditApiArg = {
  body: {
    data?: V2PaymentCreditResource;
  };
};
export type V2GetPaymentCreditApiResponse = /** status 200 Project response */ {
  data?: V2PaymentCreditResource;
};
export type V2GetPaymentCreditApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdatePaymentCreditApiResponse =
  /** status 200 Update Payment Credit response */ {
    data?: V2PaymentCreditResource;
  };
export type V2UpdatePaymentCreditApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2PaymentCreditResource;
  };
};
export type V2DeletePaymentCreditApiResponse =
  /** status 204 The Delete Payment Credit was deleted successfully */ undefined;
export type V2DeletePaymentCreditApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListPaymentTermsForAccountApiResponse =
  /** status 200 Payment Term list response */ {
    data?: V2PaymentTermResource[];
    included?: (V2AccountResource | V2PhaseResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListPaymentTermsForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each payment credit */
  include?: ("account" | "phase")[];
};
export type V2CreatePaymentTermApiResponse =
  /** status 201 Create Payment Term response */ {
    data?: V2PaymentTermResource;
  };
export type V2CreatePaymentTermApiArg = {
  body: {
    data?: V2PaymentTermResource;
  };
};
export type V2GetPaymentTermApiResponse = /** status 200 Project response */ {
  data?: V2PaymentTermResource;
  included?: (V2AccountResource | V2PhaseResource)[];
};
export type V2GetPaymentTermApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each payment credit */
  include?: ("account" | "phase")[];
};
export type V2UpdatePaymentTermApiResponse =
  /** status 200 Update Payment Term response */ {
    data?: V2PaymentTermResource;
  };
export type V2UpdatePaymentTermApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2PaymentTermResource;
  };
};
export type V2DeletePaymentTermApiResponse =
  /** status 204 The Delete Payment Term was deleted successfully */ undefined;
export type V2DeletePaymentTermApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListPerformanceIndicatorsForAccountApiResponse =
  /** status 200 Performance Indicator list response */ {
    data?: V2PerformanceIndicatorResource[];
    included?: V2CustomerSuccessResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListPerformanceIndicatorsForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each performance indicator */
  include?: "customer-success"[];
};
export type V2CreatePerformanceIndicatorApiResponse =
  /** status 201 Create Performance Indicator response */ {
    data?: V2PerformanceIndicatorResource;
  };
export type V2CreatePerformanceIndicatorApiArg = {
  body: {
    data?: V2PerformanceIndicatorResource;
  };
};
export type V2GetPerformanceIndicatorApiResponse =
  /** status 200 Project response */ {
    data?: V2PerformanceIndicatorResource;
    included?: V2CustomerSuccessResource[];
  };
export type V2GetPerformanceIndicatorApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each performance indicator */
  include?: "customer-success"[];
};
export type V2UpdatePerformanceIndicatorApiResponse =
  /** status 200 Update Performance Indicator response */ {
    data?: V2PerformanceIndicatorResource;
  };
export type V2UpdatePerformanceIndicatorApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2PerformanceIndicatorResource;
  };
};
export type V2DeletePerformanceIndicatorApiResponse =
  /** status 204 The Delete Performance Indicator was deleted successfully */ undefined;
export type V2DeletePerformanceIndicatorApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListPhasesForAccountApiResponse =
  /** status 200 Phase list response */ {
    data?: V2PhaseResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListPhasesForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each phase */
  include?: "account"[];
};
export type V2CreatePhaseApiResponse = /** status 201 Create Phase response */ {
  data?: V2PhaseResource;
};
export type V2CreatePhaseApiArg = {
  body: {
    data?: V2PhaseResource;
  };
};
export type V2GetPhaseByIdApiResponse =
  /** status 200 Find phase by ID response */ {
    data?: V2PhaseResource;
    included?: V2AccountResource[];
  };
export type V2GetPhaseByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each phase */
  include?: "account"[];
};
export type V2UpdatePhaseApiResponse = /** status 200 Update Phase response */ {
  data?: V2PhaseResource;
};
export type V2UpdatePhaseApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2PhaseResource;
  };
};
export type V2DeletePhaseApiResponse =
  /** status 204 The phase was deleted successfully */ undefined;
export type V2DeletePhaseApiArg = {
  /** ID of record */
  id: number;
};
export type V2ChangePhasePositionByIdApiResponse =
  /** status 200 Find phase by ID response */ {
    data?: V2PhaseResource;
  };
export type V2ChangePhasePositionByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2PhaseResource;
  };
};
export type V2RestorePhaseByIdApiResponse =
  /** status 200 Restored phase response */ {
    data?: V2PhaseResource;
  };
export type V2RestorePhaseByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2PurgePhaseByIdApiResponse =
  /** status 204 The phase was purged successfully */ undefined;
export type V2PurgePhaseByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListPresalesEngineersForAccountApiResponse =
  /** status 200 Presales Engineer list response */ {
    data?: V2PresalesEngineerResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListPresalesEngineersForAccountApiArg = {
  filter?: {
    name?: string;
    email?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each presales engineer */
  include?: "account"[];
};
export type V2GetPresalesEngineerByIdApiResponse =
  /** status 200 Find presales engineer by ID response */ {
    data?: V2PresalesEngineerResource;
    included?: V2AccountResource[];
  };
export type V2GetPresalesEngineerByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each presales engineer */
  include?: "account"[];
};
export type V2ListPricingAdjustmentsForAccountApiResponse =
  /** status 200 PricingAdjustment list response */ {
    data?: V2PricingAdjustmentResource[];
    included?: V2ProjectResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListPricingAdjustmentsForAccountApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each pricing adjustment */
  include?: "project"[];
};
export type V2CreatePricingAdjustmentApiResponse =
  /** status 201 Create PricingAdjustment response */ {
    data?: V2PricingAdjustmentResource;
  };
export type V2CreatePricingAdjustmentApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  body: {
    data?: V2PricingAdjustmentResource;
  };
};
export type V2GetPricingAdjustmentByIdApiResponse =
  /** status 200 Update resource response */ {
    data?: V2PricingAdjustmentResource;
  };
export type V2GetPricingAdjustmentByIdApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each pricing adjustment */
  include?: "project"[];
};
export type V2UpdatePricingAdjustmentByIdApiResponse =
  /** status 200 Update resource response */ {
    data?: V2PricingAdjustmentResource;
  };
export type V2UpdatePricingAdjustmentByIdApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2PricingAdjustmentResource;
  };
};
export type V2DeletePricingAdjustmentByIdApiResponse =
  /** status 204 The Pricing Adjustment was deleted successfully */ undefined;
export type V2DeletePricingAdjustmentByIdApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  /** ID of record */
  id: number;
};
export type V2ListPrivilegesApiResponse =
  /** status 200 List of all privileges supported by the Role Based Authorization Controls (RBAC) */ {
    data?: V2PrivilegeResource[];
  };
export type V2ListPrivilegesApiArg = void;
export type V2ListProductAccountingsForAccountApiResponse =
  /** status 200 Product Accounting list response */ {
    data?: V2ProductAccountingResource[];
    included?: (V2ProductResource | V2ServiceCategoryResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProductAccountingsForAccountApiArg = {
  /** ID of product */
  productId: number;
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each product accounting */
  include?: ("product" | "service-category")[];
};
export type V2CreateProductAccountingApiResponse =
  /** status 201 Create ProductAccounting response */ {
    data?: V2ProductAccountingResource;
  };
export type V2CreateProductAccountingApiArg = {
  /** ID of product */
  productId: number;
  body: {
    data?: V2ProductAccountingResource;
  };
};
export type V2GetProductAccountingApiResponse =
  /** status 200 Project response */ {
    data?: V2ProductAccountingResource;
    included?: (V2ProductResource | V2ServiceCategoryResource)[];
  };
export type V2GetProductAccountingApiArg = {
  /** ID of product */
  productId: number;
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each product accounting */
  include?: ("product" | "service-category")[];
};
export type V2UpdateProductAccountingApiResponse =
  /** status 200 Update ProductAccounting response */ {
    data?: V2ProductAccountingResource;
  };
export type V2UpdateProductAccountingApiArg = {
  /** ID of product */
  productId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2ProductAccountingResource;
  };
};
export type V2DeleteProductAccountingApiResponse =
  /** status 204 The product accounting was deleted successfully */ undefined;
export type V2DeleteProductAccountingApiArg = {
  /** ID of product */
  productId: number;
  /** ID of record */
  id: number;
};
export type V2ListProductsForAccountApiResponse =
  /** status 200 Product list response */ {
    data?: V2ProductResource[];
    included?: (V2AccountResource | V2ServiceResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProductsForAccountApiArg = {
  filter?: {
    name?: string;
    category?: string;
    subcategory?: string;
    sku?: string;
    "product-id"?: string;
    "manufacturer-name"?: string;
    "manufacturer-part-number"?: string;
    "vendor-name"?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each product */
  include?: ("account" | "services")[];
};
export type V2CreateProductApiResponse =
  /** status 201 Create Product response */ {
    data?: V2ProductResource;
  };
export type V2CreateProductApiArg = {
  body: {
    data?: V2ProductResource;
  };
};
export type V2GetProductApiResponse = /** status 200 Project response */ {
  data?: V2ProductResource;
  included?: (V2AccountResource | V2ServiceResource)[];
};
export type V2GetProductApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each product */
  include?: ("account" | "services")[];
};
export type V2UpdateProductApiResponse =
  /** status 200 Update Product response */ {
    data?: V2ProductResource;
  };
export type V2UpdateProductApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProductResource;
  };
};
export type V2DeleteProductApiResponse =
  /** status 204 The Delete Product was deleted successfully */ undefined;
export type V2DeleteProductApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListProjectApprovalsForAccountApiResponse =
  /** status 200 Project Approval list response */ {
    data?: V2ProjectApprovalResource[];
    included?: (V2ProjectResource | V2UserResource | V2ApprovalStepResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectApprovalsForAccountApiArg = {
  filter?: {
    "approval-step"?: string;
    "pending-user-approval"?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each client */
  include?: ("project" | "user" | "approval-step")[];
};
export type V2CreateProjectApprovalApiResponse =
  /** status 201 Create Project Approval response */ {
    data?: V2ProjectApprovalResource;
  };
export type V2CreateProjectApprovalApiArg = {
  body: {
    data?: V2ProjectApprovalResource;
  };
};
export type V2GetProjectApprovalApiResponse =
  /** status 200 Project response */ {
    data?: V2ProjectApprovalResource;
    included?: (V2ProjectResource | V2UserResource | V2ApprovalStepResource)[];
  };
export type V2GetProjectApprovalApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each client */
  include?: ("project" | "user" | "approval-step")[];
};
export type V2UpdateProjectApprovalApiResponse =
  /** status 200 Update Project Approval response */ {
    data?: V2ProjectApprovalResource;
  };
export type V2UpdateProjectApprovalApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectApprovalResource;
  };
};
export type V2DeleteProjectApprovalApiResponse =
  /** status 204 The Delete Project Approval was deleted successfully */ undefined;
export type V2DeleteProjectApprovalApiArg = {
  /** ID of record */
  id: number;
};
export type V2ApproveProjectApprovalByIdApiResponse =
  /** status 200 Update Project Approval response */ {
    data?: V2ProjectApprovalResource;
  };
export type V2ApproveProjectApprovalByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectApprovalResource;
  };
};
export type V2CancelProjectApprovalByIdApiResponse =
  /** status 200 Update Project Approval response */ {
    data?: V2ProjectApprovalResource;
  };
export type V2CancelProjectApprovalByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectApprovalResource;
  };
};
export type V2DeclineProjectApprovalByIdApiResponse =
  /** status 200 Update Project Approval response */ {
    data?: V2ProjectApprovalResource;
  };
export type V2DeclineProjectApprovalByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectApprovalResource;
  };
};
export type V2RescopeProjectApprovalByIdApiResponse =
  /** status 200 Update Project Approval response */ {
    data?: V2ProjectApprovalResource;
  };
export type V2RescopeProjectApprovalByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectApprovalResource;
  };
};
export type V2ListProjectAttachmentsForAccountApiResponse =
  /** status 200 Project Attachment list response */ {
    data?: V2ProjectAttachmentResource[];
    included?: (V2ProjectResource | V2AttachmentTypeResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectAttachmentsForAccountApiArg = {
  filter?: {
    project?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project attachment */
  include?: ("project" | "attachment-type")[];
};
export type V2CreateProjectAttachmentApiResponse =
  /** status 201 Create Project Attachment response */ {
    data?: V2ProjectAttachmentResource;
  };
export type V2CreateProjectAttachmentApiArg = {
  body: {
    data?: V2ProjectAttachmentResource;
  };
};
export type V2GetProjectAttachmentByIdApiResponse =
  /** status 200 Find project attachment by ID response */ {
    data?: V2ProjectAttachmentResource;
    included?: (V2ProjectResource | V2AttachmentTypeResource)[];
  };
export type V2GetProjectAttachmentByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project attachment */
  include?: ("project" | "attachment-type")[];
};
export type V2UpdateProjectAttachmentApiResponse =
  /** status 200 Update Project Attachment response */ {
    data?: V2ProjectAttachmentResource;
  };
export type V2UpdateProjectAttachmentApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectAttachmentResource;
  };
};
export type V2DeleteProjectAttachmentApiResponse =
  /** status 204 The Project Attachment was deleted successfully */ undefined;
export type V2DeleteProjectAttachmentApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountProjectAttachmentsApiResponse =
  /** status 200 project attachments count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectAttachmentsApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2DownloadProjectAttachmentApiResponse =
  /** status 200 Successful file download */ Blob;
export type V2DownloadProjectAttachmentApiArg = {
  /** ID of record */
  id: number;
};
export type V2UploadProjectAttachmentApiResponse =
  /** status 201 The attached file was saved successfully */ undefined;
export type V2UploadProjectAttachmentApiArg = {
  /** ID of record */
  id: number;
  body: {
    "project_attachment[document]"?: Blob;
  };
};
export type V2ListProjectCollaboratorsApiResponse =
  /** status 200 Project Collaborator list response */ {
    data?: V2ProjectCollaboratorResource[];
    included?: (V2ProjectResource | V2UserResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectCollaboratorsApiArg = {
  filter?: {
    project?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project collaborator */
  include?: ("project" | "user")[];
};
export type V2CreateProjectCollaboratorApiResponse =
  /** status 201 Create Project Collaborator response */ {
    data?: V2ProjectCollaboratorResource;
  };
export type V2CreateProjectCollaboratorApiArg = {
  body: {
    data?: V2ProjectCollaboratorResource;
  };
};
export type V2GetProjectCollaboratorByIdApiResponse =
  /** status 200 Project Collaborator list response */ {
    data?: V2ProjectCollaboratorResource;
    included?: (V2ProjectResource | V2UserResource)[];
  };
export type V2GetProjectCollaboratorByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project collaborator */
  include?: ("project" | "user")[];
};
export type V2UpdateProjectCollaboratorApiResponse =
  /** status 200 Update Project Collaborator response */ {
    data?: V2ProjectCollaboratorResource;
  };
export type V2UpdateProjectCollaboratorApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectCollaboratorResource;
  };
};
export type V2DeleteProjectCollaboratorApiResponse =
  /** status 204 The Project Collaborator was deleted successfully */ undefined;
export type V2DeleteProjectCollaboratorApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountProjectCollaboratorsApiResponse =
  /** status 200 project collaborators count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectCollaboratorsApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListProjectConditionsForAccountApiResponse =
  /** status 200 ProjectCondition list response */ {
    data?: V2ProjectConditionResource[];
    included?: (V2ProjectResource | V2ServiceConditionResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectConditionsForAccountApiArg = {
  filter?: {
    project?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project condition */
  include?: ("project" | "service-condition")[];
};
export type V2GetProjectConditionApiResponse =
  /** status 200 Project response */ {
    data?: V2ProjectConditionResource;
    included?: (V2ProjectResource | V2ServiceConditionResource)[];
  };
export type V2GetProjectConditionApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project condition */
  include?: ("project" | "service-condition")[];
};
export type V2UpdateProjectConditionApiResponse =
  /** status 200 Update ProjectCondition response */ {
    data?: V2ProjectConditionResource;
  };
export type V2UpdateProjectConditionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectConditionResource;
  };
};
export type V2DeleteProjectConditionApiResponse =
  /** status 204 The Delete ProjectCondition was deleted successfully */ undefined;
export type V2DeleteProjectConditionApiArg = {
  /** ID of record */
  id: number;
};
export type V2SkipProjectConditionApiResponse =
  /** status 200 Skipped Project Condition response */ {
    data?: V2ProjectConditionResource;
  };
export type V2SkipProjectConditionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectConditionResource;
  };
};
export type V2RestoreProjectConditionApiResponse =
  /** status 200 Restored Project Condition response */ {
    data?: V2ProjectConditionResource;
  };
export type V2RestoreProjectConditionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectConditionResource;
  };
};
export type V2CountProjectConditionsApiResponse =
  /** status 200 project conditions count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectConditionsApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListProjectContactsApiResponse =
  /** status 200 Project Contact list response */ {
    data?: V2ProjectContactResource[];
    included?: (V2ProjectResource | V2ContactResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectContactsApiArg = {
  filter?: {
    project?: string;
    name?: string;
    email?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project contact */
  include?: ("project" | "contact")[];
};
export type V2CreateProjectContactApiResponse =
  /** status 201 Create Project Contact response */ {
    data?: V2ProjectContactResource;
  };
export type V2CreateProjectContactApiArg = {
  body: {
    data?: V2ProjectContactResource;
  };
};
export type V2GetProjectContactApiResponse =
  /** status 200 Project Contact list response */ {
    data?: V2ProjectContactResource;
    included?: (V2ProjectResource | V2ContactResource)[];
  };
export type V2GetProjectContactApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project contact */
  include?: ("project" | "contact")[];
};
export type V2UpdateProjectContactApiResponse =
  /** status 200 Update Project Contact response */ {
    data?: V2ProjectContactResource;
  };
export type V2UpdateProjectContactApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectContactResource;
  };
};
export type V2DeleteProjectContactApiResponse =
  /** status 204 The Project Contact was deleted successfully */ undefined;
export type V2DeleteProjectContactApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountProjectContactsApiResponse =
  /** status 200 project contacts count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectContactsApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListProjectCreditsApiResponse =
  /** status 200 Project Credit list response */ {
    data?: V2ProjectCreditResource[];
    included?: (V2ProjectResource | V2PaymentCreditResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectCreditsApiArg = {
  filter?: {
    project?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project credit */
  include?: ("project" | "payment-credit")[];
};
export type V2CreateProjectCreditApiResponse =
  /** status 201 Create Project Credit response */ {
    data?: V2ProjectCreditResource;
  };
export type V2CreateProjectCreditApiArg = {
  body: {
    data?: V2ProjectCreditResource;
  };
};
export type V2GetProjectCreditByIdApiResponse =
  /** status 200 Project credit response */ {
    data?: V2ProjectCreditResource;
    included?: (V2ProjectResource | V2PaymentCreditResource)[];
  };
export type V2GetProjectCreditByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project credit */
  include?: ("project" | "payment-credit")[];
};
export type V2UpdateProjectCreditApiResponse =
  /** status 200 Update Project Credit response */ {
    data?: V2ProjectCreditResource;
  };
export type V2UpdateProjectCreditApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectCreditResource;
  };
};
export type V2DeleteProjectCreditApiResponse =
  /** status 204 The Project Credit was deleted successfully */ undefined;
export type V2DeleteProjectCreditApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListProjectDocumentsForAccountApiResponse =
  /** status 200 Project Document list response */ {
    data?: V2ProjectDocumentResource[];
    included?: (V2ProjectResource | V2DocumentDeliveryResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectDocumentsForAccountApiArg = {
  filter?: {
    project?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project document */
  include?: ("project" | "document-deliveries")[];
};
export type V2CreateProjectDocumentApiResponse =
  /** status 201 Create Project Document response */ {
    data?: V2ProjectDocumentResource;
  };
export type V2CreateProjectDocumentApiArg = {
  body: {
    data?: V2ProjectDocumentResource;
  };
};
export type V2GetProjectDocumentApiResponse =
  /** status 200 Project document response */ {
    data?: V2ProjectDocumentResource;
    included?: (V2ProjectResource | V2DocumentDeliveryResource)[];
  };
export type V2GetProjectDocumentApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project document */
  include?: ("project" | "document-deliveries")[];
};
export type V2CreateProjectDuplicationApiResponse =
  /** status 201 Create Project Duplication response */ {
    data?: V2ProjectDuplicationResource;
  };
export type V2CreateProjectDuplicationApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
  body: {
    data?: V2ProjectDuplicationResource;
  };
};
export type V2ListProjectExpensesApiResponse =
  /** status 200 Project Expense list response */ {
    data?: V2ProjectExpenseResource[];
    included?: (
      | V2ProjectResource
      | V2ProjectPhaseResource
      | V2ExpenseCategoryResource
      | V2ProjectResourceResource
      | V2ResourceResource
      | V2ResourceRateResource
      | V2ProjectServiceResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectExpensesApiArg = {
  filter?: {
    project?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project expense */
  include?: (
    | "project"
    | "project-phase"
    | "expense-category"
    | "project-resource"
    | "resource"
    | "resource-rate"
    | "project-service"
  )[];
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "active"
    | "-active"
    | "rate"
    | "-rate"
    | "quantity"
    | "-quantity"
    | "description"
    | "-description"
    | "markup"
    | "-markup"
    | "revenue"
    | "-revenue"
    | "cost"
    | "-cost"
    | "variable"
    | "-variable"
  )[];
};
export type V2CreateProjectExpenseApiResponse =
  /** status 201 Create Project Expense response */ {
    data?: V2ProjectExpenseResource;
  };
export type V2CreateProjectExpenseApiArg = {
  body: {
    data?: V2ProjectExpenseResource;
  };
};
export type V2GetProjectExpenseByIdApiResponse =
  /** status 200 Project list response */ {
    data?: V2ProjectExpenseResource;
    included?: (
      | V2ProjectResource
      | V2ProjectPhaseResource
      | V2ExpenseCategoryResource
      | V2ProjectResourceResource
      | V2ResourceResource
      | V2ResourceRateResource
      | V2ProjectServiceResource
    )[];
  };
export type V2GetProjectExpenseByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project expense */
  include?: (
    | "project"
    | "project-phase"
    | "expense-category"
    | "project-resource"
    | "resource"
    | "resource-rate"
    | "project-service"
  )[];
};
export type V2UpdateProjectExpenseApiResponse =
  /** status 200 Update Project Expense response */ {
    data?: V2ProjectExpenseResource;
  };
export type V2UpdateProjectExpenseApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectExpenseResource;
  };
};
export type V2DeleteProjectExpenseApiResponse =
  /** status 204 The Project Expense was deleted successfully */ undefined;
export type V2DeleteProjectExpenseApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountProjectExpensesApiResponse =
  /** status 200 project expenses count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectExpensesApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListProjectGovernancesApiResponse =
  /** status 200 Project Governance list response */ {
    data?: V2ProjectGovernanceResource[];
    included?: (
      | V2ProjectResource
      | V2ProjectPhaseResource
      | V2GovernanceResource
      | V2ProjectResourceResource
      | V2ResourceResource
      | V2ResourceRateResource
      | V2ServiceCategoryResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectGovernancesApiArg = {
  filter?: {
    project?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project governance */
  include?: (
    | "project"
    | "project-phase"
    | "governance"
    | "project-resource"
    | "resource"
    | "resource-rate"
    | "service-category"
  )[];
};
export type V2CreateProjectGovernanceApiResponse =
  /** status 201 Create Project Governance response */ {
    data?: V2ProjectGovernanceResource;
  };
export type V2CreateProjectGovernanceApiArg = {
  body: {
    data?: V2ProjectGovernanceResource;
  };
};
export type V2GetProjectGovernanceByIdApiResponse =
  /** status 200 Project list response */ {
    data?: V2ProjectGovernanceResource;
    included?: (
      | V2ProjectResource
      | V2ProjectPhaseResource
      | V2GovernanceResource
      | V2ProjectResourceResource
      | V2ResourceResource
      | V2ResourceRateResource
      | V2ServiceCategoryResource
    )[];
  };
export type V2GetProjectGovernanceByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project governance */
  include?: (
    | "project"
    | "project-phase"
    | "governance"
    | "project-resource"
    | "resource"
    | "resource-rate"
    | "service-category"
  )[];
};
export type V2UpdateProjectGovernanceApiResponse =
  /** status 200 Update Project Governance response */ {
    data?: V2ProjectGovernanceResource;
  };
export type V2UpdateProjectGovernanceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectGovernanceResource;
  };
};
export type V2DeleteProjectGovernanceApiResponse =
  /** status 204 The Delete Project Governance was deleted successfully */ undefined;
export type V2DeleteProjectGovernanceApiArg = {
  /** ID of record */
  id: number;
};
export type V2ChangeProjectGovernancePositionByIdApiResponse =
  /** status 200 Find project governance by ID response */ {
    data?: V2ProjectGovernanceResource;
  };
export type V2ChangeProjectGovernancePositionByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectGovernanceResource;
  };
};
export type V2CountProjectGovernancesApiResponse =
  /** status 200 project governances count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectGovernancesApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListProjectLocationsApiResponse =
  /** status 200 Project Location list response */ {
    data?: V2ProjectLocationResource[];
    included?: V2ProjectResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectLocationsApiArg = {
  filter?: {
    project?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project location */
  include?: "project"[];
};
export type V2CreateProjectLocationApiResponse =
  /** status 201 Create Project Location response */ {
    data?: V2ProjectLocationResource;
  };
export type V2CreateProjectLocationApiArg = {
  body: {
    data?: V2ProjectLocationResource;
  };
};
export type V2GetProjectLocationByIdApiResponse =
  /** status 200 Project list response */ {
    data?: V2ProjectLocationResource;
    included?: V2ProjectResource[];
  };
export type V2GetProjectLocationByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project location */
  include?: "project"[];
};
export type V2UpdateProjectLocationApiResponse =
  /** status 200 Update Project Location response */ {
    data?: V2ProjectLocationResource;
  };
export type V2UpdateProjectLocationApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectLocationResource;
  };
};
export type V2DeleteProjectLocationApiResponse =
  /** status 204 The Delete Project Location was deleted successfully */ undefined;
export type V2DeleteProjectLocationApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountProjectLocationsApiResponse =
  /** status 200 project locations count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectLocationsApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListProjectPhasesForAccountApiResponse =
  /** status 200 Project Phase list response */ {
    data?: V2ProjectPhaseResource[];
    included?: (V2ProjectResource | V2PhaseResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectPhasesForAccountApiArg = {
  filter?: {
    active?: boolean;
    project?: number;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project phase */
  include?: ("project" | "phase")[];
};
export type V2CreateProjectPhaseApiResponse =
  /** status 201 Create Project Phase response */ {
    data?: V2ProjectPhaseResource;
  };
export type V2CreateProjectPhaseApiArg = {
  body: {
    data?: V2ProjectPhaseResource;
  };
};
export type V2GetProjectPhaseByIdApiResponse =
  /** status 200 Find Project Phase by ID response */ {
    data?: V2ProjectPhaseResource;
    included?: (V2ProjectResource | V2PhaseResource)[];
  };
export type V2GetProjectPhaseByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project phase */
  include?: ("project" | "phase")[];
};
export type V2UpdateProjectPhaseApiResponse =
  /** status 200 Update Project Phase response */ {
    data?: V2ProjectPhaseResource;
  };
export type V2UpdateProjectPhaseApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectPhaseResource;
  };
};
export type V2DeleteProjectPhaseApiResponse =
  /** status 204 The Project Phase was deleted successfully */ undefined;
export type V2DeleteProjectPhaseApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListProjectProductsForAccountApiResponse =
  /** status 200 Product list response */ {
    data?: V2ProjectProductResource[];
    included?: (
      | V2ProjectResource
      | V2ProductResource
      | V2ProjectServiceResource
      | V2ProjectLocationResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectProductsForAccountApiArg = {
  filter?: {
    project?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "active"
    | "-active"
    | "name"
    | "-name"
    | "description"
    | "-description"
    | "quantity"
    | "-quantity"
    | "sku"
    | "-sku"
    | "product-id"
    | "-product-id"
    | "manufacturer-part-number"
    | "-manufacturer-part-number"
    | "unit-of-measure"
    | "-unit-of-measure"
    | "category"
    | "-category"
    | "subcategory"
    | "-subcategory"
    | "unit-cost"
    | "-unit-cost"
    | "unit-price"
    | "-unit-price"
    | "custom"
    | "-custom"
    | "variable-rates"
    | "-variable-rates"
    | "billing-frequency"
    | "-billing-frequency"
    | "line-number"
    | "-line-number"
    | "vendor-discount"
    | "-vendor-discount"
    | "list-price"
    | "-list-price"
    | "markup"
    | "-markup"
    | "project-variables"
    | "-project-variables"
    | "source"
    | "-source"
    | "hardware-price"
    | "-hardware-price"
    | "hardware-cost"
    | "-hardware-cost"
    | "custom-hardware-price?"
    | "-custom-hardware-price?"
    | "custom-hardware-cost?"
    | "-custom-hardware-cost?"
    | "project-location.name"
    | "-project-location.name"
  )[];
  /** Associated data that may be loaded with each project product */
  include?: ("project" | "product" | "project-service" | "project-location")[];
};
export type V2CreateProjectProductApiResponse =
  /** status 201 Create Product response */ {
    data?: V2ProjectProductResource;
  };
export type V2CreateProjectProductApiArg = {
  body: {
    data?: V2ProjectProductResource;
  };
};
export type V2GetProjectProductApiResponse =
  /** status 200 Project product response */ {
    data?: V2ProjectProductResource;
    included?: (
      | V2ProjectResource
      | V2ProductResource
      | V2ProjectServiceResource
      | V2ProjectLocationResource
    )[];
  };
export type V2GetProjectProductApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project product */
  include?: ("project" | "product" | "project-service" | "project-location")[];
};
export type V2UpdateProjectProductApiResponse =
  /** status 200 Update Product response */ {
    data?: V2ProjectProductResource;
  };
export type V2UpdateProjectProductApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectProductResource;
  };
};
export type V2DeleteProjectProductApiResponse =
  /** status 204 The Delete Product was deleted successfully */ undefined;
export type V2DeleteProjectProductApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountProjectProductsApiResponse =
  /** status 200 project products count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectProductsApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListProjectResourcesForAccountApiResponse =
  /** status 200 ProjectResource list response */ {
    data?: V2ProjectResourceResource[];
    included?: (
      | V2ProjectResource
      | V2ResourceResource
      | V2LineOfBusinessResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectResourcesForAccountApiArg = {
  filter?: {
    project?: string;
    active?: boolean;
    "governed-categories"?: string[];
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project resource */
  include?: ("project" | "resource" | "line-of-business")[];
};
export type V2CreateProjectResourceApiResponse =
  /** status 201 Create Project Resource response */ {
    data?: V2ProjectResourceResource;
  };
export type V2CreateProjectResourceApiArg = {
  body: {
    data?: V2ProjectResourceResource;
  };
};
export type V2GetProjectResourceApiResponse =
  /** status 200 Project response */ {
    data?: V2ProjectResourceResource;
    included?: (
      | V2ProjectResource
      | V2ResourceResource
      | V2LineOfBusinessResource
    )[];
  };
export type V2GetProjectResourceApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateProjectResourceApiResponse =
  /** status 200 Update ProjectResource response */ {
    data?: V2ProjectResourceResource;
  };
export type V2UpdateProjectResourceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectResourceResource;
  };
};
export type V2DeleteProjectResourceApiResponse =
  /** status 204 The project resource was deleted successfully */ undefined;
export type V2DeleteProjectResourceApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountProjectResourcesApiResponse =
  /** status 200 Project resources count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectResourcesApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListProjectServicesApiResponse =
  /** status 200 Project Service list response */ {
    data?: V2ProjectServiceResource[];
    included?: (
      | V2ProjectResource
      | V2ProjectLocationResource
      | V2ProjectPhaseResource
      | V2ProjectResourceResource
      | V2ResourceResource
      | V2ServiceResource
      | V2LobResource
      | V2ServiceCategoryResource
      | V2ProjectSubserviceResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectServicesApiArg = {
  filter?: {
    project?: string;
    phase?: string;
    lob?: string;
    "project-location"?: string;
    "service-type"?: "professional_services" | "managed_services";
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project service */
  include?: (
    | "project"
    | "project-location"
    | "project-phase"
    | "project-resource"
    | "resource"
    | "service"
    | "lob"
    | "service-category"
    | "project-subservices"
  )[];
};
export type V2CreateProjectServiceApiResponse =
  /** status 201 Create Project Service response */ {
    data?: V2ProjectServiceResource;
  };
export type V2CreateProjectServiceApiArg = {
  body: {
    data?: V2ProjectServiceResource;
  };
};
export type V2GetProjectServiceByIdApiResponse =
  /** status 200 Project Service list response */ {
    data?: V2ProjectServiceResource;
    included?: (
      | V2ProjectResource
      | V2ProjectLocationResource
      | V2ProjectPhaseResource
      | V2ProjectResourceResource
      | V2ResourceResource
      | V2ServiceResource
      | V2LobResource
      | V2ServiceCategoryResource
      | V2ProjectSubserviceResource
    )[];
  };
export type V2GetProjectServiceByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project service */
  include?: (
    | "project"
    | "project-location"
    | "project-phase"
    | "project-resource"
    | "resource"
    | "service"
    | "lob"
    | "service-category"
    | "project-subservices"
  )[];
};
export type V2UpdateProjectServiceApiResponse =
  /** status 200 Update Project Service response */ {
    data?: V2ProjectServiceResource;
  };
export type V2UpdateProjectServiceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectServiceResource;
  };
};
export type V2DeleteProjectServiceApiResponse =
  /** status 204 The Delete Project Service was deleted successfully */ undefined;
export type V2DeleteProjectServiceApiArg = {
  /** ID of record */
  id: number;
};
export type V2DuplicateProjectServiceByIdApiResponse =
  /** status 200 Project Service response */ {
    data?: V2ProjectServiceResource[];
  };
export type V2DuplicateProjectServiceByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: {
      id: number;
      type: string;
      attributes?: {
        all_locations?: boolean;
      };
    };
  };
};
export type V2RefreshProjectServiceByIdApiResponse =
  /** status 200 Project Service response */ {
    data?: V2ProjectServiceResource;
  };
export type V2RefreshProjectServiceByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: {
      id: number;
      type: string;
    };
  };
};
export type V2SyncrhonizeStandardProjectServiceByIdApiResponse =
  /** status 200 Project Service response */ {
    data?: V2ProjectServiceResource;
  };
export type V2SyncrhonizeStandardProjectServiceByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountProjectServicesApiResponse =
  /** status 200 Project services count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectServicesApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListProjectSubservicesApiResponse =
  /** status 200 Project Subservice list response */ {
    data?: V2ProjectSubserviceResource[];
    included?: (
      | V2AccountResource
      | V2ProjectResource
      | V2ProjectServiceResource
      | V2ProjectLocationResource
      | V2LobResource
      | V2PhaseResource
      | V2ProjectResourceResource
      | V2ResourceResource
      | V2ServiceCategoryResource
      | V2SubserviceResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectSubservicesApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project subservice */
  include?: (
    | "account"
    | "project"
    | "project-service"
    | "project-location"
    | "lob"
    | "phase"
    | "project-resource"
    | "resource"
    | "service-category"
    | "subservice"
  )[];
};
export type V2CreateProjectSubserviceApiResponse =
  /** status 201 Create Project Subservice response */ {
    data?: V2ProjectSubserviceResource;
  };
export type V2CreateProjectSubserviceApiArg = {
  body: {
    data?: V2ProjectSubserviceResource;
  };
};
export type V2GetProjectSubserviceByIdApiResponse =
  /** status 200 Project Subservice list response */ {
    data?: V2ProjectSubserviceResource;
    included?: (
      | V2AccountResource
      | V2ProjectResource
      | V2ProjectServiceResource
      | V2ProjectLocationResource
      | V2LobResource
      | V2PhaseResource
      | V2ProjectResourceResource
      | V2ResourceResource
      | V2ServiceCategoryResource
      | V2SubserviceResource
    )[];
  };
export type V2GetProjectSubserviceByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateProjectSubserviceApiResponse =
  /** status 200 Update Project Subservice response */ {
    data?: V2ProjectSubserviceResource;
  };
export type V2UpdateProjectSubserviceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectSubserviceResource;
  };
};
export type V2DeleteProjectSubserviceApiResponse =
  /** status 204 The Delete Project Subservice was deleted successfully */ undefined;
export type V2DeleteProjectSubserviceApiArg = {
  /** ID of record */
  id: number;
};
export type V2SyncrhonizeStandardProjectSubserviceByIdApiResponse =
  /** status 200 Project Subservice response */ {
    data?: V2ProjectSubserviceResource;
  };
export type V2SyncrhonizeStandardProjectSubserviceByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListProjectSurveysApiResponse =
  /** status 200 Project Survey list response */ {
    data?: V2ProjectSurveyResource[];
    included?: (V2ProjectResource | V2SurveyResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectSurveysApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CountProjectSurveysApiResponse =
  /** status 200 project surveys count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectSurveysApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2GetProjectSurveyApiResponse = /** status 200 Project response */ {
  data?: V2ProjectSurveyResource;
  included?: (V2ProjectResource | V2SurveyResource)[];
};
export type V2GetProjectSurveyApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project survey */
  include?: ("project" | "survey")[];
};
export type V2ListProjectVariablesApiResponse =
  /** status 200 Project Variable list response */ {
    data?: V2ProjectVariableResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectVariablesApiArg = {
  filter?: {
    "variable-context"?:
      | "client"
      | "crm_opportunity"
      | "project"
      | "governance"
      | "service_location"
      | "project_contact"
      | "product"
      | "resource"
      | "section"
      | "service"
      | "teammate";
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project variable */
  include?: "account"[];
};
export type V2CreateProjectVariableApiResponse =
  /** status 201 Create Project Variable response */ {
    data?: V2ProjectVariableResource;
  };
export type V2CreateProjectVariableApiArg = {
  body: {
    data?: V2ProjectVariableResource;
  };
};
export type V2GetProjectVariableByIdApiResponse =
  /** status 200 Find Project Variable by ID response */ {
    data?: V2ProjectVariableResource;
    included?: V2AccountResource[];
    links?: V2Paging;
  };
export type V2GetProjectVariableByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project variable */
  include?: "account"[];
};
export type V2UpdateProjectVariableApiResponse =
  /** status 200 Update Project Variable response */ {
    data?: V2ProjectVariableResource;
  };
export type V2UpdateProjectVariableApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectVariableResource;
  };
};
export type V2DeleteProjectVariableApiResponse =
  /** status 204 The project variable was deleted successfully */ undefined;
export type V2DeleteProjectVariableApiArg = {
  /** ID of record */
  id: number;
};
export type V2ChangeProjectVariablePositionByIdApiResponse =
  /** status 200 Repositioned project variable response */ {
    data?: V2ProjectVariableResource;
  };
export type V2ChangeProjectVariablePositionByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectVariableResource;
  };
};
export type V2RestoreProjectVariableByIdApiResponse =
  /** status 200 Restored project variable response */ {
    data?: V2ProjectVariableResource;
  };
export type V2RestoreProjectVariableByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2PurgeProjectVariableByIdApiResponse =
  /** status 204 The project variable was purged successfully */ undefined;
export type V2PurgeProjectVariableByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListProjectVersionsApiResponse =
  /** status 200 Project Version list response */ {
    data?: V2ProjectVersionResource[];
    included?: (V2ProjectResource | V2ApprovalStepResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectVersionsApiArg = {
  filter?: {
    project?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project version */
  include?: ("project" | "approval-steps")[];
};
export type V2CreateProjectVersionApiResponse =
  /** status 201 Create Project Version response */ {
    data?: V2ProjectVersionResource;
  };
export type V2CreateProjectVersionApiArg = {
  body: {
    data?: V2ProjectVersionResource;
  };
};
export type V2GetProjectVersionByIdApiResponse =
  /** status 200 Project list response */ {
    data?: V2ProjectVersionResource;
    included?: (V2ProjectResource | V2ApprovalStepResource)[];
  };
export type V2GetProjectVersionByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateProjectVersionApiResponse =
  /** status 200 Update Project Version response */ {
    data?: V2ProjectVersionResource;
  };
export type V2UpdateProjectVersionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ProjectVersionResource;
  };
};
export type V2RevertProjectVersionApiResponse =
  /** status 204 Project state was reverted successfully */ undefined;
export type V2RevertProjectVersionApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountProjectVersionsApiResponse =
  /** status 200 project versions count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountProjectVersionsApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListProjectsForAccountApiResponse =
  /** status 200 Project list response */ {
    data?: V2ProjectResource[];
    included?: (
      | V2AccountResource
      | V2BusinessUnitResource
      | V2ClientResource
      | V2CreatorResource
      | V2DocumentTemplateResource
      | V2ExternalRequestResource
      | V2SalesExecutiveResource
      | V2PresalesEngineerResource
      | V2PsaProjectResource
      | V2PaymentTermResource
      | V2RateTableResource
      | V2CrmOpportunityResource
      | V2ApprovalStepResource
      | V2CustomerSuccessResource
      | V2NoteResource
      | V2ProjectAttachmentResource
      | V2ProjectCollaboratorResource
      | V2ProjectContactResource
      | V2ProjectConditionResource
      | V2ProjectCreditResource
      | V2ProjectDocumentResource
      | V2ProjectExpenseResource
      | V2ProjectGovernanceResource
      | V2ProjectLocationResource
      | V2ProjectProductResource
      | V2ProjectPhaseResource
      | V2ProjectResourceResource
      | V2ResourcePlanResource
      | V2ProjectServiceResource
      | V2PartnerRequestResource
      | V2ProjectVersionResource
      | V2ResourceRateResource
      | V2QuoteResource
      | V2AuditLogResource
      | V2PricingAdjustmentResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListProjectsForAccountApiArg = {
  filter?: {
    "project-name"?: string;
    status?:
      | "building"
      | "technical_approval"
      | "sales_approval"
      | "business_approval"
      | "approved"
      | "won"
      | "lost"
      | "canceled";
    "creator.id"?: string;
    "team.id"?: string;
    "collaborator.id"?: string;
    "client.id"?: string;
    "client.name"?: string;
    "presales-engineer.id"?: string;
    "presales-engineer.name"?: string;
    "sales-executive.id"?: string;
    "sales-executive.name"?: string;
    "created-at.after"?: string;
    "created-at.before"?: string;
    "updated-at.after"?: string;
    "updated-at.before"?: string;
    "approved-at.after"?: string;
    "approved-at.before"?: string;
    "my-projects"?: boolean;
    "tag-list"?: string;
    active?: boolean;
    "service-id"?: string;
    "rate-table"?: string;
    lob?: string;
    "business-unit"?: string;
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "active"
    | "-active"
    | "project-name"
    | "-project-name"
    | "status"
    | "-status"
    | "project-variables"
    | "-project-variables"
    | "submitted-at"
    | "-submitted-at"
    | "approved-at"
    | "-approved-at"
    | "executive-summary"
    | "-executive-summary"
    | "key-objectives"
    | "-key-objectives"
    | "our-responsibilities"
    | "-our-responsibilities"
    | "client-responsibilities"
    | "-client-responsibilities"
    | "solution-summary"
    | "-solution-summary"
    | "out-of-scope"
    | "-out-of-scope"
    | "field-labels"
    | "-field-labels"
    | "payment-info"
    | "-payment-info"
    | "total-effort"
    | "-total-effort"
    | "total-revenue"
    | "-total-revenue"
    | "ms-revenue"
    | "-ms-revenue"
    | "third-party-revenue"
    | "-third-party-revenue"
    | "contract-revenue"
    | "-contract-revenue"
    | "contract-cost"
    | "-contract-cost"
    | "price-adjustment"
    | "-price-adjustment"
    | "mrr-adjustment"
    | "-mrr-adjustment"
    | "mrr-terms"
    | "-mrr-terms"
    | "recurring-billing-frequency"
    | "-recurring-billing-frequency"
    | "contract-margin"
    | "-contract-margin"
    | "service-start-date"
    | "-service-start-date"
    | "include-ps-revenue-in-mrr"
    | "-include-ps-revenue-in-mrr"
    | "net-mrr"
    | "-net-mrr"
    | "created-at"
    | "-created-at"
    | "updated-at"
    | "-updated-at"
    | "tag-list"
    | "-tag-list"
    | "client-name"
    | "-client-name"
    | "presales-engineer-name"
    | "-presales-engineer-name"
    | "sales-executive-name"
    | "-sales-executive-name"
    | "travel-limit"
    | "-travel-limit"
    | "service-category"
    | "-service-category"
    | "cola"
    | "-cola"
    | "msa-date"
    | "-msa-date"
    | "storage-options"
    | "-storage-options"
    | "ps-revenue-adjustment"
    | "-ps-revenue-adjustment"
    | "ps-cost-adjustment"
    | "-ps-cost-adjustment"
    | "ms-revenue-adjustment"
    | "-ms-revenue-adjustment"
    | "ms-cost-adjustment"
    | "-ms-cost-adjustment"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project */
  include?: (
    | "account"
    | "business-unit"
    | "client"
    | "creator"
    | "document-template"
    | "external-request"
    | "sales-executive"
    | "presales-engineer"
    | "psa-project"
    | "payment-term"
    | "rate-table"
    | "crm-opportunity"
    | "approval-steps"
    | "customer-successes"
    | "notes"
    | "project-attachments"
    | "project-collaborators"
    | "project-contacts"
    | "project-conditions"
    | "project-credits"
    | "project-documents"
    | "project-expenses"
    | "project-governances"
    | "project-locations"
    | "project-products"
    | "project-phases"
    | "project-resources"
    | "resource-plans"
    | "project-services"
    | "partner-requests"
    | "project-versions"
    | "resource-rates"
    | "quotes"
    | "audit-logs"
    | "pricing-adjustments"
  )[];
};
export type V2CreateProjectApiResponse =
  /** status 201 Create Project response */ {
    data?: V2ProjectResource;
  };
export type V2CreateProjectApiArg = {
  body: {
    data?: V2CreateProjectResource;
  };
};
export type V2GetProjectByIdApiResponse =
  /** status 200 Project list response */ {
    data?: V2ProjectResource;
    included?: (
      | V2AccountResource
      | V2BusinessUnitResource
      | V2ClientResource
      | V2CreatorResource
      | V2DocumentTemplateResource
      | V2ExternalRequestResource
      | V2SalesExecutiveResource
      | V2PresalesEngineerResource
      | V2PsaProjectResource
      | V2PaymentTermResource
      | V2RateTableResource
      | V2CrmOpportunityResource
      | V2ApprovalStepResource
      | V2CustomerSuccessResource
      | V2NoteResource
      | V2ProjectAttachmentResource
      | V2ProjectCollaboratorResource
      | V2ProjectContactResource
      | V2ProjectConditionResource
      | V2ProjectCreditResource
      | V2ProjectDocumentResource
      | V2ProjectExpenseResource
      | V2ProjectGovernanceResource
      | V2ProjectLocationResource
      | V2ProjectProductResource
      | V2ProjectPhaseResource
      | V2ProjectResourceResource
      | V2ResourcePlanResource
      | V2ProjectServiceResource
      | V2PartnerRequestResource
      | V2ProjectVersionResource
      | V2ResourceRateResource
      | V2QuoteResource
      | V2AuditLogResource
      | V2PricingAdjustmentResource
    )[];
  };
export type V2GetProjectByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project */
  include?: (
    | "account"
    | "business-unit"
    | "client"
    | "creator"
    | "document-template"
    | "external-request"
    | "sales-executive"
    | "presales-engineer"
    | "psa-project"
    | "payment-term"
    | "rate-table"
    | "crm-opportunity"
    | "approval-steps"
    | "customer-successes"
    | "notes"
    | "project-attachments"
    | "project-collaborators"
    | "project-contacts"
    | "project-conditions"
    | "project-credits"
    | "project-documents"
    | "project-expenses"
    | "project-governances"
    | "project-locations"
    | "project-products"
    | "project-phases"
    | "project-resources"
    | "resource-plans"
    | "project-services"
    | "partner-requests"
    | "project-versions"
    | "resource-rates"
    | "quotes"
    | "audit-logs"
    | "pricing-adjustments"
  )[];
};
export type V2UpdateProjectApiResponse =
  /** status 200 Update Project response */ {
    data?: V2ProjectResource;
  };
export type V2UpdateProjectApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2CreateProjectResource;
  };
};
export type V2DeleteProjectApiResponse =
  /** status 204 The Project was deleted successfully */ undefined;
export type V2DeleteProjectApiArg = {
  /** ID of record */
  id: number;
};
export type V2PurgeProjectApiResponse =
  /** status 204 The Project was deleted successfully */ undefined;
export type V2PurgeProjectApiArg = {
  /** ID of record */
  id: number;
};
export type V2RemoveCrmIntegrationFromProjectApiResponse =
  /** status 204 The Project CRM Integration was deleted successfully */ undefined;
export type V2RemoveCrmIntegrationFromProjectApiArg = {
  /** ID of record */
  id: number;
};
export type V2RequestApprovalForProjectByIdApiResponse =
  /** status 200 Project after approval request */ {
    data?: V2ProjectResource;
  };
export type V2RequestApprovalForProjectByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2CancelApprovalRequestForProjectByIdApiResponse =
  /** status 200 Project after approval request canceled */ {
    data?: V2ProjectResource;
  };
export type V2CancelApprovalRequestForProjectByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2RestartScopingForProjectByIdApiResponse =
  /** status 200 Project after restarting scoping */ {
    data?: V2ProjectResource;
  };
export type V2RestartScopingForProjectByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateProjectToWonByIdApiResponse =
  /** status 200 Project after marked won */ {
    data?: V2ProjectResource;
  };
export type V2UpdateProjectToWonByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateProjectToLostByIdApiResponse =
  /** status 200 Project after marked lost */ {
    data?: V2ProjectResource;
  };
export type V2UpdateProjectToLostByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2SyncProjectRevenueToCrmApiResponse =
  /** status 204 The Project synchronized successfully */ undefined;
export type V2SyncProjectRevenueToCrmApiArg = {
  /** ID of record */
  id: number;
};
export type V2DuplicateProjectByIdApiResponse =
  /** status 200 Duplicate Project */ {
    data?: V2ProjectResource;
  };
export type V2DuplicateProjectByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2ExportProjectsApiResponse = /** status 202 Export job started */ {
  message?: string;
  job_id?: string;
};
export type V2ExportProjectsApiArg = {
  body: {
    data?: {
      attributes: {
        include_archived: boolean;
      };
    };
  };
};
export type V2UpdateTargetMarginApiResponse =
  /** status 200 Project after project service target margins set */ {
    data?: V2ProjectResource;
  };
export type V2UpdateTargetMarginApiArg = {
  /** ID of record */
  id: number;
};
export type V2ProjectMergeDataApiResponse =
  /** status 200 Merge data for the project */ {
    data?: {
      id?: string;
      type?: string;
      attributes?: {
        content?: object;
      };
    };
  };
export type V2ProjectMergeDataApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListPromptContentsForAccountApiResponse =
  /** status 200 PromptContent list response */ {
    data?: V2PromptContentResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListPromptContentsForAccountApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2GetPromptContentApiResponse = /** status 200 Project response */ {
  data?: V2PromptContentResource;
};
export type V2GetPromptContentApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListPromptOverridesForAccountApiResponse =
  /** status 200 PromptOverride list response */ {
    data?: V2PromptOverrideResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListPromptOverridesForAccountApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each client */
  include?: ("account" | "open-router-key")[];
};
export type V2CreatePromptOverrideApiResponse =
  /** status 201 Create PromptOverride response */ {
    data?: V2PromptOverrideResource;
  };
export type V2CreatePromptOverrideApiArg = {
  body: {
    data?: V2PromptOverrideResource;
  };
};
export type V2GetPromptOverrideApiResponse =
  /** status 200 Project response */ {
    data?: V2PromptOverrideResource;
  };
export type V2GetPromptOverrideApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each client */
  include?: ("account" | "open-router-key")[];
};
export type V2UpdatePromptOverrideApiResponse =
  /** status 200 Update PromptOverride response */ {
    data?: V2PromptOverrideResource;
  };
export type V2UpdatePromptOverrideApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2PromptOverrideResource;
  };
};
export type V2DeletePromptOverrideApiResponse =
  /** status 204 The prompt override was deleted successfully */ undefined;
export type V2DeletePromptOverrideApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListQuestionnaireSectionsForQuestionnaireApiResponse =
  /** status 200 Questionnaire Section list response */ {
    data?: V2QuestionnaireSectionResource[];
    included?: (V2QuestionnaireResource | V2QuestionResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListQuestionnaireSectionsForQuestionnaireApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "name"
    | "-name"
    | "expression"
    | "-expression"
    | "position"
    | "-position"
    | "introduction"
    | "-introduction"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each questionnaire section */
  include?: ("questionnaire" | "questions")[];
};
export type V2CreateQuestionnaireSectionApiResponse =
  /** status 201 Create Questionnaire Section response */ {
    data?: V2QuestionnaireSectionResource;
  };
export type V2CreateQuestionnaireSectionApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  body: {
    data?: V2QuestionnaireSectionResource;
  };
};
export type V2GetQuestionnaireSectionByIdApiResponse =
  /** status 200 Find questionnaire section by ID response */ {
    data?: V2QuestionnaireSectionResource;
    included?: (V2QuestionnaireResource | V2QuestionResource)[];
    links?: V2Paging;
  };
export type V2GetQuestionnaireSectionByIdApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
  /** Include related resources in the response. The only supported value is "questions". */
  include?: ("questionnaire" | "questions")[];
};
export type V2UpdateQuestionnaireSectionApiResponse =
  /** status 200 Update Questionnaire Section response */ {
    data?: V2QuestionnaireSectionResource;
  };
export type V2UpdateQuestionnaireSectionApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2QuestionnaireSectionResource;
  };
};
export type V2DeleteQuestionnaireSectionApiResponse =
  /** status 204 The Delete QuestionnaireSection was deleted successfully */ undefined;
export type V2DeleteQuestionnaireSectionApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
};
export type V2ListQuestionnairesForAccountApiResponse =
  /** status 200 Questionnaire list response */ {
    data?: V2QuestionnaireResource[];
    included?: (
      | V2AccountResource
      | V2QuestionResource
      | V2QuestionnaireSectionResource
      | V2QuestionnaireCalculationResource
      | V2QuestionnaireLookupResource
      | V2QuestionnaireRecommendationResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListQuestionnairesForAccountApiArg = {
  filter?: {
    "tag-list"?: string;
    "service-id"?: string;
    "team.id"?: string[];
    active?: boolean;
    published?: boolean;
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "active"
    | "-active"
    | "name"
    | "-name"
    | "published"
    | "-published"
    | "created-at"
    | "-created-at"
    | "slug"
    | "-slug"
    | "introduction"
    | "-introduction"
    | "thank-you"
    | "-thank-you"
    | "completion-url"
    | "-completion-url"
    | "questions"
    | "-questions"
    | "sections"
    | "-sections"
    | "tag-list"
    | "-tag-list"
    | "teams"
    | "-teams"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each questionnaire */
  include?: (
    | "account"
    | "questions"
    | "questionnaire-sections"
    | "calculations"
    | "lookups"
    | "recommendations"
  )[];
};
export type V2CreateQuestionnaireApiResponse =
  /** status 201 Create Questionnaire response */ {
    data?: V2QuestionnaireResource;
  };
export type V2CreateQuestionnaireApiArg = {
  body: {
    data?: V2QuestionnaireResource;
  };
};
export type V2GetQuestionnaireByIdApiResponse =
  /** status 200 Find questionnaire by ID response */ {
    data?: V2QuestionnaireResource;
    included?: (
      | V2AccountResource
      | V2QuestionResource
      | V2QuestionnaireSectionResource
      | V2QuestionnaireCalculationResource
      | V2QuestionnaireLookupResource
      | V2QuestionnaireRecommendationResource
    )[];
    links?: V2Paging;
  };
export type V2GetQuestionnaireByIdApiArg = {
  /** ID of record */
  id: number;
  /** Include related resources in the response. The only supported value is "questions". */
  include?: (
    | "account"
    | "questions"
    | "questionnaire-sections"
    | "calculations"
    | "lookups"
    | "recommendations"
  )[];
};
export type V2UpdateQuestionnaireApiResponse =
  /** status 200 Update Questionnaire response */ {
    data?: V2QuestionnaireResource;
  };
export type V2UpdateQuestionnaireApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2QuestionnaireResource;
  };
};
export type V2DeleteQuestionnaireApiResponse =
  /** status 204 The Delete Questionnaire was deleted successfully */ undefined;
export type V2DeleteQuestionnaireApiArg = {
  /** ID of record */
  id: number;
};
export type V2EvaluateQuestionnaireApiResponse =
  /** status 200 Result of evaluating the provided equation based on the survey and provided responses */ {
    data?: {
      id: number;
      type: "questionnaires";
      attributes:
        | V2EvlauateStringAttributes
        | V2EvlauateNumberAttributes
        | V2EvlauateBooleanAttributes;
    };
  };
export type V2EvaluateQuestionnaireApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: {
      id: number;
      type: "questionnaires";
      attributes: {
        responses: {
          question_id: number;
          question: string;
          answer: string;
        }[];
        equation: string;
      };
    };
  };
};
export type V2ListQuestionsForQuestionnaireApiResponse =
  /** status 200 Question list response */ {
    data?: V2QuestionResource[];
    included?: (
      | V2AccountResource
      | V2QuestionnaireResource
      | V2QuestionnaireSectionResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListQuestionsForQuestionnaireApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each question */
  include?: ("account" | "questionnaire" | "questionnaire-section")[];
};
export type V2CreateQuestionApiResponse =
  /** status 201 Create Question response */ {
    data?: V2QuestionResource;
  };
export type V2CreateQuestionApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  body: {
    data?: V2QuestionResource;
  };
};
export type V2GetQuestionByIdApiResponse =
  /** status 200 Find question by ID response */ {
    data?: V2QuestionResource;
    included?: (
      | V2AccountResource
      | V2QuestionnaireResource
      | V2QuestionnaireSectionResource
    )[];
    links?: V2Paging;
  };
export type V2GetQuestionByIdApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each question */
  include?: ("account" | "questionnaire" | "questionnaire-section")[];
};
export type V2UpdateQuestionApiResponse =
  /** status 200 Update Question response */ {
    data?: V2QuestionResource;
  };
export type V2UpdateQuestionApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2QuestionResource;
  };
};
export type V2DeleteQuestionApiResponse =
  /** status 204 The question was deleted successfully */ undefined;
export type V2DeleteQuestionApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
};
export type V2ListQuestionnaireCalculationsForQuestionnaireApiResponse =
  /** status 200 Questionnaire calculation list response */ {
    data?: V2QuestionnaireCalculationResource[];
    included?: V2QuestionnaireResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListQuestionnaireCalculationsForQuestionnaireApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each calculation */
  include?: "questionnaire"[];
};
export type V2CreateQuestionnaireCalculationApiResponse =
  /** status 201 Create questionnaire calculation response */ {
    data?: V2QuestionnaireCalculationResource;
  };
export type V2CreateQuestionnaireCalculationApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  body: {
    data?: V2QuestionnaireCalculationResource;
  };
};
export type V2GetQuestionnaireCalculationByIdApiResponse =
  /** status 200 Find questionnaire calculation by ID response */ {
    data?: V2QuestionnaireCalculationResource;
    links?: V2Paging;
  };
export type V2GetQuestionnaireCalculationByIdApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
};
export type V2UpdateQuestionnaireCalculationApiResponse =
  /** status 200 Update questionnaire calculation response */ {
    data?: V2QuestionnaireCalculationResource;
  };
export type V2UpdateQuestionnaireCalculationApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2QuestionnaireCalculationResource;
  };
};
export type V2DeleteQuestionnaireCalculationApiResponse =
  /** status 204 The questionnaire calculation was deleted successfully */ undefined;
export type V2DeleteQuestionnaireCalculationApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
};
export type V2ListQuestionnaireLookupsForQuestionnaireApiResponse =
  /** status 200 Questionnaire lookup list response */ {
    data?: V2QuestionnaireLookupResource[];
    included?: V2QuestionnaireResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListQuestionnaireLookupsForQuestionnaireApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each lookup */
  include?: "questionnaire"[];
};
export type V2CreateQuestionnaireLookupApiResponse =
  /** status 201 Create questionnaire lookup response */ {
    data?: V2QuestionnaireLookupResource;
  };
export type V2CreateQuestionnaireLookupApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  body: {
    data?: V2QuestionnaireLookupResource;
  };
};
export type V2GetQuestionnaireLookupByIdApiResponse =
  /** status 200 Find questionnaire lookup by ID response */ {
    data?: V2QuestionnaireLookupResource;
    links?: V2Paging;
  };
export type V2GetQuestionnaireLookupByIdApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
};
export type V2UpdateQuestionnaireLookupApiResponse =
  /** status 200 Update questionnaire lookup response */ {
    data?: V2QuestionnaireLookupResource;
  };
export type V2UpdateQuestionnaireLookupApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2QuestionnaireLookupResource;
  };
};
export type V2DeleteQuestionnaireLookupApiResponse =
  /** status 204 The questionnaire lookup was deleted successfully */ undefined;
export type V2DeleteQuestionnaireLookupApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
};
export type V2ListQuestionnaireRecommendationsForQuestionnaireApiResponse =
  /** status 200 Questionnaire recommendation list response */ {
    data?: V2QuestionnaireRecommendationResource[];
    included?: V2QuestionnaireResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListQuestionnaireRecommendationsForQuestionnaireApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each recommendation */
  include?: "questionnaire"[];
};
export type V2CreateQuestionnaireRecommendationApiResponse =
  /** status 201 Create questionnaire recommendation response */ {
    data?: V2QuestionnaireRecommendationResource;
  };
export type V2CreateQuestionnaireRecommendationApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  body: {
    data?: V2QuestionnaireRecommendationResource;
  };
};
export type V2GetQuestionnaireRecommendationByIdApiResponse =
  /** status 200 Find questionnaire recommendation by ID response */ {
    data?: V2QuestionnaireRecommendationResource;
    links?: V2Paging;
  };
export type V2GetQuestionnaireRecommendationByIdApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
};
export type V2UpdateQuestionnaireRecommendationApiResponse =
  /** status 200 Update questionnaire recommendation response */ {
    data?: V2QuestionnaireRecommendationResource;
  };
export type V2UpdateQuestionnaireRecommendationApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2QuestionnaireRecommendationResource;
  };
};
export type V2DeleteQuestionnaireRecommendationApiResponse =
  /** status 204 The questionnaire recommendation was deleted successfully */ undefined;
export type V2DeleteQuestionnaireRecommendationApiArg = {
  /** ID of the questionnaire */
  questionnaireId: number;
  /** ID of record */
  id: number;
};
export type V2ListQuotesForAccountApiResponse =
  /** status 200 Quote list response */ {
    data?: V2QuoteResource[];
    included?: (V2ProjectResource | V2VendorResource | V2LobResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListQuotesForAccountApiArg = {
  filter?: {
    project?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each project quote */
  include?: ("project" | "vendor" | "lob")[];
};
export type V2CreateQuoteApiResponse = /** status 201 Create Quote response */ {
  data?: V2QuoteResource;
};
export type V2CreateQuoteApiArg = {
  body: {
    data?: V2QuoteResource;
  };
};
export type V2GetQuoteApiResponse = /** status 200 Project response */ {
  data?: V2QuoteResource;
  included?: (V2ProjectResource | V2VendorResource | V2LobResource)[];
};
export type V2GetQuoteApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project quote */
  include?: ("project" | "vendor" | "lob")[];
};
export type V2UpdateQuoteApiResponse = /** status 200 Update Quote response */ {
  data?: V2QuoteResource;
};
export type V2UpdateQuoteApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project quote */
  include?: ("project" | "vendor" | "lob")[];
  body: {
    data?: V2QuoteResource;
  };
};
export type V2DeleteQuoteApiResponse =
  /** status 204 The Delete Quote was deleted successfully */ undefined;
export type V2DeleteQuoteApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each project quote */
  include?: ("project" | "vendor" | "lob")[];
};
export type V2RecalculateQuoteApiResponse =
  /** status 200 Recalculate Quote response */ {
    data?: V2QuoteResource;
  };
export type V2RecalculateQuoteApiArg = {
  /** ID of record */
  id: number;
};
export type V2AcceptVendorDocumentForQuoteApiResponse =
  /** status 200 Quote response */ {
    data?: V2QuoteResource;
  };
export type V2AcceptVendorDocumentForQuoteApiArg = {
  /** ID of record */
  id: number;
};
export type V2CountQuotesApiResponse =
  /** status 200 quotes count successful */ {
    meta?: V2RecordCount;
  };
export type V2CountQuotesApiArg = {
  /** ID of project to which the resource is associated */
  projectId: number;
};
export type V2ListRateTablesForAccountApiResponse =
  /** status 200 Rate Table list response */ {
    data?: V2RateTableResource[];
    included?: (
      | V2AccountResource
      | V2CurrencyResource
      | V2ClientResource
      | V2ProjectResource
      | V2UserResource
      | V2ResourceRateResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListRateTablesForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each rate table */
  include?: (
    | "account"
    | "currency"
    | "clients"
    | "projects"
    | "users"
    | "resource-rates"
  )[];
};
export type V2CreateRateTableApiResponse =
  /** status 201 Create Rate Table response */ {
    data?: V2RateTableResource;
  };
export type V2CreateRateTableApiArg = {
  body: {
    data?: V2RateTableResource;
  };
};
export type V2GetRateTableApiResponse = /** status 200 Rate table response */ {
  data?: V2RateTableResource;
};
export type V2GetRateTableApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with the rate table */
  include?: (
    | "account"
    | "currency"
    | "clients"
    | "projects"
    | "users"
    | "resource-rates"
  )[];
};
export type V2UpdateRateTableApiResponse =
  /** status 200 Update Rate table response */ {
    data?: V2RateTableResource;
  };
export type V2UpdateRateTableApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2RateTableResource;
  };
};
export type V2DeleteRateTableApiResponse =
  /** status 204 The Delete Rate Table was deleted successfully */ undefined;
export type V2DeleteRateTableApiArg = {
  /** ID of record */
  id: number;
};
export type V2DuplicateRateTableApiResponse =
  /** status 200 Newly duplicated Rate table response */ {
    data?: V2RateTableResource;
  };
export type V2DuplicateRateTableApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListReleaseFlagsApiResponse =
  /** status 200 Release flag list response */ {
    data?: V2ReleaseFlagResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListReleaseFlagsApiArg = {
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "name"
    | "-name"
    | "key"
    | "-key"
    | "description"
    | "-description"
    | "beta-release-date"
    | "-beta-release-date"
    | "general-availability-date"
    | "-general-availability-date"
    | "status"
    | "-status"
  )[];
  filter?: {
    status?: ("building" | "beta_test" | "released")[];
  };
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateReleaseFlagApiResponse =
  /** status 201 Create release flag response */ {
    data?: V2ReleaseFlagResource;
  };
export type V2CreateReleaseFlagApiArg = {
  body: {
    data?: V2ReleaseFlagResource;
  };
};
export type V2GetReleaseFlagApiResponse =
  /** status 200 Release flag response */ {
    data?: V2ReleaseFlagResource;
  };
export type V2GetReleaseFlagApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateReleaseFlagApiResponse =
  /** status 200 Update release flag response */ {
    data?: V2ReleaseFlagResource;
  };
export type V2UpdateReleaseFlagApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ReleaseFlagResource;
  };
};
export type V2DeleteReleaseFlagApiResponse =
  /** status 204 Release flag deleted */ undefined;
export type V2DeleteReleaseFlagApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListResourceAllocationsApiResponse =
  /** status 200 Resource allocation list response */ {
    data?: V2ResourceAllocationResource[];
    included?: (V2ResourcePlanResource | V2ProjectResourceResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListResourceAllocationsApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each resource allocation */
  include?: ("resource-plan" | "project-resource")[];
};
export type V2CreateResourceAllocationApiResponse =
  /** status 201 Create Resource allocation response */ {
    data?: V2ResourceAllocationResource;
  };
export type V2CreateResourceAllocationApiArg = {
  body: {
    data?: V2ResourceAllocationResource;
  };
};
export type V2GetResourceAllocationByIdApiResponse =
  /** status 200 Project list response */ {
    data?: V2ResourceAllocationResource;
  };
export type V2GetResourceAllocationByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateResourceAllocationApiResponse =
  /** status 200 Update Resource allocation response */ {
    data?: V2ResourceAllocationResource;
  };
export type V2UpdateResourceAllocationApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ResourceAllocationResource;
  };
};
export type V2DeleteResourceAllocationApiResponse =
  /** status 204 The Resource allocation was deleted successfully */ undefined;
export type V2DeleteResourceAllocationApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListResourcePlansApiResponse =
  /** status 200 Resource plan list response */ {
    data?: V2ResourcePlanResource[];
    included?: (V2ResourcePlanResource | V2ProjectResourceResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListResourcePlansApiArg = {
  filter?: {
    project?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each resource plan */
  include?: ("project" | "resource-allocations")[];
};
export type V2CreateResourcePlanApiResponse =
  /** status 201 Create Resource plan response */ {
    data?: V2ResourcePlanResource;
  };
export type V2CreateResourcePlanApiArg = {
  body: {
    data?: V2ResourcePlanResource;
  };
};
export type V2GetResourcePlanByIdApiResponse =
  /** status 200 Project list response */ {
    data?: V2ResourcePlanResource;
  };
export type V2GetResourcePlanByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateResourcePlanApiResponse =
  /** status 200 Update Resource plan response */ {
    data?: V2ResourcePlanResource;
  };
export type V2UpdateResourcePlanApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ResourcePlanResource;
  };
};
export type V2DeleteResourcePlanApiResponse =
  /** status 204 The Resource plan was deleted successfully */ undefined;
export type V2DeleteResourcePlanApiArg = {
  /** ID of record */
  id: number;
};
export type V2DuplicateResourcePlanApiResponse =
  /** status 200 The Resource plan was deleted successfully */ {
    data?: V2ResourcePlanResource;
  };
export type V2DuplicateResourcePlanApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ResourcePlanResource;
  };
};
export type V2ListResourceRatesForAccountApiResponse =
  /** status 200 Resource Rate list response */ {
    data?: V2ResourceRateResource[];
    included?: (
      | V2AccountResource
      | V2CurrencyResource
      | V2ClientResource
      | V2ProjectResource
      | V2UserResource
      | V2ResourceRateResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListResourceRatesForAccountApiArg = {
  filter?: {
    resource?: string;
    "rate-table"?: string;
    active?: boolean;
    "governed-categories"?: string[];
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each resource rate */
  include?: ("rate-table" | "resource" | "line-of-business")[];
};
export type V2CreateResourceRateApiResponse =
  /** status 201 Create ResourceRate response */ {
    data?: V2ResourceRateResource;
  };
export type V2CreateResourceRateApiArg = {
  body: {
    data?: V2ResourceRateResource;
  };
};
export type V2GetResourceRateByIdApiResponse =
  /** status 200 Find resource rate by ID response */ {
    data?: V2ResourceRateResource;
  };
export type V2GetResourceRateByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateResourceRateApiResponse =
  /** status 200 Update Resource Rate response */ {
    data?: V2ResourceRateResource;
  };
export type V2UpdateResourceRateApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ResourceRateResource;
  };
};
export type V2DeleteResourceRateApiResponse =
  /** status 204 The Delete Resource Rate was deleted successfully */ undefined;
export type V2DeleteResourceRateApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListResourcesForAccountApiResponse =
  /** status 200 Resource list response */ {
    data?: V2ResourceResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListResourcesForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  /** Associated data that may be loaded with each resource */
  include?: "account"[];
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateResourceApiResponse =
  /** status 201 Create Resource response */ {
    data?: V2ResourceResource;
  };
export type V2CreateResourceApiArg = {
  body: {
    data?: V2ResourceResource;
  };
};
export type V2GetResourceByIdApiResponse =
  /** status 200 Find resource by ID response */ {
    data?: V2ResourceResource;
  };
export type V2GetResourceByIdApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateResourceApiResponse =
  /** status 200 Update Resource response */ {
    data?: V2ResourceResource;
  };
export type V2UpdateResourceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ResourceResource;
  };
};
export type V2DeleteResourceApiResponse =
  /** status 204 The resource was deleted successfully */ undefined;
export type V2DeleteResourceApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListRolesForAccountApiResponse =
  /** status 200 Role list response */ {
    data?: V2RoleResource[];
    included?: (V2AccountResource | V2UserResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListRolesForAccountApiArg = {
  filter?: {
    name?: string;
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "name"
    | "-name"
    | "privileges"
    | "-privileges"
    | "default"
    | "-default"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each role */
  include?: ("account" | "users")[];
};
export type V2CreateRoleApiResponse = /** status 201 Create Role response */ {
  data?: V2RoleResource;
};
export type V2CreateRoleApiArg = {
  body: {
    data?: V2RoleResource;
  };
};
export type V2GetRoleApiResponse = /** status 200 Project response */ {
  data?: V2RoleResource;
  included?: (V2AccountResource | V2UserResource)[];
};
export type V2GetRoleApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each role */
  include?: ("account" | "users")[];
};
export type V2UpdateRoleApiResponse = /** status 200 Update Role response */ {
  data?: V2RoleResource;
};
export type V2UpdateRoleApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2RoleResource;
  };
};
export type V2DeleteRoleApiResponse =
  /** status 204 The role was deleted successfully */ undefined;
export type V2DeleteRoleApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListSalesExecutivesForAccountApiResponse =
  /** status 200 Sales executive list response */ {
    data?: V2SalesExecutiveResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListSalesExecutivesForAccountApiArg = {
  filter?: {
    name?: string;
    email?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each sales executive */
  include?: "account"[];
};
export type V2CreateSalesExecutiveApiResponse =
  /** status 201 Create Sales executive response */ {
    data?: V2SalesExecutiveResource;
  };
export type V2CreateSalesExecutiveApiArg = {
  body: {
    data?: V2SalesExecutiveResource;
  };
};
export type V2GetSalesExecutiveByIdApiResponse =
  /** status 200 Find sales executive by ID response */ {
    data?: V2SalesExecutiveResource;
    included?: V2AccountResource[];
    links?: V2Paging;
  };
export type V2GetSalesExecutiveByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each sales executive */
  include?: "account"[];
};
export type V2UpdateSalesExecutiveApiResponse =
  /** status 200 Update Sales executive response */ {
    data?: V2SalesExecutiveResource;
  };
export type V2UpdateSalesExecutiveApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2SalesExecutiveResource;
  };
};
export type V2DeleteSalesExecutiveApiResponse =
  /** status 204 The Delete Sales executive was deleted successfully */ undefined;
export type V2DeleteSalesExecutiveApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListServiceCategorysForAccountApiResponse =
  /** status 200 Service Category list response */ {
    data?: V2ServiceCategoryResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListServiceCategorysForAccountApiArg = {
  filter?: {
    name?: string;
    lob?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each service category */
  include?: "account"[];
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "active"
    | "-active"
    | "name"
    | "-name"
    | "nested-name"
    | "-nested-name"
    | "position"
    | "-position"
    | "code"
    | "-code"
    | "has-parent?"
    | "-has-parent?"
    | "lob-id"
    | "-lob-id"
  )[];
};
export type V2GetServiceCategoryApiResponse =
  /** status 200 Service Category response */ {
    data?: V2ServiceCategoryResource;
    included?: V2AccountResource[];
    links?: V2Paging;
  };
export type V2GetServiceCategoryApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListServiceConditionsForAccountApiResponse =
  /** status 200 ServiceCondition list response */ {
    data?: V2ServiceConditionResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListServiceConditionsForAccountApiArg = {
  filter?: {
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each service condition */
  include?: "account"[];
};
export type V2CreateServiceConditionApiResponse =
  /** status 201 Create Service Condition response */ {
    data?: V2ServiceConditionResource;
  };
export type V2CreateServiceConditionApiArg = {
  body: {
    data?: V2ServiceConditionResource;
  };
};
export type V2GetServiceConditionApiResponse =
  /** status 200 Service response */ {
    data?: V2ServiceConditionResource;
    included?: V2AccountResource[];
    links?: V2Paging;
  };
export type V2GetServiceConditionApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each service condition */
  include?: "account"[];
};
export type V2UpdateServiceConditionApiResponse =
  /** status 200 Update ServiceCondition response */ {
    data?: V2ServiceConditionResource;
  };
export type V2UpdateServiceConditionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ServiceConditionResource;
  };
};
export type V2DeleteServiceConditionApiResponse =
  /** status 204 The Service Condition was deleted successfully */ undefined;
export type V2DeleteServiceConditionApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListServicesForAccountApiResponse =
  /** status 200 Service list response */ {
    data?: V2ServiceResource[];
    included?: (
      | V2AccountResource
      | V2ResourceResource
      | V2PhaseResource
      | V2ServiceCategoryResource
      | V2SubserviceResource
      | V2ProductResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListServicesForAccountApiArg = {
  filter?: {
    name?: string;
    tag_list?: string;
    sku?: string;
    lob?: string[];
    "service-category"?: string[];
    phase?: string[];
    blueprint?: string[];
    service_type?: "professional_services" | "managed_services";
    state?: ("pending" | "active" | "deleted" | "custom")[];
    "payment-frequency"?: ("one_time" | "monthly" | "quarterly" | "yearly")[];
    survey_recommended?: boolean;
    questionnaire?: string[];
    exclude?: string;
    active?: boolean;
    "created-at.after"?: string;
    "created-at.before"?: string;
    "updated-at.after"?: string;
    "updated-at.before"?: string;
    ids?: string[];
    search?: string;
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "name"
    | "-name"
    | "service_description"
    | "-service_description"
    | "service_type"
    | "-service_type"
    | "sku"
    | "-sku"
    | "created_at"
    | "-created_at"
    | "updated_at"
    | "-updated_at"
    | "service_category.nested_name"
    | "-service_category.nested_name"
    | "phase.name"
    | "-phase.name"
  )[];
  /** Associated data that may be loaded with each service */
  include?: (
    | "account"
    | "resource"
    | "phase"
    | "service-category"
    | "subservices"
    | "products"
    | "subservices.resource"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateServiceApiResponse =
  /** status 201 Create Service response */ {
    data?: V2ServiceResource;
  };
export type V2CreateServiceApiArg = {
  body: {
    data?: V2ServiceResource;
  };
};
export type V2GetServiceByIdApiResponse =
  /** status 200 Find service by ID response */ {
    data?: V2ServiceResource;
    included?: (
      | V2AccountResource
      | V2ResourceResource
      | V2PhaseResource
      | V2ServiceCategoryResource
      | V2SubserviceResource
      | V2ProductResource
    )[];
    links?: V2Paging;
  };
export type V2GetServiceByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each service */
  include?: (
    | "account"
    | "resource"
    | "phase"
    | "service-category"
    | "subservices"
    | "products"
  )[];
};
export type V2UpdateServiceApiResponse =
  /** status 200 Update Service response */ {
    data?: V2ServiceResource;
  };
export type V2UpdateServiceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ServiceResource;
  };
};
export type V2DeleteServiceApiResponse =
  /** status 204 The Delete Service was deleted successfully */ undefined;
export type V2DeleteServiceApiArg = {
  /** ID of record */
  id: number;
};
export type V2ActivateServiceApiResponse =
  /** status 200 Update service response */ {
    data?: V2ServiceResource;
  };
export type V2ActivateServiceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ServiceResource;
  };
};
export type V2RestoreServiceApiResponse =
  /** status 200 Update service response */ {
    data?: V2ServiceResource;
  };
export type V2RestoreServiceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ServiceResource;
  };
};
export type V2ChangeServicePositionByIdApiResponse =
  /** status 200 Update Service response */ {
    data?: V2ServiceResource;
  };
export type V2ChangeServicePositionByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ServiceResource;
  };
};
export type V2DuplicateServiceApiResponse =
  /** status 200 The service was duplicated successfully */ {
    data?: V2ServiceResource;
  };
export type V2DuplicateServiceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ServiceResource;
  };
};
export type V2DownloadServiceApiResponse = unknown;
export type V2DownloadServiceApiArg = {
  /** ID of record */
  id: number;
};
export type V2DownloadListOfServicesApiResponse = unknown;
export type V2DownloadListOfServicesApiArg = {
  filter?: {
    ids?: string[];
  };
};
export type V2GetSharedSurveyByIdApiResponse =
  /** status 200 Find survey by ID response */ {
    data?: V2SharedSurveyResource;
    included?: (
      | V2SurveyResource
      | V2QuestionnaireResource
      | V2QuestionResource
    )[];
  };
export type V2GetSharedSurveyByIdApiArg = {
  /** ID of record */
  id: string;
  /** Associated data that may be loaded with each survey */
  include?: ("survey" | "questionnaire" | "questions")[];
};
export type V2UpdateSharedSurveyApiResponse =
  /** status 200 Update Shared Survey response */ {
    data?: V2SharedSurveyResource;
  };
export type V2UpdateSharedSurveyApiArg = {
  /** ID of record */
  id: string;
  body: {
    data?: V2SharedSurveyResource;
  };
};
export type V2ListSubcontractorsForAccountApiResponse =
  /** status 200 Subcontractor list response */ {
    data?: V2SubcontractorResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListSubcontractorsForAccountApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2GetSubcontractorApiResponse =
  /** status 200 Subcontractor Project response */ {
    data?: V2SubcontractorResource;
    links?: V2Paging;
  };
export type V2GetSubcontractorApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListSubscriptionsForAccountApiResponse =
  /** status 200 Subscription list response */ {
    data?: V2SubscriptionResource;
  };
export type V2ListSubscriptionsForAccountApiArg = void;
export type V2CreateSubscriptionApiResponse =
  /** status 201 Create Subscription response */ {
    data?: V2SubscriptionResource;
  };
export type V2CreateSubscriptionApiArg = {
  body: {
    data?: V2SubscriptionResource;
  };
};
export type V2GetSubscriptionApiResponse = /** status 200 Project response */ {
  data?: V2SubscriptionResource;
};
export type V2GetSubscriptionApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateSubscriptionApiResponse =
  /** status 200 Update Subscription response */ {
    data?: V2SubscriptionResource;
  };
export type V2UpdateSubscriptionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2SubscriptionResource;
  };
};
export type V2DeleteSubscriptionApiResponse =
  /** status 204 The Delete Subscription was deleted successfully */ undefined;
export type V2DeleteSubscriptionApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListSubservicesForAccountApiResponse =
  /** status 200 Subservice list response */ {
    data?: V2SubserviceResource[];
    included?: (V2ResourceResource | V2ServiceResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListSubservicesForAccountApiArg = {
  filter?: {
    state?: "pending" | "active" | "deleted" | "custom";
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each subservice */
  include?: ("resource" | "service")[];
};
export type V2CreateSubserviceApiResponse =
  /** status 201 Create Subservice response */ {
    data?: V2SubserviceResource;
  };
export type V2CreateSubserviceApiArg = {
  body: {
    data?: V2SubserviceResource;
  };
};
export type V2GetSubserviceByIdApiResponse =
  /** status 200 Find subservice by ID response */ {
    data?: V2SubserviceResource;
    included?: (V2ResourceResource | V2ServiceResource)[];
    links?: V2Paging;
  };
export type V2GetSubserviceByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each subservice */
  include?: ("resource" | "service")[];
};
export type V2UpdateSubserviceApiResponse =
  /** status 200 Update Subservice response */ {
    data?: V2SubserviceResource;
  };
export type V2UpdateSubserviceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2SubserviceResource;
  };
};
export type V2DeleteSubserviceApiResponse =
  /** status 204 The Delete Subservice was deleted successfully */ undefined;
export type V2DeleteSubserviceApiArg = {
  /** ID of record */
  id: number;
};
export type V2ActivateSubserviceApiResponse =
  /** status 200 Update subservice response */ {
    data?: V2SubserviceResource;
  };
export type V2ActivateSubserviceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2SubserviceResource;
  };
};
export type V2ChangeSubservicePositionByIdApiResponse =
  /** status 200 Update Subservice response */ {
    data?: V2SubserviceResource;
  };
export type V2ChangeSubservicePositionByIdApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2SubserviceResource;
  };
};
export type V2ListSurveyRecommendationsForAccountApiResponse =
  /** status 200 Survey list response */ {
    data?: V2SurveyRecommendationResource[];
    included?: (
      | V2SurveyResource
      | V2ResourceResource
      | V2ProjectResourceResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListSurveyRecommendationsForAccountApiArg = {
  filter?: {
    survey?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each survey */
  include?: ("survey" | "resource" | "project-resource")[];
};
export type V2GetSurveyRecommendationByIdApiResponse =
  /** status 200 Find survey recommendation by ID response */ {
    data?: V2SurveyRecommendationResource;
    included?: (
      | V2SurveyResource
      | V2ResourceResource
      | V2ProjectResourceResource
    )[];
  };
export type V2GetSurveyRecommendationByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each survey */
  include?: ("survey" | "resource" | "project-resource")[];
};
export type V2UpdateSurveyRecommendationApiResponse =
  /** status 200 Update Survey response */ {
    data?: V2SurveyRecommendationResource;
  };
export type V2UpdateSurveyRecommendationApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2SurveyRecommendationResource;
  };
};
export type V2DeleteSurveyRecommendationApiResponse =
  /** status 204 The Delete Survey was deleted successfully */ undefined;
export type V2DeleteSurveyRecommendationApiArg = {
  /** ID of record */
  id: number;
};
export type V2ApplySurveyRecommendationApiResponse =
  /** status 200 Survey with calculated recommendations */ {
    data?: V2SurveyRecommendationResource;
  };
export type V2ApplySurveyRecommendationApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListSurveyResponsesForAccountApiResponse =
  /** status 200 Survey Response list response */ {
    data?: V2SurveyResponseResource[];
    included?: (V2SurveyResource | V2QuestionResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListSurveyResponsesForAccountApiArg = {
  filter?: {
    survey?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each client */
  include?: ("survey" | "source")[];
};
export type V2CreateSurveyResponseApiResponse =
  /** status 201 Create Survey Response response */ {
    data?: V2SurveyResponseResource;
  };
export type V2CreateSurveyResponseApiArg = {
  body: {
    data?: V2SurveyResponseResource;
  };
};
export type V2GetSurveyResponseByIdApiResponse =
  /** status 200 Find survey response by ID response */ {
    data?: V2SurveyResponseResource;
    included?: (V2SurveyResource | V2QuestionResource)[];
    links?: V2Paging;
  };
export type V2GetSurveyResponseByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each client */
  include?: ("survey" | "source")[];
};
export type V2UpdateSurveyResponseApiResponse =
  /** status 200 Update Survey Response response */ {
    data?: V2SurveyResponseResource;
  };
export type V2UpdateSurveyResponseApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2SurveyResponseResource;
  };
};
export type V2DeleteSurveyResponseApiResponse =
  /** status 204 The Delete Survey Response was deleted successfully */ undefined;
export type V2DeleteSurveyResponseApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListSurveysForAccountApiResponse =
  /** status 200 Survey list response */ {
    data?: V2SurveyResource[];
    included?: (
      | V2AccountResource
      | V2QuestionnaireResource
      | V2ProjectSurveyResource
      | V2ProjectResource
      | V2SurveyResponseResource
      | V2SurveyRecommendationResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListSurveysForAccountApiArg = {
  filter?: {
    status?: ("pending" | "shared" | "completed" | "applied" | "revised")[];
    name?: string;
    "questionnaire-id"?: string[];
    "project-id"?: string[];
    "tag-list"?: string[];
    "contact-name"?: string;
    "created-at.after"?: string;
    "created-at.before"?: string;
    "updated-at.after"?: string;
    "updated-at.before"?: string;
    creator?: string;
    "sender-id"?: string;
    emails?: string;
    shared?: boolean;
  };
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "name"
    | "-name"
    | "contact_name"
    | "-contact_name"
    | "contact_email"
    | "-contact_email"
    | "responses"
    | "-responses"
    | "recommendations"
    | "-recommendations"
    | "updated_at"
    | "-updated_at"
    | "created_at"
    | "-created_at"
    | "status"
    | "-status"
    | "emails"
    | "-emails"
    | "sender"
    | "-sender"
    | "sent_at"
    | "-sent_at"
    | "calculations"
    | "-calculations"
    | "user_id"
    | "-user_id"
    | "completed_by"
    | "-completed_by"
    | "project.project_name"
    | "-project.project_name"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each survey */
  include?: (
    | "account"
    | "questionnaire"
    | "project-survey"
    | "project"
    | "survey-responses"
    | "survey-recommendations"
  )[];
};
export type V2CreateSurveyApiResponse =
  /** status 201 Create Survey response */ {
    data?: V2SurveyResource;
  };
export type V2CreateSurveyApiArg = {
  body: {
    data?: V2SurveyResource;
  };
};
export type V2GetSurveyByIdApiResponse =
  /** status 200 Find survey by ID response */ {
    data?: V2SurveyResource;
    included?: (
      | V2AccountResource
      | V2QuestionnaireResource
      | V2ProjectSurveyResource
      | V2ProjectResource
      | V2SurveyResponseResource
      | V2SurveyRecommendationResource
    )[];
  };
export type V2GetSurveyByIdApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each survey */
  include?: (
    | "account"
    | "questionnaire"
    | "project-survey"
    | "project"
    | "survey-responses"
    | "survey-recommendations"
  )[];
};
export type V2UpdateSurveyApiResponse =
  /** status 200 Update Survey response */ {
    data?: V2SurveyResource;
  };
export type V2UpdateSurveyApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2SurveyResource;
  };
};
export type V2DeleteSurveyApiResponse =
  /** status 204 The Delete Survey was deleted successfully */ undefined;
export type V2DeleteSurveyApiArg = {
  /** ID of record */
  id: number;
};
export type V2CalculateSurveyRecommendationsApiResponse =
  /** status 200 Survey with calculated recommendations */ {
    data?: V2SurveyResource;
  };
export type V2CalculateSurveyRecommendationsApiArg = {
  /** ID of record */
  id: number;
};
export type V2ApplySurveyRecommendationsApiResponse =
  /** status 200 Survey with applied recommendations */ {
    data?: V2SurveyResource;
  };
export type V2ApplySurveyRecommendationsApiArg = {
  /** ID of record */
  id: number;
};
export type V2ShareSurveyApiResponse =
  /** status 201 Survey successfully shared and a shared_survey record was created. */ {
    data?: string;
  };
export type V2ShareSurveyApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: {
      emails?: string[];
    };
  };
};
export type V2ListTagsForAccountApiResponse =
  /** status 200 Tag list response */ {
    data?: V2TagResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListTagsForAccountApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
  filter?: {
    name?: string;
  };
};
export type V2GetTagApiResponse = /** status 200 Project response */ {
  data?: V2TagResource;
};
export type V2GetTagApiArg = {
  /** ID of record */
  id: number;
};
export type V2GetServiceTaskRatesApiResponse =
  /** status 200 Service task rates retreived successfully */ {
    data?: V2TaskRateResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2GetServiceTaskRatesApiArg = {
  /** ID of service to which the resource is associated */
  serviceId: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateTaskRateForServiceApiResponse =
  /** status 201 Create task rate response */ {
    data?: V2TaskRateResource;
  };
export type V2CreateTaskRateForServiceApiArg = {
  /** ID of service to which the resource is associated */
  serviceId: number;
  body: {
    data?: V2TaskRateResource;
  };
};
export type V2GetServiceTaskRateApiResponse =
  /** status 200 Task rate retreived successfully */ {
    data?: V2TaskRateResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2GetServiceTaskRateApiArg = {
  /** ID of service to which the resource is associated */
  serviceId: number;
  /** ID of record */
  id: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2UpdateTaskRateForServiceApiResponse =
  /** status 201 Create task rate response */ {
    data?: V2TaskRateResource;
  };
export type V2UpdateTaskRateForServiceApiArg = {
  /** ID of service to which the resource is associated */
  serviceId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2TaskRateResource;
  };
};
export type V2DeleteTaskRateFromServiceApiResponse =
  /** status 204 The task rate was deleted successfully */ undefined;
export type V2DeleteTaskRateFromServiceApiArg = {
  /** ID of service to which the resource is associated */
  serviceId: number;
  /** ID of record */
  id: number;
};
export type V2GetSubserviceTaskRatesApiResponse =
  /** status 200 Subservice task rates retreived successfully */ {
    data?: V2TaskRateResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2GetSubserviceTaskRatesApiArg = {
  /** ID of subservice to which the resource is associated */
  subserviceId: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateTaskRateForSubserviceApiResponse =
  /** status 201 Create task rate response */ {
    data?: V2TaskRateResource;
  };
export type V2CreateTaskRateForSubserviceApiArg = {
  /** ID of subservice to which the resource is associated */
  subserviceId: number;
  body: {
    data?: V2TaskRateResource;
  };
};
export type V2GetSubserviceTaskRateApiResponse =
  /** status 200 Task rate retreived successfully */ {
    data?: V2TaskRateResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2GetSubserviceTaskRateApiArg = {
  /** ID of subservice to which the resource is associated */
  subserviceId: number;
  /** ID of record */
  id: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2UpdateTaskRateForSubserviceApiResponse =
  /** status 201 Create task rate response */ {
    data?: V2TaskRateResource;
  };
export type V2UpdateTaskRateForSubserviceApiArg = {
  /** ID of subservice to which the resource is associated */
  subserviceId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2TaskRateResource;
  };
};
export type V2DeleteTaskRateFromSubserviceApiResponse =
  /** status 204 The task rate was deleted successfully */ undefined;
export type V2DeleteTaskRateFromSubserviceApiArg = {
  /** ID of subservice to which the resource is associated */
  subserviceId: number;
  /** ID of record */
  id: number;
};
export type V2GetProductTaskRatesApiResponse =
  /** status 200 Product task rates retreived successfully */ {
    data?: V2TaskRateResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2GetProductTaskRatesApiArg = {
  /** ID of record */
  productId: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateTaskRateForProductApiResponse =
  /** status 201 Create task rate response */ {
    data?: V2TaskRateResource;
  };
export type V2CreateTaskRateForProductApiArg = {
  /** ID of record */
  productId: number;
  body: {
    data?: V2TaskRateResource;
  };
};
export type V2GetProductTaskRateApiResponse =
  /** status 200 Task rate retreived successfully */ {
    data?: V2TaskRateResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2GetProductTaskRateApiArg = {
  /** ID of record */
  productId: number;
  /** ID of record */
  id: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2UpdateTaskRateForProductApiResponse =
  /** status 201 Create task rate response */ {
    data?: V2TaskRateResource;
  };
export type V2UpdateTaskRateForProductApiArg = {
  /** ID of record */
  productId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2TaskRateResource;
  };
};
export type V2DeleteTaskRateFromProductApiResponse =
  /** status 204 The task rate was deleted successfully */ undefined;
export type V2DeleteTaskRateFromProductApiArg = {
  /** ID of record */
  productId: number;
  /** ID of record */
  id: number;
};
export type V2ListTeamsForAccountApiResponse =
  /** status 200 Team list response */ {
    data?: V2TeamResource[];
    included?: (V2AccountResource | V2UserResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListTeamsForAccountApiArg = {
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each team */
  include?: ("account" | "users")[];
  filter?: {
    name?: string;
  };
};
export type V2CreateTeamApiResponse = /** status 201 Create Team response */ {
  data?: V2TeamResource;
};
export type V2CreateTeamApiArg = {
  body: {
    data?: V2TeamResource;
  };
};
export type V2GetTeamApiResponse = /** status 200 Project response */ {
  data?: V2TeamResource;
  included?: (V2AccountResource | V2UserResource)[];
  links?: V2Paging;
};
export type V2GetTeamApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each team */
  include?: ("account" | "users")[];
};
export type V2UpdateTeamApiResponse = /** status 200 Update Team response */ {
  data?: V2TeamResource;
};
export type V2UpdateTeamApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2TeamResource;
  };
};
export type V2DeleteTeamApiResponse =
  /** status 204 The Team was deleted successfully */ undefined;
export type V2DeleteTeamApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListTextBlocksForAccountApiResponse =
  /** status 200 TextBlock list response */ {
    data?: V2TextBlockResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListTextBlocksForAccountApiArg = {
  /** Names of attributes that should be used to sort the data.  Prefix "-" indicates descending */
  sort?: (
    | "id"
    | "-id"
    | "name"
    | "-name"
    | "slug"
    | "-slug"
    | "merge-block"
    | "-merge-block"
  )[];
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each text block */
  include?: "account"[];
};
export type V2CreateTextBlockApiResponse =
  /** status 201 Create TextBlock response */ {
    data?: V2TextBlockResource;
  };
export type V2CreateTextBlockApiArg = {
  body: {
    data?: V2TextBlockResource;
  };
};
export type V2GetTextBlockApiResponse = /** status 200 Project response */ {
  data?: V2TextBlockResource;
  included?: V2AccountResource[];
};
export type V2GetTextBlockApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each text block */
  include?: "account"[];
};
export type V2UpdateTextBlockApiResponse =
  /** status 200 Update TextBlock response */ {
    data?: V2TextBlockResource;
  };
export type V2UpdateTextBlockApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2TextBlockResource;
  };
};
export type V2DeleteTextBlockApiResponse =
  /** status 204 The text block was deleted successfully */ undefined;
export type V2DeleteTextBlockApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListThirdPartyServicesForAccountApiResponse =
  /** status 200 ThirdPartyService list response */ {
    data?: V2ThirdPartyServiceResource[];
    included?: V2ProjectPhaseResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListThirdPartyServicesForAccountApiArg = {
  filter?: {
    source_type?: "Quote" | "ThirdPartyRequest" | "ThirdPartyService";
    source_id?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each third party service */
  include?: ("source" | "project-phase" | "project-task" | "subtasks")[];
};
export type V2CreateThirdPartyServiceApiResponse =
  /** status 201 Create ThirdPartyService response */ {
    data?: V2ThirdPartyServiceResource;
  };
export type V2CreateThirdPartyServiceApiArg = {
  body: {
    data?: V2ThirdPartyServiceResource;
  };
};
export type V2GetThirdPartyServiceApiResponse =
  /** status 200 Project response */ {
    data?: V2ThirdPartyServiceResource;
    included?: V2ProjectPhaseResource[];
    links?: V2Paging;
  };
export type V2GetThirdPartyServiceApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each third party service */
  include?: ("source" | "project-phase" | "project-task" | "subtasks")[];
};
export type V2UpdateThirdPartyServiceApiResponse =
  /** status 200 Update Third Party Service response */ {
    data?: V2ThirdPartyServiceResource;
  };
export type V2UpdateThirdPartyServiceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ThirdPartyServiceResource;
  };
};
export type V2DeleteThirdPartyServiceApiResponse =
  /** status 204 The Delete Third Party Service was deleted successfully */ undefined;
export type V2DeleteThirdPartyServiceApiArg = {
  /** ID of record */
  id: number;
};
export type V2MoveThirdPartyServiceApiResponse =
  /** status 200 Move Third Party Service response */ {
    data?: V2ThirdPartyServiceResource;
  };
export type V2MoveThirdPartyServiceApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2ThirdPartyServiceResource;
  };
};
export type GetV2UserFavoritesApiResponse =
  /** status 200 User Favorite list response */ {
    data?: V2UserFavoriteResource[];
    links?: V2Paging;
  };
export type GetV2UserFavoritesApiArg = {
  filter?: {
    type?: string;
  };
};
export type V2CreateUserFavoriteApiResponse =
  /** status 201 Create user favorite response */ {
    data?: V2UserFavoriteResource;
  };
export type V2CreateUserFavoriteApiArg = {
  body: {
    data?: V2UserFavoriteResource;
  };
};
export type V2DeleteUserFavoriteApiResponse =
  /** status 204 The Delete user favorite was deleted successfully */ undefined;
export type V2DeleteUserFavoriteApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListUserFiltersForAccountApiResponse =
  /** status 200 User Filter list response */ {
    data?: V2UserFilterResource[];
    links?: V2Paging;
  };
export type V2ListUserFiltersForAccountApiArg = {
  filter?: {
    "data-type"?: string;
    "data-path"?: string;
    active?: boolean;
  };
};
export type V2CreateUserFilterApiResponse =
  /** status 201 Create User Filter response */ {
    data?: V2UserFilterResource;
  };
export type V2CreateUserFilterApiArg = {
  body: {
    data?: V2UserFilterResource;
  };
};
export type V2GetUserFilterApiResponse = /** status 200 Project response */ {
  data?: V2UserFilterResource;
  links?: V2Paging;
};
export type V2GetUserFilterApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateUserFilterApiResponse =
  /** status 200 Update User Filter response */ {
    data?: V2UserFilterResource;
  };
export type V2UpdateUserFilterApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2UserFilterResource;
  };
};
export type V2DeleteUserFilterApiResponse =
  /** status 204 The Delete User Filter was deleted successfully */ undefined;
export type V2DeleteUserFilterApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListUserFlagValuesApiResponse =
  /** status 200 User flag value list response */ {
    data?: V2UserFlagValueResource[];
  };
export type V2ListUserFlagValuesApiArg = void;
export type V2GetUserFlagValueApiResponse =
  /** status 200 User flag value response */ {
    data?: V2UserFlagValueResource;
  };
export type V2GetUserFlagValueApiArg = {
  /** The LaunchDarkly flag key */
  id: string;
};
export type V2UpdateUserFlagValueApiResponse =
  /** status 200 User flag value updated */ {
    data?: V2UserFlagValueResource;
  };
export type V2UpdateUserFlagValueApiArg = {
  /** The LaunchDarkly flag key */
  id: string;
  body: {
    data?: V2UserFlagValueResource;
  };
};
export type V2DeleteUserFlagValueApiResponse =
  /** status 204 User flag override cleared */ undefined;
export type V2DeleteUserFlagValueApiArg = {
  /** The LaunchDarkly flag key */
  id: string;
};
export type V2ListUserViewsForAccountApiResponse =
  /** status 200 User View list response */ {
    data?: V2UserViewResource[];
    included?: (V2UserResource | V2AccountResource)[];
    links?: V2Paging;
  };
export type V2ListUserViewsForAccountApiArg = {
  filter?: {
    "view-type"?: "project" | "product";
    products?: boolean;
  };
  /** Associated data that may be loaded with each user view */
  include?: ("user" | "account")[];
};
export type V2CreateUserViewApiResponse =
  /** status 201 Create User View response */ {
    data?: V2UserViewResource;
  };
export type V2CreateUserViewApiArg = {
  body: {
    data?: V2UserViewResource;
  };
};
export type V2GetUserViewApiResponse = /** status 200 Project response */ {
  data?: V2UserViewResource;
  included?: (V2UserResource | V2AccountResource)[];
  links?: V2Paging;
};
export type V2GetUserViewApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each user view */
  include?: ("user" | "account")[];
};
export type V2UpdateUserViewApiResponse =
  /** status 200 Update User View response */ {
    data?: V2UserViewResource;
  };
export type V2UpdateUserViewApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2UserViewResource;
  };
};
export type V2DeleteUserViewApiResponse =
  /** status 204 The Delete User View was deleted successfully */ undefined;
export type V2DeleteUserViewApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListUsersForAccountApiResponse =
  /** status 200 User list response */ {
    data?: V2UserResource[];
    included?: (
      | V2AccountResource
      | V2RateTableResource
      | V2TeamResource
      | V2RoleResource
    )[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListUsersForAccountApiArg = {
  filter?: {
    active?: boolean;
    name?: string;
    email?: string;
    title?: string;
    role?: string;
    team?: string;
    "user-type"?: "view_only" | "licensed" | "sales" | "service" | "approver";
    exclude?: string;
    "view-only"?: boolean;
    "created-at.after"?: string;
    "created-at.before"?: string;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each user */
  include?: ("account" | "rate-table" | "teams" | "roles")[];
};
export type V2CreateUserApiResponse = /** status 201 Create User response */ {
  data?: V2UserResource;
};
export type V2CreateUserApiArg = {
  body: {
    data?: V2UserResourceWrite;
  };
};
export type V2ShowCurrentUserForAccountApiResponse =
  /** status 200 Current User response */ {
    data?: V2UserResource[];
    included?: (
      | V2AccountResource
      | V2RateTableResource
      | V2TeamResource
      | V2RoleResource
    )[];
    links?: V2Paging;
  };
export type V2ShowCurrentUserForAccountApiArg = {
  /** Associated data that may be loaded with each user */
  include?: ("account" | "rate-table" | "teams" | "roles")[];
};
export type V2GetUserApiResponse = /** status 200 Project response */ {
  data?: V2UserResource;
  included?: (
    | V2AccountResource
    | V2RateTableResource
    | V2TeamResource
    | V2RoleResource
  )[];
  links?: V2Paging;
};
export type V2GetUserApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each user */
  include?: ("account" | "rate-table" | "teams" | "roles")[];
};
export type V2UpdateUserApiResponse = /** status 200 Update User response */ {
  data?: V2UserResource;
};
export type V2UpdateUserApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2UserResourceWrite;
  };
};
export type V2DeleteUserApiResponse =
  /** status 204 The Delete User was deleted successfully */ undefined;
export type V2DeleteUserApiArg = {
  /** ID of record */
  id: number;
};
export type V2ResetUserFiltersApiResponse =
  /** status 204 User filters reset successfully */ undefined;
export type V2ResetUserFiltersApiArg = {
  /** ID of record */
  id: number;
};
export type V2UnlockUserApiResponse =
  /** status 204 User filters reset successfully */ undefined;
export type V2UnlockUserApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListServiceAccountCredentialsApiResponse =
  /** status 200 Service-account credential list response */ {
    data?: V2ServiceAccountCredentialResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListServiceAccountCredentialsApiArg = {
  /** ID of user to which the resource is associated */
  userId: number;
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateServiceAccountCredentialApiResponse =
  /** status 201 Create service-account credential response */ {
    data?: V2ServiceAccountCredentialResource;
  };
export type V2CreateServiceAccountCredentialApiArg = {
  /** ID of user to which the resource is associated */
  userId: number;
  body: {
    data?: V2ServiceAccountCredentialResource;
  };
};
export type V2GetServiceAccountCredentialApiResponse =
  /** status 200 Service-account credential response */ {
    data?: V2ServiceAccountCredentialResource;
  };
export type V2GetServiceAccountCredentialApiArg = {
  /** ID of user to which the resource is associated */
  userId: number;
  /** ID of record */
  id: number;
};
export type V2UpdateServiceAccountCredentialApiResponse =
  /** status 200 Update service-account credential response */ {
    data?: V2ServiceAccountCredentialResource;
  };
export type V2UpdateServiceAccountCredentialApiArg = {
  /** ID of user to which the resource is associated */
  userId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2ServiceAccountCredentialResource;
  };
};
export type V2DeleteServiceAccountCredentialApiResponse =
  /** status 204 The service-account credential was deleted successfully */ undefined;
export type V2DeleteServiceAccountCredentialApiArg = {
  /** ID of user to which the resource is associated */
  userId: number;
  /** ID of record */
  id: number;
};
export type V2RotateServiceAccountCredentialApiResponse =
  /** status 201 Rotation response with newly generated client secret */ {
    data?: V2ServiceAccountCredentialRotationResource;
  };
export type V2RotateServiceAccountCredentialApiArg = {
  /** ID of user to which the resource is associated */
  userId: number;
  /** ID of the parent service-account credential */
  serviceAccountCredentialId: number;
};
export type V2ListVendorsForAccountApiResponse =
  /** status 200 Vendor list response */ {
    data?: V2VendorResource[];
    included?: (V2AccountResource | V2QuoteResource)[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListVendorsForAccountApiArg = {
  filter?: {
    name?: string;
    active?: boolean;
  };
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each vendor */
  include?: ("account" | "quotes")[];
};
export type V2CreateVendorApiResponse =
  /** status 201 Create Vendor response */ {
    data?: V2VendorResource;
  };
export type V2CreateVendorApiArg = {
  body: {
    data?: V2VendorResource;
  };
};
export type V2GetVendorApiResponse = /** status 200 Project response */ {
  data?: V2VendorResource;
};
export type V2GetVendorApiArg = {
  /** ID of record */
  id: number;
};
export type V2UpdateVendorApiResponse =
  /** status 200 Update Vendor response */ {
    data?: V2VendorResource;
  };
export type V2UpdateVendorApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2VendorResource;
  };
};
export type V2DeleteVendorApiResponse =
  /** status 204 The Delete Vendor was deleted successfully */ undefined;
export type V2DeleteVendorApiArg = {
  /** ID of record */
  id: number;
};
export type V2ListSpecialConditionsForVendorApiResponse =
  /** status 200 special condition list response */ {
    data?: V2SpecialConditionResource[];
    links?: V2Paging;
  };
export type V2ListSpecialConditionsForVendorApiArg = {
  /** ID of vendor record */
  vendorId: number;
  page?: {
    number?: number;
    size?: number;
  };
  /** Associated data that may be loaded with each vendor */
  include?: ("owner" | "service-condition")[];
};
export type V2CreateSpecialConditionForVendorApiResponse =
  /** status 201 Create special condition response */ {
    data?: V2SpecialConditionResource;
  };
export type V2CreateSpecialConditionForVendorApiArg = {
  /** ID of vendor record */
  vendorId: number;
  body: {
    data?: V2SpecialConditionResource;
  };
};
export type V2GetVendorSpecialConditionByIdApiResponse =
  /** status 200 Find special condition by ID response */ {
    data?: V2SpecialConditionResource;
  };
export type V2GetVendorSpecialConditionByIdApiArg = {
  /** ID of vendor record */
  vendorId: number;
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each vendor */
  include?: ("owner" | "service-condition")[];
};
export type V2UpdateVendorSpecialConditionApiResponse =
  /** status 200 Update vendor special condition response */ {
    data?: V2SpecialConditionResource;
  };
export type V2UpdateVendorSpecialConditionApiArg = {
  /** ID of vendor record */
  vendorId: number;
  /** ID of record */
  id: number;
  body: {
    data?: V2SpecialConditionResource;
  };
};
export type V2DeleteVendorSpecialConditionApiResponse =
  /** status 204 The special condition was deleted successfully */ undefined;
export type V2DeleteVendorSpecialConditionApiArg = {
  /** ID of vendor record */
  vendorId: number;
  /** ID of record */
  id: number;
};
export type V2ListWebhookSubscriptionsForAccountApiResponse =
  /** status 200 Webhook Subscription list response */ {
    data?: V2WebhookSubscriptionResource[];
    included?: V2AccountResource[];
    meta?: V2PagingMeta;
    links?: V2Paging;
  };
export type V2ListWebhookSubscriptionsForAccountApiArg = {
  /** Associated data that may be loaded with each webhook subscription */
  include?: "account"[];
  page?: {
    number?: number;
    size?: number;
  };
};
export type V2CreateWebhookSubscriptionApiResponse =
  /** status 201 Create Webhook Subscription response */ {
    data?: V2WebhookSubscriptionResource;
  };
export type V2CreateWebhookSubscriptionApiArg = {
  body: {
    data?: V2WebhookSubscriptionResource;
  };
};
export type V2GetWebhookSubscriptionApiResponse =
  /** status 200 Project response */ {
    data?: V2WebhookSubscriptionResource;
    included?: V2AccountResource[];
    links?: V2Paging;
  };
export type V2GetWebhookSubscriptionApiArg = {
  /** ID of record */
  id: number;
  /** Associated data that may be loaded with each webhook subscription */
  include?: "account"[];
};
export type V2UpdateWebhookSubscriptionApiResponse =
  /** status 200 Update Webhook Subscription response */ {
    data?: V2WebhookSubscriptionResource;
  };
export type V2UpdateWebhookSubscriptionApiArg = {
  /** ID of record */
  id: number;
  body: {
    data?: V2WebhookSubscriptionResource;
  };
};
export type V2DeleteWebhookSubscriptionApiResponse =
  /** status 204 The Delete Webhook Subscription was deleted successfully */ undefined;
export type V2DeleteWebhookSubscriptionApiArg = {
  /** ID of record */
  id: number;
};
export type V2AutotaskCredentials = {
  public_key: string;
  private_key: string;
};
export type V2ConnectwiseCredentials = {
  company_id: string;
  public_key: string;
  private_key: string;
};
export type V2DocusignCredentials = {
  client_id: string;
  private_key: string;
};
export type V2HalopsaCredentials = {
  client_id: string;
  client_secret: string;
};
export type V2HubspotCredentials = {
  client_secret?: string;
  private_key?: string;
};
export type V2MicrosoftDynamicsCredentials = {
  client_id: string;
  client_secret: string;
  tenant_id: string;
};
export type V2SalesforceCredentials = {
  client_id: string;
  client_secret: string;
  instance_url: string;
};
export type V2FilestorageCredentials = {
  registration_email?: string;
  account_token?: string;
};
export type V2AutotaskMappings = {
  statuses?: string;
  stages?: string;
};
export type V2ConnectwiseMappings = {
  statuses?: string;
};
export type V2MicrosoftDynamicsMappings = {
  states?: string;
  stages?: string;
  product_types?: boolean;
  mark_won?: null | "won";
  mark_lost?: null | "lost";
};
export type V2SalesforceMappings = {
  stages?: string;
};
export type V2AutotaskSettings = {
  skip_revenue_sync?: boolean;
};
export type V2ConnectwiseSettings = {
  host?: string;
  version?: string;
  skip_revenue_sync?: boolean;
  include_products?: boolean;
};
export type V2DocusignSettings = {
  oauth_host?: string;
  title?: string;
  internal_signature_placeholder?: boolean;
  external_signature_placeholder?: boolean;
};
export type V2HalopsaSettings = {
  host?: string;
};
export type V2MicrosoftDynamicsSettings = {
  host?: string;
  crm_url?: string;
  skip_revenue_sync?: boolean;
};
export type V2SalesforceSettings = {
  host?: string;
  skip_revenue_sync?: boolean;
  pkce?: boolean;
};
export type V2FilestorageSettings = {
  storage?: string;
  root_folder_id?: string;
  service_type?: string;
};
export type V2Relationships = {
  links?: {
    self?: string;
    related?: string;
  };
  data: {
    id: number;
    type: string;
  };
};
export type V2AccountConnectionResource = {
  id?: number;
  type: string;
  attributes: {
    service?:
      | "salesforce"
      | "connectwise"
      | "hubspot"
      | "docusign"
      | "microsoft_dynamics"
      | "autotask"
      | "scopestack"
      | "halopsa"
      | "merge_dev";
    active?: boolean;
    host?: string;
    status?:
      | "Activating"
      | "Connected"
      | "Disabled"
      | "Connection Error"
      | "Delete Pending";
    opportunities?: number;
    "error-info"?: string;
    "status-information"?: string;
    "last-sync-at"?: string;
    "supports-crm"?: boolean;
    crm?: boolean;
    "supports-psa"?: boolean;
    psa?: boolean;
    "supports-product"?: boolean;
    product?: boolean;
    "supports-esignature"?: boolean;
    esignature?: boolean;
    "supports-file-storage"?: boolean;
    "file-storage"?: boolean;
    oauth_url?: string;
    credentials?:
      | V2AutotaskCredentials
      | V2ConnectwiseCredentials
      | V2DocusignCredentials
      | V2HalopsaCredentials
      | V2HubspotCredentials
      | V2MicrosoftDynamicsCredentials
      | V2SalesforceCredentials
      | V2FilestorageCredentials;
    mappings?:
      | V2AutotaskMappings
      | V2ConnectwiseMappings
      | V2MicrosoftDynamicsMappings
      | V2SalesforceMappings;
    settings?:
      | V2AutotaskSettings
      | V2ConnectwiseSettings
      | V2DocusignSettings
      | V2HalopsaSettings
      | V2MicrosoftDynamicsSettings
      | V2SalesforceSettings
      | V2FilestorageSettings;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2PagingMeta = {
  "record-count"?: number;
  "page-count"?: number;
};
export type V2Paging = {
  first?: string;
  next?: string;
  last?: string;
};
export type V2AuthenticationError = {
  error?: string;
};
export type V2NotFoundError = {
  errors?: {
    title?: string;
    detail?: string;
    code?: string;
    status?: string;
  }[];
};
export type V2ValidationError = {
  errors?: {
    title?: string;
    detail?: string;
    code?: string;
    status?: string;
  }[];
};
export type V2ToManyRelationships = {
  links?: {
    self?: string;
    related?: string;
  };
  data?: {
    id?: number;
    type?: string;
  }[];
};
export type V2AccountResource = {
  id?: string;
  type: string;
  attributes: {
    slug: string;
    "account-id"?: number;
    name: string;
    status?: "building" | "pending" | "trial" | "active" | "canceled";
    "rate-type"?: "hour" | "day" | "week";
    "loe-rounding"?:
      | "one_minute"
      | "five_minutes"
      | "tenth_of_an_hour"
      | "ten_minutes"
      | "quarter_hour"
      | "half_hour"
      | "one_hour";
    "short-date-format"?:
      | "%m/%d/%Y"
      | "%m-%d-%Y"
      | "%d/%m/%Y"
      | "%d-%m/%Y"
      | "%Y/%m/%d"
      | "%Y-%m-%d"
      | "%d-%b-%Y";
    "long-date-format"?: "%B %-e, %Y" | "%-e %B %Y" | "%Y %B %-e";
    "time-format"?: "%-l:%M %p" | "%l:%M %p" | "%H:%M";
    street_adddress?: string;
    city?: string;
    state?: string;
    postal_code?: string;
    country?: string;
    "time-zone"?:
      | "International Date Line West"
      | "Midway Island"
      | "American Samoa"
      | "Hawaii"
      | "Alaska"
      | "Pacific Time (US & Canada)"
      | "Tijuana"
      | "Mountain Time (US & Canada)"
      | "Arizona"
      | "Chihuahua"
      | "Mazatlan"
      | "Central Time (US & Canada)"
      | "Saskatchewan"
      | "Guadalajara"
      | "Mexico City"
      | "Monterrey"
      | "Central America"
      | "Eastern Time (US & Canada)"
      | "Indiana (East)"
      | "Bogota"
      | "Lima"
      | "Quito"
      | "Atlantic Time (Canada)"
      | "Caracas"
      | "La Paz"
      | "Santiago"
      | "Newfoundland"
      | "Brasilia"
      | "Buenos Aires"
      | "Montevideo"
      | "Georgetown"
      | "Puerto Rico"
      | "Greenland"
      | "Mid-Atlantic"
      | "Azores"
      | "Cape Verde Is."
      | "Dublin"
      | "Edinburgh"
      | "Lisbon"
      | "London"
      | "Casablanca"
      | "Monrovia"
      | "UTC"
      | "Belgrade"
      | "Bratislava"
      | "Budapest"
      | "Ljubljana"
      | "Prague"
      | "Sarajevo"
      | "Skopje"
      | "Warsaw"
      | "Zagreb"
      | "Brussels"
      | "Copenhagen"
      | "Madrid"
      | "Paris"
      | "Amsterdam"
      | "Berlin"
      | "Bern"
      | "Zurich"
      | "Rome"
      | "Stockholm"
      | "Vienna"
      | "West Central Africa"
      | "Bucharest"
      | "Cairo"
      | "Helsinki"
      | "Kyiv"
      | "Riga"
      | "Sofia"
      | "Tallinn"
      | "Vilnius"
      | "Athens"
      | "Istanbul"
      | "Minsk"
      | "Jerusalem"
      | "Harare"
      | "Pretoria"
      | "Kaliningrad"
      | "Moscow"
      | "St. Petersburg"
      | "Volgograd"
      | "Samara"
      | "Kuwait"
      | "Riyadh"
      | "Nairobi"
      | "Baghdad"
      | "Tehran"
      | "Abu Dhabi"
      | "Muscat"
      | "Baku"
      | "Tbilisi"
      | "Yerevan"
      | "Kabul"
      | "Ekaterinburg"
      | "Islamabad"
      | "Karachi"
      | "Tashkent"
      | "Chennai"
      | "Kolkata"
      | "Mumbai"
      | "New Delhi"
      | "Kathmandu"
      | "Dhaka"
      | "Sri Jayawardenepura"
      | "Almaty"
      | "Astana"
      | "Novosibirsk"
      | "Rangoon"
      | "Bangkok"
      | "Hanoi"
      | "Jakarta"
      | "Krasnoyarsk"
      | "Beijing"
      | "Chongqing"
      | "Hong Kong"
      | "Urumqi"
      | "Kuala Lumpur"
      | "Singapore"
      | "Taipei"
      | "Perth"
      | "Irkutsk"
      | "Ulaanbaatar"
      | "Seoul"
      | "Osaka"
      | "Sapporo"
      | "Tokyo"
      | "Yakutsk"
      | "Darwin"
      | "Adelaide"
      | "Canberra"
      | "Melbourne"
      | "Sydney"
      | "Brisbane"
      | "Hobart"
      | "Vladivostok"
      | "Guam"
      | "Port Moresby"
      | "Magadan"
      | "Srednekolymsk"
      | "Solomon Is."
      | "New Caledonia"
      | "Fiji"
      | "Kamchatka"
      | "Marshall Is."
      | "Auckland"
      | "Wellington"
      | "Nuku'alofa"
      | "Tokelau Is."
      | "Chatham Is."
      | "Samoa";
    "plan-name"?: string;
    "crm?"?: boolean;
    "psa?"?: boolean;
    entitlements?: string[];
    settings?: {
      guided_project_creation?: boolean;
      password_interval?: number;
      project_resource_rates?: boolean;
      watermarking?: boolean;
      "sales-review"?: boolean;
    };
    "plan-details"?: {
      questionnaires?: boolean;
      approval_workflow?: boolean;
      partner_services?: boolean;
      customer_success?: boolean;
    };
    "field-labels"?: {
      executive_summary?: string;
      solution_summary?: string;
      customer_summary?: string;
      customer_success?: string;
      sales_executive?: string;
      presales_engineer?: string;
      client?: string;
      business_unit?: string;
      location?: string;
      our_responsibilities?: string;
      client_responsibilities?: string;
      out_of_scope?: string;
    };
  };
  relationships: {
    "business-units"?: V2ToManyRelationships;
    clients?: V2ToManyRelationships;
    "crm-opportunities"?: V2ToManyRelationships;
    "document-templates"?: V2ToManyRelationships;
    "expense-categories"?: V2ToManyRelationships;
    governances?: V2ToManyRelationships;
    "payment-credits"?: V2ToManyRelationships;
    "payment-terms"?: V2ToManyRelationships;
    phases?: V2ToManyRelationships;
    products?: V2ToManyRelationships;
    "project-variables"?: V2ToManyRelationships;
    projects?: V2ToManyRelationships;
    "rate-tables"?: V2ToManyRelationships;
    resources?: V2ToManyRelationships;
    roles?: V2ToManyRelationships;
    "service-categories"?: V2ToManyRelationships;
    services?: V2ToManyRelationships;
    teams?: V2ToManyRelationships;
    users?: V2ToManyRelationships;
  };
  links?: {
    projects?: string;
    "business-unit"?: string;
    clients?: string;
    "crm-opportunities"?: string;
    "document-templates"?: string;
    "expense-categories"?: string;
    governances?: string;
    "payment-terms"?: string;
    "presales-engineers"?: string;
    phases?: string;
    "project-variables"?: string;
    resources?: string;
    "sales-executives"?: string;
    services?: string;
    users?: string;
    self?: string;
  };
};
export type V2AccountFinancialResource = {
  id?: number;
  type: string;
  attributes: {
    "total-projects"?: number;
    won?: number;
    lost?: number;
    "total-contract-value"?: string;
    "total-contract-cost"?: string;
    "average-contract-value"?: string;
    "average-contract-margin"?: string;
    "monthly-projects"?: {
      month?: string;
      "start-at"?: string;
      revenue?: string;
      cost?: string;
      won?: number;
      lost?: number;
    }[];
  };
};
export type V2AccountFlagValueResource = {
  id: string;
  type: string;
  attributes: {
    name?: string;
    description?: string;
    variation?: any;
    variations?: {
      value?: any;
      name?: string;
    }[];
    "has-override"?: boolean;
  };
};
export type V2AccountHealthSnapshotResource = {
  id?: string;
  type: string;
  attributes: {
    "week-start"?: string;
    status?: "healthy" | "watch" | "at_risk";
    "primary-driver"?: string;
    "projects-w0-30"?: number;
    "projects-w31-60"?: number;
    "projects-w61-90"?: number;
    "signins-w0-30"?: number;
    "signins-w31-60"?: number;
    "signins-w61-90"?: number;
    "project-slope"?: number;
    "project-baseline-ratio"?: number;
    "signin-slope"?: number;
    signals?: object;
    "created-at"?: string;
    "updated-at"?: string;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2AccountLogoResource = {
  id?: number;
  type: string;
  attributes: {
    logo?: string;
    "logo-uuid"?: string;
  };
};
export type V2BusinessUnitResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "external-name"?: string;
    "street-address"?: string;
    street2?: string;
    city?: string;
    state?: string;
    "postal-code"?: string;
    country?: string;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2EmbeddedProjectVariable = {
  name: string;
  label?: string;
  variable_type?: "number" | "text" | "date";
  minimum?: number;
  maximum?: number;
  required?: boolean;
  select_options?: {
    key?: string;
    value?: string;
    default?: boolean;
  }[];
  position?: number;
  context?:
    | "client"
    | "crm_opportunity"
    | "project"
    | "governance"
    | "service_location"
    | "project_contact"
    | "product"
    | "resource"
    | "section"
    | "service"
    | "teammate";
  uuid?: string;
  value: string;
};
export type V2ClientResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "msa-date"?: string;
    domain?: string;
    "user-defined-fields"?: V2EmbeddedProjectVariable[];
    active?: boolean;
  };
  relationships: {
    account: V2Relationships;
    contacts?: V2ToManyRelationships;
    "rate-table"?: V2Relationships;
  };
};
export type V2CrmOpportunityResource = {
  id?: number;
  type: string;
  attributes: {
    "account-id"?: string;
    "opportunity-id"?: string;
    "account-name"?: string;
    name?: string;
    "display-name"?: string;
    amount?: number;
    stage?: string;
    "is-closed"?: boolean;
    "owner-id"?: string;
    "owner-name"?: string;
    "location-name"?: string;
    street?: string;
    city?: string;
    state?: string;
    "postal-code"?: string;
    country?: string;
    "custom-attributes"?: {
      key?: string;
      value?: string;
    }[];
  };
  relationships: {
    account: V2Relationships;
    "crm-opportunity"?: V2Relationships;
    projects?: V2ToManyRelationships;
  };
};
export type V2DocumentTemplateResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    format: "word_template" | "html_template" | "tag_template";
    "merge-template"?: string;
    "merge-template-filename"?: string;
    "filename-format"?: string[];
    "template-format"?: "v1" | "v2";
    "include-formatting"?: boolean;
    teams?: {
      id?: string;
      name?: string;
    }[];
  };
  relationships: {
    account: V2Relationships;
    "rate-table"?: V2Relationships;
  };
};
export type V2GovernanceResource = {
  id?: number;
  type?: string;
  attributes?: {
    name: string;
    active?: boolean;
    rate?: number;
    "fixed-hours"?: number;
    "allocation-method"?:
      | "prorate_phases_by_effort"
      | "select_phase"
      | "select_category"
      | "project_management_phase";
    "calculation-type"?: "percent_of_total" | "fixed_hours";
    required?: boolean;
    "assign-effort-to-service"?: boolean;
    "filter-type"?: "all_services" | "filter_by_lob" | "filter_by_phase";
    "filter-id"?: number;
    position?: number;
  };
  relationships?: {
    account?: V2Relationships;
    resource?: V2Relationships;
    phase?: V2Relationships;
    "service-category"?: V2Relationships;
  };
};
export type V2LineOfBusinessResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    code?: string;
    "nested-name"?: string;
    position?: number;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2PaymentCreditResource = {
  id?: number;
  type: string;
  attributes: {
    "payment-source": string;
    description: string;
    criteria?: string;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2PaymentTermResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    slug?: string;
    position?: number;
    "include-expense-in-revenue"?: boolean;
    "include-expense-in-cost"?: boolean;
    "travel-limit"?: boolean;
    "include-materials"?: boolean;
    "pricing-model"?: "other" | "fixed_fee" | "time_and_materials";
    rounding?:
      | "2000.00"
      | "1300.00"
      | "1240.00"
      | "1235.00"
      | "1234.60"
      | "1234.57"
      | "1234.568";
    default?: boolean;
    terms?: {
      id?: number;
      description?: string;
      percentage_due?: number;
      term_type?: "percent" | "milestone";
      position?: number;
      phase_id?: number;
    }[];
  };
  relationships: {
    account: V2Relationships;
    "rate-table"?: V2Relationships;
  };
};
export type V2PhaseResource = {
  id?: number;
  type?: string;
  attributes?: {
    name: string;
    "sow-language": string;
    active?: boolean;
    position?: number;
    default?: boolean;
  };
  relationships?: {
    account?: V2Relationships;
    "project-expenses"?: V2ToManyRelationships;
  };
};
export type V2ProductResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    description?: string;
    sku?: string;
    "product-id"?: string;
    "manufacturer-part-number"?: string;
    "unit-of-measure"?: string;
    category?: string;
    subcategory?: string;
    "unit-price"?: number;
    "unit-cost"?: number;
    "list-price"?: number;
    "vendor-discount"?: number;
    "vendor-rebate"?: number;
    markup?: number;
    "billing-frequency"?:
      | "one_time"
      | "monthly"
      | "bi-monthly"
      | "quarterly"
      | "semi-annual"
      | "yearly";
    "project-variables"?: V2EmbeddedProjectVariable[];
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2ProjectVariableResource = {
  id?: number;
  type?: string;
  attributes?: {
    label: string;
    name: string;
    variable_type?: "number" | "text" | "date";
    context?:
      | "client"
      | "crm_opportunity"
      | "project"
      | "governance"
      | "service_location"
      | "project_contact"
      | "product"
      | "resource"
      | "section"
      | "service"
      | "teammate";
    minimum?: number;
    maximum?: number;
    required?: boolean;
    position?: number;
    select_options?: {
      key?: string;
      value?: string;
      default?: boolean;
    }[];
  };
  relationships?: {
    account?: V2Relationships;
  };
};
export type V2ProjectResource = {
  id?: number;
  type: string;
  attributes: {
    "project-name": string;
    status?: string;
    "executive-summary"?: string;
    "key-objectives"?: string;
    "our-responsibilities"?: string;
    "client-responsibilities"?: string;
    "solution-summary"?: string;
    "out-of-scope"?: string;
    "contract-revenue"?: number;
    "contract-cost"?: number;
    "total-effort"?: number;
    "total-revenue"?: number;
    "one-time-adjustment"?: number;
    "ms-revenue"?: number;
    "mrr-adjustment"?: number;
    "mrr-terms"?: number;
    cola?: number;
    "recurring-billing-frequency"?: "monthly" | "quarterly" | "yearly";
    "include-ps-revenue-in-mrr"?:
      | "do_not_include_ps_revenue"
      | "add_to_first_month"
      | "amortize_over_all_months";
    "service-start-date"?: string;
    "third-party-revenue"?: number;
    "travel-limit"?: number;
    "submitted-at"?: string;
    "approved-at"?: string;
    "msa-date"?: string;
    "storage-options"?: object;
    "project-variables"?: V2EmbeddedProjectVariable[];
    "field-labels"?: {
      executive_summary?: string;
      solution_summary?: string;
      customer_summary?: string;
      customer_success?: string;
      sales_executive?: string;
      presales_engineer?: string;
      client?: string;
      request_approval?: string;
      business_unit?: string;
      location?: string;
      our_responsibilities?: string;
      client_responsibilities?: string;
      out_of_scope?: string;
      currency_unit?: string;
    };
    "tag-list"?: string[];
    "payment-info"?: {
      "pricing-model"?: "other" | "fixed_fee" | "time_and_materials";
      "include-expenses"?: boolean;
      "include-product"?: boolean;
      "rate-type"?: "hour" | "day" | "week";
    };
  };
  relationships: {
    account: V2Relationships;
    "business-unit"?: V2Relationships;
    client: V2Relationships;
    "document-template"?: V2Relationships;
    "external-request"?: V2Relationships;
    "sales-executive"?: V2Relationships;
    "presales-engineer"?: V2Relationships;
    "psa-project"?: V2Relationships;
    "crm-opportunity"?: V2Relationships;
    "payment-term"?: V2Relationships;
    user?: V2Relationships;
    "project-attachments"?: V2ToManyRelationships;
    "project-collaborators"?: V2ToManyRelationships;
    "project-contacts"?: V2ToManyRelationships;
    "project-conditions"?: V2ToManyRelationships;
    "project-credits"?: V2ToManyRelationships;
    "project-documents"?: V2ToManyRelationships;
    "project-expenses"?: V2ToManyRelationships;
    "project-governances"?: V2ToManyRelationships;
    "project-locations"?: V2ToManyRelationships;
    "project-materials"?: V2ToManyRelationships;
    "project-phases"?: V2ToManyRelationships;
    "project-products"?: V2ToManyRelationships;
    "project-resources"?: V2ToManyRelationships;
    "project-versions"?: V2ToManyRelationships;
    "project-services"?: V2ToManyRelationships;
    "rate-table": V2Relationships;
    "resource-plans"?: V2ToManyRelationships;
    "approval-steps"?: V2ToManyRelationships;
    notes?: V2ToManyRelationships;
    quotes?: V2ToManyRelationships;
    "partner-requests"?: V2ToManyRelationships;
    "audit-logs"?: V2ToManyRelationships;
    "customer-successes"?: V2ToManyRelationships;
  };
};
export type V2RateTableResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    default?: boolean;
  };
  relationships: {
    account: V2Relationships;
    currency?: V2Relationships;
    clients?: V2ToManyRelationships;
    projects?: V2ToManyRelationships;
    users?: V2ToManyRelationships;
    "resource-rates"?: V2ToManyRelationships;
  };
};
export type V2ResourceResource = {
  id?: number;
  type?: string;
  attributes?: {
    name: string;
    active?: boolean;
    "external-name"?: string;
    description?: string;
    default?: boolean;
    hourly_rate?: number;
    hourly_cost?: number;
    "user-defined-fields"?: V2EmbeddedProjectVariable[];
  };
  relationships?: {
    account?: V2Relationships;
    governances?: V2ToManyRelationships;
    "project-governances"?: V2ToManyRelationships;
    "project-resources"?: V2ToManyRelationships;
    "project-services"?: V2ToManyRelationships;
    "project-subservices"?: V2ToManyRelationships;
  };
};
export type V2ServiceResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    sku?: string;
    "service-description"?: string;
    guidance?: string;
    languages?: object;
    state?: "pending" | "active" | "deleted" | "custom";
    position?: number;
    "minimum-quantity"?: number;
    lob_id?: number;
    "service-type"?: "professional_services" | "managed_services";
    "payment-frequency"?: "one_time" | "monthly" | "quarterly" | "yearly";
    "suggested-hours"?: number;
    "total-hours"?: number;
    "tag-list"?: string[];
    teams?: {
      id?: string;
      name?: string;
    }[];
    variables?: V2EmbeddedProjectVariable[];
    "updated-at"?: string;
    "actual-hours"?: number;
    deviation?: number;
    "custom-service-cost?"?: boolean;
    "custom-service-price?"?: boolean;
    "custom-hours?"?: boolean;
  };
  relationships: {
    account: V2Relationships;
    phase?: V2Relationships;
    resource?: V2Relationships;
    "service-category"?: V2Relationships;
    products?: V2ToManyRelationships;
    subservices?: V2ToManyRelationships;
  };
};
export type V2RoleResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    default?: boolean;
    privileges?: {
      privilege:
        | "projects.overview"
        | "projects.executive_summary"
        | "projects.request_approval"
        | "projects.psa"
        | "projects.terms_and_conditions"
        | "projects.notes"
        | "projects.locations"
        | "projects.attachments"
        | "projects.contacts"
        | "projects.collaborators"
        | "projects.versions"
        | "projects.outcomes"
        | "projects.success_strategy"
        | "projects.adoption_barriers"
        | "projects.project_phases"
        | "projects.tasks"
        | "projects.custom_tasks"
        | "projects.managed_services"
        | "projects.service_pricing"
        | "projects.managed_service_pricing"
        | "projects.pricing_adjustment"
        | "projects.costing_adjustment"
        | "projects.sow_language"
        | "projects.materials"
        | "projects.partner_requests"
        | "projects.vendor_quotes"
        | "projects.project_governance"
        | "projects.travel_and_expense"
        | "projects.payment_credits"
        | "projects.pricing"
        | "projects.service_margins"
        | "projects.resource_rates"
        | "projects.resource_costs"
        | "projects.vendor_resource_rates"
        | "projects.vendor_resource_costs"
        | "projects.work_breakdown"
        | "projects.resource_planning"
        | "projects.surveys"
        | "projects.merge_data"
        | "projects.duplicate"
        | "settings.account"
        | "settings.prompt_overrides"
        | "settings.billing"
        | "settings.connected_apps"
        | "settings.oauth"
        | "settings.webhooks"
        | "settings.access_tokens"
        | "settings.lines_of_business"
        | "settings.task_types"
        | "settings.language_fields"
        | "settings.tasks"
        | "settings.managed_services"
        | "settings.materials"
        | "settings.blueprints"
        | "settings.research_packages"
        | "settings.research_package_drafts"
        | "settings.text_blocks"
        | "settings.terms_and_conditions"
        | "settings.signature_types"
        | "settings.sow_templates"
        | "settings.attachment_types"
        | "settings.questionnaires"
        | "settings.resources"
        | "settings.travel_and_expense"
        | "settings.payment_terms"
        | "settings.payment_credits"
        | "settings.currencies"
        | "settings.project_governance"
        | "settings.project_phases"
        | "settings.project_variables"
        | "settings.project_approval"
        | "settings.users"
        | "settings.sales_executives"
        | "settings.roles"
        | "settings.teams"
        | "settings.business_units"
        | "settings.clients"
        | "settings.partnerships"
        | "settings.vendors"
        | "settings.audit_logs"
        | "reports.work_breakdown"
        | "reports.project_pricing"
        | "reports.autotask_psa";
      "access-level":
        | "none"
        | "view"
        | "create"
        | "manage"
        | "purge"
        | "adjust_standards";
    }[];
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2TeamResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "created-at": string;
    "document-templates"?: {
      id?: string;
      name?: string;
    }[];
    questionnaires?: {
      id?: string;
      name?: string;
      introduction?: string;
    }[];
    services?: {
      id?: string;
      name?: string;
      "service-catgory"?: string;
      phase?: string;
    }[];
  };
  relationships: {
    account: V2Relationships;
    users?: {
      links?: {
        self?: string;
        related?: string;
      };
      data?: {
        id?: string;
        type?: string;
      }[];
    };
  };
};
export type V2UserResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "start-page"?: "Home" | "Projects" | "Approvals" | "Surveys" | "Settings";
    active?: boolean;
    "sso-provider"?: string;
    phone?: string;
    email: string;
    title?: string;
    presales?: boolean;
    sales?: boolean;
    roles?: {
      id: number;
      name?: string;
    }[];
    "view-only"?: boolean;
    "user-type"?: "view_only" | "licensed" | "sales" | "service" | "approver";
    privileges?: object;
    "guided-onboarding"?: {
      onboarding_status?: string;
      skipped_onboarding?: boolean;
      modified_governance?: boolean;
      modified_phases?: boolean;
      modified_resources?: boolean;
      modified_services?: boolean;
    };
    "preferred-rate-table"?: V2RateTableResource;
  };
  relationships: {
    account?: V2Relationships;
    "rate-table"?: V2Relationships;
    teams?: V2ToManyRelationships;
    roles?: V2ToManyRelationships;
  };
};
export type V2ApprovalLevelResource = {
  id?: number;
  type?: string;
  attributes?: {
    name?: string;
    kind?: "business" | "technical" | "sales";
    measure?:
      | "contract_cost"
      | "contract_revenue"
      | "contract_margin"
      | "contract_profit"
      | "customized_services"
      | "customized_terms"
      | "net_mrr"
      | "ps_margin"
      | "ms_margin"
      | "payment_credit_amount"
      | "third_party_margin"
      | "third_party_revenue"
      | "total_effort"
      | "business_unit_id";
    evaluation?: "greater_than" | "equal_to" | "less_than" | "between";
    "minimum-value"?: number;
    "maximum-value"?: number;
    "signatures-required"?: number;
    position?: number;
    "submitter-may-approve"?: boolean;
    "limit-approvals-to-team"?: boolean;
    "trigger-description"?: string;
    triggers?: {
      id?: number;
      measure?:
        | "contract_cost"
        | "contract_revenue"
        | "contract_margin"
        | "contract_profit"
        | "customized_services"
        | "customized_terms"
        | "net_mrr"
        | "ps_margin"
        | "ms_margin"
        | "payment_credit_amount"
        | "third_party_margin"
        | "third_party_revenue"
        | "total_effort"
        | "business_unit_id";
      evaluation?: "greater_than" | "equal_to" | "less_than" | "between";
      comparison_value?: string;
      maximum_value?: number;
    }[];
    approvers?: {
      id?: number;
      user_id?: number;
      name?: string;
      required?: boolean;
      position?: number;
      lob_ids?: number[];
    }[];
  };
  relationships?: {
    account?: V2Relationships;
  };
};
export type V2LobApprovalResource = {
  id?: number;
  type?: string;
  attributes?: {
    name?: string;
    "required-approvals"?: number;
    "submitter-may-approve"?: boolean;
    "limit-approvals-to-team"?: boolean;
  };
  relationships?: {
    section?: V2Relationships;
    "lob-approval-users"?: V2ToManyRelationships;
  };
};
export type V2LobResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    code?: string;
    "nested-name"?: string;
    position?: number;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2LobApprovalUserResource = {
  id?: number;
  type?: string;
  attributes?: {
    "required-approver"?: boolean;
    "user-id"?: number;
    user?: {
      name?: string;
      email?: string;
    };
  };
  relationships?: {
    "lob-approval"?: V2Relationships;
  };
};
export type V2ApprovalStepResource = {
  id?: number;
  type?: string;
  attributes?: {
    status?: "pending" | "approved" | "declined" | "canceled" | "rescoped";
    step?: "technical_approval" | "sales_approval" | "business_approval";
    description?: string;
  };
  relationships?: {
    project?: V2Relationships;
    "project-version"?: V2Relationships;
    "project-approvals"?: V2ToManyRelationships;
  };
};
export type V2ProjectVersionResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    comment?: string;
    username?: string;
    "started-at"?: string;
    "completed-at"?: string;
    "updated-at"?: string;
  };
  relationships: {
    project: V2Relationships;
    "approval-steps"?: V2ToManyRelationships;
  };
};
export type V2ProjectApprovalResource = {
  id?: number;
  type: string;
  attributes: {
    status?:
      | "required"
      | "optional"
      | "declined"
      | "approved"
      | "canceled"
      | "rescope";
    role?: string;
    reason?: string;
    comment?: string;
    "completed-at"?: string;
    "approver-name"?: string;
  };
  relationships: {
    account?: V2Relationships;
    user: V2Relationships;
    "approval-step": V2Relationships;
    "approval-level"?: V2Relationships;
  };
};
export type V2AttachmentTypeResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    document_type: "image" | "pdf" | "word";
  };
  relationships: {
    account: V2Relationships;
    "rate-table"?: V2Relationships;
    "project-attachments"?: V2ToManyRelationships;
  };
};
export type V2ProjectAttachmentResource = {
  id?: number;
  type: string;
  attributes: {
    document?: string;
  };
  relationships: {
    project: V2Relationships;
    "attachment-type"?: V2Relationships;
  };
};
export type V2AuditLogResource = {
  id?: number;
  type?: string;
  attributes?: {
    name?: string;
    "item-type"?:
      | "AccountConnection"
      | "ApprovalLevelUser"
      | "Blueprint"
      | "BlueprintItem"
      | "CustomerSuccess"
      | "DocumentTemplate"
      | "LevelOfEffort"
      | "MCPKey"
      | "Material"
      | "Membership"
      | "OauthApplication"
      | "PerformanceIndicator"
      | "Project"
      | "ProjectApproval"
      | "ProjectAttachment"
      | "ProjectCollaborator"
      | "ProjectCondition"
      | "ProjectContact"
      | "ProjectCredit"
      | "ProjectDocument"
      | "ProjectExpense"
      | "ProjectGovernance"
      | "ProjectIntegration"
      | "ProjectLocation"
      | "ProjectMaterial"
      | "ProjectPhase"
      | "ProjectResource"
      | "ProjectService"
      | "ProjectSubservice"
      | "ProjectSurvey"
      | "PromptOverride"
      | "Quote"
      | "RateTable"
      | "ResourceRate"
      | "ServiceApprover"
      | "Task"
      | "TaskMaterial"
      | "TaskRate"
      | "TeamUser"
      | "ThirdPartyRequest"
      | "ThirdPartyService"
      | "User";
    "item-id"?: number;
    "changed-by"?: string;
    event?: string;
    "created-at"?: string;
    changes?: {
      attribute?: string;
      "changed-from"?: string;
      "changed-to"?: string;
    }[];
  };
};
export type V2ProjectCollaboratorResource = {
  id?: number;
  type: string;
  attributes?: {
    name?: string;
    "project-variables"?: V2EmbeddedProjectVariable[];
  };
  relationships: {
    project: V2Relationships;
    user: V2Relationships;
  };
};
export type V2ProjectConditionResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    content?: string;
    status?: "active" | "skipped" | "optional" | "deleted";
  };
  relationships: {
    project: V2Relationships;
    "service-condition": V2Relationships;
  };
};
export type V2ProjectCreditResource = {
  id?: number;
  type: string;
  attributes: {
    amount: number;
    criteria?: string;
  };
  relationships: {
    project: V2Relationships;
    "payment-credit": V2Relationships;
  };
};
export type V2RelationshipsString = {
  links?: {
    self?: string;
    related?: string;
  };
  data: {
    id: string;
    type: string;
  };
};
export type V2ProjectExpenseResource = {
  id?: number;
  type: string;
  attributes: {
    description: string;
    rate: number;
    quantity: number;
    "deleted-at"?: string;
    cost?: number;
    revenue?: number;
    markup?: number;
    variable?: boolean;
  };
  relationships: {
    project: V2Relationships;
    "project-phase"?: V2Relationships;
    "expense-category": V2Relationships;
    "project-resource"?: V2RelationshipsString;
    resource: V2Relationships;
    "resource-rate"?: V2Relationships;
    "project-service"?: V2Relationships;
  };
};
export type V2ProjectGovernanceResource = {
  id?: number;
  type?: string;
  attributes?: {
    description?: string;
    rate?: number;
    fixed_hours?: number;
    hours?: number;
    "calculation-type"?: "percent_of_total" | "fixed_hours";
    "allocation-method"?:
      | "prorate_phases_by_effort"
      | "select_phase"
      | "select_category"
      | "project_management_phase";
    "assign-effort-to-service"?: boolean;
    "filter-type"?: "all_services" | "filter_by_lob" | "filter_by_phase";
    "filter-id"?: number;
    position?: number;
    "project-variables"?: V2EmbeddedProjectVariable[];
  };
  relationships?: {
    project?: V2Relationships;
    "project-phase"?: V2Relationships;
    governance?: V2Relationships;
    "project-resource"?: V2RelationshipsString;
    resource?: V2Relationships;
    "allocationed-governances"?: V2Relationships;
  };
};
export type V2ProjectPhaseResource = {
  id?: number;
  type?: string;
  attributes?: {
    name: string;
    "sow-language": string;
    active?: boolean;
    position?: number;
  };
  relationships?: {
    project?: V2Relationships;
    phase?: V2Relationships;
  };
};
export type V2ProjectProductResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    description?: string;
    custom?: boolean;
    source?: "standard" | "custom" | "imported" | "connectwise";
    variable_rates?: object;
    quantity: number;
    sku?: string;
    "product-id"?: string;
    "manufacturer-part-number"?: string;
    "unit-of-measure"?: string;
    category?: string;
    subcategory?: string;
    "unit-price"?: number;
    "unit-cost"?: number;
    "hardware-price"?: number;
    "hardware-cost"?: number;
    "line-number"?: string;
    "list-price"?: number;
    "vendor-discount"?: number;
    markup?: number;
    "billing-frequency"?:
      | "one_time"
      | "monthly"
      | "bi-monthly"
      | "quarterly"
      | "semi-annual"
      | "yearly";
    "project-variables"?: V2EmbeddedProjectVariable[];
  };
  relationships: {
    project: V2Relationships;
    product?: V2Relationships;
    "project-location"?: V2Relationships;
  };
};
export type V2StandardProjectResource = {
  resource_id: number;
  resource_type: string;
  name?: string;
};
export type V2VendorProjectResource = {
  resource_id: number;
  resource_type: string;
  name?: string;
};
export type V2ProjectResourceResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "external-name"?: string;
    description?: string;
    "total-hours"?: number;
    "hourly-rate"?: number;
    "hourly-cost"?: number;
    "expense-rate"?: number;
    code?: string;
    resource: V2StandardProjectResource | V2VendorProjectResource;
    "user-defined-fields"?: V2EmbeddedProjectVariable[];
  };
  relationships: {
    project: V2Relationships;
  };
};
export type V2ProjectServiceResource = {
  id?: number;
  type?: string;
  attributes?: {
    name: string;
    quantity: number;
    "override-hours": number;
    "total-hours"?: number;
    "extended-hours"?: number;
    "actual-hours"?: number;
    position?: number;
    "service-type": "professional_services" | "managed_services";
    "lob-id": number;
    "payment-frequency"?: string;
    "task-source": string;
    languages?: object;
    "calculated-pricing"?: object;
    notes?: {
      id?: number;
      name?: string;
      content: string;
      username?: string;
      created_at?: string;
      updated_at?: string;
    }[];
  };
  relationships?: {
    project: V2Relationships;
    "project-location"?: V2Relationships;
    "project-phase"?: V2Relationships;
    "project-resource"?: V2RelationshipsString;
    resource?: V2Relationships;
    service?: V2Relationships;
    lob?: V2Relationships;
    "project-subservices"?: V2ToManyRelationships;
    "allocated-governances"?: V2Relationships;
  };
};
export type V2ProjectSubserviceResource = {
  id?: number;
  type?: string;
  attributes?: {
    name: string;
    quantity: number;
    "override-hours": number;
    "extended-hours"?: number;
    "actual-hours"?: number;
    position?: number;
    "service-type"?: string;
    "lob-id"?: number;
    "payment-frequency"?: string;
    "task-source"?: string;
    languages?: object;
  };
  relationships?: {
    "project-service"?: V2Relationships;
    "project-resource"?: V2RelationshipsString;
    resource?: V2Relationships;
    service?: V2Relationships;
  };
};
export type V2BlueprintResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    code?: string;
    payload?: (
      | V2ProjectResource
      | V2ProjectCollaboratorResource
      | V2ProjectConditionResource
      | V2ProjectCreditResource
      | V2ProjectExpenseResource
      | V2ProjectGovernanceResource
      | V2ProjectPhaseResource
      | V2ProjectProductResource
      | V2ProjectResourceResource
      | V2ProjectServiceResource
      | V2ProjectSubserviceResource
    )[];
    "tag-list"?: string[];
    "executive-summary"?: string;
    "solution-summary"?: string;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2SpecialConditionResource = {
  id?: number;
  type: string;
  attributes: {
    content?: string;
    status?: "active" | "skipped" | "optional";
  };
  relationships: {
    owner?: V2Relationships;
    "service-condition": V2Relationships;
  };
};
export type V2ContactResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    phone?: string;
    email?: string;
    title?: string;
    active?: boolean;
    sales?: boolean;
    presales?: boolean;
  };
  relationships: {
    contactable?: V2Relationships;
  };
};
export type V2CollaboratorResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    active: boolean;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2ConnectedAppResource = {
  id?: number;
  type: string;
  attributes: {
    service?: string;
    about?: string;
    logo?: string;
    summary?: string;
    help_url?: string;
    authorization?: {
      type?: string;
      token?: string;
    };
    providers?: {
      name?: string;
      logo?: string;
    }[];
    features?: string[];
    categories?: {
      category?: string;
      fields?: {
        label?: string;
        path?: string;
        help?: string;
        type?: string;
        options?: string[];
      }[];
    }[];
  };
};
export type V2ContentTemplateResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    description?: string;
    "template-type"?: "service" | "blueprint" | "survey";
  };
  relationships: object;
};
export type V2CurrencyResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "currency-type":
      | "dollars"
      | "euros"
      | "dirham"
      | "francs"
      | "kroner"
      | "pounds"
      | "rand"
      | "rupeeI"
      | "rupeeN"
      | "shekels"
      | "won"
      | "yen";
    "conversion-rate": number;
    default?: boolean;
  };
  relationships?: {
    account: V2Relationships;
    "resource-rates"?: V2ToManyRelationships;
    users?: V2ToManyRelationships;
  };
};
export type V2CustomerSuccessResource = {
  id?: number;
  type: string;
  attributes: {
    outcome: string;
    "adoption-barriers"?: string;
    "ongoing-strategy"?: string;
    position?: number;
  };
  relationships: {
    account?: V2Relationships;
    project: V2Relationships;
    "performance-indicators"?: V2ToManyRelationships;
  };
};
export type V2PerformanceIndicatorResource = {
  id?: number;
  type: string;
  attributes: {
    "due-on"?: string;
    "started-on"?: string;
    "completed-on"?: string;
    status?: "pending" | "in_progress" | "delayed" | "completed";
    notes?: string;
  };
  relationships: {
    account?: V2Relationships;
    project?: V2Relationships;
    "customer-success": V2Relationships;
  };
};
export type V2DataImportResource = {
  id?: string;
  type: string;
  attributes: {
    "import-type":
      | "standard_services"
      | "bill_of_material"
      | "quoted_services"
      | "service_locations"
      | "managed_services"
      | "resource_rates"
      | "resources"
      | "standard_products";
    "context-type": "Account" | "Project" | "Quote";
    "context-id": string;
    "data-file": string;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2DocumentDeliveryResource = {
  id?: number;
  type: string;
  attributes: {
    "document-name"?: string;
    status?: "pending" | "in_progress" | "delivered" | "failed" | "canceled";
    delivery_type?: "email" | "docusign" | "download" | "cloud_storage";
    recipients?: {
      all?: string;
      internal?: string;
      external?: string;
    };
  };
  relationships: {
    account: V2Relationships;
    "rate-table"?: V2Relationships;
  };
};
export type V2DocumentRequestResource = {
  id?: string;
  type: string;
  attributes: {
    status?: "created" | "processing" | "finished" | "failed";
    "force-regeneration"?: boolean;
    "generate-pdf"?: boolean;
    "delivery-type"?: "download" | "email" | "docusign";
    "email-list"?: string;
    "account-connection-id"?: string;
    "drive-id"?: string;
    filepath?: string;
    "document-url"?: string;
    templates?: {
      document_type: "sow" | "pricing" | "breakdown" | "autotask" | "report";
      template_id: string;
      filename?: string;
    }[];
  };
  relationships: {
    project: V2Relationships;
    "document-deliveries"?: V2ToManyRelationships;
    "project-documents"?: V2ToManyRelationships;
  };
};
export type V2ProjectDocumentResource = {
  id?: number;
  type: string;
  attributes: {
    name?: string;
    status?:
      | "created"
      | "enqueued"
      | "processing"
      | "finished"
      | "failed"
      | "to_delete"
      | "generated"
      | "delivering";
    "document-type": "sow" | "pricing" | "breakdown" | "autotask" | "report";
    "delivery-type"?: "download" | "email" | "docusign";
    "email-list"?: string;
    "force-regeneration"?: boolean;
    "template-id": string;
    "template-name"?: string;
    "document-url"?: string;
    "error-text"?: string;
    "generate-pdf"?: boolean;
    "account-connection-id"?: string;
    "drive-id"?: string;
    filepath?: string;
    filename?: string;
  };
  relationships: {
    project: V2Relationships;
    "document-deliveries"?: V2ToManyRelationships;
  };
};
export type V2ExecutiveSummaryRequestResource = {
  id?: number;
  type: string;
  attributes: {
    status?: "pending" | "generating" | "failed" | "complete";
    "executive-summary"?: string;
  };
};
export type V2ExpenseCategoryResource = {
  id?: number;
  type?: string;
  attributes?: {
    name: string;
    rate?: number;
    "use-resource-rate"?: boolean;
    variable?: boolean;
    markup?: number;
    status?: "optional" | "required";
  };
  relationships?: {
    account?: V2Relationships;
    phase?: V2Relationships;
  };
};
export type V2ExternalRequestResource = {
  id?: number;
  type: string;
  attributes: {
    description: string;
    "revision-description"?: string;
    "service-type"?: "professional_services" | "managed_services";
    cost?: number;
    "recurring-cost"?: number;
    "billing-frequency"?: "one_time" | "monthly" | "quarterly" | "yearly";
    markup?: number;
    price?: number;
    requested_at?: string;
  };
  relationships: {
    account: V2Relationships;
    project: V2Relationships;
    lob?: V2Relationships;
    subcontractor?: V2Relationships;
    subproject?: V2Relationships;
  };
};
export type V2SubcontractorResource = {
  id?: number;
  type: string;
  attributes: {
    slug: string;
    "subcontractor-id"?: number;
    name: string;
    street_adddress?: string;
    city?: string;
    state?: string;
    postal_code?: string;
    country?: string;
  };
  links?: {
    projects?: string;
    "business-unit"?: string;
    clients?: string;
    "crm-opportunities"?: string;
    "document-templates"?: string;
    "expense-categories"?: string;
    governances?: string;
    "payment-terms"?: string;
    "presales-engineers"?: string;
    phases?: string;
    "project-variables"?: string;
    resources?: string;
    "sales-executives"?: string;
    services?: string;
    users?: string;
    self?: string;
  };
};
export type V2SubprojectResource = {
  id?: number;
  type?: string;
  attributes?: {
    "project-name": string;
    status?: string;
    "executive-summary"?: string;
    "key-objectives"?: string;
    "our-responsibilities"?: string;
    "client-responsibilities"?: string;
    "solution-summary"?: string;
    "out-of-scope"?: string;
    "total-effort"?: number;
    "total-revenue"?: number;
    "ms-revenue"?: number;
    "third-party-revenue"?: number;
    "submitted-at"?: string;
    "approved-at"?: string;
    "project-variables"?: V2EmbeddedProjectVariable[];
    "field-labels"?: {
      executive_summary?: string;
      solution_summary?: string;
      customer_summary?: string;
      customer_success?: string;
      sales_executive?: string;
      presales_engineer?: string;
      client?: string;
      business_unit?: string;
      location?: string;
      our_responsibilities?: string;
      client_responsibilities?: string;
      out_of_scope?: string;
    };
  };
  relationships?: {
    account?: V2Relationships;
    "business-unit"?: V2Relationships;
    client?: V2Relationships;
    "document-template"?: V2Relationships;
    "external-request"?: V2Relationships;
    "sales-executive"?: V2Relationships;
    "presales-engineer"?: V2Relationships;
    "psa-project"?: V2Relationships;
    "crm-opportunity"?: V2Relationships;
    "payment-term"?: V2Relationships;
    user?: V2Relationships;
    "project-attachments"?: V2Relationships;
    "project-collaborators"?: V2Relationships;
    "project-contacts"?: V2Relationships;
    "project-conditions"?: V2Relationships;
    "project-expenses"?: V2Relationships;
    "project-governances"?: V2Relationships;
    "project-locations"?: V2Relationships;
    "project-materials"?: V2Relationships;
    "project-services"?: V2Relationships;
    "rate-table"?: V2Relationships;
    "approval-steps"?: V2Relationships;
  };
};
export type V2FreeTrialResource = {
  id?: number;
  type: string;
  attributes: {
    "start-on"?: string;
    "end-on"?: string;
    "trial-plan-id"?:
      | "ScopeStack-Essentials-Plan-Monthly-USD"
      | "ScopeStack-Business-Plan-Monthly-USD"
      | "ScopeStack-Premium-Plan-Monthly-USD";
    status?: "active" | "purchased" | "canceled" | "expired";
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2ServiceCategoryResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    code?: string;
    "nested-name"?: string;
    "has-parent?"?: boolean;
    position?: number;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2IntegratedProductResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    description?: string;
    sku?: string;
    "product-id"?: string;
    "manufacturer-part-number"?: string;
    "unit-of-measure"?: string;
    category?: string;
    subcategory?: string;
    "unit-price"?: number;
    "unit-cost"?: number;
    "vendor-name"?: string;
    "vendor-discount"?: number;
    "vendor-rebate"?: number;
    markup?: number;
    "billing-frequency"?:
      | "one_time"
      | "monthly"
      | "bi-monthly"
      | "quarterly"
      | "semi-annual"
      | "yearly";
  };
};
export type V2IntegrationLogResource = {
  id?: number;
  type: string;
  attributes: {
    content: string;
    "created-at"?: string;
  };
  relationships: {
    account: V2Relationships;
    "account-connection"?: V2Relationships;
  };
};
export type V2LandingPageContentResource = {
  id?: number;
  type: string;
  attributes: {
    title?: string;
    content?: string;
    link?: string;
    icon?: string;
    stage?: string;
    "content-type"?: string;
  };
  relationships: object;
};
export type V2LanguageFieldResource = {
  id?: number;
  type?: string;
  attributes?: {
    name: string;
    "sow-language": string;
    active?: boolean;
    position?: number;
    preamble?: string;
    postamble?: string;
  };
  relationships?: {
    account?: V2Relationships;
    "project-expenses"?: V2ToManyRelationships;
  };
};
export type V2LevelOfEffortResource = {
  id?: number;
  type: string;
  attributes: {
    "minimum-quantity"?: number;
    "base-amount"?: number;
    "unit-amount"?: number;
  };
  relationships: {
    service?: V2Relationships;
  };
};
export type V2MeResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "start-page"?: "Home" | "Projects" | "Approvals" | "Surveys" | "Settings";
    email?: string;
    phone?: string;
    title?: string;
    "account-slug"?: string;
    "account-id"?: string;
    privileges?: {
      privilege?: string;
      "access-level"?: "none" | "view" | "create" | "manage";
    }[];
    "site-admin"?: boolean;
  };
};
export type V2NoteResource = {
  id?: number;
  type: string;
  attributes: {
    content: string;
    notable?: {
      "notable-id"?: number;
      "notable-type"?: string;
      name?: string;
    };
    username?: string;
    created_at?: string;
    updated_at?: string;
  };
  relationships: {
    project: V2Relationships;
  };
};
export type V2OpenRouterAzureKeys = {
  name?: string;
  default?: boolean;
  llms?: (
    | "ai21/jamba-large-1.7"
    | "aion-labs/aion-1.0"
    | "aion-labs/aion-1.0-mini"
    | "aion-labs/aion-2.0"
    | "aion-labs/aion-rp-llama-3.1-8b"
    | "allenai/olmo-3-32b-think"
    | "amazon/nova-2-lite-v1"
    | "amazon/nova-lite-v1"
    | "amazon/nova-micro-v1"
    | "amazon/nova-premier-v1"
    | "amazon/nova-pro-v1"
    | "anthracite-org/magnum-v4-72b"
    | "anthropic/claude-3-haiku"
    | "anthropic/claude-fable-5"
    | "anthropic/claude-haiku-4.5"
    | "anthropic/claude-opus-4"
    | "anthropic/claude-opus-4.1"
    | "anthropic/claude-opus-4.5"
    | "anthropic/claude-opus-4.6"
    | "anthropic/claude-opus-4.7"
    | "anthropic/claude-opus-4.7-fast"
    | "anthropic/claude-opus-4.8"
    | "anthropic/claude-opus-4.8-fast"
    | "anthropic/claude-sonnet-4"
    | "anthropic/claude-sonnet-4.5"
    | "anthropic/claude-sonnet-4.6"
    | "arcee-ai/coder-large"
    | "arcee-ai/trinity-large-thinking"
    | "arcee-ai/trinity-mini"
    | "arcee-ai/virtuoso-large"
    | "baidu/ernie-4.5-vl-424b-a47b"
    | "bytedance-seed/seed-1.6"
    | "bytedance-seed/seed-1.6-flash"
    | "bytedance-seed/seed-2.0-lite"
    | "bytedance-seed/seed-2.0-mini"
    | "bytedance/ui-tars-1.5-7b"
    | "cognitivecomputations/dolphin-mistral-24b-venice-edition:free"
    | "cohere/command-a"
    | "cohere/command-r-08-2024"
    | "cohere/command-r-plus-08-2024"
    | "cohere/command-r7b-12-2024"
    | "cohere/north-mini-code:free"
    | "deepcogito/cogito-v2.1-671b"
    | "deepseek/deepseek-chat"
    | "deepseek/deepseek-chat-v3-0324"
    | "deepseek/deepseek-chat-v3.1"
    | "deepseek/deepseek-r1"
    | "deepseek/deepseek-r1-0528"
    | "deepseek/deepseek-r1-distill-llama-70b"
    | "deepseek/deepseek-v3.1-terminus"
    | "deepseek/deepseek-v3.2"
    | "deepseek/deepseek-v3.2-exp"
    | "deepseek/deepseek-v4-flash"
    | "deepseek/deepseek-v4-pro"
    | "google/gemini-2.5-flash"
    | "google/gemini-2.5-flash-image"
    | "google/gemini-2.5-flash-lite"
    | "google/gemini-2.5-flash-lite-preview-09-2025"
    | "google/gemini-2.5-pro"
    | "google/gemini-2.5-pro-preview"
    | "google/gemini-2.5-pro-preview-05-06"
    | "google/gemini-3-flash-preview"
    | "google/gemini-3-pro-image"
    | "google/gemini-3-pro-image-preview"
    | "google/gemini-3.1-flash-image"
    | "google/gemini-3.1-flash-image-preview"
    | "google/gemini-3.1-flash-lite"
    | "google/gemini-3.1-flash-lite-preview"
    | "google/gemini-3.1-pro-preview"
    | "google/gemini-3.1-pro-preview-customtools"
    | "google/gemini-3.5-flash"
    | "google/gemma-2-27b-it"
    | "google/gemma-3-12b-it"
    | "google/gemma-3-27b-it"
    | "google/gemma-3-4b-it"
    | "google/gemma-3n-e4b-it"
    | "google/gemma-4-26b-a4b-it"
    | "google/gemma-4-26b-a4b-it:free"
    | "google/gemma-4-31b-it"
    | "google/gemma-4-31b-it:free"
    | "google/lyria-3-clip-preview"
    | "google/lyria-3-pro-preview"
    | "gryphe/mythomax-l2-13b"
    | "ibm-granite/granite-4.0-h-micro"
    | "ibm-granite/granite-4.1-8b"
    | "inception/mercury-2"
    | "inclusionai/ling-2.6-1t"
    | "inclusionai/ling-2.6-flash"
    | "inclusionai/ring-2.6-1t"
    | "inflection/inflection-3-pi"
    | "inflection/inflection-3-productivity"
    | "kwaipilot/kat-coder-pro-v2"
    | "liquid/lfm-2-24b-a2b"
    | "liquid/lfm-2.5-1.2b-instruct:free"
    | "liquid/lfm-2.5-1.2b-thinking:free"
    | "mancer/weaver"
    | "meta-llama/llama-3-8b-instruct"
    | "meta-llama/llama-3.1-70b-instruct"
    | "meta-llama/llama-3.1-8b-instruct"
    | "meta-llama/llama-3.2-11b-vision-instruct"
    | "meta-llama/llama-3.2-1b-instruct"
    | "meta-llama/llama-3.2-3b-instruct"
    | "meta-llama/llama-3.2-3b-instruct:free"
    | "meta-llama/llama-3.3-70b-instruct"
    | "meta-llama/llama-3.3-70b-instruct:free"
    | "meta-llama/llama-4-maverick"
    | "meta-llama/llama-4-scout"
    | "meta-llama/llama-guard-4-12b"
    | "microsoft/phi-4"
    | "microsoft/phi-4-mini-instruct"
    | "microsoft/wizardlm-2-8x22b"
    | "minimax/minimax-01"
    | "minimax/minimax-m1"
    | "minimax/minimax-m2"
    | "minimax/minimax-m2-her"
    | "minimax/minimax-m2.1"
    | "minimax/minimax-m2.5"
    | "minimax/minimax-m2.7"
    | "minimax/minimax-m3"
    | "mistralai/codestral-2508"
    | "mistralai/devstral-2512"
    | "mistralai/ministral-14b-2512"
    | "mistralai/ministral-3b-2512"
    | "mistralai/ministral-8b-2512"
    | "mistralai/mistral-large"
    | "mistralai/mistral-large-2407"
    | "mistralai/mistral-large-2512"
    | "mistralai/mistral-medium-3"
    | "mistralai/mistral-medium-3-5"
    | "mistralai/mistral-medium-3.1"
    | "mistralai/mistral-nemo"
    | "mistralai/mistral-saba"
    | "mistralai/mistral-small-24b-instruct-2501"
    | "mistralai/mistral-small-2603"
    | "mistralai/mistral-small-3.1-24b-instruct"
    | "mistralai/mistral-small-3.2-24b-instruct"
    | "mistralai/mixtral-8x22b-instruct"
    | "mistralai/voxtral-small-24b-2507"
    | "moonshotai/kimi-k2"
    | "moonshotai/kimi-k2-0905"
    | "moonshotai/kimi-k2-thinking"
    | "moonshotai/kimi-k2.5"
    | "moonshotai/kimi-k2.6"
    | "moonshotai/kimi-k2.7-code"
    | "morph/morph-v3-fast"
    | "morph/morph-v3-large"
    | "nex-agi/nex-n2-pro"
    | "nousresearch/hermes-3-llama-3.1-405b"
    | "nousresearch/hermes-3-llama-3.1-405b:free"
    | "nousresearch/hermes-3-llama-3.1-70b"
    | "nousresearch/hermes-4-405b"
    | "nousresearch/hermes-4-70b"
    | "nvidia/llama-3.3-nemotron-super-49b-v1.5"
    | "nvidia/nemotron-3-nano-30b-a3b"
    | "nvidia/nemotron-3-nano-30b-a3b:free"
    | "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free"
    | "nvidia/nemotron-3-super-120b-a12b"
    | "nvidia/nemotron-3-super-120b-a12b:free"
    | "nvidia/nemotron-3-ultra-550b-a55b"
    | "nvidia/nemotron-3-ultra-550b-a55b:free"
    | "nvidia/nemotron-3.5-content-safety:free"
    | "nvidia/nemotron-nano-12b-v2-vl:free"
    | "nvidia/nemotron-nano-9b-v2:free"
    | "openai/gpt-3.5-turbo"
    | "openai/gpt-3.5-turbo-0613"
    | "openai/gpt-3.5-turbo-16k"
    | "openai/gpt-3.5-turbo-instruct"
    | "openai/gpt-4"
    | "openai/gpt-4-turbo"
    | "openai/gpt-4-turbo-preview"
    | "openai/gpt-4.1"
    | "openai/gpt-4.1-mini"
    | "openai/gpt-4.1-nano"
    | "openai/gpt-4o"
    | "openai/gpt-4o-2024-05-13"
    | "openai/gpt-4o-2024-08-06"
    | "openai/gpt-4o-2024-11-20"
    | "openai/gpt-4o-mini"
    | "openai/gpt-4o-mini-2024-07-18"
    | "openai/gpt-4o-mini-search-preview"
    | "openai/gpt-4o-search-preview"
    | "openai/gpt-5"
    | "openai/gpt-5-chat"
    | "openai/gpt-5-codex"
    | "openai/gpt-5-image"
    | "openai/gpt-5-image-mini"
    | "openai/gpt-5-mini"
    | "openai/gpt-5-nano"
    | "openai/gpt-5-pro"
    | "openai/gpt-5.1"
    | "openai/gpt-5.1-chat"
    | "openai/gpt-5.1-codex"
    | "openai/gpt-5.1-codex-max"
    | "openai/gpt-5.1-codex-mini"
    | "openai/gpt-5.2"
    | "openai/gpt-5.2-chat"
    | "openai/gpt-5.2-codex"
    | "openai/gpt-5.2-pro"
    | "openai/gpt-5.3-chat"
    | "openai/gpt-5.3-codex"
    | "openai/gpt-5.4"
    | "openai/gpt-5.4-image-2"
    | "openai/gpt-5.4-mini"
    | "openai/gpt-5.4-nano"
    | "openai/gpt-5.4-pro"
    | "openai/gpt-5.5"
    | "openai/gpt-5.5-pro"
    | "openai/gpt-audio"
    | "openai/gpt-audio-mini"
    | "openai/gpt-chat-latest"
    | "openai/gpt-oss-120b"
    | "openai/gpt-oss-120b:free"
    | "openai/gpt-oss-20b"
    | "openai/gpt-oss-20b:free"
    | "openai/gpt-oss-safeguard-20b"
    | "openai/o1"
    | "openai/o1-pro"
    | "openai/o3"
    | "openai/o3-deep-research"
    | "openai/o3-mini"
    | "openai/o3-mini-high"
    | "openai/o3-pro"
    | "openai/o4-mini"
    | "openai/o4-mini-deep-research"
    | "openai/o4-mini-high"
    | "openrouter/auto"
    | "openrouter/bodybuilder"
    | "openrouter/free"
    | "openrouter/fusion"
    | "openrouter/owl-alpha"
    | "openrouter/pareto-code"
    | "perceptron/perceptron-mk1"
    | "perplexity/sonar"
    | "perplexity/sonar-deep-research"
    | "perplexity/sonar-pro"
    | "perplexity/sonar-pro-search"
    | "perplexity/sonar-reasoning-pro"
    | "poolside/laguna-m.1"
    | "poolside/laguna-m.1:free"
    | "poolside/laguna-xs.2"
    | "poolside/laguna-xs.2:free"
    | "qwen/qwen-2.5-72b-instruct"
    | "qwen/qwen-2.5-7b-instruct"
    | "qwen/qwen-2.5-coder-32b-instruct"
    | "qwen/qwen-plus"
    | "qwen/qwen-plus-2025-07-28"
    | "qwen/qwen-plus-2025-07-28:thinking"
    | "qwen/qwen2.5-vl-72b-instruct"
    | "qwen/qwen3-14b"
    | "qwen/qwen3-235b-a22b"
    | "qwen/qwen3-235b-a22b-2507"
    | "qwen/qwen3-235b-a22b-thinking-2507"
    | "qwen/qwen3-30b-a3b"
    | "qwen/qwen3-30b-a3b-instruct-2507"
    | "qwen/qwen3-30b-a3b-thinking-2507"
    | "qwen/qwen3-32b"
    | "qwen/qwen3-8b"
    | "qwen/qwen3-coder"
    | "qwen/qwen3-coder-30b-a3b-instruct"
    | "qwen/qwen3-coder-flash"
    | "qwen/qwen3-coder-next"
    | "qwen/qwen3-coder-plus"
    | "qwen/qwen3-coder:free"
    | "qwen/qwen3-max"
    | "qwen/qwen3-max-thinking"
    | "qwen/qwen3-next-80b-a3b-instruct"
    | "qwen/qwen3-next-80b-a3b-instruct:free"
    | "qwen/qwen3-next-80b-a3b-thinking"
    | "qwen/qwen3-vl-235b-a22b-instruct"
    | "qwen/qwen3-vl-235b-a22b-thinking"
    | "qwen/qwen3-vl-30b-a3b-instruct"
    | "qwen/qwen3-vl-30b-a3b-thinking"
    | "qwen/qwen3-vl-32b-instruct"
    | "qwen/qwen3-vl-8b-instruct"
    | "qwen/qwen3-vl-8b-thinking"
    | "qwen/qwen3.5-122b-a10b"
    | "qwen/qwen3.5-27b"
    | "qwen/qwen3.5-35b-a3b"
    | "qwen/qwen3.5-397b-a17b"
    | "qwen/qwen3.5-9b"
    | "qwen/qwen3.5-flash-02-23"
    | "qwen/qwen3.5-plus-02-15"
    | "qwen/qwen3.5-plus-20260420"
    | "qwen/qwen3.6-27b"
    | "qwen/qwen3.6-35b-a3b"
    | "qwen/qwen3.6-flash"
    | "qwen/qwen3.6-max-preview"
    | "qwen/qwen3.6-plus"
    | "qwen/qwen3.7-max"
    | "qwen/qwen3.7-plus"
    | "rekaai/reka-edge"
    | "rekaai/reka-flash-3"
    | "relace/relace-apply-3"
    | "relace/relace-search"
    | "sakana/fugu-ultra"
    | "sao10k/l3-lunaris-8b"
    | "sao10k/l3.1-70b-hanami-x1"
    | "sao10k/l3.1-euryale-70b"
    | "sao10k/l3.3-euryale-70b"
    | "stepfun/step-3.5-flash"
    | "stepfun/step-3.7-flash"
    | "switchpoint/router"
    | "tencent/hunyuan-a13b-instruct"
    | "tencent/hy3-preview"
    | "thedrummer/cydonia-24b-v4.1"
    | "thedrummer/rocinante-12b"
    | "thedrummer/skyfall-36b-v2"
    | "thedrummer/unslopnemo-12b"
    | "undi95/remm-slerp-l2-13b"
    | "upstage/solar-pro-3"
    | "writer/palmyra-x5"
    | "x-ai/grok-4.20"
    | "x-ai/grok-4.20-multi-agent"
    | "x-ai/grok-4.3"
    | "x-ai/grok-build-0.1"
    | "xiaomi/mimo-v2.5"
    | "xiaomi/mimo-v2.5-pro"
    | "z-ai/glm-4.5"
    | "z-ai/glm-4.5-air"
    | "z-ai/glm-4.5v"
    | "z-ai/glm-4.6"
    | "z-ai/glm-4.6v"
    | "z-ai/glm-4.7"
    | "z-ai/glm-4.7-flash"
    | "z-ai/glm-5"
    | "z-ai/glm-5-turbo"
    | "z-ai/glm-5.1"
    | "z-ai/glm-5.2"
    | "z-ai/glm-5v-turbo"
    | "~anthropic/claude-fable-latest"
    | "~anthropic/claude-haiku-latest"
    | "~anthropic/claude-opus-latest"
    | "~anthropic/claude-sonnet-latest"
    | "~google/gemini-flash-latest"
    | "~google/gemini-pro-latest"
    | "~moonshotai/kimi-latest"
    | "~openai/gpt-latest"
    | "~openai/gpt-mini-latest"
  )[];
  "key-type": string;
  "model-slug": string;
  "endpoint-url": string;
  "api-key": string;
  "model-id": string;
};
export type V2OpenRouterAwsBedrockKeys = {
  name?: string;
  default?: boolean;
  llms?: (
    | "ai21/jamba-large-1.7"
    | "aion-labs/aion-1.0"
    | "aion-labs/aion-1.0-mini"
    | "aion-labs/aion-2.0"
    | "aion-labs/aion-rp-llama-3.1-8b"
    | "allenai/olmo-3-32b-think"
    | "amazon/nova-2-lite-v1"
    | "amazon/nova-lite-v1"
    | "amazon/nova-micro-v1"
    | "amazon/nova-premier-v1"
    | "amazon/nova-pro-v1"
    | "anthracite-org/magnum-v4-72b"
    | "anthropic/claude-3-haiku"
    | "anthropic/claude-fable-5"
    | "anthropic/claude-haiku-4.5"
    | "anthropic/claude-opus-4"
    | "anthropic/claude-opus-4.1"
    | "anthropic/claude-opus-4.5"
    | "anthropic/claude-opus-4.6"
    | "anthropic/claude-opus-4.7"
    | "anthropic/claude-opus-4.7-fast"
    | "anthropic/claude-opus-4.8"
    | "anthropic/claude-opus-4.8-fast"
    | "anthropic/claude-sonnet-4"
    | "anthropic/claude-sonnet-4.5"
    | "anthropic/claude-sonnet-4.6"
    | "arcee-ai/coder-large"
    | "arcee-ai/trinity-large-thinking"
    | "arcee-ai/trinity-mini"
    | "arcee-ai/virtuoso-large"
    | "baidu/ernie-4.5-vl-424b-a47b"
    | "bytedance-seed/seed-1.6"
    | "bytedance-seed/seed-1.6-flash"
    | "bytedance-seed/seed-2.0-lite"
    | "bytedance-seed/seed-2.0-mini"
    | "bytedance/ui-tars-1.5-7b"
    | "cognitivecomputations/dolphin-mistral-24b-venice-edition:free"
    | "cohere/command-a"
    | "cohere/command-r-08-2024"
    | "cohere/command-r-plus-08-2024"
    | "cohere/command-r7b-12-2024"
    | "cohere/north-mini-code:free"
    | "deepcogito/cogito-v2.1-671b"
    | "deepseek/deepseek-chat"
    | "deepseek/deepseek-chat-v3-0324"
    | "deepseek/deepseek-chat-v3.1"
    | "deepseek/deepseek-r1"
    | "deepseek/deepseek-r1-0528"
    | "deepseek/deepseek-r1-distill-llama-70b"
    | "deepseek/deepseek-v3.1-terminus"
    | "deepseek/deepseek-v3.2"
    | "deepseek/deepseek-v3.2-exp"
    | "deepseek/deepseek-v4-flash"
    | "deepseek/deepseek-v4-pro"
    | "google/gemini-2.5-flash"
    | "google/gemini-2.5-flash-image"
    | "google/gemini-2.5-flash-lite"
    | "google/gemini-2.5-flash-lite-preview-09-2025"
    | "google/gemini-2.5-pro"
    | "google/gemini-2.5-pro-preview"
    | "google/gemini-2.5-pro-preview-05-06"
    | "google/gemini-3-flash-preview"
    | "google/gemini-3-pro-image"
    | "google/gemini-3-pro-image-preview"
    | "google/gemini-3.1-flash-image"
    | "google/gemini-3.1-flash-image-preview"
    | "google/gemini-3.1-flash-lite"
    | "google/gemini-3.1-flash-lite-preview"
    | "google/gemini-3.1-pro-preview"
    | "google/gemini-3.1-pro-preview-customtools"
    | "google/gemini-3.5-flash"
    | "google/gemma-2-27b-it"
    | "google/gemma-3-12b-it"
    | "google/gemma-3-27b-it"
    | "google/gemma-3-4b-it"
    | "google/gemma-3n-e4b-it"
    | "google/gemma-4-26b-a4b-it"
    | "google/gemma-4-26b-a4b-it:free"
    | "google/gemma-4-31b-it"
    | "google/gemma-4-31b-it:free"
    | "google/lyria-3-clip-preview"
    | "google/lyria-3-pro-preview"
    | "gryphe/mythomax-l2-13b"
    | "ibm-granite/granite-4.0-h-micro"
    | "ibm-granite/granite-4.1-8b"
    | "inception/mercury-2"
    | "inclusionai/ling-2.6-1t"
    | "inclusionai/ling-2.6-flash"
    | "inclusionai/ring-2.6-1t"
    | "inflection/inflection-3-pi"
    | "inflection/inflection-3-productivity"
    | "kwaipilot/kat-coder-pro-v2"
    | "liquid/lfm-2-24b-a2b"
    | "liquid/lfm-2.5-1.2b-instruct:free"
    | "liquid/lfm-2.5-1.2b-thinking:free"
    | "mancer/weaver"
    | "meta-llama/llama-3-8b-instruct"
    | "meta-llama/llama-3.1-70b-instruct"
    | "meta-llama/llama-3.1-8b-instruct"
    | "meta-llama/llama-3.2-11b-vision-instruct"
    | "meta-llama/llama-3.2-1b-instruct"
    | "meta-llama/llama-3.2-3b-instruct"
    | "meta-llama/llama-3.2-3b-instruct:free"
    | "meta-llama/llama-3.3-70b-instruct"
    | "meta-llama/llama-3.3-70b-instruct:free"
    | "meta-llama/llama-4-maverick"
    | "meta-llama/llama-4-scout"
    | "meta-llama/llama-guard-4-12b"
    | "microsoft/phi-4"
    | "microsoft/phi-4-mini-instruct"
    | "microsoft/wizardlm-2-8x22b"
    | "minimax/minimax-01"
    | "minimax/minimax-m1"
    | "minimax/minimax-m2"
    | "minimax/minimax-m2-her"
    | "minimax/minimax-m2.1"
    | "minimax/minimax-m2.5"
    | "minimax/minimax-m2.7"
    | "minimax/minimax-m3"
    | "mistralai/codestral-2508"
    | "mistralai/devstral-2512"
    | "mistralai/ministral-14b-2512"
    | "mistralai/ministral-3b-2512"
    | "mistralai/ministral-8b-2512"
    | "mistralai/mistral-large"
    | "mistralai/mistral-large-2407"
    | "mistralai/mistral-large-2512"
    | "mistralai/mistral-medium-3"
    | "mistralai/mistral-medium-3-5"
    | "mistralai/mistral-medium-3.1"
    | "mistralai/mistral-nemo"
    | "mistralai/mistral-saba"
    | "mistralai/mistral-small-24b-instruct-2501"
    | "mistralai/mistral-small-2603"
    | "mistralai/mistral-small-3.1-24b-instruct"
    | "mistralai/mistral-small-3.2-24b-instruct"
    | "mistralai/mixtral-8x22b-instruct"
    | "mistralai/voxtral-small-24b-2507"
    | "moonshotai/kimi-k2"
    | "moonshotai/kimi-k2-0905"
    | "moonshotai/kimi-k2-thinking"
    | "moonshotai/kimi-k2.5"
    | "moonshotai/kimi-k2.6"
    | "moonshotai/kimi-k2.7-code"
    | "morph/morph-v3-fast"
    | "morph/morph-v3-large"
    | "nex-agi/nex-n2-pro"
    | "nousresearch/hermes-3-llama-3.1-405b"
    | "nousresearch/hermes-3-llama-3.1-405b:free"
    | "nousresearch/hermes-3-llama-3.1-70b"
    | "nousresearch/hermes-4-405b"
    | "nousresearch/hermes-4-70b"
    | "nvidia/llama-3.3-nemotron-super-49b-v1.5"
    | "nvidia/nemotron-3-nano-30b-a3b"
    | "nvidia/nemotron-3-nano-30b-a3b:free"
    | "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free"
    | "nvidia/nemotron-3-super-120b-a12b"
    | "nvidia/nemotron-3-super-120b-a12b:free"
    | "nvidia/nemotron-3-ultra-550b-a55b"
    | "nvidia/nemotron-3-ultra-550b-a55b:free"
    | "nvidia/nemotron-3.5-content-safety:free"
    | "nvidia/nemotron-nano-12b-v2-vl:free"
    | "nvidia/nemotron-nano-9b-v2:free"
    | "openai/gpt-3.5-turbo"
    | "openai/gpt-3.5-turbo-0613"
    | "openai/gpt-3.5-turbo-16k"
    | "openai/gpt-3.5-turbo-instruct"
    | "openai/gpt-4"
    | "openai/gpt-4-turbo"
    | "openai/gpt-4-turbo-preview"
    | "openai/gpt-4.1"
    | "openai/gpt-4.1-mini"
    | "openai/gpt-4.1-nano"
    | "openai/gpt-4o"
    | "openai/gpt-4o-2024-05-13"
    | "openai/gpt-4o-2024-08-06"
    | "openai/gpt-4o-2024-11-20"
    | "openai/gpt-4o-mini"
    | "openai/gpt-4o-mini-2024-07-18"
    | "openai/gpt-4o-mini-search-preview"
    | "openai/gpt-4o-search-preview"
    | "openai/gpt-5"
    | "openai/gpt-5-chat"
    | "openai/gpt-5-codex"
    | "openai/gpt-5-image"
    | "openai/gpt-5-image-mini"
    | "openai/gpt-5-mini"
    | "openai/gpt-5-nano"
    | "openai/gpt-5-pro"
    | "openai/gpt-5.1"
    | "openai/gpt-5.1-chat"
    | "openai/gpt-5.1-codex"
    | "openai/gpt-5.1-codex-max"
    | "openai/gpt-5.1-codex-mini"
    | "openai/gpt-5.2"
    | "openai/gpt-5.2-chat"
    | "openai/gpt-5.2-codex"
    | "openai/gpt-5.2-pro"
    | "openai/gpt-5.3-chat"
    | "openai/gpt-5.3-codex"
    | "openai/gpt-5.4"
    | "openai/gpt-5.4-image-2"
    | "openai/gpt-5.4-mini"
    | "openai/gpt-5.4-nano"
    | "openai/gpt-5.4-pro"
    | "openai/gpt-5.5"
    | "openai/gpt-5.5-pro"
    | "openai/gpt-audio"
    | "openai/gpt-audio-mini"
    | "openai/gpt-chat-latest"
    | "openai/gpt-oss-120b"
    | "openai/gpt-oss-120b:free"
    | "openai/gpt-oss-20b"
    | "openai/gpt-oss-20b:free"
    | "openai/gpt-oss-safeguard-20b"
    | "openai/o1"
    | "openai/o1-pro"
    | "openai/o3"
    | "openai/o3-deep-research"
    | "openai/o3-mini"
    | "openai/o3-mini-high"
    | "openai/o3-pro"
    | "openai/o4-mini"
    | "openai/o4-mini-deep-research"
    | "openai/o4-mini-high"
    | "openrouter/auto"
    | "openrouter/bodybuilder"
    | "openrouter/free"
    | "openrouter/fusion"
    | "openrouter/owl-alpha"
    | "openrouter/pareto-code"
    | "perceptron/perceptron-mk1"
    | "perplexity/sonar"
    | "perplexity/sonar-deep-research"
    | "perplexity/sonar-pro"
    | "perplexity/sonar-pro-search"
    | "perplexity/sonar-reasoning-pro"
    | "poolside/laguna-m.1"
    | "poolside/laguna-m.1:free"
    | "poolside/laguna-xs.2"
    | "poolside/laguna-xs.2:free"
    | "qwen/qwen-2.5-72b-instruct"
    | "qwen/qwen-2.5-7b-instruct"
    | "qwen/qwen-2.5-coder-32b-instruct"
    | "qwen/qwen-plus"
    | "qwen/qwen-plus-2025-07-28"
    | "qwen/qwen-plus-2025-07-28:thinking"
    | "qwen/qwen2.5-vl-72b-instruct"
    | "qwen/qwen3-14b"
    | "qwen/qwen3-235b-a22b"
    | "qwen/qwen3-235b-a22b-2507"
    | "qwen/qwen3-235b-a22b-thinking-2507"
    | "qwen/qwen3-30b-a3b"
    | "qwen/qwen3-30b-a3b-instruct-2507"
    | "qwen/qwen3-30b-a3b-thinking-2507"
    | "qwen/qwen3-32b"
    | "qwen/qwen3-8b"
    | "qwen/qwen3-coder"
    | "qwen/qwen3-coder-30b-a3b-instruct"
    | "qwen/qwen3-coder-flash"
    | "qwen/qwen3-coder-next"
    | "qwen/qwen3-coder-plus"
    | "qwen/qwen3-coder:free"
    | "qwen/qwen3-max"
    | "qwen/qwen3-max-thinking"
    | "qwen/qwen3-next-80b-a3b-instruct"
    | "qwen/qwen3-next-80b-a3b-instruct:free"
    | "qwen/qwen3-next-80b-a3b-thinking"
    | "qwen/qwen3-vl-235b-a22b-instruct"
    | "qwen/qwen3-vl-235b-a22b-thinking"
    | "qwen/qwen3-vl-30b-a3b-instruct"
    | "qwen/qwen3-vl-30b-a3b-thinking"
    | "qwen/qwen3-vl-32b-instruct"
    | "qwen/qwen3-vl-8b-instruct"
    | "qwen/qwen3-vl-8b-thinking"
    | "qwen/qwen3.5-122b-a10b"
    | "qwen/qwen3.5-27b"
    | "qwen/qwen3.5-35b-a3b"
    | "qwen/qwen3.5-397b-a17b"
    | "qwen/qwen3.5-9b"
    | "qwen/qwen3.5-flash-02-23"
    | "qwen/qwen3.5-plus-02-15"
    | "qwen/qwen3.5-plus-20260420"
    | "qwen/qwen3.6-27b"
    | "qwen/qwen3.6-35b-a3b"
    | "qwen/qwen3.6-flash"
    | "qwen/qwen3.6-max-preview"
    | "qwen/qwen3.6-plus"
    | "qwen/qwen3.7-max"
    | "qwen/qwen3.7-plus"
    | "rekaai/reka-edge"
    | "rekaai/reka-flash-3"
    | "relace/relace-apply-3"
    | "relace/relace-search"
    | "sakana/fugu-ultra"
    | "sao10k/l3-lunaris-8b"
    | "sao10k/l3.1-70b-hanami-x1"
    | "sao10k/l3.1-euryale-70b"
    | "sao10k/l3.3-euryale-70b"
    | "stepfun/step-3.5-flash"
    | "stepfun/step-3.7-flash"
    | "switchpoint/router"
    | "tencent/hunyuan-a13b-instruct"
    | "tencent/hy3-preview"
    | "thedrummer/cydonia-24b-v4.1"
    | "thedrummer/rocinante-12b"
    | "thedrummer/skyfall-36b-v2"
    | "thedrummer/unslopnemo-12b"
    | "undi95/remm-slerp-l2-13b"
    | "upstage/solar-pro-3"
    | "writer/palmyra-x5"
    | "x-ai/grok-4.20"
    | "x-ai/grok-4.20-multi-agent"
    | "x-ai/grok-4.3"
    | "x-ai/grok-build-0.1"
    | "xiaomi/mimo-v2.5"
    | "xiaomi/mimo-v2.5-pro"
    | "z-ai/glm-4.5"
    | "z-ai/glm-4.5-air"
    | "z-ai/glm-4.5v"
    | "z-ai/glm-4.6"
    | "z-ai/glm-4.6v"
    | "z-ai/glm-4.7"
    | "z-ai/glm-4.7-flash"
    | "z-ai/glm-5"
    | "z-ai/glm-5-turbo"
    | "z-ai/glm-5.1"
    | "z-ai/glm-5.2"
    | "z-ai/glm-5v-turbo"
    | "~anthropic/claude-fable-latest"
    | "~anthropic/claude-haiku-latest"
    | "~anthropic/claude-opus-latest"
    | "~anthropic/claude-sonnet-latest"
    | "~google/gemini-flash-latest"
    | "~google/gemini-pro-latest"
    | "~moonshotai/kimi-latest"
    | "~openai/gpt-latest"
    | "~openai/gpt-mini-latest"
  )[];
  "key-type": string;
  key: string;
  "access-key-id"?: string;
  "secret-access-key"?: string;
  region: string;
};
export type V2OpenRouterGoogleVertexKeys = {
  name?: string;
  default?: boolean;
  llms?: (
    | "ai21/jamba-large-1.7"
    | "aion-labs/aion-1.0"
    | "aion-labs/aion-1.0-mini"
    | "aion-labs/aion-2.0"
    | "aion-labs/aion-rp-llama-3.1-8b"
    | "allenai/olmo-3-32b-think"
    | "amazon/nova-2-lite-v1"
    | "amazon/nova-lite-v1"
    | "amazon/nova-micro-v1"
    | "amazon/nova-premier-v1"
    | "amazon/nova-pro-v1"
    | "anthracite-org/magnum-v4-72b"
    | "anthropic/claude-3-haiku"
    | "anthropic/claude-fable-5"
    | "anthropic/claude-haiku-4.5"
    | "anthropic/claude-opus-4"
    | "anthropic/claude-opus-4.1"
    | "anthropic/claude-opus-4.5"
    | "anthropic/claude-opus-4.6"
    | "anthropic/claude-opus-4.7"
    | "anthropic/claude-opus-4.7-fast"
    | "anthropic/claude-opus-4.8"
    | "anthropic/claude-opus-4.8-fast"
    | "anthropic/claude-sonnet-4"
    | "anthropic/claude-sonnet-4.5"
    | "anthropic/claude-sonnet-4.6"
    | "arcee-ai/coder-large"
    | "arcee-ai/trinity-large-thinking"
    | "arcee-ai/trinity-mini"
    | "arcee-ai/virtuoso-large"
    | "baidu/ernie-4.5-vl-424b-a47b"
    | "bytedance-seed/seed-1.6"
    | "bytedance-seed/seed-1.6-flash"
    | "bytedance-seed/seed-2.0-lite"
    | "bytedance-seed/seed-2.0-mini"
    | "bytedance/ui-tars-1.5-7b"
    | "cognitivecomputations/dolphin-mistral-24b-venice-edition:free"
    | "cohere/command-a"
    | "cohere/command-r-08-2024"
    | "cohere/command-r-plus-08-2024"
    | "cohere/command-r7b-12-2024"
    | "cohere/north-mini-code:free"
    | "deepcogito/cogito-v2.1-671b"
    | "deepseek/deepseek-chat"
    | "deepseek/deepseek-chat-v3-0324"
    | "deepseek/deepseek-chat-v3.1"
    | "deepseek/deepseek-r1"
    | "deepseek/deepseek-r1-0528"
    | "deepseek/deepseek-r1-distill-llama-70b"
    | "deepseek/deepseek-v3.1-terminus"
    | "deepseek/deepseek-v3.2"
    | "deepseek/deepseek-v3.2-exp"
    | "deepseek/deepseek-v4-flash"
    | "deepseek/deepseek-v4-pro"
    | "google/gemini-2.5-flash"
    | "google/gemini-2.5-flash-image"
    | "google/gemini-2.5-flash-lite"
    | "google/gemini-2.5-flash-lite-preview-09-2025"
    | "google/gemini-2.5-pro"
    | "google/gemini-2.5-pro-preview"
    | "google/gemini-2.5-pro-preview-05-06"
    | "google/gemini-3-flash-preview"
    | "google/gemini-3-pro-image"
    | "google/gemini-3-pro-image-preview"
    | "google/gemini-3.1-flash-image"
    | "google/gemini-3.1-flash-image-preview"
    | "google/gemini-3.1-flash-lite"
    | "google/gemini-3.1-flash-lite-preview"
    | "google/gemini-3.1-pro-preview"
    | "google/gemini-3.1-pro-preview-customtools"
    | "google/gemini-3.5-flash"
    | "google/gemma-2-27b-it"
    | "google/gemma-3-12b-it"
    | "google/gemma-3-27b-it"
    | "google/gemma-3-4b-it"
    | "google/gemma-3n-e4b-it"
    | "google/gemma-4-26b-a4b-it"
    | "google/gemma-4-26b-a4b-it:free"
    | "google/gemma-4-31b-it"
    | "google/gemma-4-31b-it:free"
    | "google/lyria-3-clip-preview"
    | "google/lyria-3-pro-preview"
    | "gryphe/mythomax-l2-13b"
    | "ibm-granite/granite-4.0-h-micro"
    | "ibm-granite/granite-4.1-8b"
    | "inception/mercury-2"
    | "inclusionai/ling-2.6-1t"
    | "inclusionai/ling-2.6-flash"
    | "inclusionai/ring-2.6-1t"
    | "inflection/inflection-3-pi"
    | "inflection/inflection-3-productivity"
    | "kwaipilot/kat-coder-pro-v2"
    | "liquid/lfm-2-24b-a2b"
    | "liquid/lfm-2.5-1.2b-instruct:free"
    | "liquid/lfm-2.5-1.2b-thinking:free"
    | "mancer/weaver"
    | "meta-llama/llama-3-8b-instruct"
    | "meta-llama/llama-3.1-70b-instruct"
    | "meta-llama/llama-3.1-8b-instruct"
    | "meta-llama/llama-3.2-11b-vision-instruct"
    | "meta-llama/llama-3.2-1b-instruct"
    | "meta-llama/llama-3.2-3b-instruct"
    | "meta-llama/llama-3.2-3b-instruct:free"
    | "meta-llama/llama-3.3-70b-instruct"
    | "meta-llama/llama-3.3-70b-instruct:free"
    | "meta-llama/llama-4-maverick"
    | "meta-llama/llama-4-scout"
    | "meta-llama/llama-guard-4-12b"
    | "microsoft/phi-4"
    | "microsoft/phi-4-mini-instruct"
    | "microsoft/wizardlm-2-8x22b"
    | "minimax/minimax-01"
    | "minimax/minimax-m1"
    | "minimax/minimax-m2"
    | "minimax/minimax-m2-her"
    | "minimax/minimax-m2.1"
    | "minimax/minimax-m2.5"
    | "minimax/minimax-m2.7"
    | "minimax/minimax-m3"
    | "mistralai/codestral-2508"
    | "mistralai/devstral-2512"
    | "mistralai/ministral-14b-2512"
    | "mistralai/ministral-3b-2512"
    | "mistralai/ministral-8b-2512"
    | "mistralai/mistral-large"
    | "mistralai/mistral-large-2407"
    | "mistralai/mistral-large-2512"
    | "mistralai/mistral-medium-3"
    | "mistralai/mistral-medium-3-5"
    | "mistralai/mistral-medium-3.1"
    | "mistralai/mistral-nemo"
    | "mistralai/mistral-saba"
    | "mistralai/mistral-small-24b-instruct-2501"
    | "mistralai/mistral-small-2603"
    | "mistralai/mistral-small-3.1-24b-instruct"
    | "mistralai/mistral-small-3.2-24b-instruct"
    | "mistralai/mixtral-8x22b-instruct"
    | "mistralai/voxtral-small-24b-2507"
    | "moonshotai/kimi-k2"
    | "moonshotai/kimi-k2-0905"
    | "moonshotai/kimi-k2-thinking"
    | "moonshotai/kimi-k2.5"
    | "moonshotai/kimi-k2.6"
    | "moonshotai/kimi-k2.7-code"
    | "morph/morph-v3-fast"
    | "morph/morph-v3-large"
    | "nex-agi/nex-n2-pro"
    | "nousresearch/hermes-3-llama-3.1-405b"
    | "nousresearch/hermes-3-llama-3.1-405b:free"
    | "nousresearch/hermes-3-llama-3.1-70b"
    | "nousresearch/hermes-4-405b"
    | "nousresearch/hermes-4-70b"
    | "nvidia/llama-3.3-nemotron-super-49b-v1.5"
    | "nvidia/nemotron-3-nano-30b-a3b"
    | "nvidia/nemotron-3-nano-30b-a3b:free"
    | "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free"
    | "nvidia/nemotron-3-super-120b-a12b"
    | "nvidia/nemotron-3-super-120b-a12b:free"
    | "nvidia/nemotron-3-ultra-550b-a55b"
    | "nvidia/nemotron-3-ultra-550b-a55b:free"
    | "nvidia/nemotron-3.5-content-safety:free"
    | "nvidia/nemotron-nano-12b-v2-vl:free"
    | "nvidia/nemotron-nano-9b-v2:free"
    | "openai/gpt-3.5-turbo"
    | "openai/gpt-3.5-turbo-0613"
    | "openai/gpt-3.5-turbo-16k"
    | "openai/gpt-3.5-turbo-instruct"
    | "openai/gpt-4"
    | "openai/gpt-4-turbo"
    | "openai/gpt-4-turbo-preview"
    | "openai/gpt-4.1"
    | "openai/gpt-4.1-mini"
    | "openai/gpt-4.1-nano"
    | "openai/gpt-4o"
    | "openai/gpt-4o-2024-05-13"
    | "openai/gpt-4o-2024-08-06"
    | "openai/gpt-4o-2024-11-20"
    | "openai/gpt-4o-mini"
    | "openai/gpt-4o-mini-2024-07-18"
    | "openai/gpt-4o-mini-search-preview"
    | "openai/gpt-4o-search-preview"
    | "openai/gpt-5"
    | "openai/gpt-5-chat"
    | "openai/gpt-5-codex"
    | "openai/gpt-5-image"
    | "openai/gpt-5-image-mini"
    | "openai/gpt-5-mini"
    | "openai/gpt-5-nano"
    | "openai/gpt-5-pro"
    | "openai/gpt-5.1"
    | "openai/gpt-5.1-chat"
    | "openai/gpt-5.1-codex"
    | "openai/gpt-5.1-codex-max"
    | "openai/gpt-5.1-codex-mini"
    | "openai/gpt-5.2"
    | "openai/gpt-5.2-chat"
    | "openai/gpt-5.2-codex"
    | "openai/gpt-5.2-pro"
    | "openai/gpt-5.3-chat"
    | "openai/gpt-5.3-codex"
    | "openai/gpt-5.4"
    | "openai/gpt-5.4-image-2"
    | "openai/gpt-5.4-mini"
    | "openai/gpt-5.4-nano"
    | "openai/gpt-5.4-pro"
    | "openai/gpt-5.5"
    | "openai/gpt-5.5-pro"
    | "openai/gpt-audio"
    | "openai/gpt-audio-mini"
    | "openai/gpt-chat-latest"
    | "openai/gpt-oss-120b"
    | "openai/gpt-oss-120b:free"
    | "openai/gpt-oss-20b"
    | "openai/gpt-oss-20b:free"
    | "openai/gpt-oss-safeguard-20b"
    | "openai/o1"
    | "openai/o1-pro"
    | "openai/o3"
    | "openai/o3-deep-research"
    | "openai/o3-mini"
    | "openai/o3-mini-high"
    | "openai/o3-pro"
    | "openai/o4-mini"
    | "openai/o4-mini-deep-research"
    | "openai/o4-mini-high"
    | "openrouter/auto"
    | "openrouter/bodybuilder"
    | "openrouter/free"
    | "openrouter/fusion"
    | "openrouter/owl-alpha"
    | "openrouter/pareto-code"
    | "perceptron/perceptron-mk1"
    | "perplexity/sonar"
    | "perplexity/sonar-deep-research"
    | "perplexity/sonar-pro"
    | "perplexity/sonar-pro-search"
    | "perplexity/sonar-reasoning-pro"
    | "poolside/laguna-m.1"
    | "poolside/laguna-m.1:free"
    | "poolside/laguna-xs.2"
    | "poolside/laguna-xs.2:free"
    | "qwen/qwen-2.5-72b-instruct"
    | "qwen/qwen-2.5-7b-instruct"
    | "qwen/qwen-2.5-coder-32b-instruct"
    | "qwen/qwen-plus"
    | "qwen/qwen-plus-2025-07-28"
    | "qwen/qwen-plus-2025-07-28:thinking"
    | "qwen/qwen2.5-vl-72b-instruct"
    | "qwen/qwen3-14b"
    | "qwen/qwen3-235b-a22b"
    | "qwen/qwen3-235b-a22b-2507"
    | "qwen/qwen3-235b-a22b-thinking-2507"
    | "qwen/qwen3-30b-a3b"
    | "qwen/qwen3-30b-a3b-instruct-2507"
    | "qwen/qwen3-30b-a3b-thinking-2507"
    | "qwen/qwen3-32b"
    | "qwen/qwen3-8b"
    | "qwen/qwen3-coder"
    | "qwen/qwen3-coder-30b-a3b-instruct"
    | "qwen/qwen3-coder-flash"
    | "qwen/qwen3-coder-next"
    | "qwen/qwen3-coder-plus"
    | "qwen/qwen3-coder:free"
    | "qwen/qwen3-max"
    | "qwen/qwen3-max-thinking"
    | "qwen/qwen3-next-80b-a3b-instruct"
    | "qwen/qwen3-next-80b-a3b-instruct:free"
    | "qwen/qwen3-next-80b-a3b-thinking"
    | "qwen/qwen3-vl-235b-a22b-instruct"
    | "qwen/qwen3-vl-235b-a22b-thinking"
    | "qwen/qwen3-vl-30b-a3b-instruct"
    | "qwen/qwen3-vl-30b-a3b-thinking"
    | "qwen/qwen3-vl-32b-instruct"
    | "qwen/qwen3-vl-8b-instruct"
    | "qwen/qwen3-vl-8b-thinking"
    | "qwen/qwen3.5-122b-a10b"
    | "qwen/qwen3.5-27b"
    | "qwen/qwen3.5-35b-a3b"
    | "qwen/qwen3.5-397b-a17b"
    | "qwen/qwen3.5-9b"
    | "qwen/qwen3.5-flash-02-23"
    | "qwen/qwen3.5-plus-02-15"
    | "qwen/qwen3.5-plus-20260420"
    | "qwen/qwen3.6-27b"
    | "qwen/qwen3.6-35b-a3b"
    | "qwen/qwen3.6-flash"
    | "qwen/qwen3.6-max-preview"
    | "qwen/qwen3.6-plus"
    | "qwen/qwen3.7-max"
    | "qwen/qwen3.7-plus"
    | "rekaai/reka-edge"
    | "rekaai/reka-flash-3"
    | "relace/relace-apply-3"
    | "relace/relace-search"
    | "sakana/fugu-ultra"
    | "sao10k/l3-lunaris-8b"
    | "sao10k/l3.1-70b-hanami-x1"
    | "sao10k/l3.1-euryale-70b"
    | "sao10k/l3.3-euryale-70b"
    | "stepfun/step-3.5-flash"
    | "stepfun/step-3.7-flash"
    | "switchpoint/router"
    | "tencent/hunyuan-a13b-instruct"
    | "tencent/hy3-preview"
    | "thedrummer/cydonia-24b-v4.1"
    | "thedrummer/rocinante-12b"
    | "thedrummer/skyfall-36b-v2"
    | "thedrummer/unslopnemo-12b"
    | "undi95/remm-slerp-l2-13b"
    | "upstage/solar-pro-3"
    | "writer/palmyra-x5"
    | "x-ai/grok-4.20"
    | "x-ai/grok-4.20-multi-agent"
    | "x-ai/grok-4.3"
    | "x-ai/grok-build-0.1"
    | "xiaomi/mimo-v2.5"
    | "xiaomi/mimo-v2.5-pro"
    | "z-ai/glm-4.5"
    | "z-ai/glm-4.5-air"
    | "z-ai/glm-4.5v"
    | "z-ai/glm-4.6"
    | "z-ai/glm-4.6v"
    | "z-ai/glm-4.7"
    | "z-ai/glm-4.7-flash"
    | "z-ai/glm-5"
    | "z-ai/glm-5-turbo"
    | "z-ai/glm-5.1"
    | "z-ai/glm-5.2"
    | "z-ai/glm-5v-turbo"
    | "~anthropic/claude-fable-latest"
    | "~anthropic/claude-haiku-latest"
    | "~anthropic/claude-opus-latest"
    | "~anthropic/claude-sonnet-latest"
    | "~google/gemini-flash-latest"
    | "~google/gemini-pro-latest"
    | "~moonshotai/kimi-latest"
    | "~openai/gpt-latest"
    | "~openai/gpt-mini-latest"
  )[];
  "key-type": string;
  "model-type": string;
  "project-id": string;
  "private-key-id": string;
  "private-key": string;
  "client-email": string;
  "client-id": string;
  "auth-uri": string;
  "token-uri": string;
  "auth-provider-x509-cert-url": string;
  "client-x509-cert-url": string;
  "universe-domain": string;
  region: string;
};
export type V2OpenRouterOtherKeys = {
  name?: string;
  default?: boolean;
  llms?: (
    | "ai21/jamba-large-1.7"
    | "aion-labs/aion-1.0"
    | "aion-labs/aion-1.0-mini"
    | "aion-labs/aion-2.0"
    | "aion-labs/aion-rp-llama-3.1-8b"
    | "allenai/olmo-3-32b-think"
    | "amazon/nova-2-lite-v1"
    | "amazon/nova-lite-v1"
    | "amazon/nova-micro-v1"
    | "amazon/nova-premier-v1"
    | "amazon/nova-pro-v1"
    | "anthracite-org/magnum-v4-72b"
    | "anthropic/claude-3-haiku"
    | "anthropic/claude-fable-5"
    | "anthropic/claude-haiku-4.5"
    | "anthropic/claude-opus-4"
    | "anthropic/claude-opus-4.1"
    | "anthropic/claude-opus-4.5"
    | "anthropic/claude-opus-4.6"
    | "anthropic/claude-opus-4.7"
    | "anthropic/claude-opus-4.7-fast"
    | "anthropic/claude-opus-4.8"
    | "anthropic/claude-opus-4.8-fast"
    | "anthropic/claude-sonnet-4"
    | "anthropic/claude-sonnet-4.5"
    | "anthropic/claude-sonnet-4.6"
    | "arcee-ai/coder-large"
    | "arcee-ai/trinity-large-thinking"
    | "arcee-ai/trinity-mini"
    | "arcee-ai/virtuoso-large"
    | "baidu/ernie-4.5-vl-424b-a47b"
    | "bytedance-seed/seed-1.6"
    | "bytedance-seed/seed-1.6-flash"
    | "bytedance-seed/seed-2.0-lite"
    | "bytedance-seed/seed-2.0-mini"
    | "bytedance/ui-tars-1.5-7b"
    | "cognitivecomputations/dolphin-mistral-24b-venice-edition:free"
    | "cohere/command-a"
    | "cohere/command-r-08-2024"
    | "cohere/command-r-plus-08-2024"
    | "cohere/command-r7b-12-2024"
    | "cohere/north-mini-code:free"
    | "deepcogito/cogito-v2.1-671b"
    | "deepseek/deepseek-chat"
    | "deepseek/deepseek-chat-v3-0324"
    | "deepseek/deepseek-chat-v3.1"
    | "deepseek/deepseek-r1"
    | "deepseek/deepseek-r1-0528"
    | "deepseek/deepseek-r1-distill-llama-70b"
    | "deepseek/deepseek-v3.1-terminus"
    | "deepseek/deepseek-v3.2"
    | "deepseek/deepseek-v3.2-exp"
    | "deepseek/deepseek-v4-flash"
    | "deepseek/deepseek-v4-pro"
    | "google/gemini-2.5-flash"
    | "google/gemini-2.5-flash-image"
    | "google/gemini-2.5-flash-lite"
    | "google/gemini-2.5-flash-lite-preview-09-2025"
    | "google/gemini-2.5-pro"
    | "google/gemini-2.5-pro-preview"
    | "google/gemini-2.5-pro-preview-05-06"
    | "google/gemini-3-flash-preview"
    | "google/gemini-3-pro-image"
    | "google/gemini-3-pro-image-preview"
    | "google/gemini-3.1-flash-image"
    | "google/gemini-3.1-flash-image-preview"
    | "google/gemini-3.1-flash-lite"
    | "google/gemini-3.1-flash-lite-preview"
    | "google/gemini-3.1-pro-preview"
    | "google/gemini-3.1-pro-preview-customtools"
    | "google/gemini-3.5-flash"
    | "google/gemma-2-27b-it"
    | "google/gemma-3-12b-it"
    | "google/gemma-3-27b-it"
    | "google/gemma-3-4b-it"
    | "google/gemma-3n-e4b-it"
    | "google/gemma-4-26b-a4b-it"
    | "google/gemma-4-26b-a4b-it:free"
    | "google/gemma-4-31b-it"
    | "google/gemma-4-31b-it:free"
    | "google/lyria-3-clip-preview"
    | "google/lyria-3-pro-preview"
    | "gryphe/mythomax-l2-13b"
    | "ibm-granite/granite-4.0-h-micro"
    | "ibm-granite/granite-4.1-8b"
    | "inception/mercury-2"
    | "inclusionai/ling-2.6-1t"
    | "inclusionai/ling-2.6-flash"
    | "inclusionai/ring-2.6-1t"
    | "inflection/inflection-3-pi"
    | "inflection/inflection-3-productivity"
    | "kwaipilot/kat-coder-pro-v2"
    | "liquid/lfm-2-24b-a2b"
    | "liquid/lfm-2.5-1.2b-instruct:free"
    | "liquid/lfm-2.5-1.2b-thinking:free"
    | "mancer/weaver"
    | "meta-llama/llama-3-8b-instruct"
    | "meta-llama/llama-3.1-70b-instruct"
    | "meta-llama/llama-3.1-8b-instruct"
    | "meta-llama/llama-3.2-11b-vision-instruct"
    | "meta-llama/llama-3.2-1b-instruct"
    | "meta-llama/llama-3.2-3b-instruct"
    | "meta-llama/llama-3.2-3b-instruct:free"
    | "meta-llama/llama-3.3-70b-instruct"
    | "meta-llama/llama-3.3-70b-instruct:free"
    | "meta-llama/llama-4-maverick"
    | "meta-llama/llama-4-scout"
    | "meta-llama/llama-guard-4-12b"
    | "microsoft/phi-4"
    | "microsoft/phi-4-mini-instruct"
    | "microsoft/wizardlm-2-8x22b"
    | "minimax/minimax-01"
    | "minimax/minimax-m1"
    | "minimax/minimax-m2"
    | "minimax/minimax-m2-her"
    | "minimax/minimax-m2.1"
    | "minimax/minimax-m2.5"
    | "minimax/minimax-m2.7"
    | "minimax/minimax-m3"
    | "mistralai/codestral-2508"
    | "mistralai/devstral-2512"
    | "mistralai/ministral-14b-2512"
    | "mistralai/ministral-3b-2512"
    | "mistralai/ministral-8b-2512"
    | "mistralai/mistral-large"
    | "mistralai/mistral-large-2407"
    | "mistralai/mistral-large-2512"
    | "mistralai/mistral-medium-3"
    | "mistralai/mistral-medium-3-5"
    | "mistralai/mistral-medium-3.1"
    | "mistralai/mistral-nemo"
    | "mistralai/mistral-saba"
    | "mistralai/mistral-small-24b-instruct-2501"
    | "mistralai/mistral-small-2603"
    | "mistralai/mistral-small-3.1-24b-instruct"
    | "mistralai/mistral-small-3.2-24b-instruct"
    | "mistralai/mixtral-8x22b-instruct"
    | "mistralai/voxtral-small-24b-2507"
    | "moonshotai/kimi-k2"
    | "moonshotai/kimi-k2-0905"
    | "moonshotai/kimi-k2-thinking"
    | "moonshotai/kimi-k2.5"
    | "moonshotai/kimi-k2.6"
    | "moonshotai/kimi-k2.7-code"
    | "morph/morph-v3-fast"
    | "morph/morph-v3-large"
    | "nex-agi/nex-n2-pro"
    | "nousresearch/hermes-3-llama-3.1-405b"
    | "nousresearch/hermes-3-llama-3.1-405b:free"
    | "nousresearch/hermes-3-llama-3.1-70b"
    | "nousresearch/hermes-4-405b"
    | "nousresearch/hermes-4-70b"
    | "nvidia/llama-3.3-nemotron-super-49b-v1.5"
    | "nvidia/nemotron-3-nano-30b-a3b"
    | "nvidia/nemotron-3-nano-30b-a3b:free"
    | "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free"
    | "nvidia/nemotron-3-super-120b-a12b"
    | "nvidia/nemotron-3-super-120b-a12b:free"
    | "nvidia/nemotron-3-ultra-550b-a55b"
    | "nvidia/nemotron-3-ultra-550b-a55b:free"
    | "nvidia/nemotron-3.5-content-safety:free"
    | "nvidia/nemotron-nano-12b-v2-vl:free"
    | "nvidia/nemotron-nano-9b-v2:free"
    | "openai/gpt-3.5-turbo"
    | "openai/gpt-3.5-turbo-0613"
    | "openai/gpt-3.5-turbo-16k"
    | "openai/gpt-3.5-turbo-instruct"
    | "openai/gpt-4"
    | "openai/gpt-4-turbo"
    | "openai/gpt-4-turbo-preview"
    | "openai/gpt-4.1"
    | "openai/gpt-4.1-mini"
    | "openai/gpt-4.1-nano"
    | "openai/gpt-4o"
    | "openai/gpt-4o-2024-05-13"
    | "openai/gpt-4o-2024-08-06"
    | "openai/gpt-4o-2024-11-20"
    | "openai/gpt-4o-mini"
    | "openai/gpt-4o-mini-2024-07-18"
    | "openai/gpt-4o-mini-search-preview"
    | "openai/gpt-4o-search-preview"
    | "openai/gpt-5"
    | "openai/gpt-5-chat"
    | "openai/gpt-5-codex"
    | "openai/gpt-5-image"
    | "openai/gpt-5-image-mini"
    | "openai/gpt-5-mini"
    | "openai/gpt-5-nano"
    | "openai/gpt-5-pro"
    | "openai/gpt-5.1"
    | "openai/gpt-5.1-chat"
    | "openai/gpt-5.1-codex"
    | "openai/gpt-5.1-codex-max"
    | "openai/gpt-5.1-codex-mini"
    | "openai/gpt-5.2"
    | "openai/gpt-5.2-chat"
    | "openai/gpt-5.2-codex"
    | "openai/gpt-5.2-pro"
    | "openai/gpt-5.3-chat"
    | "openai/gpt-5.3-codex"
    | "openai/gpt-5.4"
    | "openai/gpt-5.4-image-2"
    | "openai/gpt-5.4-mini"
    | "openai/gpt-5.4-nano"
    | "openai/gpt-5.4-pro"
    | "openai/gpt-5.5"
    | "openai/gpt-5.5-pro"
    | "openai/gpt-audio"
    | "openai/gpt-audio-mini"
    | "openai/gpt-chat-latest"
    | "openai/gpt-oss-120b"
    | "openai/gpt-oss-120b:free"
    | "openai/gpt-oss-20b"
    | "openai/gpt-oss-20b:free"
    | "openai/gpt-oss-safeguard-20b"
    | "openai/o1"
    | "openai/o1-pro"
    | "openai/o3"
    | "openai/o3-deep-research"
    | "openai/o3-mini"
    | "openai/o3-mini-high"
    | "openai/o3-pro"
    | "openai/o4-mini"
    | "openai/o4-mini-deep-research"
    | "openai/o4-mini-high"
    | "openrouter/auto"
    | "openrouter/bodybuilder"
    | "openrouter/free"
    | "openrouter/fusion"
    | "openrouter/owl-alpha"
    | "openrouter/pareto-code"
    | "perceptron/perceptron-mk1"
    | "perplexity/sonar"
    | "perplexity/sonar-deep-research"
    | "perplexity/sonar-pro"
    | "perplexity/sonar-pro-search"
    | "perplexity/sonar-reasoning-pro"
    | "poolside/laguna-m.1"
    | "poolside/laguna-m.1:free"
    | "poolside/laguna-xs.2"
    | "poolside/laguna-xs.2:free"
    | "qwen/qwen-2.5-72b-instruct"
    | "qwen/qwen-2.5-7b-instruct"
    | "qwen/qwen-2.5-coder-32b-instruct"
    | "qwen/qwen-plus"
    | "qwen/qwen-plus-2025-07-28"
    | "qwen/qwen-plus-2025-07-28:thinking"
    | "qwen/qwen2.5-vl-72b-instruct"
    | "qwen/qwen3-14b"
    | "qwen/qwen3-235b-a22b"
    | "qwen/qwen3-235b-a22b-2507"
    | "qwen/qwen3-235b-a22b-thinking-2507"
    | "qwen/qwen3-30b-a3b"
    | "qwen/qwen3-30b-a3b-instruct-2507"
    | "qwen/qwen3-30b-a3b-thinking-2507"
    | "qwen/qwen3-32b"
    | "qwen/qwen3-8b"
    | "qwen/qwen3-coder"
    | "qwen/qwen3-coder-30b-a3b-instruct"
    | "qwen/qwen3-coder-flash"
    | "qwen/qwen3-coder-next"
    | "qwen/qwen3-coder-plus"
    | "qwen/qwen3-coder:free"
    | "qwen/qwen3-max"
    | "qwen/qwen3-max-thinking"
    | "qwen/qwen3-next-80b-a3b-instruct"
    | "qwen/qwen3-next-80b-a3b-instruct:free"
    | "qwen/qwen3-next-80b-a3b-thinking"
    | "qwen/qwen3-vl-235b-a22b-instruct"
    | "qwen/qwen3-vl-235b-a22b-thinking"
    | "qwen/qwen3-vl-30b-a3b-instruct"
    | "qwen/qwen3-vl-30b-a3b-thinking"
    | "qwen/qwen3-vl-32b-instruct"
    | "qwen/qwen3-vl-8b-instruct"
    | "qwen/qwen3-vl-8b-thinking"
    | "qwen/qwen3.5-122b-a10b"
    | "qwen/qwen3.5-27b"
    | "qwen/qwen3.5-35b-a3b"
    | "qwen/qwen3.5-397b-a17b"
    | "qwen/qwen3.5-9b"
    | "qwen/qwen3.5-flash-02-23"
    | "qwen/qwen3.5-plus-02-15"
    | "qwen/qwen3.5-plus-20260420"
    | "qwen/qwen3.6-27b"
    | "qwen/qwen3.6-35b-a3b"
    | "qwen/qwen3.6-flash"
    | "qwen/qwen3.6-max-preview"
    | "qwen/qwen3.6-plus"
    | "qwen/qwen3.7-max"
    | "qwen/qwen3.7-plus"
    | "rekaai/reka-edge"
    | "rekaai/reka-flash-3"
    | "relace/relace-apply-3"
    | "relace/relace-search"
    | "sakana/fugu-ultra"
    | "sao10k/l3-lunaris-8b"
    | "sao10k/l3.1-70b-hanami-x1"
    | "sao10k/l3.1-euryale-70b"
    | "sao10k/l3.3-euryale-70b"
    | "stepfun/step-3.5-flash"
    | "stepfun/step-3.7-flash"
    | "switchpoint/router"
    | "tencent/hunyuan-a13b-instruct"
    | "tencent/hy3-preview"
    | "thedrummer/cydonia-24b-v4.1"
    | "thedrummer/rocinante-12b"
    | "thedrummer/skyfall-36b-v2"
    | "thedrummer/unslopnemo-12b"
    | "undi95/remm-slerp-l2-13b"
    | "upstage/solar-pro-3"
    | "writer/palmyra-x5"
    | "x-ai/grok-4.20"
    | "x-ai/grok-4.20-multi-agent"
    | "x-ai/grok-4.3"
    | "x-ai/grok-build-0.1"
    | "xiaomi/mimo-v2.5"
    | "xiaomi/mimo-v2.5-pro"
    | "z-ai/glm-4.5"
    | "z-ai/glm-4.5-air"
    | "z-ai/glm-4.5v"
    | "z-ai/glm-4.6"
    | "z-ai/glm-4.6v"
    | "z-ai/glm-4.7"
    | "z-ai/glm-4.7-flash"
    | "z-ai/glm-5"
    | "z-ai/glm-5-turbo"
    | "z-ai/glm-5.1"
    | "z-ai/glm-5.2"
    | "z-ai/glm-5v-turbo"
    | "~anthropic/claude-fable-latest"
    | "~anthropic/claude-haiku-latest"
    | "~anthropic/claude-opus-latest"
    | "~anthropic/claude-sonnet-latest"
    | "~google/gemini-flash-latest"
    | "~google/gemini-pro-latest"
    | "~moonshotai/kimi-latest"
    | "~openai/gpt-latest"
    | "~openai/gpt-mini-latest"
  )[];
  "key-type": string;
  key: string;
};
export type V2OpenRouterKeyResource = {
  id?: string;
  type: string;
  attributes:
    | V2OpenRouterAzureKeys
    | V2OpenRouterAwsBedrockKeys
    | V2OpenRouterGoogleVertexKeys
    | V2OpenRouterOtherKeys;
  relationships?: {
    account: V2Relationships;
    "prompt-overrides"?: V2ToManyRelationships;
  };
};
export type V2PartnerRequestResource = {
  id?: number;
  type: string;
  attributes: {
    description: string;
    "revision-description"?: string;
    "service-type"?: "professional_services" | "managed_services";
    cost: number;
    "recurring-cost"?: number;
    "billing-frequency"?: "one_time" | "monthly" | "quarterly" | "yearly";
    markup: number;
    price?: number;
    responded_at?: string;
  };
  relationships: {
    project: V2Relationships;
    lob?: V2Relationships;
    subcontractor?: V2Relationships;
    currency?: V2Relationships;
    "third-party-services"?: V2ToManyRelationships;
  };
};
export type V2ThirdPartyServiceResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "original-description"?: string;
    "service-description"?: string;
    quantity?: number;
    "est-hours"?: number;
    "est-rate"?: number;
    "est-cost"?: number;
    markup?: number;
    "price-override"?: number;
    "mrr-terms"?: number;
    position?: number;
    languages?: object;
    "original-languages"?: object;
    "payment-frequency"?: "one_time" | "monthly" | "quarterly" | "yearly";
    "source-type"?: "Quote" | "ThirdPartyRequest" | "ThirdPartyService";
    "source-id"?: number;
    "shadow-service"?: boolean;
    "vendor-resource"?: boolean;
  };
  relationships: {
    source?: V2Relationships;
    "project-phase"?: V2Relationships;
    "project-task"?: V2Relationships;
    subtasks?: V2ToManyRelationships;
  };
};
export type V2RecordCount = {
  "record-count"?: number;
};
export type V2PresalesEngineerResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    phone?: string;
    email: string;
    title?: string;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2PricingAdjustmentResource = {
  id?: number;
  type: string;
  attributes: {
    price: number;
    cost: number;
    source_type: string;
    source_id: number;
    billing_frequency: string;
  };
  relationships?: {
    project?: V2Relationships;
  };
};
export type V2PrivilegeResource = {
  id: string;
  type: "privileges";
  attributes: {
    name: string;
    "default-level": string;
    description: string;
    levels: string[];
  };
};
export type V2ProductAccountingResource = {
  id?: number;
  type: string;
  attributes: {
    code: string;
  };
  relationships: {
    product: V2Relationships;
    "service-category"?: V2Relationships;
  };
};
export type V2ServiceConditionResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    content?: string;
    position?: number;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2ProjectContactResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    phone?: string;
    email?: string;
    title?: string;
    "contact-type"?:
      | "primary_customer_contact"
      | "customer_contact"
      | "primary_internal_contact"
      | "internal_contact";
    "project-variables"?: V2EmbeddedProjectVariable[];
  };
  relationships: {
    project: V2Relationships;
    contact: V2Relationships;
  };
};
export type V2ProjectDuplicationResource = {
  id?: number;
  type: string;
  attributes?: {
    status?: string;
    content?: {
      id?: string;
      type: string;
    }[];
  };
  relationships: {
    "source-project"?: V2Relationships;
    "target-project"?: V2Relationships;
  };
};
export type V2ResourceRateResource = {
  id?: number;
  type: string;
  attributes: {
    name?: string;
    external_name?: string;
    description?: string;
    "hourly-rate": number;
    "hourly-cost": number;
    "expense-rate"?: number;
    code?: string;
  };
  relationships: {
    "rate-table": V2Relationships;
    resource: V2Relationships;
    "line-of-business"?: V2Relationships;
  };
};
export type V2ProjectLocationResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    street: string;
    street2?: string;
    city: string;
    state?: string;
    "postal-code": string;
    country?: string;
    "deleted-at"?: string;
    "project-variables"?: V2EmbeddedProjectVariable[];
  };
  relationships: {
    project: V2Relationships;
  };
};
export type V2SubserviceResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "service-description"?: string;
    languages?: object;
    state?: "pending" | "active" | "deleted" | "custom";
    active?: boolean;
    "suggested-hours"?: number;
    "minimum-quantity"?: number;
    quantity?: number;
    position?: number;
    "custom-service-cost?"?: boolean;
    "custom-service-price?"?: boolean;
    "custom-hours?"?: boolean;
  };
  relationships: {
    resource?: V2Relationships;
    service: V2Relationships;
  };
};
export type V2ProjectSurveyResource = {
  id?: number;
  type?: string;
  relationships?: {
    project?: V2Relationships;
    survey?: V2Relationships;
  };
};
export type V2SurveyResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    status?: "pending" | "shared" | "completed" | "applied" | "revised";
    "contact-name"?: string;
    "contact-email"?: string;
    responses?: {
      "survey-response-id"?: number;
      "question-id"?: number;
      question?: string;
      answer?: string;
    }[];
    calculations?: {
      calculation_id?: string;
      value?: string;
    }[];
    recommendations?: {
      status?: "pending" | "applied" | "inactive";
      quantity?: number;
      item_type?: "Governance" | "Material" | "Task";
      item_id?: number;
      resource_id?: number;
      target_type?: "Governance" | "Material" | "Task";
      target_id?: number;
      project_resource_id?: number;
      refinements?: {
        quantity?: number;
        status?: "pending" | "applied";
        item_type?: string;
        item_id?: string;
        resource_id?: string;
        project_resource_id?: string;
      }[];
    }[];
    "updated-at"?: string;
    emails?: string;
    sender?: string;
    sent_at?: string;
    completed_by?: string;
  };
  relationships: {
    account?: V2Relationships;
    questionnaire: V2Relationships;
    project?: V2Relationships;
    "survey-responses"?: V2ToManyRelationships;
    "survey-reommendations"?: V2ToManyRelationships;
  };
};
export type V2CreatorResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    phone?: string;
    email: string;
    title?: string;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2SalesExecutiveResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    phone?: string;
    email?: string;
    title?: string;
    active?: boolean;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2PsaProjectResource = {
  id?: number;
  type: string;
  attributes: {
    "start-on"?: string;
    "end-on"?: string;
    "project-id"?: string;
    "error-message"?: string;
    "project-options"?: {
      board?: string;
      import?: "new" | "existing";
      process?: "current_process" | "task_as_ticket" | "phase_as_ticket";
      template?: string;
      governance?: string;
    };
  };
  relationships: {
    account: V2Relationships;
    "rate-table"?: V2Relationships;
  };
};
export type V2ResourcePlanResource = {
  id?: number;
  type?: string;
  attributes?: {
    name: string;
    description?: string;
    "start-on"?: string;
    weeks: number;
    sprints?: number;
    baseline?: boolean;
    "phase-mapping"?: {
      date?: string;
      project_phase_id?: number;
    }[];
    "allocated-hours"?: {
      hours?: number;
      project_resource_id?: number;
    }[];
  };
  relationships?: {
    project?: V2Relationships;
    "resource-allocations"?: V2ToManyRelationships;
  };
};
export type V2QuoteResource = {
  id?: number;
  type: string;
  attributes: {
    description: string;
    service_type?: "professional_services" | "managed_services";
    "price-override"?: number;
    cost?: number;
    "mrr-override"?: number;
    "recurring-cost"?: number;
    "billing-frequency"?: "one_time" | "monthly" | "quarterly" | "yearly";
    "revenue-calculation"?: "margin" | "markup";
    "pricing-model"?: "time_and_materials" | "fixed_fee";
    markup?: number;
    "mrr-markup"?: number;
    price?: number;
    "service-pricing"?: boolean;
    "vendor-document"?: string;
    "vendor-document-status"?:
      | "pending"
      | "submitted"
      | "processed"
      | "error"
      | "accepted"
      | "not_applicable";
  };
  relationships: {
    project: V2Relationships;
    lob?: V2Relationships;
    "third-party-services"?: V2Relationships;
    vendor: V2Relationships;
  };
};
export type V2CreateProjectResource = {
  id?: number;
  type: string;
  attributes: {
    "project-name": string;
    status?: string;
    "executive-summary"?: string;
    "key-objectives"?: string;
    "our-responsibilities"?: string;
    "client-responsibilities"?: string;
    "solution-summary"?: string;
    "out-of-scope"?: string;
    "one-time-adjustment"?: number;
    "mrr-adjustment"?: number;
    "mrr-terms"?: number;
    cola?: number;
    "recurring-billing-frequency"?: "monthly" | "quarterly" | "yearly";
    "include-ps-revenue-in-mrr"?:
      | "do_not_include_ps_revenue"
      | "add_to_first_month"
      | "amortize_over_all_months";
    "service-start-date"?: string;
    "travel-limit"?: number;
    "submitted-at"?: string;
    "approved-at"?: string;
    "msa-date"?: string;
    "project-variables"?: V2EmbeddedProjectVariable[];
    "field-labels"?: {
      executive_summary?: string;
      solution_summary?: string;
      customer_summary?: string;
      customer_success?: string;
      sales_executive?: string;
      presales_engineer?: string;
      client?: string;
      business_unit?: string;
      location?: string;
      our_responsibilities?: string;
      client_responsibilities?: string;
      out_of_scope?: string;
    };
    "tag-list"?: string[];
    "client-name"?: string;
    "sales-executive-name"?: string;
    "presales-engineer-name"?: string;
    "payment-info"?: {
      "pricing-model"?: "other" | "fixed_fee" | "time_and_materials";
      "include-expenses"?: boolean;
      "include-product"?: boolean;
      "rate-type"?: "hour" | "day" | "week";
    };
  };
  relationships: {
    account: V2Relationships;
    "business-unit"?: V2Relationships;
    client: V2Relationships;
    "document-template"?: V2Relationships;
    "external-request"?: V2Relationships;
    "sales-executive"?: V2Relationships;
    "presales-engineer"?: V2Relationships;
    "psa-project"?: V2Relationships;
    "crm-opportunity"?: V2Relationships;
    "payment-term"?: V2Relationships;
    user?: V2Relationships;
    "project-attachments"?: V2ToManyRelationships;
    "project-collaborators"?: V2ToManyRelationships;
    "project-contacts"?: V2ToManyRelationships;
    "project-conditions"?: V2ToManyRelationships;
    "project-credits"?: V2ToManyRelationships;
    "project-documents"?: V2ToManyRelationships;
    "project-expenses"?: V2ToManyRelationships;
    "project-governances"?: V2ToManyRelationships;
    "project-locations"?: V2ToManyRelationships;
    "project-materials"?: V2ToManyRelationships;
    "project-phases"?: V2ToManyRelationships;
    "project-products"?: V2ToManyRelationships;
    "project-resources"?: V2ToManyRelationships;
    "project-versions"?: V2ToManyRelationships;
    "project-services"?: V2ToManyRelationships;
    "rate-table": V2Relationships;
    "resource-plans"?: V2ToManyRelationships;
    "approval-steps"?: V2ToManyRelationships;
    notes?: V2ToManyRelationships;
    quotes?: V2ToManyRelationships;
    "partner-requests"?: V2ToManyRelationships;
    "audit-logs"?: V2ToManyRelationships;
    "customer-successes"?: V2ToManyRelationships;
  };
};
export type V2PromptContentResource = {
  id?: string;
  type: string;
  attributes: {
    "prompt-type"?:
      | "generate_executive_summary"
      | "research_service_offering_research"
      | "research_service_offering_services"
      | "research_service_offering_questions";
    content: string;
    model?: (
      | "ai21/jamba-large-1.7"
      | "aion-labs/aion-1.0"
      | "aion-labs/aion-1.0-mini"
      | "aion-labs/aion-2.0"
      | "aion-labs/aion-rp-llama-3.1-8b"
      | "allenai/olmo-3-32b-think"
      | "amazon/nova-2-lite-v1"
      | "amazon/nova-lite-v1"
      | "amazon/nova-micro-v1"
      | "amazon/nova-premier-v1"
      | "amazon/nova-pro-v1"
      | "anthracite-org/magnum-v4-72b"
      | "anthropic/claude-3-haiku"
      | "anthropic/claude-fable-5"
      | "anthropic/claude-haiku-4.5"
      | "anthropic/claude-opus-4"
      | "anthropic/claude-opus-4.1"
      | "anthropic/claude-opus-4.5"
      | "anthropic/claude-opus-4.6"
      | "anthropic/claude-opus-4.7"
      | "anthropic/claude-opus-4.7-fast"
      | "anthropic/claude-opus-4.8"
      | "anthropic/claude-opus-4.8-fast"
      | "anthropic/claude-sonnet-4"
      | "anthropic/claude-sonnet-4.5"
      | "anthropic/claude-sonnet-4.6"
      | "arcee-ai/coder-large"
      | "arcee-ai/trinity-large-thinking"
      | "arcee-ai/trinity-mini"
      | "arcee-ai/virtuoso-large"
      | "baidu/ernie-4.5-vl-424b-a47b"
      | "bytedance-seed/seed-1.6"
      | "bytedance-seed/seed-1.6-flash"
      | "bytedance-seed/seed-2.0-lite"
      | "bytedance-seed/seed-2.0-mini"
      | "bytedance/ui-tars-1.5-7b"
      | "cognitivecomputations/dolphin-mistral-24b-venice-edition:free"
      | "cohere/command-a"
      | "cohere/command-r-08-2024"
      | "cohere/command-r-plus-08-2024"
      | "cohere/command-r7b-12-2024"
      | "cohere/north-mini-code:free"
      | "deepcogito/cogito-v2.1-671b"
      | "deepseek/deepseek-chat"
      | "deepseek/deepseek-chat-v3-0324"
      | "deepseek/deepseek-chat-v3.1"
      | "deepseek/deepseek-r1"
      | "deepseek/deepseek-r1-0528"
      | "deepseek/deepseek-r1-distill-llama-70b"
      | "deepseek/deepseek-v3.1-terminus"
      | "deepseek/deepseek-v3.2"
      | "deepseek/deepseek-v3.2-exp"
      | "deepseek/deepseek-v4-flash"
      | "deepseek/deepseek-v4-pro"
      | "google/gemini-2.5-flash"
      | "google/gemini-2.5-flash-image"
      | "google/gemini-2.5-flash-lite"
      | "google/gemini-2.5-flash-lite-preview-09-2025"
      | "google/gemini-2.5-pro"
      | "google/gemini-2.5-pro-preview"
      | "google/gemini-2.5-pro-preview-05-06"
      | "google/gemini-3-flash-preview"
      | "google/gemini-3-pro-image"
      | "google/gemini-3-pro-image-preview"
      | "google/gemini-3.1-flash-image"
      | "google/gemini-3.1-flash-image-preview"
      | "google/gemini-3.1-flash-lite"
      | "google/gemini-3.1-flash-lite-preview"
      | "google/gemini-3.1-pro-preview"
      | "google/gemini-3.1-pro-preview-customtools"
      | "google/gemini-3.5-flash"
      | "google/gemma-2-27b-it"
      | "google/gemma-3-12b-it"
      | "google/gemma-3-27b-it"
      | "google/gemma-3-4b-it"
      | "google/gemma-3n-e4b-it"
      | "google/gemma-4-26b-a4b-it"
      | "google/gemma-4-26b-a4b-it:free"
      | "google/gemma-4-31b-it"
      | "google/gemma-4-31b-it:free"
      | "google/lyria-3-clip-preview"
      | "google/lyria-3-pro-preview"
      | "gryphe/mythomax-l2-13b"
      | "ibm-granite/granite-4.0-h-micro"
      | "ibm-granite/granite-4.1-8b"
      | "inception/mercury-2"
      | "inclusionai/ling-2.6-1t"
      | "inclusionai/ling-2.6-flash"
      | "inclusionai/ring-2.6-1t"
      | "inflection/inflection-3-pi"
      | "inflection/inflection-3-productivity"
      | "kwaipilot/kat-coder-pro-v2"
      | "liquid/lfm-2-24b-a2b"
      | "liquid/lfm-2.5-1.2b-instruct:free"
      | "liquid/lfm-2.5-1.2b-thinking:free"
      | "mancer/weaver"
      | "meta-llama/llama-3-8b-instruct"
      | "meta-llama/llama-3.1-70b-instruct"
      | "meta-llama/llama-3.1-8b-instruct"
      | "meta-llama/llama-3.2-11b-vision-instruct"
      | "meta-llama/llama-3.2-1b-instruct"
      | "meta-llama/llama-3.2-3b-instruct"
      | "meta-llama/llama-3.2-3b-instruct:free"
      | "meta-llama/llama-3.3-70b-instruct"
      | "meta-llama/llama-3.3-70b-instruct:free"
      | "meta-llama/llama-4-maverick"
      | "meta-llama/llama-4-scout"
      | "meta-llama/llama-guard-4-12b"
      | "microsoft/phi-4"
      | "microsoft/phi-4-mini-instruct"
      | "microsoft/wizardlm-2-8x22b"
      | "minimax/minimax-01"
      | "minimax/minimax-m1"
      | "minimax/minimax-m2"
      | "minimax/minimax-m2-her"
      | "minimax/minimax-m2.1"
      | "minimax/minimax-m2.5"
      | "minimax/minimax-m2.7"
      | "minimax/minimax-m3"
      | "mistralai/codestral-2508"
      | "mistralai/devstral-2512"
      | "mistralai/ministral-14b-2512"
      | "mistralai/ministral-3b-2512"
      | "mistralai/ministral-8b-2512"
      | "mistralai/mistral-large"
      | "mistralai/mistral-large-2407"
      | "mistralai/mistral-large-2512"
      | "mistralai/mistral-medium-3"
      | "mistralai/mistral-medium-3-5"
      | "mistralai/mistral-medium-3.1"
      | "mistralai/mistral-nemo"
      | "mistralai/mistral-saba"
      | "mistralai/mistral-small-24b-instruct-2501"
      | "mistralai/mistral-small-2603"
      | "mistralai/mistral-small-3.1-24b-instruct"
      | "mistralai/mistral-small-3.2-24b-instruct"
      | "mistralai/mixtral-8x22b-instruct"
      | "mistralai/voxtral-small-24b-2507"
      | "moonshotai/kimi-k2"
      | "moonshotai/kimi-k2-0905"
      | "moonshotai/kimi-k2-thinking"
      | "moonshotai/kimi-k2.5"
      | "moonshotai/kimi-k2.6"
      | "moonshotai/kimi-k2.7-code"
      | "morph/morph-v3-fast"
      | "morph/morph-v3-large"
      | "nex-agi/nex-n2-pro"
      | "nousresearch/hermes-3-llama-3.1-405b"
      | "nousresearch/hermes-3-llama-3.1-405b:free"
      | "nousresearch/hermes-3-llama-3.1-70b"
      | "nousresearch/hermes-4-405b"
      | "nousresearch/hermes-4-70b"
      | "nvidia/llama-3.3-nemotron-super-49b-v1.5"
      | "nvidia/nemotron-3-nano-30b-a3b"
      | "nvidia/nemotron-3-nano-30b-a3b:free"
      | "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free"
      | "nvidia/nemotron-3-super-120b-a12b"
      | "nvidia/nemotron-3-super-120b-a12b:free"
      | "nvidia/nemotron-3-ultra-550b-a55b"
      | "nvidia/nemotron-3-ultra-550b-a55b:free"
      | "nvidia/nemotron-3.5-content-safety:free"
      | "nvidia/nemotron-nano-12b-v2-vl:free"
      | "nvidia/nemotron-nano-9b-v2:free"
      | "openai/gpt-3.5-turbo"
      | "openai/gpt-3.5-turbo-0613"
      | "openai/gpt-3.5-turbo-16k"
      | "openai/gpt-3.5-turbo-instruct"
      | "openai/gpt-4"
      | "openai/gpt-4-turbo"
      | "openai/gpt-4-turbo-preview"
      | "openai/gpt-4.1"
      | "openai/gpt-4.1-mini"
      | "openai/gpt-4.1-nano"
      | "openai/gpt-4o"
      | "openai/gpt-4o-2024-05-13"
      | "openai/gpt-4o-2024-08-06"
      | "openai/gpt-4o-2024-11-20"
      | "openai/gpt-4o-mini"
      | "openai/gpt-4o-mini-2024-07-18"
      | "openai/gpt-4o-mini-search-preview"
      | "openai/gpt-4o-search-preview"
      | "openai/gpt-5"
      | "openai/gpt-5-chat"
      | "openai/gpt-5-codex"
      | "openai/gpt-5-image"
      | "openai/gpt-5-image-mini"
      | "openai/gpt-5-mini"
      | "openai/gpt-5-nano"
      | "openai/gpt-5-pro"
      | "openai/gpt-5.1"
      | "openai/gpt-5.1-chat"
      | "openai/gpt-5.1-codex"
      | "openai/gpt-5.1-codex-max"
      | "openai/gpt-5.1-codex-mini"
      | "openai/gpt-5.2"
      | "openai/gpt-5.2-chat"
      | "openai/gpt-5.2-codex"
      | "openai/gpt-5.2-pro"
      | "openai/gpt-5.3-chat"
      | "openai/gpt-5.3-codex"
      | "openai/gpt-5.4"
      | "openai/gpt-5.4-image-2"
      | "openai/gpt-5.4-mini"
      | "openai/gpt-5.4-nano"
      | "openai/gpt-5.4-pro"
      | "openai/gpt-5.5"
      | "openai/gpt-5.5-pro"
      | "openai/gpt-audio"
      | "openai/gpt-audio-mini"
      | "openai/gpt-chat-latest"
      | "openai/gpt-oss-120b"
      | "openai/gpt-oss-120b:free"
      | "openai/gpt-oss-20b"
      | "openai/gpt-oss-20b:free"
      | "openai/gpt-oss-safeguard-20b"
      | "openai/o1"
      | "openai/o1-pro"
      | "openai/o3"
      | "openai/o3-deep-research"
      | "openai/o3-mini"
      | "openai/o3-mini-high"
      | "openai/o3-pro"
      | "openai/o4-mini"
      | "openai/o4-mini-deep-research"
      | "openai/o4-mini-high"
      | "openrouter/auto"
      | "openrouter/bodybuilder"
      | "openrouter/free"
      | "openrouter/fusion"
      | "openrouter/owl-alpha"
      | "openrouter/pareto-code"
      | "perceptron/perceptron-mk1"
      | "perplexity/sonar"
      | "perplexity/sonar-deep-research"
      | "perplexity/sonar-pro"
      | "perplexity/sonar-pro-search"
      | "perplexity/sonar-reasoning-pro"
      | "poolside/laguna-m.1"
      | "poolside/laguna-m.1:free"
      | "poolside/laguna-xs.2"
      | "poolside/laguna-xs.2:free"
      | "qwen/qwen-2.5-72b-instruct"
      | "qwen/qwen-2.5-7b-instruct"
      | "qwen/qwen-2.5-coder-32b-instruct"
      | "qwen/qwen-plus"
      | "qwen/qwen-plus-2025-07-28"
      | "qwen/qwen-plus-2025-07-28:thinking"
      | "qwen/qwen2.5-vl-72b-instruct"
      | "qwen/qwen3-14b"
      | "qwen/qwen3-235b-a22b"
      | "qwen/qwen3-235b-a22b-2507"
      | "qwen/qwen3-235b-a22b-thinking-2507"
      | "qwen/qwen3-30b-a3b"
      | "qwen/qwen3-30b-a3b-instruct-2507"
      | "qwen/qwen3-30b-a3b-thinking-2507"
      | "qwen/qwen3-32b"
      | "qwen/qwen3-8b"
      | "qwen/qwen3-coder"
      | "qwen/qwen3-coder-30b-a3b-instruct"
      | "qwen/qwen3-coder-flash"
      | "qwen/qwen3-coder-next"
      | "qwen/qwen3-coder-plus"
      | "qwen/qwen3-coder:free"
      | "qwen/qwen3-max"
      | "qwen/qwen3-max-thinking"
      | "qwen/qwen3-next-80b-a3b-instruct"
      | "qwen/qwen3-next-80b-a3b-instruct:free"
      | "qwen/qwen3-next-80b-a3b-thinking"
      | "qwen/qwen3-vl-235b-a22b-instruct"
      | "qwen/qwen3-vl-235b-a22b-thinking"
      | "qwen/qwen3-vl-30b-a3b-instruct"
      | "qwen/qwen3-vl-30b-a3b-thinking"
      | "qwen/qwen3-vl-32b-instruct"
      | "qwen/qwen3-vl-8b-instruct"
      | "qwen/qwen3-vl-8b-thinking"
      | "qwen/qwen3.5-122b-a10b"
      | "qwen/qwen3.5-27b"
      | "qwen/qwen3.5-35b-a3b"
      | "qwen/qwen3.5-397b-a17b"
      | "qwen/qwen3.5-9b"
      | "qwen/qwen3.5-flash-02-23"
      | "qwen/qwen3.5-plus-02-15"
      | "qwen/qwen3.5-plus-20260420"
      | "qwen/qwen3.6-27b"
      | "qwen/qwen3.6-35b-a3b"
      | "qwen/qwen3.6-flash"
      | "qwen/qwen3.6-max-preview"
      | "qwen/qwen3.6-plus"
      | "qwen/qwen3.7-max"
      | "qwen/qwen3.7-plus"
      | "rekaai/reka-edge"
      | "rekaai/reka-flash-3"
      | "relace/relace-apply-3"
      | "relace/relace-search"
      | "sakana/fugu-ultra"
      | "sao10k/l3-lunaris-8b"
      | "sao10k/l3.1-70b-hanami-x1"
      | "sao10k/l3.1-euryale-70b"
      | "sao10k/l3.3-euryale-70b"
      | "stepfun/step-3.5-flash"
      | "stepfun/step-3.7-flash"
      | "switchpoint/router"
      | "tencent/hunyuan-a13b-instruct"
      | "tencent/hy3-preview"
      | "thedrummer/cydonia-24b-v4.1"
      | "thedrummer/rocinante-12b"
      | "thedrummer/skyfall-36b-v2"
      | "thedrummer/unslopnemo-12b"
      | "undi95/remm-slerp-l2-13b"
      | "upstage/solar-pro-3"
      | "writer/palmyra-x5"
      | "x-ai/grok-4.20"
      | "x-ai/grok-4.20-multi-agent"
      | "x-ai/grok-4.3"
      | "x-ai/grok-build-0.1"
      | "xiaomi/mimo-v2.5"
      | "xiaomi/mimo-v2.5-pro"
      | "z-ai/glm-4.5"
      | "z-ai/glm-4.5-air"
      | "z-ai/glm-4.5v"
      | "z-ai/glm-4.6"
      | "z-ai/glm-4.6v"
      | "z-ai/glm-4.7"
      | "z-ai/glm-4.7-flash"
      | "z-ai/glm-5"
      | "z-ai/glm-5-turbo"
      | "z-ai/glm-5.1"
      | "z-ai/glm-5.2"
      | "z-ai/glm-5v-turbo"
      | "~anthropic/claude-fable-latest"
      | "~anthropic/claude-haiku-latest"
      | "~anthropic/claude-opus-latest"
      | "~anthropic/claude-sonnet-latest"
      | "~google/gemini-flash-latest"
      | "~google/gemini-pro-latest"
      | "~moonshotai/kimi-latest"
      | "~openai/gpt-latest"
      | "~openai/gpt-mini-latest"
    )[];
  };
};
export type V2PromptOverrideResource = {
  id?: string;
  type: string;
  attributes: {
    "prompt-type"?:
      | "generate_executive_summary"
      | "research_service_offering_research"
      | "research_service_offering_services"
      | "research_service_offering_questions";
    content: string;
    model?: (
      | "ai21/jamba-large-1.7"
      | "aion-labs/aion-1.0"
      | "aion-labs/aion-1.0-mini"
      | "aion-labs/aion-2.0"
      | "aion-labs/aion-rp-llama-3.1-8b"
      | "allenai/olmo-3-32b-think"
      | "amazon/nova-2-lite-v1"
      | "amazon/nova-lite-v1"
      | "amazon/nova-micro-v1"
      | "amazon/nova-premier-v1"
      | "amazon/nova-pro-v1"
      | "anthracite-org/magnum-v4-72b"
      | "anthropic/claude-3-haiku"
      | "anthropic/claude-fable-5"
      | "anthropic/claude-haiku-4.5"
      | "anthropic/claude-opus-4"
      | "anthropic/claude-opus-4.1"
      | "anthropic/claude-opus-4.5"
      | "anthropic/claude-opus-4.6"
      | "anthropic/claude-opus-4.7"
      | "anthropic/claude-opus-4.7-fast"
      | "anthropic/claude-opus-4.8"
      | "anthropic/claude-opus-4.8-fast"
      | "anthropic/claude-sonnet-4"
      | "anthropic/claude-sonnet-4.5"
      | "anthropic/claude-sonnet-4.6"
      | "arcee-ai/coder-large"
      | "arcee-ai/trinity-large-thinking"
      | "arcee-ai/trinity-mini"
      | "arcee-ai/virtuoso-large"
      | "baidu/ernie-4.5-vl-424b-a47b"
      | "bytedance-seed/seed-1.6"
      | "bytedance-seed/seed-1.6-flash"
      | "bytedance-seed/seed-2.0-lite"
      | "bytedance-seed/seed-2.0-mini"
      | "bytedance/ui-tars-1.5-7b"
      | "cognitivecomputations/dolphin-mistral-24b-venice-edition:free"
      | "cohere/command-a"
      | "cohere/command-r-08-2024"
      | "cohere/command-r-plus-08-2024"
      | "cohere/command-r7b-12-2024"
      | "cohere/north-mini-code:free"
      | "deepcogito/cogito-v2.1-671b"
      | "deepseek/deepseek-chat"
      | "deepseek/deepseek-chat-v3-0324"
      | "deepseek/deepseek-chat-v3.1"
      | "deepseek/deepseek-r1"
      | "deepseek/deepseek-r1-0528"
      | "deepseek/deepseek-r1-distill-llama-70b"
      | "deepseek/deepseek-v3.1-terminus"
      | "deepseek/deepseek-v3.2"
      | "deepseek/deepseek-v3.2-exp"
      | "deepseek/deepseek-v4-flash"
      | "deepseek/deepseek-v4-pro"
      | "google/gemini-2.5-flash"
      | "google/gemini-2.5-flash-image"
      | "google/gemini-2.5-flash-lite"
      | "google/gemini-2.5-flash-lite-preview-09-2025"
      | "google/gemini-2.5-pro"
      | "google/gemini-2.5-pro-preview"
      | "google/gemini-2.5-pro-preview-05-06"
      | "google/gemini-3-flash-preview"
      | "google/gemini-3-pro-image"
      | "google/gemini-3-pro-image-preview"
      | "google/gemini-3.1-flash-image"
      | "google/gemini-3.1-flash-image-preview"
      | "google/gemini-3.1-flash-lite"
      | "google/gemini-3.1-flash-lite-preview"
      | "google/gemini-3.1-pro-preview"
      | "google/gemini-3.1-pro-preview-customtools"
      | "google/gemini-3.5-flash"
      | "google/gemma-2-27b-it"
      | "google/gemma-3-12b-it"
      | "google/gemma-3-27b-it"
      | "google/gemma-3-4b-it"
      | "google/gemma-3n-e4b-it"
      | "google/gemma-4-26b-a4b-it"
      | "google/gemma-4-26b-a4b-it:free"
      | "google/gemma-4-31b-it"
      | "google/gemma-4-31b-it:free"
      | "google/lyria-3-clip-preview"
      | "google/lyria-3-pro-preview"
      | "gryphe/mythomax-l2-13b"
      | "ibm-granite/granite-4.0-h-micro"
      | "ibm-granite/granite-4.1-8b"
      | "inception/mercury-2"
      | "inclusionai/ling-2.6-1t"
      | "inclusionai/ling-2.6-flash"
      | "inclusionai/ring-2.6-1t"
      | "inflection/inflection-3-pi"
      | "inflection/inflection-3-productivity"
      | "kwaipilot/kat-coder-pro-v2"
      | "liquid/lfm-2-24b-a2b"
      | "liquid/lfm-2.5-1.2b-instruct:free"
      | "liquid/lfm-2.5-1.2b-thinking:free"
      | "mancer/weaver"
      | "meta-llama/llama-3-8b-instruct"
      | "meta-llama/llama-3.1-70b-instruct"
      | "meta-llama/llama-3.1-8b-instruct"
      | "meta-llama/llama-3.2-11b-vision-instruct"
      | "meta-llama/llama-3.2-1b-instruct"
      | "meta-llama/llama-3.2-3b-instruct"
      | "meta-llama/llama-3.2-3b-instruct:free"
      | "meta-llama/llama-3.3-70b-instruct"
      | "meta-llama/llama-3.3-70b-instruct:free"
      | "meta-llama/llama-4-maverick"
      | "meta-llama/llama-4-scout"
      | "meta-llama/llama-guard-4-12b"
      | "microsoft/phi-4"
      | "microsoft/phi-4-mini-instruct"
      | "microsoft/wizardlm-2-8x22b"
      | "minimax/minimax-01"
      | "minimax/minimax-m1"
      | "minimax/minimax-m2"
      | "minimax/minimax-m2-her"
      | "minimax/minimax-m2.1"
      | "minimax/minimax-m2.5"
      | "minimax/minimax-m2.7"
      | "minimax/minimax-m3"
      | "mistralai/codestral-2508"
      | "mistralai/devstral-2512"
      | "mistralai/ministral-14b-2512"
      | "mistralai/ministral-3b-2512"
      | "mistralai/ministral-8b-2512"
      | "mistralai/mistral-large"
      | "mistralai/mistral-large-2407"
      | "mistralai/mistral-large-2512"
      | "mistralai/mistral-medium-3"
      | "mistralai/mistral-medium-3-5"
      | "mistralai/mistral-medium-3.1"
      | "mistralai/mistral-nemo"
      | "mistralai/mistral-saba"
      | "mistralai/mistral-small-24b-instruct-2501"
      | "mistralai/mistral-small-2603"
      | "mistralai/mistral-small-3.1-24b-instruct"
      | "mistralai/mistral-small-3.2-24b-instruct"
      | "mistralai/mixtral-8x22b-instruct"
      | "mistralai/voxtral-small-24b-2507"
      | "moonshotai/kimi-k2"
      | "moonshotai/kimi-k2-0905"
      | "moonshotai/kimi-k2-thinking"
      | "moonshotai/kimi-k2.5"
      | "moonshotai/kimi-k2.6"
      | "moonshotai/kimi-k2.7-code"
      | "morph/morph-v3-fast"
      | "morph/morph-v3-large"
      | "nex-agi/nex-n2-pro"
      | "nousresearch/hermes-3-llama-3.1-405b"
      | "nousresearch/hermes-3-llama-3.1-405b:free"
      | "nousresearch/hermes-3-llama-3.1-70b"
      | "nousresearch/hermes-4-405b"
      | "nousresearch/hermes-4-70b"
      | "nvidia/llama-3.3-nemotron-super-49b-v1.5"
      | "nvidia/nemotron-3-nano-30b-a3b"
      | "nvidia/nemotron-3-nano-30b-a3b:free"
      | "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free"
      | "nvidia/nemotron-3-super-120b-a12b"
      | "nvidia/nemotron-3-super-120b-a12b:free"
      | "nvidia/nemotron-3-ultra-550b-a55b"
      | "nvidia/nemotron-3-ultra-550b-a55b:free"
      | "nvidia/nemotron-3.5-content-safety:free"
      | "nvidia/nemotron-nano-12b-v2-vl:free"
      | "nvidia/nemotron-nano-9b-v2:free"
      | "openai/gpt-3.5-turbo"
      | "openai/gpt-3.5-turbo-0613"
      | "openai/gpt-3.5-turbo-16k"
      | "openai/gpt-3.5-turbo-instruct"
      | "openai/gpt-4"
      | "openai/gpt-4-turbo"
      | "openai/gpt-4-turbo-preview"
      | "openai/gpt-4.1"
      | "openai/gpt-4.1-mini"
      | "openai/gpt-4.1-nano"
      | "openai/gpt-4o"
      | "openai/gpt-4o-2024-05-13"
      | "openai/gpt-4o-2024-08-06"
      | "openai/gpt-4o-2024-11-20"
      | "openai/gpt-4o-mini"
      | "openai/gpt-4o-mini-2024-07-18"
      | "openai/gpt-4o-mini-search-preview"
      | "openai/gpt-4o-search-preview"
      | "openai/gpt-5"
      | "openai/gpt-5-chat"
      | "openai/gpt-5-codex"
      | "openai/gpt-5-image"
      | "openai/gpt-5-image-mini"
      | "openai/gpt-5-mini"
      | "openai/gpt-5-nano"
      | "openai/gpt-5-pro"
      | "openai/gpt-5.1"
      | "openai/gpt-5.1-chat"
      | "openai/gpt-5.1-codex"
      | "openai/gpt-5.1-codex-max"
      | "openai/gpt-5.1-codex-mini"
      | "openai/gpt-5.2"
      | "openai/gpt-5.2-chat"
      | "openai/gpt-5.2-codex"
      | "openai/gpt-5.2-pro"
      | "openai/gpt-5.3-chat"
      | "openai/gpt-5.3-codex"
      | "openai/gpt-5.4"
      | "openai/gpt-5.4-image-2"
      | "openai/gpt-5.4-mini"
      | "openai/gpt-5.4-nano"
      | "openai/gpt-5.4-pro"
      | "openai/gpt-5.5"
      | "openai/gpt-5.5-pro"
      | "openai/gpt-audio"
      | "openai/gpt-audio-mini"
      | "openai/gpt-chat-latest"
      | "openai/gpt-oss-120b"
      | "openai/gpt-oss-120b:free"
      | "openai/gpt-oss-20b"
      | "openai/gpt-oss-20b:free"
      | "openai/gpt-oss-safeguard-20b"
      | "openai/o1"
      | "openai/o1-pro"
      | "openai/o3"
      | "openai/o3-deep-research"
      | "openai/o3-mini"
      | "openai/o3-mini-high"
      | "openai/o3-pro"
      | "openai/o4-mini"
      | "openai/o4-mini-deep-research"
      | "openai/o4-mini-high"
      | "openrouter/auto"
      | "openrouter/bodybuilder"
      | "openrouter/free"
      | "openrouter/fusion"
      | "openrouter/owl-alpha"
      | "openrouter/pareto-code"
      | "perceptron/perceptron-mk1"
      | "perplexity/sonar"
      | "perplexity/sonar-deep-research"
      | "perplexity/sonar-pro"
      | "perplexity/sonar-pro-search"
      | "perplexity/sonar-reasoning-pro"
      | "poolside/laguna-m.1"
      | "poolside/laguna-m.1:free"
      | "poolside/laguna-xs.2"
      | "poolside/laguna-xs.2:free"
      | "qwen/qwen-2.5-72b-instruct"
      | "qwen/qwen-2.5-7b-instruct"
      | "qwen/qwen-2.5-coder-32b-instruct"
      | "qwen/qwen-plus"
      | "qwen/qwen-plus-2025-07-28"
      | "qwen/qwen-plus-2025-07-28:thinking"
      | "qwen/qwen2.5-vl-72b-instruct"
      | "qwen/qwen3-14b"
      | "qwen/qwen3-235b-a22b"
      | "qwen/qwen3-235b-a22b-2507"
      | "qwen/qwen3-235b-a22b-thinking-2507"
      | "qwen/qwen3-30b-a3b"
      | "qwen/qwen3-30b-a3b-instruct-2507"
      | "qwen/qwen3-30b-a3b-thinking-2507"
      | "qwen/qwen3-32b"
      | "qwen/qwen3-8b"
      | "qwen/qwen3-coder"
      | "qwen/qwen3-coder-30b-a3b-instruct"
      | "qwen/qwen3-coder-flash"
      | "qwen/qwen3-coder-next"
      | "qwen/qwen3-coder-plus"
      | "qwen/qwen3-coder:free"
      | "qwen/qwen3-max"
      | "qwen/qwen3-max-thinking"
      | "qwen/qwen3-next-80b-a3b-instruct"
      | "qwen/qwen3-next-80b-a3b-instruct:free"
      | "qwen/qwen3-next-80b-a3b-thinking"
      | "qwen/qwen3-vl-235b-a22b-instruct"
      | "qwen/qwen3-vl-235b-a22b-thinking"
      | "qwen/qwen3-vl-30b-a3b-instruct"
      | "qwen/qwen3-vl-30b-a3b-thinking"
      | "qwen/qwen3-vl-32b-instruct"
      | "qwen/qwen3-vl-8b-instruct"
      | "qwen/qwen3-vl-8b-thinking"
      | "qwen/qwen3.5-122b-a10b"
      | "qwen/qwen3.5-27b"
      | "qwen/qwen3.5-35b-a3b"
      | "qwen/qwen3.5-397b-a17b"
      | "qwen/qwen3.5-9b"
      | "qwen/qwen3.5-flash-02-23"
      | "qwen/qwen3.5-plus-02-15"
      | "qwen/qwen3.5-plus-20260420"
      | "qwen/qwen3.6-27b"
      | "qwen/qwen3.6-35b-a3b"
      | "qwen/qwen3.6-flash"
      | "qwen/qwen3.6-max-preview"
      | "qwen/qwen3.6-plus"
      | "qwen/qwen3.7-max"
      | "qwen/qwen3.7-plus"
      | "rekaai/reka-edge"
      | "rekaai/reka-flash-3"
      | "relace/relace-apply-3"
      | "relace/relace-search"
      | "sakana/fugu-ultra"
      | "sao10k/l3-lunaris-8b"
      | "sao10k/l3.1-70b-hanami-x1"
      | "sao10k/l3.1-euryale-70b"
      | "sao10k/l3.3-euryale-70b"
      | "stepfun/step-3.5-flash"
      | "stepfun/step-3.7-flash"
      | "switchpoint/router"
      | "tencent/hunyuan-a13b-instruct"
      | "tencent/hy3-preview"
      | "thedrummer/cydonia-24b-v4.1"
      | "thedrummer/rocinante-12b"
      | "thedrummer/skyfall-36b-v2"
      | "thedrummer/unslopnemo-12b"
      | "undi95/remm-slerp-l2-13b"
      | "upstage/solar-pro-3"
      | "writer/palmyra-x5"
      | "x-ai/grok-4.20"
      | "x-ai/grok-4.20-multi-agent"
      | "x-ai/grok-4.3"
      | "x-ai/grok-build-0.1"
      | "xiaomi/mimo-v2.5"
      | "xiaomi/mimo-v2.5-pro"
      | "z-ai/glm-4.5"
      | "z-ai/glm-4.5-air"
      | "z-ai/glm-4.5v"
      | "z-ai/glm-4.6"
      | "z-ai/glm-4.6v"
      | "z-ai/glm-4.7"
      | "z-ai/glm-4.7-flash"
      | "z-ai/glm-5"
      | "z-ai/glm-5-turbo"
      | "z-ai/glm-5.1"
      | "z-ai/glm-5.2"
      | "z-ai/glm-5v-turbo"
      | "~anthropic/claude-fable-latest"
      | "~anthropic/claude-haiku-latest"
      | "~anthropic/claude-opus-latest"
      | "~anthropic/claude-sonnet-latest"
      | "~google/gemini-flash-latest"
      | "~google/gemini-pro-latest"
      | "~moonshotai/kimi-latest"
      | "~openai/gpt-latest"
      | "~openai/gpt-mini-latest"
    )[];
  };
  relationships: {
    account: V2Relationships;
    "open-router-key"?: V2RelationshipsString;
  };
};
export type V2QuestionnaireSectionResource = {
  id?: string;
  type: string;
  attributes: {
    name: string;
    position?: number;
    expression?: string;
    introduction?: string;
  };
  relationships: {
    questionnaire?: V2Relationships;
    questions?: V2ToManyRelationships;
  };
};
export type V2QuestionnaireResource = {
  id?: number;
  type?: string;
  attributes?: {
    name: string;
    published?: boolean;
    "created-at"?: string;
    slug?: string;
    introduction?: string;
    thank_you?: string;
    "completion-url"?: string;
    questions?: {
      question?: string;
      slug?: string;
      postion?: number;
      "value-type"?:
        | "text"
        | "number"
        | "date"
        | "checkbox"
        | "email"
        | "phone";
      required?: boolean;
      settings?: {
        min?: string;
        max?: string;
        step?: number;
      };
      "select-options"?: {
        key?: string;
        value?: string;
      }[];
    }[];
    sections?: {
      name?: string;
      id?: string;
      introduction?: string;
      expression?: string;
      position?: number;
    }[];
    "tag-list"?: string[];
    teams?: {
      id?: string;
      name?: string;
    }[];
  };
  relationships?: {
    account?: V2Relationships;
    "questionnaire-sections"?: V2ToManyRelationships;
    questions?: V2ToManyRelationships;
    calculations?: V2ToManyRelationships;
    lookups?: V2ToManyRelationships;
    recommendations?: V2ToManyRelationships;
  };
};
export type V2QuestionResource = {
  id?: number;
  type?: string;
  attributes?: {
    question?: string;
    name?: string;
    slug?: string;
    "questionnaire-position"?: number;
    position?: number;
    "value-type"?: "text" | "number" | "date" | "checkbox" | "email" | "phone";
    required?: boolean;
    settings?: {
      min?: string;
      max?: string;
      step?: number;
    };
    "select-options"?: {
      key?: string;
      value?: string;
      default?: boolean;
    }[];
  };
  relationships?: {
    account?: V2Relationships;
    questionnaire?: V2Relationships;
    "questionnaire-section"?: V2Relationships;
  };
};
export type V2QuestionnaireCalculationResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    slug?: string;
    "calculation-type"?: string;
    "operand-1"?: string;
    "value-type-1"?: string;
    "operand-2"?: string;
    "value-type-2"?: string;
    expression?: string;
    active?: boolean;
  };
  relationships?: {
    questionnaire?: V2Relationships;
  };
};
export type V2QuestionnaireLookupResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    slug?: string;
    "index-1": string;
    "index-2"?: string;
    "value-type"?: "text" | "number" | "date" | "checkbox" | "email" | "phone";
    lookups?: object;
    active?: boolean;
  };
  relationships?: {
    questionnaire?: V2Relationships;
  };
};
export type V2QuestionnaireRecommendationResource = {
  id?: number;
  type: string;
  attributes: {
    "condition-type"?:
      | "always"
      | "greater_than"
      | "greater_than_or_equal_to"
      | "equal_to"
      | "less_than_or_equal_to"
      | "less_than";
    "conditional-value"?: string;
    "comparison-value"?: string;
    "comparison-value-type"?:
      | "text"
      | "number"
      | "date"
      | "checkbox"
      | "email"
      | "phone"
      | "selected_value";
    "quantity-value": string;
    "item-id": number;
    "item-type"?: "Task" | "Governance" | "Material";
    position?: number;
    refinements?: {
      id?: number;
      "quantity-value"?: string;
      "task-id"?: number;
    }[];
    active?: boolean;
  };
  relationships?: {
    questionnaire?: V2Relationships;
  };
};
export type V2EvlauateStringAttributes = {
  result: string;
};
export type V2EvlauateNumberAttributes = {
  result: number;
};
export type V2EvlauateBooleanAttributes = {
  result: boolean;
};
export type V2VendorResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "street-address"?: string;
    street2?: string;
    city?: string;
    state?: string;
    "postal-code"?: string;
    country?: string;
    "project-count"?: number;
  };
  relationships: {
    account: V2Relationships;
    quotes?: V2ToManyRelationships;
  };
};
export type V2ReleaseFlagResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    key: string;
    description?: string;
    "beta-release-date"?: string;
    "general-availability-date"?: string;
    status?: "building" | "beta_test" | "released";
  };
};
export type V2ResourceAllocationResource = {
  id?: number;
  type?: string;
  attributes?: {
    personnnel?: string;
    "assigned-hours"?: number[];
  };
  relationships?: {
    "resource-plan"?: V2Relationships;
    "project-resource"?: V2Relationships;
  };
};
export type V2SharedSurveyResource = {
  id?: string;
  type: string;
  attributes: {
    "survey-status"?:
      | "pending"
      | "shared"
      | "completed"
      | "applied"
      | "revised";
    "sent-by"?: string;
    responses?: {
      "survey-response-id"?: number;
      "question-id"?: number;
      question?: string;
      answer?: string;
      "value-type"?:
        | "text"
        | "number"
        | "date"
        | "checkbox"
        | "email"
        | "phone";
      "select-options"?: {
        key?: string;
        value?: string;
        default?: boolean;
      }[];
      required?: boolean;
      position?: number;
    }[];
  };
  relationships: {
    survey?: V2Relationships;
    questionnaire?: V2Relationships;
    questions?: V2ToManyRelationships;
  };
};
export type V2SubscriptionResource = {
  id?: number;
  type: string;
  attributes: {
    "plan-name"?: string;
    "plan-id"?: string;
    "plan-revenue"?: {
      price?: number;
      billing_period_unit?: "month" | "year";
    };
    "plan-quantity"?: number;
    "max-users"?: number;
    status?: "building" | "pending" | "trial" | "active" | "canceled";
    entitlements?: {
      id?: string;
      name?: string;
      description?: string;
    }[];
    addons?: {
      id?: string;
      name?: string;
      description?: string;
    }[];
    "cancellation-reason"?: string;
    "canceled-on"?: string;
    "available-plans"?: {
      name?: string;
      id?: string;
      price?: number;
      minimum_quantity?: number;
    }[];
    "free-trial-available"?: boolean;
  };
  relationships: {
    account: V2Relationships;
    "rate-table"?: V2Relationships;
  };
};
export type V2SurveyRecommendationResource = {
  id?: number;
  type: string;
  attributes: {
    quantity?: number;
    status?: "pending" | "applied" | "inactive";
    "item-type"?: string;
    "item-id"?: string;
    refinements?: {
      quantity?: number;
      status?: "pending" | "applied";
      item_type?: string;
      item_id?: string;
      resource_id?: string;
      project_resource_id?: string;
    }[];
  };
  relationships: {
    survey?: V2Relationships;
    resource?: V2Relationships;
    "project-resource"?: V2RelationshipsString;
  };
};
export type V2SurveyResponseResource = {
  id?: number;
  type: string;
  attributes: {
    question: string;
    answer: string;
    value_name?: string;
    value_type?: "text" | "number" | "date" | "checkbox" | "email" | "phone";
    slug?: string;
    settings?: {
      min?: string;
      max?: string;
      step?: number;
    };
  };
  relationships: {
    survey: V2Relationships;
    source: V2Relationships;
  };
};
export type V2TagResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
  };
  relationships: object;
};
export type V2TaskRateResource = {
  id?: number;
  type: string;
  attributes: {
    "rate-type"?:
      | "service_price"
      | "service_cost"
      | "hardware_price"
      | "hardware_cost";
    "minimum-quantity"?: number;
    "base-amount"?: number;
    "unit-amount"?: number;
  };
  relationships: {
    service?: V2Relationships;
  };
};
export type V2TextBlockResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "merge-block"?: string;
    slug?: string;
  };
  relationships: {
    account: V2Relationships;
  };
};
export type V2FavoriteProduct = {
  name?: string;
  description?: string;
  product_id?: string;
  sku?: string;
  manufacturer_name?: string;
  manufacturer_part_number?: string;
  vendor_name?: string;
  category?: string;
  subcategory?: string;
  unit_cost?: number;
  unit_price?: number;
  unit_of_measure?: string;
  vendor_discount?: number;
  markup?: number;
  vendor_rebate?: number;
};
export type V2FavoriteSurvey = {
  name?: string;
  description?: string;
};
export type V2UserFavoriteResource = {
  id?: number;
  type?: string;
  attributes?: {
    "user-id"?: number;
    name: string;
    source?: "standard" | "connectwise";
    source_key?: string;
    content_type?: string;
    content?: V2FavoriteProduct | V2FavoriteSurvey;
  };
  relationships?: {
    user?: V2Relationships;
  };
};
export type V2ProjectFilter = {
  showMyProjectsOnly?: boolean;
  showMyProjects?: boolean;
  tags?: string[];
  teams?: string[];
  status?: string[];
  clients?: string[];
  teammates?: string[];
  presalesEngineers?: string[];
  salesExecs?: string[];
  dateCreatedStart?: string[];
  dateCreatedEnd?: string[];
  dateEditedStart?: string[];
  dateEditedEnd?: string[];
};
export type V2ServiceFilter = {
  lobs?: string[];
  categories?: string[];
  frequency?: ("one_time" | "monthly" | "quarterly" | "yearly")[];
  phases?: string[];
  blueprints?: string[];
  questionnaires?: string[];
  startDateCreated?: string;
  endDateCreated?: string;
  startDateUpdated?: string;
  endDateUpdated?: string;
};
export type V2UserFilterResource = {
  id?: number;
  type: string;
  attributes: {
    "data-type": string;
    "data-path"?: string;
    name?: string;
    filters: V2ProjectFilter | V2ServiceFilter;
    active?: boolean;
  };
  relationships: {
    account: V2Relationships;
    user: V2Relationships;
  };
};
export type V2UserFlagValueResource = {
  id: string;
  type: string;
  attributes: {
    name?: string;
    description?: string;
    variation?: any;
    variations?: {
      value?: any;
      name?: string;
    }[];
    "has-override"?: boolean;
  };
};
export type V2UserViewResource = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    columns?: {
      label?: string;
      width?: number;
      format?:
        | "currency"
        | "date"
        | "decimal"
        | "percent"
        | "string"
        | "titleize";
      optional?: boolean;
      selected?: boolean;
      sortable?: boolean;
      sorted?: "asc" | "desc";
      position?: number;
      "data-path"?: string;
      "data-type"?: string;
    };
    filters?: {
      showMyProjectsOnly?: boolean;
      showMyProjects?: boolean;
      tags?: string[];
      teams?: string[];
      status?: string[];
      clients?: string[];
      teammates?: string[];
      presalesEngineers?: string[];
      salesExecs?: string[];
      dateCreatedStart?: string[];
      dateCreatedEnd?: string[];
      dateEditedStart?: string[];
      dateEditedEnd?: string[];
    };
    "page-size"?: number;
    "view-type"?: "project" | "product";
  };
  relationships: {
    account: V2Relationships;
    user?: V2Relationships;
  };
};
export type V2UserResourceWrite = {
  id?: number;
  type: string;
  attributes: {
    name: string;
    "start-page"?: "Home" | "Projects" | "Approvals" | "Surveys" | "Settings";
    active?: boolean;
    phone?: string;
    "sso-provider"?: string;
    email: string;
    title?: string;
    presales?: boolean;
    sales?: boolean;
    password?: string;
    "password-confirmation"?: string;
    roles?: {
      id: number;
      name?: string;
    }[];
    "view-only"?: boolean;
    "user-type"?: "view_only" | "licensed" | "sales" | "service" | "approver";
    "guided-onboarding"?: {
      onboarding_status?: string;
      skipped_onboarding?: boolean;
      modified_governance?: boolean;
      modified_phases?: boolean;
      modified_resources?: boolean;
      modified_services?: boolean;
    };
    "preferred-rate-table"?: V2RateTableResource;
  };
  relationships?: {
    account?: V2Relationships;
    "rate-table"?: V2Relationships;
    roles?: V2ToManyRelationships;
    teams?: V2ToManyRelationships;
  };
};
export type V2ServiceAccountCredentialResource = {
  id?: string;
  type: string;
  attributes: {
    name: string;
    "redirect-uri"?: string;
    "client-id"?: string;
    "client-secret"?: string;
  };
};
export type V2ServiceAccountCredentialRotationResource = {
  id?: string;
  type: string;
  attributes: {
    "client-secret": string;
  };
  relationships?: {
    "service-account-credential"?: V2RelationshipsString;
  };
};
export type V2WebhookSubscriptionResource = {
  id?: number;
  type: string;
  attributes: {
    "webhook-url"?: string;
    "event-type"?:
      | "project_status_changed"
      | "service_status_changed"
      | "document_status_changed";
  };
  relationships: {
    account: V2Relationships;
  };
};
export const {
  useV2ListAccountConnectionsQuery,
  useV2CreateAccountConnectionMutation,
  useV2GetAccountConnectionQuery,
  useV2UpdateAccountConnectionMutation,
  useV2DeleteAccountConnectionMutation,
  useV2ReconnectAccountConnectionMutation,
  useV2EnableAccountConnectionMutation,
  useV2DisableAccountConnectionMutation,
  useV2GetAccountFinancialsQuery,
  useV2ListAccountFlagValuesQuery,
  useV2GetAccountFlagValueQuery,
  useV2UpdateAccountFlagValueMutation,
  useV2DeleteAccountFlagValueMutation,
  useV2ListAccountHealthSnapshotsQuery,
  useV2GetAccountHealthSnapshotQuery,
  useV2GetAccountLogoQuery,
  useV2UpdateAccountLogoMutation,
  useV2ListAccountsQuery,
  useV2CreateAccountMutation,
  useV2GetAccountQuery,
  useV2ListApprovalLevelsForAccountQuery,
  useV2CreateApprovalLevelMutation,
  useV2GetApprovalLevelQuery,
  useV2UpdateApprovalLevelMutation,
  useV2DeleteApprovalLevelMutation,
  useV2ChangeApprovalLevelPositionByIdMutation,
  useV2RestoreApprovalLevelByIdMutation,
  useV2PurgeApprovalLevelByIdMutation,
  useV2ConsolidateTechnicalApprovalLevelsMutation,
  useV2ListLobApprovalsForAccountQuery,
  useV2CreateLobApprovalMutation,
  useV2GetLobApprovalQuery,
  useV2UpdateLobApprovalMutation,
  useV2DeleteLobApprovalMutation,
  useV2ListLobApprovalUsersForAccountQuery,
  useV2CreateLobApprovalUserMutation,
  useV2GetLobApprovalUserQuery,
  useV2UpdateLobApprovalUserMutation,
  useV2DeleteLobApprovalUserMutation,
  useV2ListApprovalStepsForAccountQuery,
  useV2GetApprovalStepQuery,
  useV2ListAttachmentTypesForAccountQuery,
  useV2CreateAttachmentTypeMutation,
  useV2GetAttachmentTypeQuery,
  useV2UpdateAttachmentTypeMutation,
  useV2DeleteAttachmentTypeMutation,
  useV2ListAuditLogsQuery,
  useV2ListProjectAuditLogsQuery,
  useV2GetAuditLogByIdQuery,
  useV2RevertAuditLogByIdMutation,
  useV2ListBlueprintsForAccountQuery,
  useV2CreateBlueprintMutation,
  useV2GetBlueprintQuery,
  useV2UpdateBlueprintMutation,
  useV2DeleteBlueprintMutation,
  useV2ListBusinessUnitsForAccountQuery,
  useV2CreateBusinessUnitMutation,
  useV2GetBusinessUnitQuery,
  useV2UpdateBusinessUnitMutation,
  useV2DeleteBusinessUnitMutation,
  useV2ListSpecialConditionsForBusinessUnitQuery,
  useV2CreateSpecialConditionForBusinessUnitMutation,
  useV2GetBusinessUnitSpecialConditionByIdQuery,
  useV2UpdateBusinessUnitSpecialConditionMutation,
  useV2DeleteBusinessUnitSpecialConditionMutation,
  useV2ListClientsForAccountQuery,
  useV2CreateClientMutation,
  useV2GetClientQuery,
  useV2UpdateClientMutation,
  useV2DeleteClientMutation,
  useV2DownloadClientsCsvQuery,
  useV2MergeClientRecordsMutation,
  useV2ListContactsForClientQuery,
  useV2CreateContactForClientMutation,
  useV2GetClientContactByIdQuery,
  useV2UpdateClientContactMutation,
  useV2DeleteClientContactMutation,
  useV2ListSpecialConditionsForClientQuery,
  useV2CreateSpecialConditionForClientMutation,
  useV2GetClientSpecialConditionByIdQuery,
  useV2UpdateClientSpecialConditionMutation,
  useV2DeleteClientSpecialConditionMutation,
  useV2ListCollaboratorsForAccountQuery,
  useV2GetCollaboratorByIdQuery,
  useV2ListConnectedAppQuery,
  useV2ListContactsForAccountQuery,
  useV2CreateContactMutation,
  useV2GetContactByIdQuery,
  useV2UpdateContactMutation,
  useV2DeleteContactMutation,
  useV2ListContentTemplatesForAccountQuery,
  useV2GetContentTemplateQuery,
  useV2ImportContentTemplateMutation,
  useV2ListCrmOpportunitiesForAccountQuery,
  useV2ListCurrencysForAccountQuery,
  useV2CreateCurrencyMutation,
  useV2GetCurrencyQuery,
  useV2UpdateCurrencyMutation,
  useV2DeleteCurrencyMutation,
  useV2ListCustomerSuccessesQuery,
  useV2CreateCustomerSuccessMutation,
  useV2GetCustomerSuccessQuery,
  useV2UpdateCustomerSuccessMutation,
  useV2DeleteCustomerSuccessMutation,
  useV2ListDataImportsForAccountQuery,
  useV2CreateDataImportMutation,
  useV2GetDataImportByIdQuery,
  useV2ListDocumentDeliveriesForAccountQuery,
  useV2GetDocumentDeliveryQuery,
  useV2ListDocumentRequestsForAccountQuery,
  useV2CreateDocumentRequestMutation,
  useV2GetDocumentRequestQuery,
  useV2UpdateDocumentRequestMutation,
  useV2DeleteDocumentRequestMutation,
  useV2ListDocumentTemplatesForAccountQuery,
  useV2CreateDocumentTemplateMutation,
  useV2GetDocumentTemplateQuery,
  useV2UpdateDocumentTemplateMutation,
  useV2DeleteDocumentTemplateMutation,
  useV2RestoreDocumentTemplateMutation,
  useV2GetFilenameFormatOptionsQuery,
  useV2DownloadDocumentTemplateQuery,
  useV2UploadDocumentTemplateMutation,
  useV2CreateExecutiveSummaryRequestMutation,
  useV2GetExecutiveSummaryRequestQuery,
  useV2ListExpenseCategoriessForAccountQuery,
  useV2CreateExpenseCategoryMutation,
  useV2GetExpenseCategoryByIdQuery,
  useV2UpdateExpenseCategoryMutation,
  useV2DeleteExpenseCategoryMutation,
  useV2ListExternalRequestsForAccountQuery,
  useV2GetExternalRequestQuery,
  useV2AcceptExternalRequestMutation,
  useV2OfferExternalRequestMutation,
  useV2DeclineExternalRequestMutation,
  useV2ListFreeTrialsForAccountQuery,
  useV2CreateFreeTrialMutation,
  useV2GetFreeTrialQuery,
  useV2CancelFreeTrialMutation,
  useV2ListGovernancesForAccountQuery,
  useV2CreateGovernanceMutation,
  useV2GetGovernanceByIdQuery,
  useV2UpdateGovernanceMutation,
  useV2DeleteGovernanceMutation,
  useV2ChangeGovernancePositionByIdMutation,
  useV2RestoreGovernanceByIdMutation,
  useV2PurgeGovernanceByIdMutation,
  useV2ListIntegratedProductsQuery,
  useV2ListIntegrationLogsForAccountQuery,
  useV2GetIntegrationLogQuery,
  useV2ListLandingPageContentQuery,
  useV2ListLanguageFieldsForAccountQuery,
  useV2GetLanguageFieldByIdQuery,
  useV2ChangeLanguageFieldPositionByIdMutation,
  useV2GetServiceLevelsOfEffortQuery,
  useV2CreateLevelOfEffortForServiceMutation,
  useV2GetServiceLevelOfEffortQuery,
  useV2UpdateLevelOfEffortForServiceMutation,
  useV2DeleteLevelOfEffortFromServiceMutation,
  useV2GetSubserviceLevelsOfEffortQuery,
  useV2CreateLevelOfEffortForSubserviceMutation,
  useV2GetSubserviceLevelOfEffortQuery,
  useV2UpdateLevelOfEffortForSubserviceMutation,
  useV2DeleteLevelOfEffortFromSubserviceMutation,
  useV2ListLineOfBusinessesForAccountQuery,
  useV2CreateLineOfBusinessMutation,
  useV2GetLineOfBusinessQuery,
  useV2UpdateLineOfBusinessMutation,
  useV2DeleteLineOfBusinessMutation,
  useV2WhoAmIQuery,
  useV2ListNotesQuery,
  useV2CreateNoteMutation,
  useV2GetNoteQuery,
  useV2UpdateNoteMutation,
  useV2DeleteNoteMutation,
  useV2ListOpenRouterKeysForAccountQuery,
  useV2CreateOpenRouterKeyMutation,
  useV2GetOpenRouterKeyQuery,
  useV2UpdateOpenRouterKeyMutation,
  useV2DeleteOpenRouterKeyMutation,
  useV2ListPartnerRequestsForAccountQuery,
  useV2CreatePartnerRequestMutation,
  useV2GetPartnerRequestQuery,
  useV2UpdatePartnerRequestMutation,
  useV2DeletePartnerRequestMutation,
  useV2CompletePartnerRequestMutation,
  useV2RevisePartnerRequestMutation,
  useV2DeclinePartnerRequestMutation,
  useV2CountPartnerRequestsQuery,
  useV2ListPaymentCreditsForAccountQuery,
  useV2CreatePaymentCreditMutation,
  useV2GetPaymentCreditQuery,
  useV2UpdatePaymentCreditMutation,
  useV2DeletePaymentCreditMutation,
  useV2ListPaymentTermsForAccountQuery,
  useV2CreatePaymentTermMutation,
  useV2GetPaymentTermQuery,
  useV2UpdatePaymentTermMutation,
  useV2DeletePaymentTermMutation,
  useV2ListPerformanceIndicatorsForAccountQuery,
  useV2CreatePerformanceIndicatorMutation,
  useV2GetPerformanceIndicatorQuery,
  useV2UpdatePerformanceIndicatorMutation,
  useV2DeletePerformanceIndicatorMutation,
  useV2ListPhasesForAccountQuery,
  useV2CreatePhaseMutation,
  useV2GetPhaseByIdQuery,
  useV2UpdatePhaseMutation,
  useV2DeletePhaseMutation,
  useV2ChangePhasePositionByIdMutation,
  useV2RestorePhaseByIdMutation,
  useV2PurgePhaseByIdMutation,
  useV2ListPresalesEngineersForAccountQuery,
  useV2GetPresalesEngineerByIdQuery,
  useV2ListPricingAdjustmentsForAccountQuery,
  useV2CreatePricingAdjustmentMutation,
  useV2GetPricingAdjustmentByIdQuery,
  useV2UpdatePricingAdjustmentByIdMutation,
  useV2DeletePricingAdjustmentByIdMutation,
  useV2ListPrivilegesQuery,
  useV2ListProductAccountingsForAccountQuery,
  useV2CreateProductAccountingMutation,
  useV2GetProductAccountingQuery,
  useV2UpdateProductAccountingMutation,
  useV2DeleteProductAccountingMutation,
  useV2ListProductsForAccountQuery,
  useV2CreateProductMutation,
  useV2GetProductQuery,
  useV2UpdateProductMutation,
  useV2DeleteProductMutation,
  useV2ListProjectApprovalsForAccountQuery,
  useV2CreateProjectApprovalMutation,
  useV2GetProjectApprovalQuery,
  useV2UpdateProjectApprovalMutation,
  useV2DeleteProjectApprovalMutation,
  useV2ApproveProjectApprovalByIdMutation,
  useV2CancelProjectApprovalByIdMutation,
  useV2DeclineProjectApprovalByIdMutation,
  useV2RescopeProjectApprovalByIdMutation,
  useV2ListProjectAttachmentsForAccountQuery,
  useV2CreateProjectAttachmentMutation,
  useV2GetProjectAttachmentByIdQuery,
  useV2UpdateProjectAttachmentMutation,
  useV2DeleteProjectAttachmentMutation,
  useV2CountProjectAttachmentsQuery,
  useV2DownloadProjectAttachmentQuery,
  useV2UploadProjectAttachmentMutation,
  useV2ListProjectCollaboratorsQuery,
  useV2CreateProjectCollaboratorMutation,
  useV2GetProjectCollaboratorByIdQuery,
  useV2UpdateProjectCollaboratorMutation,
  useV2DeleteProjectCollaboratorMutation,
  useV2CountProjectCollaboratorsQuery,
  useV2ListProjectConditionsForAccountQuery,
  useV2GetProjectConditionQuery,
  useV2UpdateProjectConditionMutation,
  useV2DeleteProjectConditionMutation,
  useV2SkipProjectConditionMutation,
  useV2RestoreProjectConditionMutation,
  useV2CountProjectConditionsQuery,
  useV2ListProjectContactsQuery,
  useV2CreateProjectContactMutation,
  useV2GetProjectContactQuery,
  useV2UpdateProjectContactMutation,
  useV2DeleteProjectContactMutation,
  useV2CountProjectContactsQuery,
  useV2ListProjectCreditsQuery,
  useV2CreateProjectCreditMutation,
  useV2GetProjectCreditByIdQuery,
  useV2UpdateProjectCreditMutation,
  useV2DeleteProjectCreditMutation,
  useV2ListProjectDocumentsForAccountQuery,
  useV2CreateProjectDocumentMutation,
  useV2GetProjectDocumentQuery,
  useV2CreateProjectDuplicationMutation,
  useV2ListProjectExpensesQuery,
  useV2CreateProjectExpenseMutation,
  useV2GetProjectExpenseByIdQuery,
  useV2UpdateProjectExpenseMutation,
  useV2DeleteProjectExpenseMutation,
  useV2CountProjectExpensesQuery,
  useV2ListProjectGovernancesQuery,
  useV2CreateProjectGovernanceMutation,
  useV2GetProjectGovernanceByIdQuery,
  useV2UpdateProjectGovernanceMutation,
  useV2DeleteProjectGovernanceMutation,
  useV2ChangeProjectGovernancePositionByIdMutation,
  useV2CountProjectGovernancesQuery,
  useV2ListProjectLocationsQuery,
  useV2CreateProjectLocationMutation,
  useV2GetProjectLocationByIdQuery,
  useV2UpdateProjectLocationMutation,
  useV2DeleteProjectLocationMutation,
  useV2CountProjectLocationsQuery,
  useV2ListProjectPhasesForAccountQuery,
  useV2CreateProjectPhaseMutation,
  useV2GetProjectPhaseByIdQuery,
  useV2UpdateProjectPhaseMutation,
  useV2DeleteProjectPhaseMutation,
  useV2ListProjectProductsForAccountQuery,
  useV2CreateProjectProductMutation,
  useV2GetProjectProductQuery,
  useV2UpdateProjectProductMutation,
  useV2DeleteProjectProductMutation,
  useV2CountProjectProductsQuery,
  useV2ListProjectResourcesForAccountQuery,
  useV2CreateProjectResourceMutation,
  useV2GetProjectResourceQuery,
  useV2UpdateProjectResourceMutation,
  useV2DeleteProjectResourceMutation,
  useV2CountProjectResourcesQuery,
  useV2ListProjectServicesQuery,
  useV2CreateProjectServiceMutation,
  useV2GetProjectServiceByIdQuery,
  useV2UpdateProjectServiceMutation,
  useV2DeleteProjectServiceMutation,
  useV2DuplicateProjectServiceByIdMutation,
  useV2RefreshProjectServiceByIdMutation,
  useV2SyncrhonizeStandardProjectServiceByIdMutation,
  useV2CountProjectServicesQuery,
  useV2ListProjectSubservicesQuery,
  useV2CreateProjectSubserviceMutation,
  useV2GetProjectSubserviceByIdQuery,
  useV2UpdateProjectSubserviceMutation,
  useV2DeleteProjectSubserviceMutation,
  useV2SyncrhonizeStandardProjectSubserviceByIdMutation,
  useV2ListProjectSurveysQuery,
  useV2CountProjectSurveysQuery,
  useV2GetProjectSurveyQuery,
  useV2ListProjectVariablesQuery,
  useV2CreateProjectVariableMutation,
  useV2GetProjectVariableByIdQuery,
  useV2UpdateProjectVariableMutation,
  useV2DeleteProjectVariableMutation,
  useV2ChangeProjectVariablePositionByIdMutation,
  useV2RestoreProjectVariableByIdMutation,
  useV2PurgeProjectVariableByIdMutation,
  useV2ListProjectVersionsQuery,
  useV2CreateProjectVersionMutation,
  useV2GetProjectVersionByIdQuery,
  useV2UpdateProjectVersionMutation,
  useV2RevertProjectVersionMutation,
  useV2CountProjectVersionsQuery,
  useV2ListProjectsForAccountQuery,
  useV2CreateProjectMutation,
  useV2GetProjectByIdQuery,
  useV2UpdateProjectMutation,
  useV2DeleteProjectMutation,
  useV2PurgeProjectMutation,
  useV2RemoveCrmIntegrationFromProjectMutation,
  useV2RequestApprovalForProjectByIdMutation,
  useV2CancelApprovalRequestForProjectByIdMutation,
  useV2RestartScopingForProjectByIdMutation,
  useV2UpdateProjectToWonByIdMutation,
  useV2UpdateProjectToLostByIdMutation,
  useV2SyncProjectRevenueToCrmMutation,
  useV2DuplicateProjectByIdMutation,
  useV2ExportProjectsMutation,
  useV2UpdateTargetMarginMutation,
  useV2ProjectMergeDataQuery,
  useV2ListPromptContentsForAccountQuery,
  useV2GetPromptContentQuery,
  useV2ListPromptOverridesForAccountQuery,
  useV2CreatePromptOverrideMutation,
  useV2GetPromptOverrideQuery,
  useV2UpdatePromptOverrideMutation,
  useV2DeletePromptOverrideMutation,
  useV2ListQuestionnaireSectionsForQuestionnaireQuery,
  useV2CreateQuestionnaireSectionMutation,
  useV2GetQuestionnaireSectionByIdQuery,
  useV2UpdateQuestionnaireSectionMutation,
  useV2DeleteQuestionnaireSectionMutation,
  useV2ListQuestionnairesForAccountQuery,
  useV2CreateQuestionnaireMutation,
  useV2GetQuestionnaireByIdQuery,
  useV2UpdateQuestionnaireMutation,
  useV2DeleteQuestionnaireMutation,
  useV2EvaluateQuestionnaireMutation,
  useV2ListQuestionsForQuestionnaireQuery,
  useV2CreateQuestionMutation,
  useV2GetQuestionByIdQuery,
  useV2UpdateQuestionMutation,
  useV2DeleteQuestionMutation,
  useV2ListQuestionnaireCalculationsForQuestionnaireQuery,
  useV2CreateQuestionnaireCalculationMutation,
  useV2GetQuestionnaireCalculationByIdQuery,
  useV2UpdateQuestionnaireCalculationMutation,
  useV2DeleteQuestionnaireCalculationMutation,
  useV2ListQuestionnaireLookupsForQuestionnaireQuery,
  useV2CreateQuestionnaireLookupMutation,
  useV2GetQuestionnaireLookupByIdQuery,
  useV2UpdateQuestionnaireLookupMutation,
  useV2DeleteQuestionnaireLookupMutation,
  useV2ListQuestionnaireRecommendationsForQuestionnaireQuery,
  useV2CreateQuestionnaireRecommendationMutation,
  useV2GetQuestionnaireRecommendationByIdQuery,
  useV2UpdateQuestionnaireRecommendationMutation,
  useV2DeleteQuestionnaireRecommendationMutation,
  useV2ListQuotesForAccountQuery,
  useV2CreateQuoteMutation,
  useV2GetQuoteQuery,
  useV2UpdateQuoteMutation,
  useV2DeleteQuoteMutation,
  useV2RecalculateQuoteMutation,
  useV2AcceptVendorDocumentForQuoteMutation,
  useV2CountQuotesQuery,
  useV2ListRateTablesForAccountQuery,
  useV2CreateRateTableMutation,
  useV2GetRateTableQuery,
  useV2UpdateRateTableMutation,
  useV2DeleteRateTableMutation,
  useV2DuplicateRateTableMutation,
  useV2ListReleaseFlagsQuery,
  useV2CreateReleaseFlagMutation,
  useV2GetReleaseFlagQuery,
  useV2UpdateReleaseFlagMutation,
  useV2DeleteReleaseFlagMutation,
  useV2ListResourceAllocationsQuery,
  useV2CreateResourceAllocationMutation,
  useV2GetResourceAllocationByIdQuery,
  useV2UpdateResourceAllocationMutation,
  useV2DeleteResourceAllocationMutation,
  useV2ListResourcePlansQuery,
  useV2CreateResourcePlanMutation,
  useV2GetResourcePlanByIdQuery,
  useV2UpdateResourcePlanMutation,
  useV2DeleteResourcePlanMutation,
  useV2DuplicateResourcePlanMutation,
  useV2ListResourceRatesForAccountQuery,
  useV2CreateResourceRateMutation,
  useV2GetResourceRateByIdQuery,
  useV2UpdateResourceRateMutation,
  useV2DeleteResourceRateMutation,
  useV2ListResourcesForAccountQuery,
  useV2CreateResourceMutation,
  useV2GetResourceByIdQuery,
  useV2UpdateResourceMutation,
  useV2DeleteResourceMutation,
  useV2ListRolesForAccountQuery,
  useV2CreateRoleMutation,
  useV2GetRoleQuery,
  useV2UpdateRoleMutation,
  useV2DeleteRoleMutation,
  useV2ListSalesExecutivesForAccountQuery,
  useV2CreateSalesExecutiveMutation,
  useV2GetSalesExecutiveByIdQuery,
  useV2UpdateSalesExecutiveMutation,
  useV2DeleteSalesExecutiveMutation,
  useV2ListServiceCategorysForAccountQuery,
  useV2GetServiceCategoryQuery,
  useV2ListServiceConditionsForAccountQuery,
  useV2CreateServiceConditionMutation,
  useV2GetServiceConditionQuery,
  useV2UpdateServiceConditionMutation,
  useV2DeleteServiceConditionMutation,
  useV2ListServicesForAccountQuery,
  useV2CreateServiceMutation,
  useV2GetServiceByIdQuery,
  useV2UpdateServiceMutation,
  useV2DeleteServiceMutation,
  useV2ActivateServiceMutation,
  useV2RestoreServiceMutation,
  useV2ChangeServicePositionByIdMutation,
  useV2DuplicateServiceMutation,
  useV2DownloadServiceMutation,
  useV2DownloadListOfServicesMutation,
  useV2GetSharedSurveyByIdQuery,
  useV2UpdateSharedSurveyMutation,
  useV2ListSubcontractorsForAccountQuery,
  useV2GetSubcontractorQuery,
  useV2ListSubscriptionsForAccountQuery,
  useV2CreateSubscriptionMutation,
  useV2GetSubscriptionQuery,
  useV2UpdateSubscriptionMutation,
  useV2DeleteSubscriptionMutation,
  useV2ListSubservicesForAccountQuery,
  useV2CreateSubserviceMutation,
  useV2GetSubserviceByIdQuery,
  useV2UpdateSubserviceMutation,
  useV2DeleteSubserviceMutation,
  useV2ActivateSubserviceMutation,
  useV2ChangeSubservicePositionByIdMutation,
  useV2ListSurveyRecommendationsForAccountQuery,
  useV2GetSurveyRecommendationByIdQuery,
  useV2UpdateSurveyRecommendationMutation,
  useV2DeleteSurveyRecommendationMutation,
  useV2ApplySurveyRecommendationMutation,
  useV2ListSurveyResponsesForAccountQuery,
  useV2CreateSurveyResponseMutation,
  useV2GetSurveyResponseByIdQuery,
  useV2UpdateSurveyResponseMutation,
  useV2DeleteSurveyResponseMutation,
  useV2ListSurveysForAccountQuery,
  useV2CreateSurveyMutation,
  useV2GetSurveyByIdQuery,
  useV2UpdateSurveyMutation,
  useV2DeleteSurveyMutation,
  useV2CalculateSurveyRecommendationsMutation,
  useV2ApplySurveyRecommendationsMutation,
  useV2ShareSurveyMutation,
  useV2ListTagsForAccountQuery,
  useV2GetTagQuery,
  useV2GetServiceTaskRatesQuery,
  useV2CreateTaskRateForServiceMutation,
  useV2GetServiceTaskRateQuery,
  useV2UpdateTaskRateForServiceMutation,
  useV2DeleteTaskRateFromServiceMutation,
  useV2GetSubserviceTaskRatesQuery,
  useV2CreateTaskRateForSubserviceMutation,
  useV2GetSubserviceTaskRateQuery,
  useV2UpdateTaskRateForSubserviceMutation,
  useV2DeleteTaskRateFromSubserviceMutation,
  useV2GetProductTaskRatesQuery,
  useV2CreateTaskRateForProductMutation,
  useV2GetProductTaskRateQuery,
  useV2UpdateTaskRateForProductMutation,
  useV2DeleteTaskRateFromProductMutation,
  useV2ListTeamsForAccountQuery,
  useV2CreateTeamMutation,
  useV2GetTeamQuery,
  useV2UpdateTeamMutation,
  useV2DeleteTeamMutation,
  useV2ListTextBlocksForAccountQuery,
  useV2CreateTextBlockMutation,
  useV2GetTextBlockQuery,
  useV2UpdateTextBlockMutation,
  useV2DeleteTextBlockMutation,
  useV2ListThirdPartyServicesForAccountQuery,
  useV2CreateThirdPartyServiceMutation,
  useV2GetThirdPartyServiceQuery,
  useV2UpdateThirdPartyServiceMutation,
  useV2DeleteThirdPartyServiceMutation,
  useV2MoveThirdPartyServiceMutation,
  useGetV2UserFavoritesQuery,
  useV2CreateUserFavoriteMutation,
  useV2DeleteUserFavoriteMutation,
  useV2ListUserFiltersForAccountQuery,
  useV2CreateUserFilterMutation,
  useV2GetUserFilterQuery,
  useV2UpdateUserFilterMutation,
  useV2DeleteUserFilterMutation,
  useV2ListUserFlagValuesQuery,
  useV2GetUserFlagValueQuery,
  useV2UpdateUserFlagValueMutation,
  useV2DeleteUserFlagValueMutation,
  useV2ListUserViewsForAccountQuery,
  useV2CreateUserViewMutation,
  useV2GetUserViewQuery,
  useV2UpdateUserViewMutation,
  useV2DeleteUserViewMutation,
  useV2ListUsersForAccountQuery,
  useV2CreateUserMutation,
  useV2ShowCurrentUserForAccountQuery,
  useV2GetUserQuery,
  useV2UpdateUserMutation,
  useV2DeleteUserMutation,
  useV2ResetUserFiltersMutation,
  useV2UnlockUserMutation,
  useV2ListServiceAccountCredentialsQuery,
  useV2CreateServiceAccountCredentialMutation,
  useV2GetServiceAccountCredentialQuery,
  useV2UpdateServiceAccountCredentialMutation,
  useV2DeleteServiceAccountCredentialMutation,
  useV2RotateServiceAccountCredentialMutation,
  useV2ListVendorsForAccountQuery,
  useV2CreateVendorMutation,
  useV2GetVendorQuery,
  useV2UpdateVendorMutation,
  useV2DeleteVendorMutation,
  useV2ListSpecialConditionsForVendorQuery,
  useV2CreateSpecialConditionForVendorMutation,
  useV2GetVendorSpecialConditionByIdQuery,
  useV2UpdateVendorSpecialConditionMutation,
  useV2DeleteVendorSpecialConditionMutation,
  useV2ListWebhookSubscriptionsForAccountQuery,
  useV2CreateWebhookSubscriptionMutation,
  useV2GetWebhookSubscriptionQuery,
  useV2UpdateWebhookSubscriptionMutation,
  useV2DeleteWebhookSubscriptionMutation,
} = injectedRtkApi;
